import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region \0rolldown/runtime.js
var n = Object.defineProperty, r = (e, t) => {
	let r = {};
	for (var i in e) n(r, i, {
		get: e[i],
		enumerable: !0
	});
	return t || n(r, Symbol.toStringTag, { value: "Module" }), r;
};
//#endregion
//#region primitives/icon/icons/Age.tsx
function i(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", {
				d: "M22 12c0 5.522-4.477 10-10 10S2 17.522 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10",
				fill: "#1ED560"
			}), /* @__PURE__ */ e("path", {
				d: "M8.13 15.24v-.88H5.4l1.27-1.62c.78-1 .78-1 1.02-1.43.28-.49.41-.96.41-1.47C8.1 8.66 7.4 8 6.15 8c-1.26 0-2.01.65-2.1 1.83l.98.08c.13-.68.5-1.03 1.08-1.03.61 0 .93.32.93.92 0 .61-.33 1.31-1.06 2.23L4 14.54v.7h4.13zm4.28 0V8.1h-.72l-1.87.8.33.82 1.19-.51v6.03h1.07zm5.26-1.28v-1.91h1.87v-.82h-1.87V9.31h-.89v1.92h-1.87v.82h1.87v1.91h.89z",
				fill: "#00182E"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/AmericanFootball.tsx
function a(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M18.574 4.241a1.5 1.5 0 011.128 1.03l.03.113a12.046 12.046 0 01-3.277 11.07A12.025 12.025 0 017.925 20c-.842 0-1.693-.089-2.54-.269a1.503 1.503 0 01-1.144-1.157A12.14 12.14 0 017.567 7.567 12.145 12.145 0 0118.574 4.24zM5.085 14.789a11.173 11.173 0 00.137 3.587c.037.183.19.338.373.376 1.211.26 2.434.313 3.624.172L5.085 14.79zm8.505-9.488a11.14 11.14 0 00-5.315 2.974A11.152 11.152 0 005.3 13.59l5.122 5.125a11.069 11.069 0 005.325-2.967 11.057 11.057 0 002.965-5.325L13.59 5.301zm-.737 3.847l.645.645.647-.646a.5.5 0 01.707.707l-.647.646.646.646a.499.499 0 11-.706.707l-.647-.646-.793.793.647.647a.5.5 0 01-.257.844L13 13.5a.5.5 0 01-.353-.147L12 12.706l-.793.793.646.647a.499.499 0 11-.705.707l-.648-.647-.645.647a.5.5 0 01-.258.136l-.095.01a.5.5 0 01-.354-.853l.645-.647-.645-.646a.5.5 0 01.707-.707l.645.646.791-.792-.645-.645a.5.5 0 01.707-.707l.645.645.793-.792-.645-.645a.5.5 0 01.707-.707zM16.16 5c-.46 0-.918.028-1.371.085l4.134 4.135c.14-1.191.088-2.415-.17-3.628a.496.496 0 00-.377-.371A11.245 11.245 0 0016.16 5z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Arrow.tsx
function o(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M13.413 7.66L9.636 3.255c-.164-.23-.504-.23-.713-.041a.516.516 0 00-.042.72l3.045 3.548H2.965A.51.51 0 002.462 8a.51.51 0 00.503.518h8.96l-3.044 3.547c-.2.198-.143.539.066.727.209.188.525.175.69-.047l3.776-4.405a.52.52 0 00.125-.34.657.657 0 00-.125-.34z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/ArrowRight.tsx
function s(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M13.413 7.66L9.636 3.255c-.164-.23-.504-.23-.713-.041a.516.516 0 00-.042.72l3.045 3.548H2.965A.51.51 0 002.462 8a.51.51 0 00.503.518h8.96l-3.044 3.547c-.2.198-.143.539.066.727.209.188.525.175.69-.047l3.776-4.405a.52.52 0 00.125-.34.657.657 0 00-.125-.34z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/ArrowTopRight.tsx
function c(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "9",
		viewBox: "0 0 10 9",
		width: "10",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M8.75336 1.5217L3.41448 0.201025C3.16066 0.11407 2.89899 0.301608 2.8413 0.561945C2.78361 0.822281 2.95543 1.08918 3.20605 1.14165L7.50785 2.2027L0.592779 7.13517C0.3782 7.28823 0.331935 7.59137 0.489484 7.81224C0.647034 8.03312 0.94872 8.08807 1.1633 7.93501L8.07837 3.00254L7.68108 7.4154C7.63621 7.67863 7.86704 7.91053 8.13198 7.94074C8.39691 7.97094 8.63343 7.78661 8.63832 7.52457L9.12777 2.04659C9.14371 1.90419 9.09135 1.79935 9.0377 1.71486C8.96971 1.63496 8.85407 1.54602 8.75336 1.5217Z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Athletics.tsx
function l(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 14 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M13.847 3.13a.452.452 0 00.036-.085v-.023a.49.49 0 00.013-.101v-.017a.457.457 0 00-.015-.09v-.026a.532.532 0 00-.046-.1L12.149.192a.422.422 0 00-.352-.19H2.084a.42.42 0 00-.071 0h-.03a.332.332 0 00-.059.024l-.03.014H1.88c-.016.01-.03.022-.044.034l-.02.015a.392.392 0 00-.062.072L.067 2.657a.422.422 0 000 .458l4.426 7.204a3.373 3.373 0 104.916 0l4.426-7.204.012.014zM8.188 9.512l-.744-1.207 3.044-4.932v-.021h2.24l-3.977 6.45a3.222 3.222 0 00-.563-.29zm-3.794-6.17H9.51L6.949 7.5 4.394 3.342zm8.298-.844H3.874L2.856.845h8.717l1.12 1.654zM2.084 1.201l4.52 7.347.45.727H6.95c-.639 0-1.264.184-1.802.527l-4.23-6.87L2.084 1.2zM6.95 15.177a2.53 2.53 0 110-5.06 2.53 2.53 0 010 5.06z",
			fill: "#00182E",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/AussieRules.tsx
function u(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M18.574 4.241a1.5 1.5 0 011.128 1.03l.03.113a12.046 12.046 0 01-3.277 11.07A12.025 12.025 0 017.925 20c-.842 0-1.693-.089-2.54-.269a1.503 1.503 0 01-1.144-1.157A12.14 12.14 0 017.567 7.567 12.145 12.145 0 0118.574 4.24zM5.085 14.789a11.173 11.173 0 00.137 3.587c.037.183.19.338.373.376 1.211.26 2.434.313 3.624.172L5.085 14.79zm8.505-9.488a11.14 11.14 0 00-5.315 2.974A11.152 11.152 0 005.3 13.59l5.122 5.125a11.069 11.069 0 005.325-2.967 11.057 11.057 0 002.965-5.325L13.59 5.301zm-.737 3.847l.645.645.647-.646a.5.5 0 01.707.707l-.647.646.646.646a.499.499 0 11-.706.707l-.647-.646-.793.793.647.647a.5.5 0 01-.257.844L13 13.5a.5.5 0 01-.353-.147L12 12.706l-.793.793.646.647a.499.499 0 11-.705.707l-.648-.647-.645.647a.5.5 0 01-.258.136l-.095.01a.5.5 0 01-.354-.853l.645-.647-.645-.646a.5.5 0 01.707-.707l.645.646.791-.792-.645-.645a.5.5 0 01.707-.707l.645.645.793-.792-.645-.645a.5.5 0 01.707-.707zM16.16 5c-.46 0-.918.028-1.371.085l4.134 4.135c.14-1.191.088-2.415-.17-3.628a.496.496 0 00-.377-.371A11.245 11.245 0 0016.16 5z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Awards.tsx
function d(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.744 6.23h-1.231v-.82a.41.41 0 00-.41-.41H7.897a.41.41 0 00-.41.41v.82h-1.23a2.258 2.258 0 00-.001 4.515.41.41 0 100-.82 1.436 1.436 0 010-2.873h1.231v3.487c0 2.018 1.34 3.79 3.282 4.341v1.403h-.947a.41.41 0 00-.347.193l-.9 1.436a.406.406 0 000 .41c.068.13.201.213.348.217h6.154a.409.409 0 00.359-.615l-.9-1.436a.411.411 0 00-.358-.205h-.947V14.88a4.514 4.514 0 003.282-4.34V7.05h1.23a1.435 1.435 0 11.001 2.872.41.41 0 100 .82 2.256 2.256 0 100-4.51zm-3.408 11.488H9.664l.385-.615h3.898l.39.615zm-1.926-1.436h-.82v-1.25c.135 0 .273.02.41.02.137 0 .275 0 .41-.02v1.25zm3.282-5.744a3.692 3.692 0 11-7.384 0V5.821h7.384v4.717z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/AzMenu.tsx
function f(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 20 12",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M6.042 0l2.847 12H6.337l-.66-2.76h-2.83L2.222 12H0L3.003 0h3.039zM19.95 0v2.04l-4.799 7.611H20V12h-8.148V9.994L16.65 2.35h-4.766V0h8.065zM4.236 3.154L3.16 7.817h2.205L4.236 3.154z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Baseball.tsx
function p(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.5 4a2.503 2.503 0 011.538 4.472L7.58 17.892c.084.189.128.395.128.609 0 .401-.157.777-.44 1.061-.283.282-.66.438-1.06.438-.35 0-.682-.12-.95-.339l-.111-.1-.707-.707c-.284-.284-.44-.661-.44-1.062s.157-.777.44-1.061c.432-.43 1.111-.533 1.66-.305L15.528 4.96a.268.268 0 01.035-.048A2.502 2.502 0 0117.5 4zM5.147 17.44a.494.494 0 000 .706l.707.708a.51.51 0 00.707 0 .496.496 0 000-.707l-.707-.707a.512.512 0 00-.707 0zm3.296-2.289L6.88 17.052l.067.067 1.901-1.563-.405-.405zM17.5 5c-.436 0-.844.184-1.129.507l-.031.042-7.259 8.826.543.543 8.827-7.258.042-.031A1.502 1.502 0 0017.5 5zM6 4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Baseball2.tsx
function m(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 16",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" }), /* @__PURE__ */ e("path", {
				d: "M13.5 0a2.503 2.503 0 011.538 4.472L3.58 13.892c.084.189.128.395.128.609 0 .401-.157.777-.44 1.061-.283.282-.66.438-1.06.438-.35 0-.682-.12-.95-.339l-.111-.1-.707-.707C.156 14.57 0 14.193 0 13.792s.157-.777.44-1.061c.432-.43 1.111-.533 1.66-.305L11.528.96a.268.268 0 01.035-.048A2.502 2.502 0 0113.5 0zM1.147 13.44a.494.494 0 000 .706l.707.708a.51.51 0 00.707 0 .496.496 0 000-.707l-.707-.707a.512.512 0 00-.707 0zm3.296-2.289L2.88 13.052l.067.067 1.901-1.563-.405-.405zM13.5 1c-.436 0-.844.184-1.129.507l-.031.042-7.259 8.826.543.543 8.827-7.258.042-.031A1.502 1.502 0 0013.5 1zM2 0c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z",
				fill: "#00182E"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Baseball3.tsx
function h(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.5 4a2.503 2.503 0 011.538 4.472L7.58 17.892c.084.189.128.395.128.609 0 .401-.157.777-.44 1.061-.283.282-.66.438-1.06.438-.35 0-.682-.12-.95-.339l-.111-.1-.707-.707c-.284-.284-.44-.661-.44-1.062s.157-.777.44-1.061c.432-.43 1.111-.533 1.66-.305L15.528 4.96a.268.268 0 01.035-.048A2.502 2.502 0 0117.5 4zM5.147 17.44a.494.494 0 000 .706l.707.708a.51.51 0 00.707 0 .496.496 0 000-.707l-.707-.707a.512.512 0 00-.707 0zm3.296-2.289L6.88 17.052l.067.067 1.901-1.563-.405-.405zM17.5 5c-.436 0-.844.184-1.129.507l-.031.042-7.259 8.826.543.543 8.827-7.258.042-.031A1.502 1.502 0 0017.5 5zM6 4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z",
				fill: "#00182E"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Basketball.tsx
function g(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.656 6.34A7.956 7.956 0 0120 12a7.95 7.95 0 01-2.344 5.66A7.974 7.974 0 0112 20a7.97 7.97 0 01-5.657-2.34A7.953 7.953 0 014 12c0-2.059.771-3.999 2.178-5.489l.165-.17c3.118-3.12 8.194-3.122 11.313 0zm-8.142 8.853l-2.099 2.101a6.975 6.975 0 004.089 1.69 8.707 8.707 0 00-1.99-3.79zm2.485-2.486l-1.776 1.777a9.738 9.738 0 012.308 4.496 6.975 6.975 0 004.052-1.685l-4.584-4.588zm2.484-2.484L12.707 12l4.584 4.587a6.944 6.944 0 001.69-4.055 9.734 9.734 0 01-4.497-2.309zm-9.465 2.272l.013.173a6.942 6.942 0 001.678 3.918l2.099-2.1a8.72 8.72 0 00-3.79-1.991zm.013-1.163l-.01.136a9.709 9.709 0 014.496 2.31L11.292 12 6.709 7.414a6.957 6.957 0 00-1.678 3.918zM17.29 7.414l-2.098 2.1a8.752 8.752 0 003.791 1.992 6.941 6.941 0 00-1.693-4.092zM11.47 5.02l-.14.011a6.976 6.976 0 00-3.913 1.676L12 11.293l1.777-1.778a9.714 9.714 0 01-2.306-4.494h-.002zm1.027-.003l.042.17a8.734 8.734 0 001.947 3.618l2.098-2.099a6.968 6.968 0 00-4.086-1.689h-.001z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Betslip.tsx
function _(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 20",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M14.197 0C15.193 0 16 .823 16 1.838v14.999a.46.46 0 01-.248.413l-.18.046a.45.45 0 01-.316-.115l-1.735-1.63-.225.206v3.767a.461.461 0 01-.27.414l-.18.045a.441.441 0 01-.316-.114l-1.713-1.631-1.78 1.63a.444.444 0 01-.609 0l-1.78-1.63-1.78 1.63a.444.444 0 01-.609 0l-1.758-1.63-1.735 1.63a.442.442 0 01-.487.097.459.459 0 01-.279-.418V4.548C0 3.533.807 2.71 1.803 2.71h.901v-.872C2.704.823 3.511 0 4.507 0zm-2.704 3.606h-9.69a.911.911 0 00-.902.919V18.49l1.285-1.194a.445.445 0 01.608 0l1.78 1.63 1.78-1.63a.448.448 0 01.61 0l1.78 1.63 1.78-1.63a.445.445 0 01.608 0l1.262 1.194V4.525a.91.91 0 00-.901-.919zM14.175.92h-9.69a.91.91 0 00-.902.919v.85h7.887c.996 0 1.803.822 1.803 1.837v9.992a.444.444 0 01.541.069L15.1 15.78l-.023-13.942a.911.911 0 00-.901-.92zM9.583 13c.23 0 .417.224.417.5s-.187.5-.417.5H4.417c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zm0-3c.23 0 .417.224.417.5s-.187.5-.417.5H4.417c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zm-2.06-3c.264 0 .477.224.477.5s-.213.5-.476.5H4.476C4.213 8 4 7.776 4 7.5s.213-.5.476-.5z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Boxing.tsx
function v(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M15.92 4a4.13 4.13 0 013.015 1.303 3.96 3.96 0 011.048 3.063l-.665 7.179a.505.505 0 01-.508.455v3.5c0 .276-.229.5-.51.5H9.106a.505.505 0 01-.51-.5V16l-.071-.006-.034-.004-.044-.012-.039-.012-.025-.012a.518.518 0 01-.137-.088l-4.071-3.49A.494.494 0 014 12v-1.5C4 9.122 5.146 8 6.553 8h.854c0-.992.378-1.958 1.065-2.697A4.125 4.125 0 0111.486 4h4.433zm-4.25 12H9.618v3h8.17v-3h-6.116zm2.543 1c.282 0 .51.224.51.5s-.228.5-.51.5h-1.021c-.281 0-.51-.224-.51-.5s.229-.5.51-.5h1.022zM15.92 5h-4.433a3.05 3.05 0 00-2.26.977 2.972 2.972 0 00-.786 2.297l.015.141a.538.538 0 01.007.069L9.107 15h9.236l.622-6.725a2.962 2.962 0 00-.787-2.299A3.05 3.05 0 0015.92 5zM7.483 9h-.93c-.844 0-1.532.673-1.532 1.5v1.273l2.95 2.528L7.484 9z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/CanadaFlag.tsx
function y(n) {
	return /* @__PURE__ */ e("svg", {
		height: "32px",
		version: "1.1",
		viewBox: "0 0 32 32",
		width: "32px",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: /* @__PURE__ */ e("g", {
			fill: "none",
			fillRule: "evenodd",
			id: "Style-guide",
			stroke: "none",
			strokeWidth: "1",
			children: /* @__PURE__ */ e("g", {
				fillRule: "nonzero",
				id: "11-Country-flags-1",
				transform: "translate(-165.000000, -444.000000)",
				children: /* @__PURE__ */ t("g", {
					id: "canada",
					transform: "translate(165.000000, 444.000000)",
					children: [/* @__PURE__ */ e("circle", {
						cx: "16",
						cy: "16",
						fill: "#F0F0F0",
						id: "Oval",
						r: "16"
					}), /* @__PURE__ */ t("g", {
						fill: "#D80027",
						id: "Group",
						transform: "translate(0.000000, 1.562500)",
						children: [
							/* @__PURE__ */ e("path", {
								d: "M32,14.4375 C32,8.094125 28.3084375,2.613125 22.9565,0.025125 L22.9565,28.8498125 C28.3084375,26.261875 32,20.780875 32,14.4375 Z",
								id: "Shape"
							}),
							/* @__PURE__ */ e("path", {
								d: "M0,14.4375 C0,20.780875 3.6915625,26.261875 9.0435,28.849875 L9.0435,0.025125 C3.6915625,2.613125 0,8.094125 0,14.4375 Z",
								id: "Shape"
							}),
							/* @__PURE__ */ e("polygon", {
								id: "Shape",
								points: "18.782625 16.5244375 21.5651875 15.133125 20.1739375 14.4375 20.1739375 13.0461875 17.3913125 14.4375 18.782625 11.654875 17.3913125 11.654875 16 9.5679375 14.6086875 11.654875 13.217375 11.654875 14.6086875 14.4375 11.8260625 13.0461875 11.8260625 14.4375 10.4348125 15.133125 13.217375 16.5244375 12.52175 17.91575 15.304375 17.91575 15.304375 20.0026875 16.695625 20.0026875 16.695625 17.91575 19.47825 17.91575"
							})
						]
					})]
				})
			})
		})
	});
}
//#endregion
//#region primitives/icon/icons/Casino.tsx
function b(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "20",
		viewBox: "0 0 16 20",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M8.00979 0C8.3418 0 8.66381 0.09 8.93581 0.27L8.96581 0.29C9.01681 0.32 9.05682 0.35 9.10782 0.39C10.4078 1.257 12.2909 2.824 13.5909 4.391C14.6889 5.719 16.141 7.764 15.989 10.299C15.909 11.707 15.334 13.004 14.3869 13.952C13.3699 14.97 12.0089 15.479 10.5579 15.399C9.92742 15.3594 9.31285 15.1848 8.75581 14.887L8.75481 18.502L12.3319 18.503C12.7449 18.503 13.0869 18.843 13.0869 19.251C13.0869 19.661 12.7449 20 12.3319 20H3.67669C3.26368 20 2.92067 19.66 2.92067 19.251C2.92067 18.842 3.26368 18.503 3.67669 18.503L7.24277 18.502V14.881C6.67966 15.1834 6.0577 15.3601 5.41973 15.399C5.33973 15.399 5.23873 15.409 5.13772 15.409C3.79769 15.409 2.55766 14.9 1.61164 13.952C0.664618 13.004 0.089605 11.707 0.00960317 10.31V10.3C-0.1314 7.765 1.30963 5.72 2.40766 4.392C3.70769 2.824 5.58973 1.257 6.88976 0.39C6.93977 0.35 6.97977 0.32 7.03077 0.29L7.06077 0.27C7.34377 0.09 7.66678 0 7.99979 0H8.00979ZM8.01979 1.497H7.99979C7.95583 1.49656 7.91295 1.51062 7.87779 1.537L7.85779 1.557L7.82779 1.577C7.80779 1.597 7.78779 1.607 7.76779 1.627C6.59776 2.405 4.78472 3.902 3.57569 5.349C2.63866 6.467 1.40964 8.204 1.52064 10.209C1.58064 11.257 1.99365 12.206 2.68967 12.894C3.03615 13.244 3.45401 13.5152 3.91477 13.6892C4.37554 13.8631 4.86838 13.9357 5.35973 13.902C6.07675 13.863 6.77576 13.53 7.43678 12.911C7.50666 12.8306 7.59301 12.7661 7.68997 12.7219C7.78693 12.6778 7.89224 12.6549 7.99879 12.655H8.00879C8.03179 12.655 8.05379 12.655 8.07679 12.658L7.99879 12.655C8.09717 12.653 8.19499 12.6704 8.28662 12.7063C8.37826 12.7422 8.46192 12.7958 8.5328 12.864C9.20782 13.513 9.92284 13.862 10.6589 13.902C11.1502 13.9355 11.643 13.8628 12.1037 13.6889C12.5644 13.5149 12.9823 13.2438 13.3289 12.894C14.0239 12.206 14.4369 11.248 14.4979 10.21C14.6079 8.204 13.3799 6.467 12.4429 5.34C11.2329 3.892 9.41982 2.395 8.2508 1.617C8.22844 1.60339 8.20822 1.58654 8.1908 1.567C8.1808 1.557 8.1708 1.547 8.1608 1.547L8.13079 1.527C8.09741 1.50662 8.0589 1.49621 8.01979 1.497Z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Checkmark.tsx
function x(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 20 20",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("circle", {
				cx: 10,
				cy: 10,
				fill: "currentColor",
				r: 10
			}), /* @__PURE__ */ e("path", {
				d: "M16.197 5.68a1.05 1.05 0 00-1.44.025l-6.453 6.51-2.207-2.206a.953.953 0 00-1.384.036l-.033.036a1.039 1.039 0 00.03 1.432l2.883 2.797a1.02 1.02 0 001.42-.014l7.252-7.2a.95.95 0 00-.032-1.383l-.036-.033z",
				fill: n.fill ? n.fill : "#00182E"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/ChevronsDown.tsx
function S(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 16",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M16 16H0V0h16z" }), /* @__PURE__ */ e("path", {
				d: "M7.306 12.776L.616 6.333A.822.822 0 01.593 5.17l.022-.022a.89.89 0 011.231 0L8 11.074l6.154-5.926a.888.888 0 011.23 0 .822.822 0 01.023 1.163l-.022.022-6.691 6.443a1 1 0 01-1.388 0z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/ChevronsLeft.tsx
function C(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 9 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M.78 7.306L7.221.616A.822.822 0 018.384.593l.022.022a.887.887 0 010 1.231L2.481 8l5.926 6.154a.886.886 0 010 1.23.822.822 0 01-1.163.023l-.022-.022L.78 8.694a1 1 0 010-1.388z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/ChevronsRight.tsx
function w(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 9 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M8.22 8.694l-6.442 6.69a.822.822 0 01-1.163.023l-.022-.022a.887.887 0 010-1.231L6.519 8 .593 1.846a.886.886 0 010-1.23.821.821 0 011.163-.024l.022.022L8.22 7.306a1 1 0 010 1.388z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/ChevronsUp.tsx
function T(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 16",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" }), /* @__PURE__ */ e("path", {
				d: "M8.694 3.224l6.69 6.443a.822.822 0 01.023 1.163l-.022.022a.89.89 0 01-1.231 0L8 4.926l-6.154 5.926a.888.888 0 01-1.23 0 .822.822 0 01-.023-1.163l.022-.022 6.691-6.443a1 1 0 011.388 0z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/CircleCheckIcon.tsx
function E(n) {
	return /* @__PURE__ */ t("svg", {
		...n,
		fill: "none",
		height: "22",
		viewBox: "0 0 22 22",
		width: "22",
		xmlns: "http://www.w3.org/2000/svg",
		children: [/* @__PURE__ */ e("circle", {
			cx: "11",
			cy: "11",
			fill: "#00E889",
			r: "11"
		}), /* @__PURE__ */ e("path", {
			d: "M15.538 6L17.1748 7.67813L9.18828 15.473L5 11.4736L6.61906 9.77859L9.17047 12.2152L15.538 6Z",
			fill: "#022E4A"
		})]
	});
}
//#endregion
//#region primitives/icon/icons/Clickout.tsx
function D(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M19.778 19.778H4.222V4.222h6.667a1.11 1.11 0 100-2.222H4.222C2.99 2 2 3 2 4.222v15.556C2 21 2.989 22 4.222 22h15.556C21 22 22 21 22 19.778V13.11a1.11 1.11 0 10-2.222 0v6.667zM14.222 3.11c0 .614.498 1.111 1.111 1.111h2.878L8.072 14.362a1.108 1.108 0 001.567 1.566l10.139-10.14v2.879a1.11 1.11 0 002.222 0V4a2 2 0 00-2-2h-4.667a1.11 1.11 0 00-1.11 1.111z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/ClockDate.tsx
function O(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 14 14",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", {
				d: "M7.0000091,0 C3.15791821,0 0.0313584162,3.12666667 0.000248368492,6.95333333 C-0.0153066554,8.82 0.700224442,10.5933333 2.02240147,11.9155556 C3.32902347,13.2533333 5.08674117,13.9844444 6.95334403,14 C6.95334403,14 7.0000091,14 7.0000091,14 C10.8421,14 13.9686598,10.8733333 13.9997698,7.04666667 C14.0308799,3.18888889 10.9043201,0.0311111111 7.0000091,0 Z M7.0000091,13.0511111 L6.95334403,13.0511111 C5.33562155,13.0355556 3.82678424,12.3977778 2.67571247,11.2466667 C1.55575075,10.1111111 0.9335498,8.58666667 0.949104824,6.96888889 C0.964659847,3.65555556 3.68678902,0.948888889 7.04667417,0.948888889 C10.3910043,0.964444444 13.0820234,3.70222222 13.0664684,7.04666667 C13.0353584,10.36 10.3132292,13.0511111 7.0000091,13.0511111 Z",
				fill: "currentColor",
				fillRule: "nonzero"
			}), /* @__PURE__ */ e("path", {
				d: "M9.57664234,7.99421965 L6.84671533,7.99421965 L6.84671533,3.50289017 C6.84671533,3.22543353 6.65693431,3 6.42335766,3 C6.18978102,3 6,3.22543353 6,3.50289017 L6,8.49710983 C6,8.77456647 6.18978102,9 6.42335766,9 L9.57664234,9 C9.81021898,9 10,8.77456647 10,8.49710983 C10,8.21965318 9.81021898,7.99421965 9.57664234,7.99421965 Z",
				fill: "currentColor",
				fillRule: "nonzero"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Close.tsx
function k(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M12 10.545l5.818-5.818a1.03 1.03 0 011.455 0 1.03 1.03 0 010 1.455L13.455 12l5.818 5.818a1.03 1.03 0 010 1.455 1.03 1.03 0 01-1.455 0L12 13.455l-5.818 5.818a1.03 1.03 0 01-1.455 0 1.03 1.03 0 010-1.455L10.545 12 4.727 6.182a1.03 1.03 0 010-1.455 1.03 1.03 0 011.455 0L12 10.545z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Closed.tsx
function A(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M8 6.545L13.818.727a1.03 1.03 0 011.455 0 1.03 1.03 0 010 1.455L9.455 8l5.818 5.818a1.03 1.03 0 010 1.455 1.03 1.03 0 01-1.455 0L8 9.455l-5.818 5.818a1.03 1.03 0 01-1.455 0 1.03 1.03 0 010-1.455L6.545 8 .727 2.182a1.03 1.03 0 010-1.455 1.03 1.03 0 011.455 0L8 6.545z",
			fill: "#00182E",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Cog.tsx
function j(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 48 46",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M23.5 14c4.701 0 8.5 3.799 8.5 8.5 0 4.701-3.799 8.5-8.5 8.5a8.492 8.492 0 01-8.5-8.5c0-4.701 3.799-8.5 8.5-8.5m0-1c-5.24 0-9.5 4.26-9.5 9.5s4.26 9.5 9.5 9.5 9.5-4.26 9.5-9.5-4.26-9.5-9.5-9.5m7.828-11c.271.008.575.088.889.27l5.566 3.229c.838.485 1.003 1.222.805 1.85l-1.543 4.927a.541.541 0 00.101.489 16.673 16.673 0 012.264 3.952.535.535 0 00.385.32l5.014 1.11c.642.142 1.191.661 1.191 1.63v6.46c0 .97-.549 1.47-1.19 1.614l-5.015 1.11a.537.537 0 00-.385.336 16.57 16.57 0 01-2.264 3.936.54.54 0 00-.1.488l1.542 4.928c.198.627.033 1.365-.805 1.85l-5.566 3.229c-.838.485-1.553.266-1.996-.219l-3.488-3.818a.536.536 0 00-.47-.168c-.742.102-1.502.168-2.263.168-.761 0-1.52-.066-2.264-.168a.536.536 0 00-.47.168L17.78 43.51c-.443.485-1.158.704-1.996.219l-5.566-3.23c-.838-.484-1.003-1.222-.805-1.85l1.543-4.927a.54.54 0 00-.101-.488 16.588 16.588 0 01-2.264-3.936.538.538 0 00-.385-.336L3.19 27.85C2.549 27.708 2 27.206 2 26.236v-6.458c0-.97.549-1.489 1.19-1.631l5.015-1.11a.536.536 0 00.385-.32 16.691 16.691 0 012.264-3.952.541.541 0 00.1-.489L9.413 7.35c-.198-.628-.034-1.365.805-1.85l5.566-3.23c.315-.181.622-.246.89-.252.449-.008.828.167 1.106.471l3.488 3.818c.12.13.295.193.47.168A16.82 16.82 0 0124 6.323c.761 0 1.52.05 2.264.151a.536.536 0 00.47-.168l3.487-3.818c.277-.303.654-.5 1.107-.487M16.662 1a2.87 2.87 0 00-1.387.402l-5.55 3.221c-1.217.706-1.641 2.011-1.303 3.087l1.47 4.68A17.771 17.771 0 007.77 16.05l-4.747 1.057C1.926 17.351 1 18.378 1 19.79v6.442c0 1.412.926 2.423 2.022 2.668l4.747 1.057a17.675 17.675 0 002.123 3.657l-1.47 4.68c-.338 1.077.086 2.382 1.304 3.088l5.549 3.22c1.218.707 2.566.413 3.326-.418l3.31-3.624c.685.084 1.375.167 2.089.167.715 0 1.404-.083 2.09-.167l3.31 3.624c.76.83 2.107 1.125 3.325.419l5.55-3.221c1.217-.706 1.641-2.011 1.303-3.087l-1.47-4.68a17.65 17.65 0 002.123-3.658l4.747-1.057C46.074 28.655 47 27.644 47 26.232V19.79c0-1.412-.926-2.44-2.022-2.684l-4.747-1.057a17.771 17.771 0 00-2.123-3.657l1.47-4.68c.338-1.077-.086-2.382-1.304-3.088l-5.549-3.22c-1.218-.707-2.566-.413-3.326.418l-3.31 3.624A17.099 17.099 0 0024 5.296c-.714 0-1.404.066-2.09.15L18.6 1.822A2.565 2.565 0 0016.663 1",
			fillRule: "evenodd",
			stroke: "currentColor",
			strokeWidth: 1
		})
	});
}
//#endregion
//#region primitives/icon/icons/CopyLinkFlat.tsx
function M(t) {
	return /* @__PURE__ */ e("svg", {
		height: "50",
		viewBox: "-12 -12 50 50",
		width: "50",
		...t,
		children: /* @__PURE__ */ e("g", { children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M15.937 9.75343C15.9463 9.90868 15.9463 10.0731 15.9091 10.2283C15.9091 10.2374 15.8998 10.2466 15.8998 10.2466C15.8349 10.5205 15.6956 10.7763 15.4821 10.9954C14.8601 11.6073 13.8483 11.6073 13.2263 10.9954C12.5857 10.3653 11.6853 10.1279 10.8498 10.2831C10.6734 10.3196 10.5063 10.3653 10.3392 10.4292C10.0236 10.5571 9.7265 10.7489 9.46657 10.9954L6.97867 13.4521L3.96162 16.4201C2.93118 17.4338 2.93118 19.0959 3.96162 20.1096C4.96421 21.0959 6.70945 21.0959 7.71204 20.1096L10.005 17.8539C10.9705 18.5023 12.0566 18.9406 13.2077 19.1324L9.96787 22.3196C8.82603 23.4429 7.33143 24 5.83683 24C4.34223 24 2.84763 23.4429 1.70579 22.3196C-0.568598 20.0822 -0.568598 16.4292 1.70579 14.1918L7.21075 8.77626C8.35258 7.65297 9.84718 7.09589 11.3418 7.09589C12.8364 7.09589 14.331 7.65297 15.4728 8.77626C15.5935 8.89498 15.6863 9.03196 15.7606 9.17808C15.7699 9.19635 15.7884 9.22374 15.7977 9.24201C15.8627 9.38813 15.8998 9.53425 15.9184 9.68037C15.937 9.70776 15.937 9.73516 15.937 9.75343ZM24.2919 1.68037C23.1872 0.593607 21.7204 0 20.1608 0C18.6013 0 17.1345 0.593607 16.0298 1.68037L12.7807 4.87671C13.9132 5.06849 15.0087 5.49772 15.9834 6.15525L18.2764 3.89954C19.2789 2.91324 21.0242 2.91324 22.0268 3.89954C22.5281 4.39269 22.8066 5.05023 22.8066 5.74429C22.8066 6.43836 22.5281 7.09589 22.0268 7.58904L21.0149 8.58448L16.5311 13.0046C15.5285 13.9909 13.7833 13.9909 12.7807 13.0046C12.1587 12.3927 11.1468 12.3927 10.5249 13.0046C9.90288 13.6164 9.90288 14.6119 10.5249 15.2237C11.6296 16.3105 13.0963 16.9041 14.6559 16.9041C16.2155 16.9041 17.6822 16.3105 18.7869 15.2237L23.28 10.8037L24.2919 9.80822C25.3966 8.72146 26 7.27854 26 5.74429C26 4.21005 25.3966 2.76712 24.2919 1.68037Z",
			fill: "currentColor",
			fillRule: "evenodd"
		}) })
	});
}
//#endregion
//#region primitives/icon/icons/Cycling.tsx
function N(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.196 10.998c-.377 0-.75.076-1.096.224a7.19 7.19 0 01-.303-1.823v-1.6h1.649a.601.601 0 010 1.2.4.4 0 100 .8A1.4 1.4 0 0017.445 7h-2.048a.4.4 0 00-.4.4v1.599H9.8v-1.2h1.4A.399.399 0 1011.199 7H8.001a.4.4 0 000 .8h1v1.489l-1.136 1.92a2.799 2.799 0 101.703 2.987h3.23a.438.438 0 00.114-.018l.034-.014a.376.376 0 00.076-.042s.012 0 .018-.01l.022-.02.022-.02a.523.523 0 00.05-.064l1.985-3.358c.07.341.163.678.278 1.007a2.8 2.8 0 101.799-.659zm-7.752-.888l2.54 3.286H9.569a2.798 2.798 0 00-1.015-1.779l.891-1.507zm-2.642 5.685a2 2 0 110-3.998c.222 0 .442.038.651.112l-1 1.683a.401.401 0 10.689.4l.999-1.683a2 2 0 01-1.34 3.486zm5.952-2.71l-2.54-3.287h4.483l-1.943 3.286zm4.442 2.71a1.998 1.998 0 01-1.477-3.34c.29.621.703 1.18 1.21 1.64a.399.399 0 00.667-.323.403.403 0 00-.134-.276 4.422 4.422 0 01-1.082-1.523 2 2 0 11.815 3.822z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Darts.tsx
function P(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M19.973 6.854a.507.507 0 00-.323-.355l-1.68-.485-.484-1.68a.414.414 0 00-.355-.322c-.162-.033-.356 0-.453.129L14.32 6.499c-.129.13-.161.29-.129.484l.485 1.648-.614.614c-.323-.194-.678-.323-1.066-.323-.55 0-1.034.193-1.421.581l-4.749 4.748a1.965 1.965 0 00-.258 2.488L4.145 19.16a.47.47 0 000 .679.49.49 0 00.356.129.486.486 0 00.355-.13l2.423-2.422c.323.194.678.323 1.066.323.549 0 1.033-.194 1.42-.582l4.75-4.748a1.964 1.964 0 00.258-2.487l.613-.614 1.68.485c.032 0 .097.032.13.032a.678.678 0 00.355-.13l2.358-2.357c.064-.162.129-.323.064-.485zm-6.17 4.878L9.056 16.48c-.387.388-1.066.388-1.486 0l-.064-.064a1.034 1.034 0 010-1.486l4.747-4.75c.194-.194.452-.29.743-.29.29 0 .55.096.743.29l.065.065c.387.42.387 1.098 0 1.486zm3.198-2.94l-.872-.258.679-.678a.47.47 0 000-.679.469.469 0 00-.679 0l-.678.679-.258-.873 1.582-1.582.323 1.13c.033.162.162.29.323.323l1.131.323-1.55 1.615z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Delete.tsx
function F(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 15 20",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M1.071 17.778C1.071 19 2.036 20 3.214 20h8.572c1.178 0 2.143-1 2.143-2.222V4.444H1.07v13.334zM15 1.11h-3.75L10.179 0H4.82L3.75 1.111H0v2.222h15V1.111z",
			fill: "#00182E",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Dollar.tsx
function I(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 20 20",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("circle", {
				cx: 10,
				cy: 10,
				fill: "#00182E",
				r: 10
			}), /* @__PURE__ */ e("path", {
				d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm-4.306-5.88l.492-1.094a.545.545 0 01.314-.289.52.52 0 01.424.036c.749.4 1.755.638 2.689.638 1.098 0 1.897-.449 1.897-1.066 0-.4-.232-.88-1.94-1.437-1.85-.581-3.738-1.43-3.738-3.335 0-1.444 1.052-2.574 2.814-3.02l.268-.068V3.29c0-.292.242-.531.535-.531h1.266c.296 0 .535.239.535.531v1.074l.313.039c.753.089 1.42.274 2.033.563a.528.528 0 01.275.304.516.516 0 01-.018.406l-.51 1.08a.541.541 0 01-.485.307.54.54 0 01-.221-.05c-.332-.153-1.11-.506-2.35-.506-1.128 0-1.63.435-1.63.87 0 .485.524.813 2.164 1.355 1.748.57 3.53 1.43 3.53 3.499 0 1.116-.773 2.618-2.956 3.167l-.267.07v1.238a.536.536 0 01-.535.535H9.305a.534.534 0 01-.535-.535v-1.134l-.317-.032c-.984-.11-1.911-.378-2.536-.738a.531.531 0 01-.223-.681z",
				fill: "#1ED560"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Down.tsx
function L(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M20 20H4V4h16z" }), /* @__PURE__ */ e("path", {
				d: "M11.306 16.776l-6.69-6.443a.822.822 0 01-.023-1.163l.022-.022a.89.89 0 011.231 0L12 15.074l6.154-5.926a.888.888 0 011.23 0 .822.822 0 01.023 1.163l-.022.022-6.691 6.443a1 1 0 01-1.388 0z",
				fill: "#00182E"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/ESports.tsx
function R(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.744 6.23h-1.231v-.82a.41.41 0 00-.41-.41H7.897a.41.41 0 00-.41.41v.82h-1.23a2.258 2.258 0 00-.001 4.515.41.41 0 100-.82 1.436 1.436 0 010-2.873h1.231v3.487c0 2.018 1.34 3.79 3.282 4.341v1.403h-.947a.41.41 0 00-.347.193l-.9 1.436a.406.406 0 000 .41c.068.13.201.213.348.217h6.154a.409.409 0 00.359-.615l-.9-1.436a.411.411 0 00-.358-.205h-.947V14.88a4.514 4.514 0 003.282-4.34V7.05h1.23a1.435 1.435 0 11.001 2.872.41.41 0 100 .82 2.256 2.256 0 100-4.51zm-3.408 11.488H9.664l.385-.615h3.898l.39.615zm-1.926-1.436h-.82v-1.25c.135 0 .273.02.41.02.137 0 .275 0 .41-.02v1.25zm3.282-5.744a3.692 3.692 0 11-7.384 0V5.821h7.384v4.717z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/ErrorCircle.tsx
function z(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 20 20",
		width: "1em",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M17.075 17.075A9.974 9.974 0 0020 10a9.976 9.976 0 00-2.925-7.075A9.974 9.974 0 0010 0a9.976 9.976 0 00-7.075 2.925A9.974 9.974 0 000 10a9.976 9.976 0 002.925 7.075A9.974 9.974 0 0010 20a9.976 9.976 0 007.075-2.925zm-5.722-3.218c0-.75-.603-1.352-1.353-1.352s-1.371.603-1.371 1.352c0 .75.621 1.372 1.371 1.372s1.353-.622 1.353-1.372zM10 11.133c-.494 0-.86-.402-.914-.914l-.457-4.076C8.556 5.43 9.305 4.77 10 4.77s1.444.659 1.353 1.372l-.439 4.076c-.055.512-.42.914-.914.914z",
			fill: "#9F1300",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Facebook.tsx
function B(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M20 40a20 20 0 110-40 20 20 0 010 40zm6.4-27.4V9h-3c-3 0-5 1.8-5 5.1V17H15v3.9h3.4v10h4v-10h3.8V17h-3.8v-2.5c0-1.1.3-1.9 1.9-1.9h2z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/FacebookFlat.tsx
function V(t) {
	return /* @__PURE__ */ e("svg", {
		height: "50",
		viewBox: "0 0 50 50",
		width: "50",
		...t,
		children: /* @__PURE__ */ e("g", { children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M32.9443 15.7872L30.3715 15.7881C28.3545 15.7881 27.9635 16.7469 27.9635 18.1535V21.2556H32.7745L32.7731 26.1147H27.9635V38.5828H22.9456V26.1147H18.75V21.2556H22.9456V17.6727C22.9456 13.5147 25.4854 11.25 29.1952 11.25L32.9443 11.256V15.7872Z",
			fill: "currentColor",
			fillRule: "evenodd"
		}) })
	});
}
//#endregion
//#region primitives/icon/icons/FacebookFooter.tsx
function H(n) {
	return /* @__PURE__ */ t("svg", {
		height: "1em",
		version: "1.1",
		viewBox: "0 0 40 40",
		width: "1em",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink",
		...n,
		children: [
			/* @__PURE__ */ e("title", { children: "icon_facebook-grey_40x40" }),
			/* @__PURE__ */ e("defs", {}),
			/* @__PURE__ */ e("g", {
				fill: "none",
				fillRule: "evenodd",
				id: "Full-pages",
				stroke: "none",
				strokeWidth: "1",
				children: /* @__PURE__ */ e("g", {
					fill: "currentColor",
					id: "1280px-and-wider-(popular-desktop)",
					transform: "translate(-828.000000, -2617.000000)",
					children: /* @__PURE__ */ e("g", {
						id: "Group-2",
						transform: "translate(-1.000000, 2304.000000)",
						children: /* @__PURE__ */ e("path", {
							d: "M849,353 C837.954305,353 829,344.045695 829,333 C829,321.954305 837.954305,313 849,313 C860.045695,313 869,321.954305 869,333 C869,344.045695 860.045695,353 849,353 Z M854.355469,325.629721 L854.355469,322.004762 L851.35616,322 C848.388353,322 846.356457,323.811747 846.356457,327.138166 L846.356457,330.004507 L843,330.004507 L843,333.89174 L846.356457,333.89174 L846.356457,343.866237 L850.370798,343.866237 L850.370798,333.89174 L854.218471,333.89174 L854.219569,330.004507 L850.370798,330.004507 L850.370798,327.522787 C850.370798,326.397497 850.683623,325.630453 852.297198,325.630453 L854.355469,325.629721 Z",
							id: "icon_facebook-grey_40x40"
						})
					})
				})
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/Filter.tsx
function U(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M8.699 5c-.94 0-1.739.634-1.997 1.504H4.564c-.329 0-.564.258-.564.587 0 .329.258.587.587.587h2.138c.235.87 1.058 1.504 1.997 1.504a2.1 2.1 0 002.021-1.504h8.67A.581.581 0 0020 7.091a.581.581 0 00-.587-.587h-8.67A2.15 2.15 0 008.699 5zm.023 1.175c.494 0 .917.4.917.916a.917.917 0 01-1.833 0c0-.517.423-.916.916-.916zm7.049 3.524c-.94 0-1.739.634-1.997 1.504H4.587A.567.567 0 004 11.79c0 .329.258.587.587.587h9.187c.235.87 1.057 1.504 1.997 1.504a2.1 2.1 0 002.02-1.504h1.622A.581.581 0 0020 11.79a.581.581 0 00-.587-.587H17.79a2.1 2.1 0 00-2.02-1.504zm.023 1.175c.494 0 .917.4.917.916a.917.917 0 01-1.833 0c0-.517.4-.916.916-.916zm-6.273 5.498a2.094 2.094 0 014.017 0h5.875c.329 0 .587.258.587.587a.581.581 0 01-.587.587h-5.85a2.101 2.101 0 01-2.021 1.504c-.94 0-1.762-.634-1.997-1.504H4.587A.581.581 0 014 16.959c0-.329.235-.587.587-.587h4.934zm2.937.587a.917.917 0 00-.916-.916c-.493 0-.893.399-.916.916a.917.917 0 001.832 0z",
			fill: "#00182E",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Football.tsx
function W(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm1.768 11.5h-3.533l-1.002 1.203.63 1.964a6.99 6.99 0 003.916.104l.974-2.105-.985-1.167zm3.374 1.245l-1.456.287-.572 1.237a7.036 7.036 0 002.028-1.524zm-8.5 1.396l-.343-1.07-1.19-.067c.456.445.971.828 1.533 1.137zm-1.914-7.3l-1.695 1.842a6.962 6.962 0 001.193 3.27l2.228.121.98-1.177-1.164-3.303-1.542-.754zm10.556 0l-1.54.754-1.177 3.301.967 1.146 2.498-.493a6.944 6.944 0 00.935-2.866l-1.683-1.843zm-5.276-1.417l-2.74 1.996 1.086 3.08h3.293l1.1-3.08-2.74-1.996zm-6.962 1.767l1.021-1.11-.282-1.3a6.937 6.937 0 00-.739 2.41zM18.224 8.8l-.278 1.284 1.007 1.098a6.944 6.944 0 00-.729-2.382zM14.57 5.49L12.508 6.6v1.95l2.885 2.104 1.572-.77.492-2.264a7.036 7.036 0 00-2.887-2.131zM6.555 7.606l.492 2.277 1.576.77 2.885-2.103V6.596L9.445 5.483a7.027 7.027 0 00-2.89 2.123zM12 5a6.99 6.99 0 00-1.165.097l1.175.635 1.174-.632c-.385-.066-.78-.1-1.184-.1z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/FreeBets.tsx
function G(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "18",
		viewBox: "0 0 18 18",
		width: "18",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M17.3874 3.68973H11.5493C12.1814 3.26152 12.5573 2.77672 12.6842 2.23286C12.809 1.60292 12.6044 0.952504 12.1424 0.510211C12.1277 0.497906 12.1106 0.488063 12.096 0.475758C12.0814 0.463454 12.0716 0.446227 12.0569 0.433922C11.5649 0.0201772 10.8959 -0.10822 10.2875 0.0943148C9.71634 0.303493 9.25017 0.803061 8.88651 1.60778C8.52041 0.803061 8.05668 0.303493 7.48556 0.0943148C6.87714 -0.10822 6.20814 0.0201772 5.71607 0.433922C5.70142 0.446227 5.68922 0.460993 5.67702 0.475758C5.66481 0.490524 5.64529 0.497906 5.63064 0.510211C5.16862 0.952504 4.96404 1.60292 5.08881 2.23286C5.21573 2.77672 5.59159 3.25906 6.22373 3.68973H0.610169C0.273182 3.68973 0 3.96517 0 4.30496V8.13169C0 8.47148 0.273182 8.74692 0.610169 8.74692H1.26671V17.3848C1.26671 17.7246 1.53989 18 1.87688 18H16.1231C16.4601 18 16.7333 17.7246 16.7333 17.3848V8.74692H17.3898C17.7268 8.74692 18 8.47148 18 8.13169V4.30496C18 4.14136 17.9354 3.9845 17.8204 3.86905C17.7055 3.7536 17.5496 3.68907 17.3874 3.68973ZM10.1337 4.92019V7.51646H7.55634V4.92019H10.1337ZM10.6975 1.24603C10.8968 1.19119 11.1101 1.23603 11.2711 1.36661L11.293 1.38138L11.3125 1.40353C11.4538 1.54747 11.5213 1.74903 11.4956 1.94985C11.4541 2.12458 11.1929 2.68813 9.60895 3.28613C10.0141 1.6447 10.5315 1.31001 10.6975 1.24603ZM7.07553 1.24603C7.24393 1.31001 7.75891 1.6447 8.16407 3.28859C6.59227 2.69059 6.3238 2.13442 6.27986 1.9597C6.24837 1.75345 6.31743 1.54455 6.46536 1.3986L6.48244 1.37892L6.50197 1.36661C6.6631 1.2364 6.87621 1.1916 7.07553 1.24603ZM1.2179 4.92019H6.336V7.51646H1.2301L1.2179 4.92019ZM2.49437 8.74692H6.336V16.7695H2.49437V8.74692ZM7.55634 16.7695V8.74692H10.1337V16.7695H7.55634ZM15.513 16.7695H11.3638V8.74692H15.513V16.7695ZM16.7772 7.51646H11.354V4.92019H16.7772V7.51646Z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Golf.tsx
function K(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M12.5 4C15.532 4 18 6.467 18 9.5a5.5 5.5 0 01-2.615 4.68.501.501 0 01.115.32v2a.5.5 0 01-.5.5h-1v2.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V17h-1a.5.5 0 01-.5-.5v-2c0-.121.043-.233.115-.32A5.5 5.5 0 017 9.5C7 6.467 9.467 4 12.5 4zm.5 13h-1v2h1v-2zm1.5-2h-4v1h4v-1zm-2-10C10.019 5 8 7.019 8 9.5s2.019 4.5 4.5 4.5S17 11.981 17 9.5 14.981 5 12.5 5zm-2.48 3a.5.5 0 010 1c-.276 0-.505-.224-.505-.5s.219-.5.495-.5h.01zm1.5-.5a.5.5 0 010 1c-.276 0-.505-.224-.505-.5s.219-.5.495-.5h.01zm-1-1a.5.5 0 010 1c-.276 0-.505-.224-.505-.5s.219-.5.495-.5h.01zm1.5-.5a.5.5 0 010 1c-.276 0-.505-.224-.505-.5s.219-.5.495-.5h.01z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Graph.tsx
function q(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 14",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M.617 0c.34 0 .616.276.616.617V12.69h14.121a.646.646 0 01.637.655.662.662 0 01-.662.654H.617A.627.627 0 010 13.355V.617C0 .277.276 0 .617 0zM14.8 1.309c.188-.072.377.09.377.286l-.12 3.048a.273.273 0 01-.446.215l-.822-.645-1.01 1.38a.677.677 0 01-.514.269l-2.639.018-1.353 2.724a.687.687 0 01-.6.359L4.986 8.89l-1.114 2.26c-.086.18-.309.25-.497.161l-.497-.269c-.171-.107-.24-.34-.154-.484l1.285-2.635a.668.668 0 01.6-.376l2.689.071L8.65 4.894c.103-.215.325-.377.565-.359l2.707-.036.822-1.111-.788-.61c-.171-.143-.137-.448.086-.52z",
			fill: "#00182E",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Guides.tsx
function J(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "17",
		viewBox: "0 0 19 17",
		width: "19",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M0.418313 17H18.5815C18.8117 17 19 16.7595 19 16.4654V2.13716C19 1.8431 18.8117 1.60257 18.5815 1.60257H17.7863V1.36203C17.7863 1.12148 17.6608 0.907611 17.4515 0.82744C16.8028 0.640227 11.1739 -0.936907 9.49985 0.82744C7.82578 -0.936907 2.1969 0.640227 1.54821 0.82744C1.35992 0.880956 1.21337 1.09483 1.21337 1.36203V1.60257H0.41847C0.188284 1.60257 0 1.84312 0 2.13716V16.4654C0 16.7595 0.188295 17 0.41847 17H0.418313ZM9.91843 1.7896C9.9393 1.76293 9.96032 1.73608 9.98119 1.70942C10.8181 0.586682 14.5638 1.12132 16.9493 1.76293V14.113C16.0077 13.8725 14.0616 13.4181 12.3458 13.4181C11.4042 13.4181 10.5462 13.5517 9.91838 13.8991L9.91843 1.7896ZM2.05049 1.7896C4.43598 1.14799 8.18162 0.586715 9.01864 1.73608C9.03951 1.76275 9.06053 1.7896 9.0814 1.81626V13.9525C7.3446 12.91 3.51526 13.7653 2.05048 14.1397L2.05049 1.7896ZM0.83682 2.67175H1.2134V14.7813C1.2134 14.9416 1.27617 15.102 1.38082 15.209C1.48548 15.3159 1.61101 15.3427 1.73654 15.3159C4.10114 14.6209 8.16062 13.9793 9.03949 15.1555C9.12313 15.2623 9.20691 15.3427 9.29055 15.4229H9.31142L9.33229 15.4496C9.35317 15.4496 9.37419 15.4762 9.39506 15.4762C9.41593 15.4762 9.41593 15.4762 9.43695 15.5029C9.47884 15.5029 9.52059 15.5295 9.54161 15.5295C9.56248 15.5295 9.62524 15.5295 9.64626 15.5029C9.66714 15.5029 9.66714 15.5029 9.68816 15.4762C9.70903 15.4762 9.73005 15.4496 9.75092 15.4496L9.77179 15.4229H9.79267C9.8763 15.3427 9.96009 15.2625 10.0437 15.1555C10.9226 13.9792 14.9821 14.6209 17.3467 15.3159C17.4722 15.3425 17.5977 15.3159 17.7024 15.209C17.807 15.1022 17.8698 14.9416 17.8698 14.7813L17.87 2.67175H18.2465V15.9307L0.836636 15.9305L0.83682 2.67175Z",
			fill: "currentColor"
		})
	});
}
//#endregion
//#region primitives/icon/icons/HamburgerMenu.tsx
function Y(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M15.077 13.538a.924.924 0 010 1.847H.923a.923.923 0 010-1.847h14.154zm0-6.769a.923.923 0 010 1.846H.923a.923.923 0 110-1.846h14.154zm0-6.769a.923.923 0 110 1.846H.923A.923.923 0 11.923 0h14.154z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Handicappers.tsx
function X(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "23",
		viewBox: "0 0 23 23",
		width: "23",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ t("mask", {
				fill: "black",
				height: "23",
				id: "path-1-outside-1_2735_20776",
				maskUnits: "userSpaceOnUse",
				width: "23",
				x: "0",
				y: "0",
				children: [/* @__PURE__ */ e("rect", {
					fill: "currentColor",
					height: "23",
					width: "23"
				}), /* @__PURE__ */ e("path", { d: "M11.4982 1.00005C7.63267 1.00005 4.49258 4.14241 4.49258 8.00724C4.49258 10.2465 5.55072 12.237 7.18922 13.5196C7.23658 13.5944 7.30981 13.6493 7.395 13.6739C8.54948 14.5118 9.96442 15.0118 11.4983 15.0118C13.0695 15.0118 14.5165 14.4864 15.6866 13.6111C15.6866 13.6112 15.6868 13.6109 15.6866 13.6111C15.7092 13.5978 15.7309 13.5821 15.7501 13.5642C17.4226 12.2834 18.5069 10.2728 18.5069 8.00719C18.5069 4.14239 15.3637 1.00005 11.4982 1.00005ZM11.4982 1.72411C14.9724 1.72411 17.7825 4.53369 17.7825 8.00724C17.7825 9.8077 17.0239 11.4245 15.813 12.5688C15.5769 10.9896 14.4984 9.69098 13.0463 9.14082C13.9092 8.61508 14.4897 7.6683 14.4897 6.58822C14.4897 4.9418 13.145 3.60003 11.4982 3.60003C9.8515 3.60003 8.5103 4.94164 8.5103 6.58822C8.5103 7.6683 9.08966 8.61508 9.95157 9.14082C8.49963 9.69114 7.4224 10.9904 7.18702 12.5702C5.97576 11.426 5.21747 9.80865 5.21747 8.00745C5.21747 4.53393 8.02414 1.72411 11.4982 1.72411ZM11.4982 4.32408C12.7536 4.32408 13.7655 5.33308 13.7655 6.58822C13.7655 7.84336 12.7536 8.85443 11.4982 8.85443C10.2428 8.85443 9.23445 7.84332 9.23445 6.58822C9.23445 5.33308 10.2428 4.32408 11.4982 4.32408ZM11.4982 9.57865C13.4904 9.57865 15.0868 11.1452 15.1368 13.1239C14.1098 13.854 12.8562 14.2871 11.4982 14.2871C10.1397 14.2871 8.88688 13.8536 7.86027 13.1233C7.91071 11.1448 9.50633 9.57865 11.4982 9.57865ZM4.12842 15.9677C3.98325 15.9768 3.85765 16.0718 3.80948 16.2088L3.20265 17.9567L1.35191 17.9928C1.19867 17.997 1.0645 18.0977 1.01746 18.2436C0.970421 18.3897 1.02053 18.5494 1.14241 18.6425L2.61405 19.7604L2.07803 21.5303C2.03341 21.6777 2.08708 21.8372 2.21171 21.9279C2.33635 22.0186 2.50462 22.0203 2.6312 21.9326L4.14956 20.8762L5.6673 21.9334C5.79387 22.0233 5.96377 22.0221 6.08936 21.931C6.21512 21.8397 6.26863 21.6785 6.22239 21.5303L5.68637 19.7605L7.16094 18.644C7.2838 18.5509 7.33423 18.3901 7.28655 18.2435C7.23886 18.0969 7.10356 17.9966 6.94951 17.9935L5.10009 17.9553L4.49471 16.2089C4.44929 16.0806 4.33565 15.9883 4.20051 15.9705C4.17658 15.9673 4.1525 15.9662 4.12842 15.9677ZM11.4763 15.9677C11.3311 15.9768 11.2055 16.0718 11.1573 16.2088L10.5505 17.9567L8.69975 17.9928C8.54635 17.997 8.41234 18.0977 8.3653 18.2436C8.31826 18.3897 8.36837 18.5494 8.49042 18.6425L9.96205 19.7604L9.42603 21.5303C9.38141 21.6777 9.43492 21.8372 9.55955 21.9279C9.68419 22.0186 9.85246 22.0203 9.97904 21.9326L11.4974 20.8762L13.0151 21.9334C13.1419 22.0233 13.3116 22.0221 13.4374 21.931C13.563 21.8397 13.6165 21.6785 13.5702 21.5303L13.0342 19.7605L14.5088 18.644C14.6316 18.5509 14.6821 18.3901 14.6344 18.2435C14.5867 18.0969 14.4514 17.9966 14.2974 17.9935L12.4479 17.9553L11.8426 16.2089C11.7971 16.0806 11.6835 15.9883 11.5484 15.9705C11.5244 15.9673 11.5003 15.9662 11.4763 15.9677ZM18.8241 15.9677C18.6791 15.9768 18.5535 16.0718 18.5052 16.2088L17.8983 17.9567L16.0476 17.9928C15.8942 17.997 15.7602 18.0977 15.7131 18.2436C15.6661 18.3897 15.7162 18.5494 15.8383 18.6425L17.3099 19.7604L16.7739 21.5303C16.7293 21.6777 16.7829 21.8372 16.9074 21.9279C17.032 22.0186 17.2003 22.0203 17.3269 21.9326L18.8452 20.8762L20.363 21.9334C20.4897 22.0233 20.6596 22.0221 20.7852 21.931C20.9108 21.8397 20.9643 21.6785 20.9182 21.5303L20.3822 19.7605L21.8568 18.644C21.9796 18.5509 22.0299 18.3901 21.9822 18.2435C21.9347 18.0969 21.7994 17.9966 21.6452 17.9935L19.7958 17.9553L19.1904 16.2089C19.145 16.0806 19.0313 15.9883 18.8962 15.9705C18.8724 15.9673 18.8482 15.9662 18.8241 15.9677ZM4.15159 17.4307L4.49881 18.4325C4.54892 18.5748 4.6818 18.6711 4.83262 18.6743L5.89354 18.6955L5.04909 19.3361C4.92866 19.4275 4.87774 19.5839 4.92106 19.7287L5.22593 20.7427L4.35819 20.1396C4.23388 20.0523 4.06851 20.0516 3.9437 20.1381L3.07306 20.7419L3.38068 19.7294C3.42432 19.5849 3.37357 19.4283 3.25346 19.3368L2.40835 18.6969L3.46927 18.6758C3.62106 18.6724 3.75442 18.5746 3.80372 18.4311L4.15159 17.4307ZM11.4994 17.4307L11.8467 18.4325C11.8968 18.5748 12.0298 18.6711 12.1805 18.6743L13.2414 18.6955L12.3969 19.3361C12.2767 19.4275 12.2256 19.5839 12.2689 19.7287L12.5738 20.7427L11.706 20.1396C11.5817 20.0523 11.4164 20.0516 11.2915 20.1381L10.4209 20.7419L10.7285 19.7294C10.772 19.5849 10.7214 19.4283 10.6013 19.3368L9.75619 18.6969L10.8171 18.6758C10.9689 18.6724 11.1024 18.5746 11.1516 18.4311L11.4994 17.4307ZM18.8473 17.4307L19.1945 18.4325C19.2444 18.5748 19.3776 18.6711 19.5285 18.6743L20.5894 18.6955L19.7449 19.3361C19.6247 19.4275 19.5734 19.5839 19.6169 19.7287L19.9218 20.7427L19.054 20.1396C18.9299 20.0523 18.7642 20.0516 18.6394 20.1381L17.7687 20.7419L18.0764 19.7294C18.1198 19.5849 18.0693 19.4284 17.9491 19.337L17.104 18.6971L18.165 18.6759C18.3167 18.6725 18.4503 18.5748 18.4994 18.4312L18.8473 17.4307Z" })]
			}),
			/* @__PURE__ */ e("path", {
				d: "M11.4982 1.00005C7.63267 1.00005 4.49258 4.14241 4.49258 8.00724C4.49258 10.2465 5.55072 12.237 7.18922 13.5196C7.23658 13.5944 7.30981 13.6493 7.395 13.6739C8.54948 14.5118 9.96442 15.0118 11.4983 15.0118C13.0695 15.0118 14.5165 14.4864 15.6866 13.6111C15.6866 13.6112 15.6868 13.6109 15.6866 13.6111C15.7092 13.5978 15.7309 13.5821 15.7501 13.5642C17.4226 12.2834 18.5069 10.2728 18.5069 8.00719C18.5069 4.14239 15.3637 1.00005 11.4982 1.00005ZM11.4982 1.72411C14.9724 1.72411 17.7825 4.53369 17.7825 8.00724C17.7825 9.8077 17.0239 11.4245 15.813 12.5688C15.5769 10.9896 14.4984 9.69098 13.0463 9.14082C13.9092 8.61508 14.4897 7.6683 14.4897 6.58822C14.4897 4.9418 13.145 3.60003 11.4982 3.60003C9.8515 3.60003 8.5103 4.94164 8.5103 6.58822C8.5103 7.6683 9.08966 8.61508 9.95157 9.14082C8.49963 9.69114 7.4224 10.9904 7.18702 12.5702C5.97576 11.426 5.21747 9.80865 5.21747 8.00745C5.21747 4.53393 8.02414 1.72411 11.4982 1.72411ZM11.4982 4.32408C12.7536 4.32408 13.7655 5.33308 13.7655 6.58822C13.7655 7.84336 12.7536 8.85443 11.4982 8.85443C10.2428 8.85443 9.23445 7.84332 9.23445 6.58822C9.23445 5.33308 10.2428 4.32408 11.4982 4.32408ZM11.4982 9.57865C13.4904 9.57865 15.0868 11.1452 15.1368 13.1239C14.1098 13.854 12.8562 14.2871 11.4982 14.2871C10.1397 14.2871 8.88688 13.8536 7.86027 13.1233C7.91071 11.1448 9.50633 9.57865 11.4982 9.57865ZM4.12842 15.9677C3.98325 15.9768 3.85765 16.0718 3.80948 16.2088L3.20265 17.9567L1.35191 17.9928C1.19867 17.997 1.0645 18.0977 1.01746 18.2436C0.970421 18.3897 1.02053 18.5494 1.14241 18.6425L2.61405 19.7604L2.07803 21.5303C2.03341 21.6777 2.08708 21.8372 2.21171 21.9279C2.33635 22.0186 2.50462 22.0203 2.6312 21.9326L4.14956 20.8762L5.6673 21.9334C5.79387 22.0233 5.96377 22.0221 6.08936 21.931C6.21512 21.8397 6.26863 21.6785 6.22239 21.5303L5.68637 19.7605L7.16094 18.644C7.2838 18.5509 7.33423 18.3901 7.28655 18.2435C7.23886 18.0969 7.10356 17.9966 6.94951 17.9935L5.10009 17.9553L4.49471 16.2089C4.44929 16.0806 4.33565 15.9883 4.20051 15.9705C4.17658 15.9673 4.1525 15.9662 4.12842 15.9677ZM11.4763 15.9677C11.3311 15.9768 11.2055 16.0718 11.1573 16.2088L10.5505 17.9567L8.69975 17.9928C8.54635 17.997 8.41234 18.0977 8.3653 18.2436C8.31826 18.3897 8.36837 18.5494 8.49042 18.6425L9.96205 19.7604L9.42603 21.5303C9.38141 21.6777 9.43492 21.8372 9.55955 21.9279C9.68419 22.0186 9.85246 22.0203 9.97904 21.9326L11.4974 20.8762L13.0151 21.9334C13.1419 22.0233 13.3116 22.0221 13.4374 21.931C13.563 21.8397 13.6165 21.6785 13.5702 21.5303L13.0342 19.7605L14.5088 18.644C14.6316 18.5509 14.6821 18.3901 14.6344 18.2435C14.5867 18.0969 14.4514 17.9966 14.2974 17.9935L12.4479 17.9553L11.8426 16.2089C11.7971 16.0806 11.6835 15.9883 11.5484 15.9705C11.5244 15.9673 11.5003 15.9662 11.4763 15.9677ZM18.8241 15.9677C18.6791 15.9768 18.5535 16.0718 18.5052 16.2088L17.8983 17.9567L16.0476 17.9928C15.8942 17.997 15.7602 18.0977 15.7131 18.2436C15.6661 18.3897 15.7162 18.5494 15.8383 18.6425L17.3099 19.7604L16.7739 21.5303C16.7293 21.6777 16.7829 21.8372 16.9074 21.9279C17.032 22.0186 17.2003 22.0203 17.3269 21.9326L18.8452 20.8762L20.363 21.9334C20.4897 22.0233 20.6596 22.0221 20.7852 21.931C20.9108 21.8397 20.9643 21.6785 20.9182 21.5303L20.3822 19.7605L21.8568 18.644C21.9796 18.5509 22.0299 18.3901 21.9822 18.2435C21.9347 18.0969 21.7994 17.9966 21.6452 17.9935L19.7958 17.9553L19.1904 16.2089C19.145 16.0806 19.0313 15.9883 18.8962 15.9705C18.8724 15.9673 18.8482 15.9662 18.8241 15.9677ZM4.15159 17.4307L4.49881 18.4325C4.54892 18.5748 4.6818 18.6711 4.83262 18.6743L5.89354 18.6955L5.04909 19.3361C4.92866 19.4275 4.87774 19.5839 4.92106 19.7287L5.22593 20.7427L4.35819 20.1396C4.23388 20.0523 4.06851 20.0516 3.9437 20.1381L3.07306 20.7419L3.38068 19.7294C3.42432 19.5849 3.37357 19.4283 3.25346 19.3368L2.40835 18.6969L3.46927 18.6758C3.62106 18.6724 3.75442 18.5746 3.80372 18.4311L4.15159 17.4307ZM11.4994 17.4307L11.8467 18.4325C11.8968 18.5748 12.0298 18.6711 12.1805 18.6743L13.2414 18.6955L12.3969 19.3361C12.2767 19.4275 12.2256 19.5839 12.2689 19.7287L12.5738 20.7427L11.706 20.1396C11.5817 20.0523 11.4164 20.0516 11.2915 20.1381L10.4209 20.7419L10.7285 19.7294C10.772 19.5849 10.7214 19.4283 10.6013 19.3368L9.75619 18.6969L10.8171 18.6758C10.9689 18.6724 11.1024 18.5746 11.1516 18.4311L11.4994 17.4307ZM18.8473 17.4307L19.1945 18.4325C19.2444 18.5748 19.3776 18.6711 19.5285 18.6743L20.5894 18.6955L19.7449 19.3361C19.6247 19.4275 19.5734 19.5839 19.6169 19.7287L19.9218 20.7427L19.054 20.1396C18.9299 20.0523 18.7642 20.0516 18.6394 20.1381L17.7687 20.7419L18.0764 19.7294C18.1198 19.5849 18.0693 19.4284 17.9491 19.337L17.104 18.6971L18.165 18.6759C18.3167 18.6725 18.4503 18.5748 18.4994 18.4312L18.8473 17.4307Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M7.18922 13.5196L7.35821 13.4126L7.33972 13.3834L7.3125 13.3621L7.18922 13.5196ZM7.395 13.6739L7.51247 13.5121L7.4841 13.4915L7.45042 13.4817L7.395 13.6739ZM15.7501 13.5642L15.6285 13.4054L15.6208 13.4113L15.6137 13.4179L15.7501 13.5642ZM15.813 12.5688L15.6152 12.5983L15.6718 12.9773L15.9503 12.7141L15.813 12.5688ZM13.0463 9.14082L12.9423 8.97003L12.5929 9.1829L12.9755 9.32785L13.0463 9.14082ZM9.95157 9.14082L10.0225 9.32784L10.4047 9.18296L10.0557 8.97008L9.95157 9.14082ZM7.18702 12.5702L7.04968 12.7156L7.32835 12.9789L7.38484 12.5997L7.18702 12.5702ZM15.1368 13.1239L15.2526 13.287L15.3394 13.2253L15.3367 13.1189L15.1368 13.1239ZM7.86027 13.1233L7.66034 13.1182L7.65762 13.2246L7.74433 13.2863L7.86027 13.1233ZM4.12842 15.9677L4.11636 15.7681L4.11597 15.7681L4.12842 15.9677ZM3.80948 16.2088L3.6208 16.1425L3.62054 16.1432L3.80948 16.2088ZM3.20265 17.9567L3.20655 18.1567L3.34588 18.154L3.39159 18.0223L3.20265 17.9567ZM1.35191 17.9928L1.34802 17.7928L1.34643 17.7929L1.35191 17.9928ZM1.01746 18.2436L0.827104 18.1823L0.827084 18.1823L1.01746 18.2436ZM1.14241 18.6425L1.02102 18.8014L1.02143 18.8018L1.14241 18.6425ZM2.61405 19.7604L2.80547 19.8184L2.84578 19.6853L2.73503 19.6012L2.61405 19.7604ZM2.07803 21.5303L1.88661 21.4723L1.8866 21.4724L2.07803 21.5303ZM2.6312 21.9326L2.74516 22.0969L2.74542 22.0968L2.6312 21.9326ZM4.14956 20.8762L4.26387 20.7121L4.14963 20.6326L4.03534 20.7121L4.14956 20.8762ZM5.6673 21.9334L5.78308 21.7703L5.78161 21.7693L5.6673 21.9334ZM6.08936 21.931L6.20683 22.0928L6.20686 22.0928L6.08936 21.931ZM6.22239 21.5303L6.03097 21.5883L6.03147 21.5899L6.22239 21.5303ZM5.68637 19.7605L5.56564 19.601L5.45457 19.6851L5.49495 19.8184L5.68637 19.7605ZM7.16094 18.644L7.28167 18.8035L7.28173 18.8034L7.16094 18.644ZM6.94951 17.9935L6.94539 18.1934L6.94552 18.1934L6.94951 17.9935ZM5.10009 17.9553L4.91112 18.0208L4.95673 18.1524L5.09597 18.1553L5.10009 17.9553ZM4.49471 16.2089L4.68368 16.1434L4.68325 16.1421L4.49471 16.2089ZM4.20051 15.9705L4.17373 16.1687L4.17442 16.1688L4.20051 15.9705ZM11.4763 15.9677L11.4642 15.7681L11.4638 15.7681L11.4763 15.9677ZM11.1573 16.2088L10.9686 16.1425L10.9684 16.1432L11.1573 16.2088ZM10.5505 17.9567L10.5544 18.1567L10.6937 18.154L10.7394 18.0223L10.5505 17.9567ZM8.69975 17.9928L8.69586 17.7928L8.69428 17.7929L8.69975 17.9928ZM8.3653 18.2436L8.17494 18.1823L8.17492 18.1823L8.3653 18.2436ZM8.49042 18.6425L8.36912 18.8015L8.36943 18.8018L8.49042 18.6425ZM9.96205 19.7604L10.1535 19.8184L10.1938 19.6853L10.083 19.6012L9.96205 19.7604ZM9.42603 21.5303L9.23461 21.4723L9.23461 21.4724L9.42603 21.5303ZM9.97904 21.9326L10.093 22.0969L10.0933 22.0968L9.97904 21.9326ZM11.4974 20.8762L11.6117 20.7121L11.4975 20.6326L11.3832 20.7121L11.4974 20.8762ZM13.0151 21.9334L13.1308 21.7703L13.1294 21.7693L13.0151 21.9334ZM13.4374 21.931L13.5547 22.0929L13.555 22.0928L13.4374 21.931ZM13.5702 21.5303L13.3788 21.5883L13.3793 21.5899L13.5702 21.5303ZM13.0342 19.7605L12.9135 19.601L12.8024 19.6851L12.8428 19.8184L13.0342 19.7605ZM14.5088 18.644L14.6295 18.8035L14.6296 18.8034L14.5088 18.644ZM14.2974 17.9935L14.2932 18.1934L14.2934 18.1934L14.2974 17.9935ZM12.4479 17.9553L12.259 18.0208L12.3046 18.1524L12.4438 18.1553L12.4479 17.9553ZM11.8426 16.2089L12.0315 16.1434L12.0311 16.1421L11.8426 16.2089ZM11.5484 15.9705L11.5216 16.1687L11.5223 16.1688L11.5484 15.9705ZM18.8241 15.9677L18.812 15.7681L18.8116 15.7681L18.8241 15.9677ZM18.5052 16.2088L18.3165 16.1423L18.3162 16.1432L18.5052 16.2088ZM17.8983 17.9567L17.9022 18.1567L18.0416 18.154L18.0873 18.0223L17.8983 17.9567ZM16.0476 17.9928L16.0437 17.7928L16.0421 17.7929L16.0476 17.9928ZM15.7131 18.2436L15.5228 18.1823L15.5228 18.1823L15.7131 18.2436ZM15.8383 18.6425L15.717 18.8015L15.7173 18.8018L15.8383 18.6425ZM17.3099 19.7604L17.5013 19.8184L17.5416 19.6853L17.4309 19.6012L17.3099 19.7604ZM16.7739 21.5303L16.5825 21.4723L16.5824 21.4724L16.7739 21.5303ZM16.9074 21.9279L16.7896 22.0896L16.7897 22.0896L16.9074 21.9279ZM17.3269 21.9326L17.4408 22.0969L17.4411 22.0968L17.3269 21.9326ZM18.8452 20.8762L18.9596 20.7121L18.8453 20.6326L18.731 20.7121L18.8452 20.8762ZM20.363 21.9334L20.4787 21.7703L20.4773 21.7693L20.363 21.9334ZM20.7852 21.931L20.9027 22.0928L20.9028 22.0928L20.7852 21.931ZM20.9182 21.5303L20.7268 21.5883L20.7273 21.5897L20.9182 21.5303ZM20.3822 19.7605L20.2615 19.601L20.1504 19.6851L20.1908 19.8184L20.3822 19.7605ZM21.8568 18.644L21.9775 18.8035L21.9776 18.8034L21.8568 18.644ZM21.9822 18.2435L21.792 18.3052L21.792 18.3054L21.9822 18.2435ZM21.6452 17.9935L21.6411 18.1934L21.6412 18.1934L21.6452 17.9935ZM19.7958 17.9553L19.6068 18.0208L19.6524 18.1524L19.7917 18.1553L19.7958 17.9553ZM19.1904 16.2089L19.3794 16.1434L19.3789 16.1421L19.1904 16.2089ZM18.8962 15.9705L18.8692 16.1687L18.8701 16.1688L18.8962 15.9705ZM4.15159 17.4307L4.34056 17.3652L4.1519 16.8208L3.96268 17.365L4.15159 17.4307ZM4.49881 18.4325L4.30984 18.498L4.31018 18.499L4.49881 18.4325ZM4.83262 18.6743L4.82833 18.8743L4.82863 18.8743L4.83262 18.6743ZM5.89354 18.6955L6.01442 18.8548L6.47288 18.507L5.89753 18.4955L5.89354 18.6955ZM5.04909 19.3361L5.16993 19.4955L5.16997 19.4955L5.04909 19.3361ZM4.92106 19.7287L4.72945 19.786L4.72953 19.7863L4.92106 19.7287ZM5.22593 20.7427L5.11178 20.907L5.58253 21.2342L5.41746 20.6851L5.22593 20.7427ZM4.35819 20.1396L4.24326 20.3033L4.24404 20.3038L4.35819 20.1396ZM3.9437 20.1381L3.82981 19.9737L3.82972 19.9738L3.9437 20.1381ZM3.07306 20.7419L2.8817 20.6838L2.71455 21.234L3.18704 20.9063L3.07306 20.7419ZM3.38068 19.7294L3.57204 19.7875L3.57213 19.7872L3.38068 19.7294ZM3.25346 19.3368L3.37465 19.1777L3.37419 19.1773L3.25346 19.3368ZM2.40835 18.6969L2.40436 18.497L1.82811 18.5085L2.28763 18.8564L2.40835 18.6969ZM3.46927 18.6758L3.47326 18.8757L3.47374 18.8757L3.46927 18.6758ZM3.80372 18.4311L3.61482 18.3654L3.61457 18.3661L3.80372 18.4311ZM11.4994 17.4307L11.6884 17.3652L11.4997 16.8208L11.3105 17.365L11.4994 17.4307ZM11.8467 18.4325L11.6577 18.498L11.658 18.499L11.8467 18.4325ZM12.1805 18.6743L12.1762 18.8743L12.1765 18.8743L12.1805 18.6743ZM13.2414 18.6955L13.3623 18.8548L13.8207 18.507L13.2454 18.4955L13.2414 18.6955ZM12.3969 19.3361L12.276 19.1768L12.276 19.1769L12.3969 19.3361ZM12.2689 19.7287L12.0773 19.786L12.0774 19.7863L12.2689 19.7287ZM12.5738 20.7427L12.4596 20.907L12.9304 21.2342L12.7653 20.6851L12.5738 20.7427ZM11.706 20.1396L11.5911 20.3033L11.5919 20.3038L11.706 20.1396ZM11.2915 20.1381L11.1776 19.9737L11.1776 19.9738L11.2915 20.1381ZM10.4209 20.7419L10.2295 20.6838L10.0624 21.234L10.5349 20.9063L10.4209 20.7419ZM10.7285 19.7294L10.9199 19.7875L10.92 19.787L10.7285 19.7294ZM10.6013 19.3368L10.7225 19.1777L10.722 19.1773L10.6013 19.3368ZM9.75619 18.6969L9.7522 18.497L9.17595 18.5085L9.63547 18.8564L9.75619 18.6969ZM10.8171 18.6758L10.8211 18.8757L10.8216 18.8757L10.8171 18.6758ZM11.1516 18.4311L10.9627 18.3654L10.9623 18.3663L11.1516 18.4311ZM18.8473 17.4307L19.0362 17.3652L18.8476 16.8208L18.6584 17.365L18.8473 17.4307ZM19.1945 18.4325L19.0055 18.498L19.0058 18.4988L19.1945 18.4325ZM19.5285 18.6743L19.5242 18.8743L19.5245 18.8743L19.5285 18.6743ZM20.5894 18.6955L20.7103 18.8548L21.1687 18.507L20.5934 18.4955L20.5894 18.6955ZM19.7449 19.3361L19.624 19.1768L19.624 19.1769L19.7449 19.3361ZM19.6169 19.7287L19.4254 19.7862L19.4254 19.7863L19.6169 19.7287ZM19.9218 20.7427L19.8076 20.907L20.2784 21.2342L20.1133 20.6851L19.9218 20.7427ZM19.054 20.1396L18.939 20.3032L18.9399 20.3038L19.054 20.1396ZM18.6394 20.1381L18.5255 19.9737L18.5254 19.9738L18.6394 20.1381ZM17.7687 20.7419L17.5774 20.6838L17.4102 21.234L17.8827 20.9063L17.7687 20.7419ZM18.0764 19.7294L18.2677 19.7875L18.2679 19.787L18.0764 19.7294ZM17.9491 19.337L18.0703 19.1779L18.0699 19.1775L17.9491 19.337ZM17.104 18.6971L17.1 18.4971L16.5238 18.5086L16.9833 18.8566L17.104 18.6971ZM18.165 18.6759L18.1689 18.8759L18.1694 18.8759L18.165 18.6759ZM18.4994 18.4312L18.3105 18.3656L18.3102 18.3665L18.4994 18.4312ZM11.4982 0.800054C7.52214 0.800054 4.29258 4.03202 4.29258 8.00724H4.69258C4.69258 4.25279 7.7432 1.20005 11.4982 1.20005V0.800054ZM4.29258 8.00724C4.29258 10.3111 5.38154 12.3585 7.06594 13.6771L7.3125 13.3621C5.71991 12.1154 4.69258 10.1818 4.69258 8.00724H4.29258ZM7.02022 13.6265C7.09375 13.7427 7.2074 13.828 7.33958 13.8661L7.45042 13.4817C7.41222 13.4707 7.3794 13.4461 7.35821 13.4126L7.02022 13.6265ZM7.27753 13.8358C8.46441 14.6971 9.92011 15.2118 11.4983 15.2118V14.8118C10.0087 14.8118 8.63455 14.3264 7.51247 13.5121L7.27753 13.8358ZM11.4983 15.2118C13.115 15.2118 14.6036 14.671 15.8064 13.7712L15.5668 13.4509C14.4294 14.3018 13.0241 14.8118 11.4983 14.8118V15.2118ZM15.828 13.7525C15.8244 13.7561 15.812 13.7685 15.7931 13.7804C15.7842 13.7859 15.7633 13.7982 15.7337 13.8054C15.7045 13.8125 15.64 13.8203 15.5758 13.7775C15.5111 13.7344 15.4934 13.6713 15.4888 13.6405C15.4842 13.6094 15.4881 13.5846 15.4903 13.5733C15.4949 13.549 15.5031 13.5309 15.5078 13.5216C15.5132 13.5109 15.5207 13.4983 15.5311 13.4854C15.5364 13.4789 15.5444 13.4698 15.5553 13.4603C15.5653 13.4516 15.5844 13.4366 15.6123 13.4254C15.6413 13.4139 15.6905 13.4025 15.7473 13.4205C15.8056 13.4391 15.8407 13.4788 15.8588 13.5093C15.8755 13.5376 15.8813 13.5634 15.8836 13.5767C15.8862 13.5914 15.8866 13.6035 15.8866 13.6111H15.4866C15.4866 13.6186 15.487 13.6308 15.4896 13.6455C15.4919 13.6588 15.4977 13.6846 15.5145 13.7129C15.5325 13.7435 15.5676 13.7831 15.6259 13.8017C15.6827 13.8198 15.732 13.8084 15.7609 13.7968C15.7889 13.7856 15.808 13.7706 15.8179 13.762C15.8289 13.7524 15.8369 13.7433 15.8422 13.7368C15.8527 13.7239 15.8602 13.7113 15.8655 13.7005C15.8702 13.6912 15.8784 13.6731 15.8831 13.6488C15.8853 13.6375 15.8891 13.6127 15.8845 13.5816C15.8799 13.5508 15.8622 13.4876 15.7975 13.4446C15.7333 13.4018 15.6688 13.4096 15.6396 13.4166C15.61 13.4238 15.5891 13.4361 15.5802 13.4417C15.5613 13.4536 15.5489 13.466 15.5452 13.4696L15.828 13.7525ZM15.7877 13.7837C15.8214 13.7639 15.8552 13.7397 15.8865 13.7105L15.6137 13.4179C15.6066 13.4246 15.5971 13.4317 15.5855 13.4385L15.7877 13.7837ZM15.8717 13.723C17.5909 12.4063 18.7069 10.3383 18.7069 8.00719H18.3069C18.3069 10.2073 17.2542 12.1604 15.6285 13.4054L15.8717 13.723ZM18.7069 8.00719C18.7069 4.03189 15.4742 0.800054 11.4982 0.800054V1.20005C15.2533 1.20005 18.3069 4.2529 18.3069 8.00719H18.7069ZM11.4982 1.92411C14.8619 1.92411 17.5825 4.64418 17.5825 8.00724H17.9825C17.9825 4.42319 15.0828 1.52411 11.4982 1.52411V1.92411ZM17.5825 8.00724C17.5825 9.75011 16.8485 11.3151 15.6756 12.4234L15.9503 12.7141C17.1993 11.5339 17.9825 9.86528 17.9825 8.00724H17.5825ZM16.0108 12.5392C15.7638 10.8871 14.6357 9.52911 13.1172 8.9538L12.9755 9.32785C14.3611 9.85285 15.39 11.0921 15.6152 12.5983L16.0108 12.5392ZM13.1504 9.31162C14.0696 8.75159 14.6897 7.74187 14.6897 6.58822H14.2897C14.2897 7.59474 13.7489 8.47856 12.9423 8.97003L13.1504 9.31162ZM14.6897 6.58822C14.6897 4.83107 13.2551 3.40003 11.4982 3.40003V3.80003C13.0348 3.80003 14.2897 5.05253 14.2897 6.58822H14.6897ZM11.4982 3.40003C9.74102 3.40003 8.3103 4.83121 8.3103 6.58822H8.7103C8.7103 5.05207 9.96199 3.80003 11.4982 3.80003V3.40003ZM8.3103 6.58822C8.3103 7.7417 8.92917 8.75146 9.84742 9.31156L10.0557 8.97008C9.25014 8.4787 8.7103 7.59491 8.7103 6.58822H8.3103ZM9.88068 8.9538C8.36222 9.52934 7.23544 10.888 6.98921 12.5408L7.38484 12.5997C7.60937 11.0927 8.63704 9.85295 10.0225 9.32784L9.88068 8.9538ZM7.32437 12.4248C6.15123 11.3166 5.41747 9.75112 5.41747 8.00745H5.01747C5.01747 9.86618 5.80029 11.5353 7.04968 12.7156L7.32437 12.4248ZM5.41747 8.00745C5.41747 4.64427 8.13472 1.92411 11.4982 1.92411V1.52411C7.91357 1.52411 5.01747 4.4236 5.01747 8.00745H5.41747ZM11.4982 4.52408C12.6435 4.52408 13.5655 5.44389 13.5655 6.58822H13.9655C13.9655 5.22228 12.8637 4.12408 11.4982 4.12408V4.52408ZM13.5655 6.58822C13.5655 7.73279 12.6432 8.65443 11.4982 8.65443V9.05443C12.8639 9.05443 13.9655 7.95393 13.9655 6.58822H13.5655ZM11.4982 8.65443C10.3536 8.65443 9.43445 7.73316 9.43445 6.58822H9.03445C9.03445 7.95347 10.1321 9.05443 11.4982 9.05443V8.65443ZM9.43445 6.58822C9.43445 5.44348 10.3533 4.52408 11.4982 4.52408V4.12408C10.1323 4.12408 9.03445 5.22269 9.03445 6.58822H9.43445ZM11.4982 9.77865C13.3816 9.77865 14.8896 11.2584 14.9368 13.129L15.3367 13.1189C15.284 11.032 13.5991 9.37865 11.4982 9.37865V9.77865ZM15.0209 12.9609C14.0263 13.668 12.8129 14.0871 11.4982 14.0871V14.4871C12.8995 14.4871 14.1933 14.04 15.2526 13.287L15.0209 12.9609ZM11.4982 14.0871C10.183 14.0871 8.97046 13.6676 7.97621 12.9603L7.74433 13.2863C8.80331 14.0396 10.0963 14.4871 11.4982 14.4871V14.0871ZM8.06021 13.1284C8.10789 11.258 9.61513 9.77865 11.4982 9.77865V9.37865C9.39754 9.37865 7.71353 11.0315 7.66034 13.1182L8.06021 13.1284ZM4.11597 15.7681C3.89065 15.7821 3.69561 15.9296 3.6208 16.1425L3.99817 16.2752C4.01969 16.2139 4.07586 16.1714 4.14086 16.1673L4.11597 15.7681ZM3.62054 16.1432L3.01371 17.8911L3.39159 18.0223L3.99842 16.2744L3.62054 16.1432ZM3.19876 17.7568L1.34802 17.7928L1.35581 18.1927L3.20655 18.1567L3.19876 17.7568ZM1.34643 17.7929C1.1083 17.7994 0.900121 17.9557 0.827104 18.1823L1.20782 18.305C1.22888 18.2396 1.28904 18.1946 1.35739 18.1927L1.34643 17.7929ZM0.827084 18.1823C0.754071 18.4091 0.831885 18.657 1.02102 18.8014L1.26381 18.4836C1.20918 18.4418 1.18677 18.3703 1.20784 18.3049L0.827084 18.1823ZM1.02143 18.8018L2.49307 19.9197L2.73503 19.6012L1.2634 18.4832L1.02143 18.8018ZM2.42264 19.7025L1.88661 21.4723L2.26944 21.5883L2.80547 19.8184L2.42264 19.7025ZM1.8866 21.4724C1.81729 21.7014 1.90071 21.949 2.09406 22.0896L2.32937 21.7662C2.27344 21.7255 2.24953 21.654 2.26945 21.5882L1.8866 21.4724ZM2.09406 22.0896C2.28757 22.2304 2.54876 22.2331 2.74516 22.0969L2.51725 21.7682C2.46048 21.8076 2.38512 21.8067 2.32937 21.7662L2.09406 22.0896ZM2.74542 22.0968L4.26378 21.0404L4.03534 20.7121L2.51699 21.7684L2.74542 22.0968ZM4.03525 21.0404L5.55299 22.0975L5.78161 21.7693L4.26387 20.7121L4.03525 21.0404ZM5.55152 22.0965C5.74827 22.2362 6.01201 22.2342 6.20683 22.0928L5.97188 21.7691C5.91552 21.81 5.83948 21.8104 5.78308 21.7703L5.55152 22.0965ZM6.20686 22.0928C6.40196 21.9512 6.48514 21.701 6.41332 21.4708L6.03147 21.5899C6.05211 21.6561 6.02829 21.7282 5.97185 21.7691L6.20686 22.0928ZM6.41381 21.4724L5.87778 19.7025L5.49495 19.8184L6.03098 21.5883L6.41381 21.4724ZM5.8071 19.9199L7.28167 18.8035L7.04022 18.4845L5.56564 19.601L5.8071 19.9199ZM7.28173 18.8034C7.47249 18.6589 7.55077 18.4092 7.47674 18.1816L7.09636 18.3054C7.11769 18.371 7.09511 18.443 7.04016 18.4846L7.28173 18.8034ZM7.47674 18.1816C7.40272 17.9541 7.19273 17.7983 6.95349 17.7935L6.94552 18.1934C7.01439 18.1948 7.075 18.2397 7.09636 18.3054L7.47674 18.1816ZM6.95363 17.7935L5.10422 17.7554L5.09597 18.1553L6.94539 18.1934L6.95363 17.7935ZM5.28906 17.8898L4.68368 16.1434L4.30574 16.2744L4.91112 18.0208L5.28906 17.8898ZM4.68325 16.1421C4.61278 15.9431 4.4365 15.7998 4.2266 15.7722L4.17442 16.1688C4.2348 16.1767 4.28579 16.218 4.30617 16.2756L4.68325 16.1421ZM4.22729 15.7723C4.19118 15.7674 4.15408 15.7658 4.11636 15.7681L4.14047 16.1673C4.15092 16.1667 4.16198 16.1671 4.17373 16.1687L4.22729 15.7723ZM11.4638 15.7681C11.2385 15.7821 11.0435 15.9296 10.9686 16.1425L11.346 16.2752C11.3675 16.2139 11.4237 16.1714 11.4887 16.1673L11.4638 15.7681ZM10.9684 16.1432L10.3616 17.8911L10.7394 18.0223L11.3463 16.2744L10.9684 16.1432ZM10.5466 17.7568L8.69586 17.7928L8.70365 18.1927L10.5544 18.1567L10.5466 17.7568ZM8.69428 17.7929C8.45592 17.7994 8.24794 17.9558 8.17494 18.1823L8.55566 18.305C8.57674 18.2396 8.63678 18.1946 8.70523 18.1927L8.69428 17.7929ZM8.17492 18.1823C8.1019 18.4091 8.17974 18.6571 8.36912 18.8015L8.61171 18.4835C8.557 18.4417 8.53462 18.3703 8.55568 18.3049L8.17492 18.1823ZM8.36943 18.8018L9.84107 19.9197L10.083 19.6012L8.6114 18.4832L8.36943 18.8018ZM9.77064 19.7025L9.23461 21.4723L9.61744 21.5883L10.1535 19.8184L9.77064 19.7025ZM9.23461 21.4724C9.16534 21.7012 9.24841 21.9489 9.4419 22.0896L9.67721 21.7662C9.62142 21.7256 9.59749 21.6542 9.61745 21.5882L9.23461 21.4724ZM9.4419 22.0896C9.63541 22.2304 9.8966 22.2331 10.093 22.0969L9.86509 21.7682C9.80832 21.8076 9.73296 21.8067 9.67721 21.7662L9.4419 22.0896ZM10.0933 22.0968L11.6116 21.0404L11.3832 20.7121L9.86482 21.7684L10.0933 22.0968ZM11.3831 21.0404L12.9008 22.0975L13.1294 21.7693L11.6117 20.7121L11.3831 21.0404ZM12.8995 22.0966C13.0963 22.2361 13.3598 22.2342 13.5547 22.0929L13.32 21.769C13.2634 21.8101 13.1874 21.8104 13.1308 21.7703L12.8995 22.0966ZM13.555 22.0928C13.7498 21.9511 13.833 21.701 13.7612 21.4708L13.3793 21.5899C13.4 21.6561 13.3761 21.7282 13.3198 21.7692L13.555 22.0928ZM13.7617 21.4724L13.2256 19.7025L12.8428 19.8184L13.3788 21.5883L13.7617 21.4724ZM13.1549 19.9199L14.6295 18.8035L14.3881 18.4845L12.9135 19.601L13.1549 19.9199ZM14.6296 18.8034C14.8203 18.6589 14.8986 18.4092 14.8246 18.1816L14.4442 18.3054C14.4655 18.371 14.4429 18.443 14.388 18.4846L14.6296 18.8034ZM14.8246 18.1816C14.7506 17.9541 14.5406 17.7983 14.3013 17.7935L14.2934 18.1934C14.3622 18.1948 14.4228 18.2397 14.4442 18.3054L14.8246 18.1816ZM14.3015 17.7935L12.4521 17.7554L12.4438 18.1553L14.2932 18.1934L14.3015 17.7935ZM12.6369 17.8898L12.0315 16.1434L11.6536 16.2744L12.259 18.0208L12.6369 17.8898ZM12.0311 16.1421C11.9606 15.9431 11.7843 15.7998 11.5744 15.7722L11.5223 16.1688C11.5826 16.1767 11.6336 16.218 11.654 16.2756L12.0311 16.1421ZM11.5751 15.7723C11.539 15.7674 11.5019 15.7658 11.4642 15.7681L11.4883 16.1673C11.4988 16.1667 11.5098 16.1671 11.5216 16.1687L11.5751 15.7723ZM18.8116 15.7681C18.5864 15.7821 18.3915 15.9297 18.3165 16.1423L18.6938 16.2753C18.7155 16.2139 18.7718 16.1714 18.8366 16.1673L18.8116 15.7681ZM18.3162 16.1432L17.7094 17.8911L18.0873 18.0223L18.6941 16.2744L18.3162 16.1432ZM17.8944 17.7568L16.0437 17.7928L16.0515 18.1927L17.9022 18.1567L17.8944 17.7568ZM16.0421 17.7929C15.8038 17.7994 15.5958 17.9558 15.5228 18.1823L15.9035 18.305C15.9246 18.2396 15.9846 18.1946 16.0531 18.1927L16.0421 17.7929ZM15.5228 18.1823C15.4497 18.4091 15.5276 18.6571 15.717 18.8015L15.9596 18.4835C15.9048 18.4417 15.8825 18.3703 15.9035 18.3049L15.5228 18.1823ZM15.7173 18.8018L17.1889 19.9197L17.4309 19.6012L15.9592 18.4832L15.7173 18.8018ZM17.1185 19.7025L16.5825 21.4723L16.9653 21.5883L17.5013 19.8184L17.1185 19.7025ZM16.5824 21.4724C16.5131 21.7013 16.5965 21.9489 16.7896 22.0896L17.0251 21.7662C16.9693 21.7256 16.9454 21.6541 16.9653 21.5882L16.5824 21.4724ZM16.7897 22.0896C16.9833 22.2304 17.2444 22.2331 17.4408 22.0969L17.2129 21.7682C17.1562 21.8076 17.0808 21.8067 17.025 21.7662L16.7897 22.0896ZM17.4411 22.0968L18.9595 21.0404L18.731 20.7121L17.2127 21.7684L17.4411 22.0968ZM18.7309 21.0404L20.2487 22.0975L20.4773 21.7693L18.9596 20.7121L18.7309 21.0404ZM20.2473 22.0966C20.4441 22.2361 20.7078 22.2343 20.9027 22.0928L20.6677 21.7691C20.6114 21.81 20.5353 21.8104 20.4787 21.7703L20.2473 22.0966ZM20.9028 22.0928C21.0977 21.9511 21.1807 21.701 21.1092 21.471L20.7273 21.5897C20.7479 21.656 20.7239 21.7282 20.6676 21.7692L20.9028 22.0928ZM21.1097 21.4724L20.5736 19.7025L20.1908 19.8184L20.7268 21.5883L21.1097 21.4724ZM20.5029 19.9199L21.9775 18.8035L21.7361 18.4845L20.2615 19.601L20.5029 19.9199ZM21.9776 18.8034C22.1685 18.6588 22.2464 18.4091 22.1724 18.1816L21.792 18.3054C21.8134 18.3711 21.7908 18.4431 21.736 18.4846L21.9776 18.8034ZM22.1725 18.1818C22.0986 17.9541 21.8885 17.7983 21.6492 17.7935L21.6412 18.1934C21.7103 18.1948 21.7708 18.2398 21.792 18.3052L22.1725 18.1818ZM21.6493 17.7935L19.7999 17.7554L19.7917 18.1553L21.6411 18.1934L21.6493 17.7935ZM19.9847 17.8898L19.3794 16.1434L19.0014 16.2744L19.6068 18.0208L19.9847 17.8898ZM19.3789 16.1421C19.3085 15.9431 19.1322 15.7998 18.9223 15.7722L18.8701 16.1688C18.9305 16.1767 18.9815 16.218 19.0019 16.2756L19.3789 16.1421ZM18.9231 15.7723C18.887 15.7674 18.8497 15.7658 18.812 15.7681L18.8362 16.1673C18.8467 16.1667 18.8578 16.1671 18.8692 16.1687L18.9231 15.7723ZM3.96262 17.4962L4.30984 18.498L4.68779 18.3671L4.34056 17.3652L3.96262 17.4962ZM4.31018 18.499C4.38793 18.7197 4.59419 18.8693 4.82833 18.8743L4.83691 18.4744C4.76941 18.4729 4.70991 18.4298 4.68745 18.3661L4.31018 18.499ZM4.82863 18.8743L5.88955 18.8955L5.89753 18.4955L4.83661 18.4744L4.82863 18.8743ZM5.77266 18.5362L4.92821 19.1768L5.16997 19.4955L6.01442 18.8548L5.77266 18.5362ZM4.92825 19.1768C4.74119 19.3186 4.66228 19.5615 4.72945 19.786L5.11267 19.6714C5.0932 19.6063 5.11613 19.5363 5.16993 19.4955L4.92825 19.1768ZM4.72953 19.7863L5.0344 20.8003L5.41746 20.6851L5.11259 19.6711L4.72953 19.7863ZM5.34008 20.5785L4.47234 19.9753L4.24404 20.3038L5.11178 20.907L5.34008 20.5785ZM4.47311 19.9759C4.28034 19.8405 4.02364 19.8394 3.82981 19.9737L4.0576 20.3025C4.11339 20.2639 4.18742 20.264 4.24326 20.3033L4.47311 19.9759ZM3.82972 19.9738L2.95908 20.5776L3.18704 20.9063L4.05768 20.3025L3.82972 19.9738ZM3.26442 20.8001L3.57204 19.7875L3.18932 19.6712L2.8817 20.6838L3.26442 20.8001ZM3.57213 19.7872C3.63993 19.5628 3.56111 19.3197 3.37465 19.1777L3.13228 19.4959C3.18603 19.5368 3.20872 19.607 3.18922 19.6715L3.57213 19.7872ZM3.37419 19.1773L2.52908 18.5375L2.28763 18.8564L3.13274 19.4963L3.37419 19.1773ZM2.41234 18.8969L3.47326 18.8757L3.46528 18.4758L2.40436 18.497L2.41234 18.8969ZM3.47374 18.8757C3.70954 18.8704 3.91644 18.7186 3.99287 18.4961L3.61457 18.3661C3.5924 18.4306 3.53258 18.4743 3.4648 18.4758L3.47374 18.8757ZM3.99263 18.4968L4.3405 17.4963L3.96268 17.365L3.61482 18.3654L3.99263 18.4968ZM11.3105 17.4962L11.6577 18.498L12.0356 18.3671L11.6884 17.3652L11.3105 17.4962ZM11.658 18.499C11.7358 18.7197 11.9422 18.8693 12.1762 18.8743L12.1848 18.4744C12.1174 18.4729 12.0577 18.4298 12.0353 18.3661L11.658 18.499ZM12.1765 18.8743L13.2374 18.8955L13.2454 18.4955L12.1844 18.4744L12.1765 18.8743ZM13.1205 18.5362L12.276 19.1768L12.5178 19.4955L13.3623 18.8548L13.1205 18.5362ZM12.276 19.1769C12.0893 19.3186 12.0101 19.5614 12.0773 19.786L12.4605 19.6714C12.4411 19.6065 12.464 19.5363 12.5179 19.4954L12.276 19.1769ZM12.0774 19.7863L12.3822 20.8003L12.7653 20.6851L12.4604 19.6711L12.0774 19.7863ZM12.6879 20.5785L11.8202 19.9753L11.5919 20.3038L12.4596 20.907L12.6879 20.5785ZM11.8209 19.9759C11.6282 19.8405 11.3715 19.8394 11.1776 19.9737L11.4054 20.3025C11.4612 20.2639 11.5353 20.264 11.5911 20.3033L11.8209 19.9759ZM11.1776 19.9738L10.3069 20.5776L10.5349 20.9063L11.4055 20.3025L11.1776 19.9738ZM10.6123 20.8001L10.9199 19.7875L10.5372 19.6712L10.2295 20.6838L10.6123 20.8001ZM10.92 19.787C10.9875 19.5629 10.9091 19.3198 10.7225 19.1777L10.4801 19.4959C10.5337 19.5367 10.5565 19.6069 10.537 19.6717L10.92 19.787ZM10.722 19.1773L9.87692 18.5375L9.63547 18.8564L10.4806 19.4963L10.722 19.1773ZM9.76018 18.8969L10.8211 18.8757L10.8131 18.4758L9.7522 18.497L9.76018 18.8969ZM10.8216 18.8757C11.0572 18.8705 11.2645 18.7187 11.3408 18.4959L10.9623 18.3663C10.9404 18.4305 10.8806 18.4743 10.8126 18.4758L10.8216 18.8757ZM11.3405 18.4968L11.6883 17.4963L11.3105 17.365L10.9627 18.3654L11.3405 18.4968ZM18.6583 17.4962L19.0055 18.498L19.3835 18.3671L19.0362 17.3652L18.6583 17.4962ZM19.0058 18.4988C19.0834 18.7199 19.2903 18.8693 19.5242 18.8743L19.5328 18.4744C19.465 18.4729 19.4054 18.4296 19.3832 18.3663L19.0058 18.4988ZM19.5245 18.8743L20.5854 18.8955L20.5934 18.4955L19.5325 18.4744L19.5245 18.8743ZM20.4685 18.5362L19.624 19.1768L19.8658 19.4955L20.7103 18.8548L20.4685 18.5362ZM19.624 19.1769C19.4375 19.3185 19.3578 19.5613 19.4254 19.7862L19.8085 19.6712C19.789 19.6065 19.8119 19.5364 19.8659 19.4954L19.624 19.1769ZM19.4254 19.7863L19.7302 20.8003L20.1133 20.6851L19.8084 19.6711L19.4254 19.7863ZM20.0359 20.5785L19.1682 19.9753L18.9399 20.3038L19.8076 20.907L20.0359 20.5785ZM19.1691 19.976C18.9764 19.8405 18.7193 19.8395 18.5255 19.9737L18.7533 20.3025C18.8091 20.2638 18.8834 20.2641 18.939 20.3032L19.1691 19.976ZM18.5254 19.9738L17.6548 20.5776L17.8827 20.9063L18.7534 20.3025L18.5254 19.9738ZM17.9601 20.8001L18.2677 19.7875L17.885 19.6712L17.5774 20.6838L17.9601 20.8001ZM18.2679 19.787C18.3353 19.5628 18.2569 19.32 18.0703 19.1779L17.828 19.4961C17.8816 19.5369 17.9043 19.6069 17.8848 19.6717L18.2679 19.787ZM18.0699 19.1775L17.2248 18.5377L16.9833 18.8566L17.8284 19.4964L18.0699 19.1775ZM17.108 18.8971L18.1689 18.8759L18.161 18.476L17.1 18.4971L17.108 18.8971ZM18.1694 18.8759C18.4051 18.8706 18.6123 18.7188 18.6886 18.496L18.3102 18.3665C18.2882 18.4307 18.2284 18.4745 18.1605 18.476L18.1694 18.8759ZM18.6883 18.4969L19.0362 17.4963L18.6584 17.365L18.3105 18.3656L18.6883 18.4969Z",
				fill: "currentColor",
				mask: "url(#path-1-outside-1_2735_20776)"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/Hockey.tsx
function Z(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M14.5 0a1.502 1.502 0 011.267 2.303l-8.1 12.768c-.37.582-1 .929-1.688.929H2c-1.103 0-2-.897-2-2s.897-2 2-2h2.944L13.29.614A1.502 1.502 0 0114.5 0zM3 13H2c-.55 0-1 .448-1 1s.45 1 1 1h1v-2zm4.142-2.309L5.75 12.592c-.188.256-.49.408-.806.408H4v2h1.978c.344 0 .66-.174.845-.465l1.785-2.815-1.466-1.029zM8.594 8.71l-.861 1.174 1.412.991.739-1.165-1.29-1zM4.5 7a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-2A.5.5 0 01.5 7h4zM4 8H1v1h3V8zm10.5-7a.496.496 0 00-.403.205L9.186 7.902l1.237.959 4.5-7.094A.5.5 0 0014.5 1z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Home.tsx
function Q(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "18",
		viewBox: "0 0 20 18",
		width: "20",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M19.7447 6.7263L10.4122 0.128171C10.2949 0.0451422 10.1501 0 10.0009 0C9.85175 0 9.70691 0.0451422 9.58968 0.128171L0.254677 6.72742C0.185815 6.77617 0.128297 6.83666 0.0854073 6.90542C0.0425172 6.97417 0.0150951 7.04986 0.00470655 7.12816C-0.00568201 7.20646 0.00116647 7.28583 0.024861 7.36175C0.0485555 7.43766 0.0886319 7.50863 0.142802 7.57061C0.196972 7.63258 0.264176 7.68435 0.340575 7.72295C0.416974 7.76155 0.501073 7.78623 0.58807 7.79558C0.675067 7.80493 0.763258 7.79877 0.847608 7.77744C0.931958 7.75612 1.01082 7.72005 1.07968 7.6713L1.99968 7.0188V17.3992C1.99968 17.731 2.29843 17.9988 2.66593 17.9988H17.3334C17.5101 17.9988 17.6796 17.9356 17.8045 17.8232C17.9295 17.7107 17.9997 17.5582 17.9997 17.3992V7.0188L18.9209 7.6713C19.0604 7.76922 19.2372 7.81353 19.4129 7.79456C19.5885 7.77559 19.7487 7.69488 19.8584 7.57005C19.9666 7.4443 20.0154 7.2853 19.9944 7.12741C19.9733 6.96952 19.8841 6.82543 19.7459 6.7263H19.7447ZM12.6659 16.7984H7.33343V10.1992H12.6659V16.7984ZM16.6659 16.7984H13.9997V9.59842C13.9997 9.43939 13.9295 9.28687 13.8045 9.17442C13.6796 9.06197 13.5101 8.9988 13.3334 8.9988H6.66593C6.57843 8.9988 6.4918 9.01431 6.41096 9.04444C6.33013 9.07457 6.25668 9.11874 6.19482 9.17442C6.13295 9.2301 6.08387 9.2962 6.05039 9.36895C6.01691 9.4417 5.99968 9.51968 5.99968 9.59842V16.7984H3.33218V6.07717L9.99968 1.36117L16.6659 6.07492V16.7984Z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/HorseRacing.tsx
function $(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "1em",
		viewBox: "0 0 18 18",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M1.05194 2.68363L1.81307 2.98149C1.12782 4.74838 0.843008 7.04121 0.733028 8.27806C0.666142 9.03006 0.684423 9.70762 0.789032 10.3496C1.44787 14.3885 4.90112 17.3202 9.0002 17.3202C13.0993 17.3202 16.5525 14.3885 17.2114 10.3493C17.316 9.7074 17.3344 9.02983 17.2674 8.2778C17.1574 7.04091 16.8726 4.74823 16.1873 2.98123L16.9486 2.68337C17.1744 2.59501 17.3202 2.38129 17.3202 2.13885V1.26484C17.3202 0.94231 17.0579 0.679993 16.7353 0.679993H13.8105C13.4663 0.679993 13.1862 0.960161 13.1862 1.30433V2.78599C13.1862 2.80834 13.1896 2.83053 13.1968 2.85186C13.2171 2.91265 15.1994 8.96966 13.0029 12.0176C12.1708 13.1721 10.8241 13.7575 9.00002 13.7575C7.17958 13.7575 5.8349 13.173 5.00308 12.0202C2.80616 8.97527 4.78312 2.91244 4.80329 2.8519C4.8104 2.83072 4.81403 2.80852 4.81403 2.78617V1.30451C4.81403 0.960358 4.53386 0.680175 4.1897 0.680175H1.26484C0.942311 0.680175 0.679993 0.942496 0.679993 1.26503V2.13903C0.679993 2.38148 0.825808 2.59519 1.05172 2.68355L1.05194 2.68363ZM1.09619 1.2651C1.09619 1.17196 1.17193 1.09622 1.26507 1.09622H4.18992C4.30484 1.09622 4.39827 1.18966 4.39827 1.30457V2.75299C4.22185 3.29606 2.40575 9.13042 4.66567 12.2634C5.58002 13.5311 7.03832 14.1738 9.00024 14.1738C10.9655 14.1738 12.4258 13.5304 13.3404 12.2611C15.5989 9.12748 13.7791 3.29632 13.6021 2.75329V1.30487C13.6021 1.18995 13.6956 1.09652 13.8105 1.09652H16.7353C16.8285 1.09652 16.9042 1.17225 16.9042 1.2654V2.13941C16.9042 2.20934 16.8621 2.27115 16.797 2.29669L15.8404 2.67086C15.7883 2.69118 15.7467 2.73166 15.7248 2.78316C15.7029 2.83467 15.7026 2.8927 15.7241 2.94435C16.4454 4.68297 16.741 7.0557 16.853 8.31521C16.9169 9.03225 16.8997 9.67601 16.8008 10.2829C16.175 14.1198 12.8941 16.9048 9.00004 16.9048C5.10598 16.9048 1.82515 14.1199 1.1993 10.2833C1.10034 9.67609 1.08337 9.03248 1.14707 8.31547C1.25907 7.05596 1.55463 4.68331 2.27602 2.94461C2.2975 2.89296 2.29721 2.83493 2.2753 2.78342C2.25339 2.73206 2.21175 2.69158 2.15966 2.67112L1.20323 2.29695C1.13809 2.27141 1.09587 2.2096 1.09587 2.13967L1.09619 1.2651Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: "0.2"
		})
	});
}
//#endregion
//#region primitives/icon/icons/HotStreak.tsx
function ee(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "19",
		viewBox: "0 0 12 19",
		width: "12",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [/* @__PURE__ */ e("path", {
			d: "M1.24716 12.4219C0.874986 16.1406 3.60558 17.3359 4.97797 18C3.33755 14.8125 4.4024 13.4401 6.39464 10.9167C6.52745 11.4479 6.21206 12.1507 7.81133 13.75C8.87383 14.8125 9.03859 16.849 8.68442 18C10.2783 17.2031 11.806 15.9495 11.6064 11.7578C11.5001 9.52656 9.96828 7.55208 9.21567 6.97656C9.21567 7.42044 9.60034 8.5 8.75575 9.02778C8.10034 8.5 8.0206 7.375 7.75497 4.98438C7.54247 3.07188 6.07244 1.44271 5.36411 1C5.36438 1.39844 5.36438 2.19531 4.96594 4.1875C4.33596 7.3374 1.513 9.76563 1.24716 12.4219Z",
			fill: "#00182E"
		}), /* @__PURE__ */ e("path", {
			d: "M4.97797 18L4.86908 18.225C4.96589 18.2719 5.08181 18.2516 5.15691 18.1746C5.23202 18.0976 5.24947 17.9812 5.20026 17.8856L4.97797 18ZM1.24716 12.4219L0.998401 12.397L1.24716 12.4219ZM4.96594 4.1875L4.7208 4.13847L4.96594 4.1875ZM5.36411 1L5.49661 0.788C5.41952 0.739817 5.32234 0.737282 5.24284 0.78138C5.16334 0.825478 5.11405 0.909257 5.11411 1.00017L5.36411 1ZM7.75497 4.98438L8.00344 4.95677L7.75497 4.98438ZM8.75575 9.02778L8.59895 9.22249L8.73744 9.33402L8.88823 9.23979L8.75575 9.02778ZM9.21567 6.97656L9.36753 6.77797C9.29198 6.7202 9.19019 6.7103 9.10492 6.75244C9.01964 6.79457 8.96567 6.88145 8.96567 6.97656H9.21567ZM11.6064 11.7578L11.3567 11.7697L11.6064 11.7578ZM8.68442 18L8.44548 17.9265C8.41605 18.0221 8.44648 18.1261 8.52283 18.1908C8.59917 18.2554 8.70673 18.2684 8.79622 18.2236L8.68442 18ZM7.81133 13.75L7.63455 13.9268L7.81133 13.75ZM6.39464 10.9167L6.63717 10.856L6.51375 10.3623L6.19842 10.7618L6.39464 10.9167ZM5.08686 17.775C4.39188 17.4387 3.41009 16.992 2.63925 16.1839C1.88075 15.3888 1.31726 14.2319 1.49592 12.4468L0.998401 12.397C0.804887 14.3306 1.4206 15.6308 2.27746 16.529C3.12197 17.4143 4.19167 17.8973 4.86908 18.225L5.08686 17.775ZM1.49592 12.4468C1.62204 11.1866 2.35749 9.96621 3.18309 8.62055C3.99594 7.29565 4.88581 5.86291 5.21109 4.23653L4.7208 4.13847C4.41609 5.66199 3.57949 7.01832 2.75691 8.35907C1.94706 9.67906 1.13812 11.0009 0.998401 12.397L1.49592 12.4468ZM5.21109 4.23653C5.61268 2.22855 5.61439 1.4152 5.61411 0.999831L5.11411 1.00017C5.11437 1.38167 5.11608 2.16207 4.7208 4.13847L5.21109 4.23653ZM5.23161 1.212C5.54858 1.4101 6.07 1.90006 6.53949 2.58269C7.00685 3.2622 7.40615 4.10884 7.5065 5.01198L8.00344 4.95677C7.89129 3.94741 7.44933 3.02321 6.95146 2.29934C6.45574 1.57858 5.88798 1.0326 5.49661 0.788L5.23161 1.212ZM7.5065 5.01198C7.63833 6.19843 7.72625 7.0946 7.86448 7.7558C8.00282 8.41749 8.20189 8.90275 8.59895 9.22249L8.91255 8.83306C8.6542 8.62502 8.4857 8.2839 8.3539 7.65348C8.222 7.02259 8.13724 6.16095 8.00344 4.95677L7.5065 5.01198ZM9.06381 7.17515C9.4074 7.43789 9.95851 8.04736 10.4372 8.87182C10.9142 9.69336 11.306 10.7057 11.3567 11.7697L11.8561 11.7459C11.8005 10.5786 11.3733 9.48815 10.8696 8.62076C10.3677 7.75629 9.77655 7.09075 9.36753 6.77797L9.06381 7.17515ZM8.92337 18.0735C9.1137 17.4549 9.16069 16.6182 9.02579 15.8011C8.89102 14.9848 8.56896 14.1541 7.98811 13.5732L7.63455 13.9268C8.11619 14.4084 8.40776 15.1272 8.53247 15.8825C8.65702 16.637 8.60931 17.394 8.44548 17.9265L8.92337 18.0735ZM7.98811 13.5732C7.20668 12.7918 6.91365 12.2499 6.79175 11.8585C6.73057 11.662 6.70961 11.4946 6.69623 11.3374C6.68368 11.19 6.67677 11.0144 6.63717 10.856L6.1521 10.9773C6.17891 11.0845 6.18238 11.196 6.19803 11.3798C6.21284 11.5538 6.23789 11.7616 6.31437 12.0072C6.4678 12.4998 6.81671 13.1089 7.63455 13.9268L7.98811 13.5732ZM11.3567 11.7697C11.4551 13.8362 11.1258 15.1436 10.603 16.0243C10.082 16.902 9.3504 17.3875 8.57263 17.7764L8.79622 18.2236C9.6123 17.8156 10.4415 17.2758 11.0329 16.2796C11.6225 15.2863 11.9573 13.8711 11.8561 11.7459L11.3567 11.7697ZM6.19842 10.7618C5.21199 12.0112 4.41087 13.0257 4.08418 14.1389C3.74984 15.2781 3.91774 16.4862 4.75568 18.1144L5.20026 17.8856C4.39778 16.3263 4.2779 15.2544 4.56394 14.2797C4.85763 13.279 5.58505 12.3456 6.59086 11.0716L6.19842 10.7618ZM8.88823 9.23979C9.4089 8.91443 9.54185 8.4142 9.55236 7.97671C9.55756 7.76047 9.53356 7.55128 9.5104 7.37714C9.48558 7.1906 9.46567 7.06578 9.46567 6.97656H8.96567C8.96567 7.10928 8.99385 7.28586 9.01476 7.44308C9.03733 7.61269 9.05671 7.7896 9.05251 7.9647C9.04421 8.30991 8.94719 8.61335 8.62327 8.81577L8.88823 9.23979Z",
			fill: "#00182E"
		})]
	});
}
//#endregion
//#region primitives/icon/icons/IceHockey.tsx
function te(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M18.5 4a1.502 1.502 0 011.267 2.303l-8.1 12.768c-.37.582-1 .929-1.688.929H6c-1.103 0-2-.897-2-2s.897-2 2-2h2.944L17.29 4.614A1.502 1.502 0 0118.5 4zM7 17H6c-.55 0-1 .448-1 1s.45 1 1 1h1v-2zm4.142-2.309L9.75 16.592c-.188.256-.49.408-.806.408H8v2h1.978c.344 0 .66-.174.845-.465l1.785-2.815-1.466-1.029zm1.452-1.981l-.861 1.174 1.412.991.739-1.165-1.29-1zM8.5 11a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h4zM8 12H5v1h3v-1zm10.5-7a.496.496 0 00-.403.205l-4.911 6.697 1.237.959 4.5-7.094A.5.5 0 0018.5 5z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Info.tsx
function ne(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "15",
		viewBox: "0 0 15 15",
		width: "15",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M7.5 13.5C8.28793 13.5 9.06815 13.3448 9.7961 13.0433C10.5241 12.7417 11.1855 12.2998 11.7426 11.7426C12.2998 11.1855 12.7417 10.5241 13.0433 9.7961C13.3448 9.06815 13.5 8.28793 13.5 7.5C13.5 6.71207 13.3448 5.93185 13.0433 5.2039C12.7417 4.47594 12.2998 3.81451 11.7426 3.25736C11.1855 2.70021 10.5241 2.25825 9.7961 1.95672C9.06815 1.65519 8.28793 1.5 7.5 1.5C5.9087 1.5 4.38258 2.13214 3.25736 3.25736C2.13214 4.38258 1.5 5.9087 1.5 7.5C1.5 9.0913 2.13214 10.6174 3.25736 11.7426C4.38258 12.8679 5.9087 13.5 7.5 13.5ZM7.5 15C3.35775 15 0 11.6422 0 7.5C0 3.35775 3.35775 0 7.5 0C11.6422 0 15 3.35775 15 7.5C15 11.6422 11.6422 15 7.5 15ZM6.75 6.75V11.25H8.25V6.75H6.75ZM6.75 3.75H8.25V5.25H6.75V3.75Z",
			fill: "white",
			opacity: "0.6"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Infinity.tsx
function re(t) {
	return /* @__PURE__ */ e("svg", {
		id: "Layer_1",
		version: "1.1",
		viewBox: "0 0 16 16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M12.98,3.93c-1.84-.55-3.71.12-4.78,1.71l-.2.3h0s-1.37,2.05-1.37,2.05c0,0,0,0,0,0h0s-.73,1.1-.73,1.1c-.6.9-1.53,1-2.21.79-.68-.2-1.4-.81-1.4-1.89s.72-1.68,1.4-1.89c.19-.06.39-.09.6-.09.56,0,1.17.23,1.61.88l.27.4,1.36-2.04c-1.09-1.33-2.81-1.86-4.5-1.35-1.84.56-3.02,2.16-3.02,4.07s1.19,3.52,3.02,4.07c1.84.56,3.71-.12,4.78-1.71l.2-.3,1.37-2.06.73-1.09c.6-.9,1.53-1,2.21-.79.68.2,1.4.81,1.4,1.89s-.72,1.68-1.4,1.89c-.67.21-1.61.1-2.21-.79l-.27-.41-1.36,2.04c.82,1,1.98,1.54,3.23,1.54.42,0,.85-.06,1.28-.19,1.84-.56,3.02-2.16,3.02-4.07s-1.19-3.52-3.02-4.08Z",
			fill: "#fff"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Insights.tsx
function ie(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "currentColor",
		height: "21",
		viewBox: "0 0 20 21",
		width: "20",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M6.53424 15.2537C4.89131 14.1353 3.80691 12.2401 3.80691 10.0876C3.80691 6.64038 6.58455 3.85474 10.0001 3.85474C13.4156 3.85474 16.1933 6.64038 16.1933 10.0876C16.1933 12.24 15.1089 14.1352 13.4661 15.2536V17.4904C13.4661 19.4287 11.9143 21 10.0001 21C8.08598 21 6.53424 19.4287 6.53424 17.4904V15.2537ZM5.28418 10.0876C5.28418 7.47634 7.39071 5.35063 10.0001 5.35063C12.6095 5.35063 14.716 7.47634 14.716 10.0876C14.716 11.6983 13.9159 13.1235 12.6873 13.9809H7.31285C6.08427 13.1235 5.28418 11.6983 5.28418 10.0876ZM11.9888 15.4767H8.01151V16.2822H11.9888V15.4767ZM10.0001 19.5041C8.99831 19.5041 8.1695 18.754 8.03165 17.7781H11.9686C11.8308 18.754 11.002 19.5041 10.0001 19.5041Z",
				fill: "currentColor",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				d: "M9.09091 0.920543C9.09091 0.412141 9.49792 0 10 0C10.5021 0 10.9091 0.412141 10.9091 0.920543V2.8186C10.6113 2.781 10.3079 2.76163 10 2.76163C9.69213 2.76163 9.38872 2.781 9.09091 2.8186V0.920543Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M5.54037 4.30823L4.21464 2.96581C3.85962 2.60631 3.28402 2.60631 2.929 2.96581C2.57397 3.3253 2.57397 3.90816 2.929 4.26765L4.25471 5.61007C4.628 5.12382 5.06017 4.68622 5.54037 4.30823Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M2.78354 9.20543H0.909091C0.407014 9.20543 0 9.61757 0 10.126C0 10.6344 0.407014 11.0465 0.909091 11.0465H2.78354C2.7464 10.745 2.72727 10.4377 2.72727 10.126C2.72727 9.81422 2.7464 9.50699 2.78354 9.20543Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M17.2165 11.0465H19.0909C19.593 11.0465 20 10.6344 20 10.126C20 9.61757 19.593 9.20543 19.0909 9.20543H17.2165C17.2536 9.50699 17.2727 9.81422 17.2727 10.126C17.2727 10.4377 17.2536 10.745 17.2165 11.0465Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M15.7455 5.61029L17.0713 4.26774C17.4263 3.90824 17.4263 3.32539 17.0713 2.96589C16.7163 2.6064 16.1407 2.6064 15.7857 2.96589L14.4598 4.30841C14.94 4.68641 15.3722 5.12403 15.7455 5.61029Z",
				fill: "currentColor"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/Instagram.tsx
function ae(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 40 40",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm5.23-7A6.778 6.778 0 0032 26.23V14.77A6.778 6.778 0 0025.23 8H13.77A6.778 6.778 0 007 14.77v11.46A6.778 6.778 0 0013.77 33h11.46zM13.77 10.083h11.46a4.693 4.693 0 014.687 4.688v11.458a4.693 4.693 0 01-4.688 4.688H13.771a4.693 4.693 0 01-4.688-4.688V14.771a4.693 4.693 0 014.688-4.688zM19.5 26.75a6.257 6.257 0 006.25-6.25 6.257 6.257 0 00-6.25-6.25 6.257 6.257 0 00-6.25 6.25 6.257 6.257 0 006.25 6.25zm0-10.417a4.171 4.171 0 014.167 4.167 4.171 4.171 0 01-4.167 4.167 4.171 4.171 0 01-4.167-4.167 4.171 4.171 0 014.167-4.167zm6.64-1.041a1.432 1.432 0 100-2.865 1.432 1.432 0 000 2.865z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/InstagramFlat.tsx
function oe(t) {
	return /* @__PURE__ */ e("svg", {
		height: "50",
		viewBox: "0 0 50 50",
		width: "50",
		...t,
		children: /* @__PURE__ */ e("g", { children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M18.3335 41.25H32.4358C37.0312 41.25 40.7692 37.4535 40.7692 32.7867V18.4637C40.7692 13.7965 37.0312 10 32.4358 10H18.3335C13.7385 10 10 13.7965 10 18.4637V32.7863C10 37.4535 13.7385 41.25 18.3335 41.25ZM12.5642 18.4637C12.5642 15.2328 15.1523 12.6043 18.3335 12.6043H32.4358C35.6169 12.6043 38.205 15.2328 38.205 18.4637V32.7867C38.205 36.0176 35.6169 38.6461 32.4358 38.6461H18.3335C15.1523 38.6461 12.5642 36.0176 12.5642 32.7867V18.4637ZM17.9487 25.625C17.9487 29.9324 21.3995 33.4375 25.641 33.4375C29.8826 33.4375 33.3333 29.9324 33.3333 25.625C33.3333 21.3168 29.8826 17.8125 25.641 17.8125C21.3995 17.8125 17.9487 21.3168 17.9487 25.625ZM20.513 25.625C20.513 22.7531 22.8133 20.4168 25.641 20.4168C28.4691 20.4168 30.7691 22.7531 30.7691 25.625C30.7691 28.4973 28.4687 30.8332 25.641 30.8332C22.8133 30.8332 20.513 28.4973 20.513 25.625ZM33.8141 19.1145C34.7876 19.1145 35.5768 18.3129 35.5768 17.3242C35.5768 16.3355 34.7876 15.534 33.8141 15.534C32.8406 15.534 32.0514 16.3355 32.0514 17.3242C32.0514 18.3129 32.8406 19.1145 33.8141 19.1145Z",
			fill: "currentColor",
			fillRule: "evenodd"
		}) })
	});
}
//#endregion
//#region primitives/icon/icons/LeagueChampionsLeague.tsx
function se(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "36",
		viewBox: "0 0 36 36",
		width: "36",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ e("path", {
			d: "M27.9001 20.7552C27.867 20.8231 27.8014 20.8699 27.7262 20.8786C26.0121 21.0775 24.1908 20.8391 23.4886 20.7289C22.3164 19.5578 21.0474 18.2551 20.1119 17.1167C20.016 17.0001 20.0113 16.8333 20.0996 16.7105C21.4337 14.8505 22.6555 13.3746 23.172 12.7903C24.6477 12.4687 26.1192 12.1839 27.1129 12.1433C27.188 12.1403 27.2594 12.1749 27.3034 12.2358C28.5843 14.0175 29.5005 15.7246 29.7946 16.3485C29.2064 17.9287 28.4988 19.525 27.9001 20.7552ZM26.2647 23.7697C25.3199 25.3515 24.6021 26.3052 24.372 26.5952C24.0598 27.0359 23.264 28.1841 22.0277 29.3454C21.9488 29.4196 21.846 29.4622 21.7375 29.4669C20.1893 29.5314 18.7498 29.4228 18.1892 29.3005C17.7145 29.1042 16.6098 28.6074 15.304 27.8855C15.1901 27.8226 15.1231 27.6999 15.1316 27.5704C15.1998 26.5582 15.5209 25.1164 15.805 23.5917C16.5074 22.3583 17.2357 20.951 17.9908 19.795C18.0703 19.6734 18.2192 19.6168 18.3597 19.6552C20.6207 20.2724 22.5826 20.7411 23.3791 20.9203C24.4697 22.1849 25.5266 23.0741 26.2376 23.6254C26.2818 23.6597 26.2932 23.7216 26.2647 23.7697ZM12.5852 25.9679C12.4706 26.0389 12.3247 26.0351 12.2146 25.9572C11.2301 25.2603 10.0555 24.3698 9.07709 23.4556C8.49994 22.4693 8.05486 21.2071 7.74416 20.1322C7.72407 20.063 7.73954 19.988 7.78515 19.9323C8.88298 18.5826 10.2006 17.5148 10.7514 17.1083C11.9941 17.6443 13.4204 18.1172 14.6681 18.5321C14.7957 18.5745 14.8858 18.6889 14.8964 18.8226C15.0723 21.0422 15.479 22.8371 15.5876 23.523C15.1217 24.0208 13.9044 25.1492 12.5852 25.9679ZM7.11692 17.2344C6.95403 16.1866 6.84694 15.0862 6.83513 14.5822C6.80812 13.4185 6.99299 12.3879 7.20773 11.4337C7.24302 11.2774 7.32405 11.1358 7.44228 11.0276C8.06599 10.4564 9.19382 9.44848 9.90563 8.992C10.5766 8.56182 12.4413 7.95984 13.2103 7.73653C13.3593 7.69308 13.5181 7.75935 13.5948 7.89408C13.6872 8.05649 13.7839 8.21771 13.8864 8.37643C14.4918 9.31882 15.1589 10.1301 15.4399 10.4816C15.0674 11.9603 14.9091 13.6183 14.8371 15.0169C14.8303 15.1481 14.7467 15.2631 14.6241 15.3109C12.6786 16.0697 11.2082 16.6635 10.7141 16.8915C9.37734 16.9479 8.10413 17.1757 7.24478 17.3259C7.18384 17.3366 7.12642 17.2951 7.11692 17.2344ZM16.9244 7.07909C16.9776 6.99655 17.0648 6.94152 17.1622 6.9286C19.1629 6.66435 20.9933 6.62543 21.6968 6.64488C22.9771 7.49618 24.2281 8.61944 25.2266 9.6847C25.2965 9.75936 25.307 9.87177 25.2517 9.95801C24.5392 11.0722 23.503 12.142 23.0479 12.6079C21.3599 13.0073 19.5703 13.5888 18.1178 14.0655C17.9765 14.1118 17.8212 14.0593 17.7368 13.9369C16.6346 12.336 15.9342 10.9635 15.6596 10.4544C15.9577 9.11974 16.3746 7.93097 16.9244 7.07909ZM30.2884 20.2207C30.2525 20.2368 30.2114 20.2116 30.2094 20.1725C30.1255 18.5291 29.9743 16.9323 29.8951 16.3484C29.9015 14.9291 29.6661 13.4564 29.4313 12.3705C29.4229 12.3313 29.4577 12.2962 29.4972 12.3041C30.8401 12.5782 31.2712 13.081 31.2712 13.081C30.5602 11.4874 29.5358 10.2864 28.4224 9.37868C27.4705 7.38607 26.3748 6.46442 26.3748 6.46442C26.4634 6.90516 26.4024 7.40362 26.2453 7.91802C26.2354 7.95073 26.1979 7.96634 26.1671 7.95141C24.3426 7.05952 22.4585 6.65216 21.7298 6.5502C20.6408 6.02104 19.4513 5.67089 18.484 5.40547C18.4582 5.39843 18.4512 5.36503 18.472 5.34775C19.7558 4.28271 20.9367 4.01159 20.9367 4.01159C18.846 3.92787 17.0466 4.30586 15.5419 4.88386C13.2939 4.70383 11.8619 5.09459 11.8619 5.09459C11.8619 5.09459 12.4826 5.83716 12.7239 6.25056C12.753 6.30057 12.7378 6.36465 12.6901 6.39754C11.2762 7.37734 10.2617 8.45367 9.86165 8.90174C9.41602 8.96197 8.64423 9.06851 7.97016 9.23461C7.94328 9.24131 7.92048 9.2143 7.93134 9.18881C8.60636 7.58196 9.34218 6.69248 9.34218 6.69248C9.34218 6.69248 5.0035 9.77112 4.18107 15.3033C4.18107 15.3033 4.53833 14.3227 5.74639 12.8363C5.76227 12.8169 5.79308 12.8207 5.8034 12.8437C6.14572 13.601 6.53705 14.2736 6.73373 14.5822C6.0693 15.651 5.61065 16.8163 5.32818 17.77C5.31841 17.8031 5.29343 17.8297 5.26086 17.8419C4.256 18.2231 4 18.5867 4 18.5867C4.15623 19.1199 4.463 19.6396 4.85052 20.1295C4.88419 20.1719 4.90129 20.2248 4.89898 20.2788C4.79229 22.6398 5.55459 24.1939 5.55459 24.1939C5.7267 23.3693 6.06374 22.5683 6.48941 21.8166C6.50638 21.7866 6.54628 21.7791 6.57316 21.8004C7.56485 22.5874 8.5921 23.2755 8.99972 23.5198C9.20998 24.0562 9.81197 25.4482 10.6163 26.8763C10.6332 26.9064 10.6195 26.9446 10.587 26.9564C9.62384 27.307 8.63567 27.4657 7.72963 27.2452C7.72963 27.2452 8.82231 28.6053 12.1929 29.1853C13.128 30.2894 14.266 31.2037 15.595 31.5213C15.595 31.5213 15.2055 31.0935 15.1092 29.4991C15.1072 29.4668 15.1331 29.4393 15.1656 29.4398C15.9978 29.4523 17.1267 29.4703 18.16 29.3954C18.5263 29.6839 19.3255 30.3171 20.105 30.7206C20.1438 30.7407 20.1463 30.7953 20.1089 30.8179C18.7387 31.6455 17.8269 31.7176 17.8269 31.7176C24.0338 31.8497 27.7604 27.8064 27.7604 27.8064C26.738 28.4781 25.5574 28.8958 24.3822 29.1446C24.3426 29.153 24.3078 29.118 24.3161 29.0783C24.5344 28.0238 24.4731 27.0041 24.4578 26.6449C25.9304 26.28 27.215 25.6228 28.1661 24.9509C28.1853 24.9373 28.2109 24.9372 28.2303 24.9506C28.6263 25.2257 28.9651 25.5344 29.3032 26.0483C29.3032 26.0483 29.9471 25.1383 30.1686 23.0299C31.763 20.951 32 18.823 32 18.823C31.6 19.4478 30.996 19.898 30.2884 20.2207Z",
			fill: "#00004B"
		})
	});
}
//#endregion
//#region primitives/icon/icons/LeagueMLB.tsx
function ce(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "100%",
		viewBox: "0 0 44 24",
		width: "50",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				d: "M40.3384 4.0328e-05H3.66857C2.69646 -0.00300847 1.76229 0.377707 1.06844 1.05971C0.725503 1.40375 0.454422 1.81277 0.271015 2.26289C0.087608 2.71301 -0.00444934 3.19521 0.000216124 3.68135V20.0718C-0.00506297 20.5562 0.0864181 21.0367 0.269278 21.4852C0.452138 21.9336 0.722685 22.3409 1.065 22.6831C1.40685 23.0254 1.81281 23.2968 2.25959 23.4816C2.70638 23.6664 3.1852 23.761 3.66857 23.76H40.3384C41.3117 23.7554 42.2435 23.3647 42.9297 22.6735C43.616 21.9822 44.0008 21.0467 43.9999 20.0718V3.67791C44.0035 3.19856 43.9128 2.72318 43.733 2.27893C43.5532 1.83467 43.2878 1.43024 42.952 1.08873C42.6161 0.747211 42.2164 0.475297 41.7757 0.288511C41.3349 0.101725 40.8618 0.00372411 40.3832 0.000104503C40.3683 -8.44465e-06 40.3533 -2.98362e-05 40.3384 4.0328e-05Z",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M42.7121 3.6781C42.7195 3.05219 42.4782 2.449 42.0415 2.00124C41.6048 1.55348 41.0085 1.29782 40.3836 1.2905C40.3686 1.29033 40.3537 1.2903 40.3387 1.29041H30.0893L35.9697 11.1336L36.5124 11.2024L36.8558 11.6531V12.0729L37.2268 12.1485L37.5703 12.6165V13.0224L37.955 13.0912L38.3431 13.5144V14.4502C38.8052 14.8681 39.3259 15.2159 39.8888 15.4824C40.4074 15.6819 40.4658 16.5145 40.7784 16.9584C41.1699 17.6052 41.7058 17.8632 41.5924 18.2245C41.3314 19.1912 40.3421 20.822 39.4216 20.8977H35.7808V22.4597H40.3421C40.9744 22.457 41.5796 22.2028 42.0247 21.7531C42.4698 21.3034 42.7184 20.695 42.7157 20.0618L42.7156 20.0514V3.67811",
				fill: "#BF0D3E"
			}),
			/* @__PURE__ */ e("path", {
				d: "M17.6389 20.9218H15.8768C15.8768 16.5111 17.3641 14.0718 19.1468 13.5867C19.3906 13.5419 19.2738 12.3378 18.9647 11.9696H17.9343C17.7694 11.9696 17.8656 11.66 17.8656 11.66L18.7002 9.87438L18.5869 9.38583H15.5024L18.0373 7.61054C18.1541 2.92806 22.9491 2.56336 25.8377 4.51411C27.5551 5.65291 27.6856 7.90987 27.5551 9.4684C27.5345 9.56818 27.1086 9.5028 27.1086 9.5028C27.1086 9.5028 26.8166 11.223 27.5792 11.223H30.9487C32.3226 11.168 33.6484 12.1004 33.6484 12.1004L33.9713 10.9203L26.5899 1.29039H3.66958C3.03553 1.28667 2.42568 1.53398 1.97279 1.97848C1.75197 2.20235 1.57758 2.46778 1.45967 2.75949C1.34177 3.05119 1.28269 3.36339 1.28583 3.67808V20.072C1.28188 20.3857 1.34062 20.6971 1.4586 20.9878C1.57657 21.2785 1.7514 21.5427 1.97279 21.7647C2.42289 22.2155 3.03308 22.4691 3.66958 22.47H18.5491C18.185 21.8438 17.7694 21.1316 17.6423 20.9218",
				fill: "#041E42"
			}),
			/* @__PURE__ */ e("path", {
				d: "M4.59 17.4435C4.59001 17.1209 4.6855 16.8056 4.86441 16.5375C5.04332 16.2693 5.2976 16.0603 5.5951 15.9369C5.8926 15.8134 6.21995 15.7812 6.53577 15.8441C6.85159 15.907 7.14168 16.0624 7.36936 16.2904C7.59705 16.5185 7.7521 16.8091 7.81491 17.1254C7.87772 17.4418 7.84546 17.7697 7.72223 18.0677C7.59899 18.3656 7.3903 18.6203 7.12256 18.7995C6.85481 18.9787 6.54004 19.0743 6.21803 19.0743L6.20435 19.0743C5.9928 19.0747 5.78323 19.0334 5.58761 18.9528C5.39199 18.8721 5.21414 18.7537 5.06423 18.6042C4.91431 18.4546 4.79527 18.277 4.71388 18.0814C4.6325 17.8858 4.59037 17.6761 4.58991 17.4642C4.58989 17.4573 4.58992 17.4504 4.59 17.4435Z",
				fill: "white"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/LeagueNBA.tsx
function le(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "100%",
		viewBox: "0 0 15 35",
		width: "20",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				d: "M11.4972 0H3.50275C1.56824 0 0 1.61261 0 3.60186V31.3981C0 33.3874 1.56824 35 3.50275 35H11.4972C13.4318 35 15 33.3874 15 31.3981V3.60186C15 1.61261 13.4318 0 11.4972 0Z",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M9.85807 0.998047C9.36822 0.998104 9.00905 1.00005 8.98681 1.0032L8.93291 1.01081L9.05044 1.06312C9.20501 1.13189 9.37643 1.23823 9.4677 1.32193C9.50814 1.35902 9.57387 1.43995 9.61378 1.50178C9.66931 1.58782 9.69785 1.6183 9.73539 1.63168C9.8547 1.67419 9.94428 1.7728 10.0241 1.94949C10.0852 2.08495 10.1076 2.21621 10.1079 2.44098C10.1083 2.75244 10.0395 3.03265 9.87545 3.38773L9.80078 3.54929L9.8546 3.61265C9.9687 3.74698 9.94523 3.87046 9.74152 4.20773C9.6932 4.28773 9.63871 4.38333 9.62043 4.42018C9.56586 4.53021 9.51455 4.58199 9.43128 4.61113L9.35528 4.63775L9.25668 4.83351C9.01762 5.30806 8.83667 5.56064 8.6831 5.63419C8.65428 5.64799 8.62331 5.66915 8.61426 5.68118C8.58703 5.71736 8.56439 5.8139 8.56497 5.89137C8.56599 6.02807 8.57465 6.03708 8.82968 6.1666C9.09073 6.29918 9.28798 6.41849 9.41392 6.52004C9.49385 6.58449 9.50021 6.59395 9.50021 6.64794C9.50021 6.69572 9.50722 6.71068 9.53909 6.73107C9.65132 6.80285 9.7436 6.86696 9.83368 6.93571C9.88878 6.97777 10.0192 7.07106 10.1235 7.14297C10.3659 7.31016 10.4954 7.41864 10.6459 7.58063C11.1188 8.08975 11.379 8.8354 11.4507 9.88634C11.4586 10.0032 11.4652 10.2783 11.4653 10.4977L11.4654 10.8966L11.5141 11.0984C11.5642 11.3059 11.6153 11.5808 11.6918 12.0548C11.7446 12.3813 11.7958 12.637 11.8351 12.7697C11.8511 12.8238 11.9407 13.0295 12.0342 13.2269C12.2517 13.6858 12.3248 13.8606 12.411 14.128C12.4805 14.3436 12.5377 14.6052 12.56 14.8093C12.6161 15.3238 12.698 15.7339 12.7585 15.8024C12.7676 15.8127 12.8478 15.8409 12.9367 15.8651C13.0256 15.8892 13.1379 15.9281 13.1862 15.9515C13.2692 15.9917 13.2768 15.9998 13.3206 16.094L13.3669 16.1939L13.5295 16.279C13.619 16.3258 13.7102 16.3818 13.7323 16.4035C13.7844 16.4547 13.8233 16.5341 13.8353 16.6138C13.8405 16.6488 13.8645 16.7071 13.8885 16.7433C13.9845 16.888 14.1275 17.1643 14.141 17.2314C14.1429 17.241 14.1462 14.1763 14.1482 10.4211C14.1522 2.91548 14.1581 3.44763 14.0673 3.08262C13.9921 2.7804 13.8641 2.48704 13.6931 2.22452C13.2751 1.58337 12.6384 1.16543 11.8685 1.0273C11.742 1.00461 11.5852 1.00162 10.3839 0.99886C10.1993 0.998437 10.0215 0.99824 9.85818 0.998258L9.85807 0.998047ZM9.65448 10.282C9.58408 10.282 9.08011 10.5952 8.78469 10.8226C8.67106 10.91 8.65411 10.9295 8.60782 11.0263C8.53642 11.1755 8.26624 11.877 7.9832 12.6481L7.85407 12.9998L7.84886 13.1646C7.84405 13.3167 7.84567 13.3294 7.86962 13.3296C7.90961 13.3298 8.02979 13.4072 8.10162 13.4791C8.24358 13.6211 8.33052 13.8002 8.44489 14.1865C8.53516 14.4914 8.75303 15.2806 8.9363 15.9667L9.12175 16.6609L9.18002 16.8789L9.09734 16.9612L9.01464 17.0436L9.04758 17.1681C9.06571 17.2366 9.09883 17.3619 9.1212 17.4465C9.38476 18.4436 9.50688 19.169 9.62793 20.4575C9.6857 21.0722 9.72921 21.2854 9.8674 21.6302C10.001 21.9636 10.1455 22.2594 10.3281 22.5737C10.5877 23.0203 10.7349 23.3395 10.8174 23.6342C10.8995 23.9276 11.0048 24.4784 11.1261 25.2485C11.285 26.2574 11.3409 26.5945 11.365 26.6896C11.3875 26.7783 11.4112 26.8215 11.5245 26.9808C11.7179 27.2525 11.7633 27.3245 11.8587 27.5121C12.014 27.8174 12.0532 28.0015 12.0114 28.23C11.9989 28.2985 11.963 28.4634 11.9316 28.5963C11.7818 29.2305 11.7538 29.5335 11.8177 29.8286C11.8255 29.865 11.8578 30.0573 11.8893 30.2559C11.9529 30.656 11.9941 30.8241 12.0489 30.9071C12.0971 30.9801 12.1442 31.129 12.1438 31.2075C12.1435 31.242 12.1309 31.299 12.1155 31.3341C12.1001 31.3693 12.0875 31.4081 12.0875 31.4205C12.0875 31.4328 12.1509 31.6414 12.2282 31.8841C12.3056 32.1267 12.3851 32.3845 12.4047 32.457C12.561 33.0325 12.5577 33.4991 12.3952 33.8343C12.2835 34.0645 12.1459 34.2188 11.895 34.3951C11.8723 34.4111 11.8788 34.4126 11.9391 34.4051C12.033 34.3934 12.2075 34.3475 12.3597 34.2944C12.7533 34.1572 13.1479 33.8888 13.4456 33.5559C13.8271 33.1294 14.0755 32.5623 14.1368 31.9778C14.147 31.8801 14.1516 29.834 14.1515 25.4578L14.1514 19.08L14.1062 19.1826C14.0483 19.3141 13.9102 19.5547 13.8318 19.6608C13.6065 19.9656 13.2967 20.2255 12.9607 20.3914C12.1698 20.782 11.2492 20.6999 10.5323 20.1747C10.3608 20.0491 10.0999 19.7787 9.9779 19.6C9.47942 18.8702 9.39508 17.9246 9.75608 17.1123C10.0281 16.5002 10.5719 16.0017 11.1826 15.8048C11.2642 15.7784 11.3367 15.7517 11.3436 15.7454C11.3598 15.7306 11.326 15.6438 11.1391 15.2193C10.9903 14.8809 10.7944 14.461 10.4728 13.7898C10.2966 13.4219 10.2704 13.3426 10.1661 12.8604C10.0664 12.3992 9.90115 11.519 9.75483 10.6699C9.68527 10.2669 9.68909 10.2817 9.65459 10.2817L9.65448 10.282Z",
				fill: "#C8102E"
			}),
			/* @__PURE__ */ e("path", {
				d: "M5.72373 0.992842C4.57661 0.993516 3.40858 0.998703 3.31233 1.00774C2.67172 1.0679 2.12223 1.32512 1.66981 1.77656C1.23273 2.21273 0.979182 2.71427 0.86602 3.36656C0.843462 3.49659 0.841632 4.39462 0.837165 17.5131C0.833924 27.0292 0.83707 31.6068 0.846995 31.7909C0.886866 32.5306 1.13754 33.1183 1.63153 33.6304C2.0977 34.1137 2.68418 34.3934 3.33331 34.442C3.5258 34.4565 11.4513 34.4605 11.4507 34.4462C11.4505 34.4403 11.4118 34.4091 11.3646 34.3769C11.1862 34.2548 11.0437 34.0527 10.9915 33.8476C10.9281 33.5984 10.9317 33.316 11.0063 32.6773C11.0715 32.1184 11.1115 31.6744 11.121 31.4019L11.1303 31.133L11.0539 31.0472C10.8918 30.8653 10.8591 30.7305 10.9332 30.5495C10.9537 30.4994 10.9704 30.4425 10.9704 30.4232C10.9704 30.3698 10.895 30.1181 10.8248 29.9374C10.743 29.7267 10.6208 29.4754 10.4317 29.1288C10.1604 28.6318 10.1052 28.4979 10.1037 28.333C10.1027 28.2291 10.1222 28.1768 10.1929 28.0934L10.2348 28.044L10.1943 27.9211C10.1407 27.7584 10.0853 27.6165 9.97331 27.3547L9.88066 27.1382L9.75223 27.0593C9.23393 26.7399 8.60433 26.2461 7.98802 25.6732C7.80522 25.5033 7.47975 25.178 7.20972 24.8967C7.04254 24.722 6.78488 24.4689 6.63713 24.3342C6.37369 24.094 6.27445 23.9883 6.22996 23.9005C6.21771 23.8764 6.17118 23.8137 6.12655 23.7613C5.55221 23.0873 4.26088 21.1136 3.82961 20.2508C3.78169 20.1549 3.74112 20.0748 3.73948 20.0729C3.73783 20.0709 3.58511 20.0467 3.40007 20.019C3.21503 19.9914 3.05897 19.9634 3.05328 19.9567C3.04758 19.9501 3.01959 19.8632 2.99107 19.7637C2.87897 19.3726 2.73563 19.0439 2.32558 18.2377C1.74061 17.0876 1.5886 16.5076 1.67459 15.7542C1.72974 15.2709 1.88481 14.5109 1.96337 14.3389C2.01071 14.2353 2.12029 14.0955 2.28834 13.9243L2.445 13.7643V13.5862V13.4081L2.06679 13.4077C1.5658 13.4073 1.42228 13.3851 1.31707 13.2918C1.25366 13.2355 1.24193 13.205 1.18609 12.9506C1.16959 12.8754 1.13371 12.7567 1.10634 12.6869C0.995985 12.4051 0.989052 12.2957 1.06567 12.045C1.09241 11.9574 1.12467 11.8435 1.13735 11.7918C1.25089 11.3289 1.53751 10.6267 2.09173 9.45364C2.18691 9.25218 2.28571 9.02471 2.31128 8.94816C2.48067 8.44121 2.64107 8.03927 2.80826 7.70276C3.17816 6.95833 3.46204 6.51422 3.75462 6.22235C3.90475 6.07254 4.01632 5.99174 4.1893 5.90752C4.42354 5.79348 4.59755 5.75707 5.16637 5.70303L5.54787 5.66677L5.59051 5.61663L5.63312 5.5665L5.81691 5.5574C6.42581 5.5272 6.64517 5.44778 6.74919 5.21987C6.80079 5.10684 6.82329 4.98525 6.87765 4.52578C6.90497 4.29482 6.92877 4.09597 6.93056 4.08388C6.93256 4.07031 6.92447 4.06353 6.9094 4.06614C6.77998 4.08854 6.67097 3.78998 6.66709 3.40258C6.66395 3.08845 6.70834 3.01735 6.91766 3.00119L7.03274 2.99211L7.03585 2.88222C7.04269 2.6429 7.07145 2.29498 7.09757 2.13574C7.1576 1.76979 7.23752 1.59043 7.42756 1.39507C7.566 1.25276 7.70562 1.15811 7.91115 1.0673C7.98271 1.03568 8.022 1.01108 8.01161 1.00443C7.99761 0.995416 6.87083 0.991578 5.72349 0.992266L5.72373 0.992842ZM2.52986 27.6449H2.98081H3.43176L3.45405 27.7731C3.46631 27.8436 3.50868 28.0859 3.54818 28.3116C3.58769 28.5372 3.64511 28.8668 3.67579 29.0441C3.70646 29.2214 3.78879 29.6928 3.85875 30.0917C3.92871 30.4906 4.01885 31.0065 4.05906 31.2382C4.09926 31.4699 4.13456 31.657 4.13751 31.6539C4.14197 31.6493 4.12086 31.2644 4.09239 30.8316C4.08194 30.673 4.07267 30.5104 4.06361 30.3262C4.05905 30.2335 4.05279 30.1181 4.04967 30.0698C4.04655 30.0214 4.04013 29.8599 4.03539 29.7108C4.03065 29.5617 4.02405 29.4068 4.02073 29.3665C4.01741 29.3262 4.01077 28.9223 4.00596 28.4691L3.9972 27.6449H4.28852H4.57986V30.1723V32.6996H4.16604H3.75224L3.68379 32.315C3.64613 32.1035 3.56865 31.67 3.51158 31.3517C3.45453 31.0334 3.36581 30.5356 3.31445 30.2455C3.18057 29.4894 3.11256 29.113 3.07355 28.9122L3.03942 28.7363L3.04607 28.8755C3.04975 28.9521 3.05914 29.2092 3.06692 29.447C3.07471 29.6847 3.0842 29.9583 3.08802 30.055C3.09299 30.1808 3.09933 32.3618 3.09564 32.674C3.09536 32.6976 3.07233 32.6997 2.81258 32.6997H2.52982V30.1723V27.6449L2.52986 27.6449ZM5.03231 27.6449L5.5519 27.645C5.83766 27.645 6.11283 27.6517 6.16337 27.6598C6.46891 27.7088 6.6859 27.8858 6.78414 28.1662C6.85174 28.3592 6.85881 28.4567 6.85274 29.1101C6.84804 29.6149 6.8436 29.7166 6.82297 29.7914C6.78256 29.9378 6.72908 30.0353 6.63791 30.1285L6.55178 30.2165L6.63051 30.297C6.72241 30.3909 6.77379 30.481 6.81756 30.6252C6.84806 30.7257 6.84906 30.7488 6.84906 31.3444C6.84906 32.0326 6.84775 32.0443 6.74579 32.2602C6.65129 32.4602 6.48685 32.5957 6.25423 32.6652C6.18316 32.6864 6.08402 32.6911 5.60137 32.6961L5.03231 32.7034V30.1746V27.6457V27.6449ZM7.64912 27.6449H8.1138H8.57848L8.58673 27.6998C8.59128 27.73 8.63021 28.0713 8.67327 28.4581C8.71634 28.8449 8.80529 29.6393 8.87096 30.2235C9.12318 32.4682 9.14651 32.6762 9.14651 32.688C9.14651 32.6938 8.9941 32.6997 8.80776 32.6997H8.46907L8.46179 32.6521C8.45777 32.6259 8.44162 32.433 8.42586 32.2235C8.41011 32.014 8.39337 31.8046 8.38869 31.7583L8.38019 31.6741H8.09201C7.80452 31.6741 7.80382 31.6742 7.79728 31.707C7.79368 31.7252 7.77728 31.918 7.76083 32.1356C7.74438 32.3531 7.72723 32.5691 7.72269 32.6154L7.71444 32.6997H7.39128H7.06813V32.6558C7.06813 32.6197 7.16483 31.7701 7.25908 30.978C7.27058 30.8813 7.3532 30.1692 7.44265 29.3956C7.62778 27.7946 7.63215 27.7571 7.64191 27.6924L7.64907 27.6448L7.64912 27.6449ZM8.07359 28.2122C8.07143 28.2123 8.06925 28.2146 8.06685 28.2173C8.06376 28.2208 8.05725 28.283 8.05241 28.3555C8.04756 28.428 8.04029 28.5302 8.03623 28.5826C8.03216 28.635 8.00982 28.9416 7.98658 29.2639C7.96333 29.5862 7.9215 30.1221 7.89363 30.4547C7.86576 30.7873 7.84601 31.0675 7.8497 31.0774C7.85463 31.0906 7.91832 31.0954 8.09022 31.0954C8.21882 31.0954 8.32778 31.0915 8.33233 31.0868C8.33688 31.0821 8.3217 30.858 8.29858 30.5887C8.11314 28.4278 8.09449 28.2122 8.0736 28.2123L8.07359 28.2122ZM5.68266 28.287V29.1135C5.68266 29.568 5.68532 29.9427 5.68857 29.9461C5.69182 29.9495 5.77294 29.9499 5.86883 29.9472C6.06942 29.9413 6.11871 29.9243 6.16666 29.8444L6.19862 29.7916V29.125C6.19862 28.4847 6.1975 28.4564 6.17034 28.4086C6.11401 28.3095 6.08385 28.2977 5.87248 28.2924L5.6826 28.2865L5.68266 28.287ZM5.68266 30.4981V31.2764V32.0547H5.84933C6.05102 32.0547 6.12135 32.0274 6.16959 31.9302C6.19756 31.8738 6.19869 31.8484 6.19869 31.2708C6.19869 30.694 6.19756 30.6681 6.17003 30.6188C6.12346 30.5356 6.05662 30.5112 5.85583 30.5041L5.68265 30.4998L5.68266 30.4981Z",
				fill: "#1D428A"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/LeagueNCAAB.tsx
function ue(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "100%",
		viewBox: "0 0 29 29",
		width: "36",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M25.6066 6.98547L20.0566 27.5802H2.04523L7.5956 6.98547H25.6066Z",
				fill: "#1879BF",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M22.5083 18.7914C25.6492 17.6065 27.4376 16.0332 27.63 14.3625C27.9956 11.188 22.975 8.47195 16.4172 8.29547C9.91462 8.1205 4.34228 10.5087 3.89288 13.6436C4.83906 10.9894 9.67977 9.04019 15.2634 9.19034C21.2832 9.35253 25.8865 11.8933 25.5445 14.8656C25.419 15.957 24.0489 17.3975 22.6505 18.0452L22.5083 18.7914Z",
				fill: "white",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M15.3347 8.62252C21.3548 8.7847 25.9581 11.3256 25.6161 14.2979C25.3531 16.5814 22.2483 18.4551 18.0933 19.1272C23.3183 18.6384 27.3928 16.4836 27.7021 13.795C28.0668 10.6206 23.0473 7.90442 16.489 7.7278C9.98609 7.55298 4.17755 10.1184 3.72845 13.2533C4.67463 10.5984 9.75154 8.47222 15.3347 8.62252Z",
				fill: "#CC1E4C",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M2.94446 24.2317L7.59605 6.98551L15.0203 6.97137L15.4593 6.97107C15.4593 6.97107 15.6594 7.17508 15.7752 7.22352C17.2835 7.8518 18.6998 9.09632 19.7839 10.6748C19.8157 10.7201 19.8703 10.6307 19.8703 10.6307L20.212 11.2938C20.212 11.2938 20.2693 11.4421 20.2816 11.463C21.3573 13.3233 21.9779 15.5388 21.8182 17.7265C21.8144 17.7756 21.829 17.9185 21.8252 17.9673C21.8117 18.1204 21.6421 19.4732 21.6421 19.4732C21.6421 19.4732 21.6653 18.8888 21.6077 19.1635C21.2113 21.0475 20.3847 22.7967 19.1068 24.2437L15.266 24.2405L2.94446 24.2317Z",
				fill: "white",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M15.2662 24.241C15.9756 23.5168 16.6061 22.6871 17.1562 21.7721C18.6774 19.1528 19.2819 16.3797 18.9516 13.533L18.8532 12.6868L19.3637 13.3691C19.401 13.4192 19.4516 13.4778 19.5056 13.54C19.6742 13.7365 19.8847 13.9805 19.9658 14.2724L19.9741 14.3018L19.9747 14.3321C19.9794 14.967 20.0802 15.6429 20.1769 16.2969C20.3215 17.2694 20.5327 18.2559 20.3785 19.2126C20.3785 19.2119 20.3097 20.2127 20.1655 20.8575C19.9765 21.7012 19.6475 22.9603 18.9054 24.2437L15.2662 24.241Z",
				fill: "#CC1E4C",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M2.94763 24.2316L4.67238 17.8248C5.01059 17.8073 5.95165 17.8066 6.20516 17.8007C6.36072 17.7969 6.49447 17.7938 6.60821 17.789C9.93028 17.6486 11.5952 17.1201 12.4065 16.7015C14.5575 15.5912 15.2439 13.8636 15.439 13.1721C15.6896 12.2863 15.7683 11.3358 15.6452 10.6915L15.5539 10.2152L15.9803 10.4466C16.6499 10.8102 17.1874 11.2327 17.7554 11.6797C17.8785 11.7761 17.8909 11.9209 17.8979 11.9983C17.8988 12.0098 17.9003 12.0254 17.9009 12.0307C17.9009 12.0307 17.9003 12.0254 17.8972 12.0171L17.903 12.0317L17.906 12.0469C18.1332 13.0528 18.1614 14.9295 18.1614 14.9295L18.1453 14.7028C18.1138 16.7852 17.5135 18.9966 16.4542 20.9291C15.7658 22.1845 14.9019 23.3028 13.8994 24.2402L2.94763 24.2316Z",
				fill: "#CC1E4C",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M7.1223 8.74574C7.64918 8.65803 7.84762 8.65848 8.24481 8.6326C10.3014 8.53872 12.1375 8.83841 14.0273 9.57471L14.136 9.61729L14.1659 9.73013C14.3777 10.5338 14.3821 11.3478 14.1778 12.1488C13.836 13.6405 12.8931 14.7909 11.5245 15.3827C10.0019 16.1039 8.23277 16.2276 6.52171 16.3472C6.2002 16.3693 5.39575 16.3887 5.05408 16.4153L7.1223 8.74574ZM20.4509 13.8588C20.4586 13.3838 20.4842 12.2529 20.1991 11.2385L20.7353 12.1214C21.4831 13.604 21.8701 15.5855 21.8701 16.5025C21.8701 17.2547 21.8242 18.0032 21.8242 18.0032C21.702 16.7018 21.0538 14.8647 20.4813 13.9754L20.4505 13.9215L20.4509 13.8588ZM18.4776 11.2996C17.9507 9.85951 16.8785 8.02524 15.4519 6.97736L16.6549 7.63271C18.0345 8.49464 19.0143 9.40817 19.8323 10.5946L19.8607 10.6364L19.8696 10.6867C19.9504 11.1725 19.9935 11.7705 19.992 12.4164L19.9914 13.0505L19.586 12.5626C19.154 12.0425 18.7996 11.6461 18.5325 11.3845L18.4952 11.3484L18.4776 11.2996ZM7.30239 8.14891C9.2462 7.896 11.3928 7.89058 13.26 8.45417L13.9938 8.67533L13.5026 8.08707C13.1422 7.65513 12.7484 7.28457 12.334 6.98383L7.59577 6.98563L7.30239 8.14891ZM15.012 6.98217C15.1137 7.0574 15.2103 7.1433 15.3 7.24049L15.2759 7.21762C15.9803 7.78738 16.7034 8.77162 17.2098 9.84958L17.5633 10.6017L16.8737 10.1377C16.3456 9.78188 15.8849 9.51995 15.2828 9.23364L15.2156 9.20205L15.1804 9.13706C14.7814 8.41279 14.0637 7.62655 13.0133 6.98021L15.012 6.98217ZM19.1406 24.2434C19.4841 23.6453 19.8753 22.789 19.8753 22.789C20.487 21.3204 20.8064 19.4968 20.8248 17.8785V17.8962C20.8159 17.7602 20.8097 17.6192 20.803 17.47C20.7885 17.1366 20.7213 16.7996 20.6692 16.496C20.6098 16.1478 20.5561 15.6542 20.5185 15.1185C20.9957 15.8463 21.1672 16.3875 21.1672 16.3875C21.5827 17.6797 21.8979 19.0533 21.4022 20.3434L21.4078 20.3273C21.1664 21.1289 20.5824 22.3781 20.2568 22.8707C19.9944 23.2676 19.4941 23.9103 19.1993 24.2446L19.1406 24.2434Z",
				fill: "#CC1E4C",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M5.92275 13.1194C3.33578 14.0501 1.49879 15.5796 1.29809 17.3235C0.932801 20.4976 5.95344 23.2143 12.5112 23.3909C19.0142 23.566 24.8223 20.9413 25.2713 17.8064C24.3263 20.4608 19.2486 22.6461 13.6656 22.4958C7.6457 22.3339 3.04195 19.7929 3.38392 16.8207C3.52053 15.6318 4.37418 14.5478 5.73093 13.7476L5.92275 13.1194Z",
				fill: "white",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M6.12016 12.3335C3.53213 13.3192 1.57057 15.0109 1.37002 16.7558C1.00443 19.93 6.02537 22.6462 12.583 22.8228C19.086 22.9978 24.8944 20.3734 25.3434 17.2383C24.3978 19.8931 19.3204 22.0782 13.7371 21.9279C7.71718 21.7656 3.11388 19.225 3.4557 16.2527C3.59276 15.0599 4.56571 13.9757 5.92909 13.1194L6.12016 12.3335Z",
				fill: "#1879BF",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M3.47206 25.2484H3.30717L3.4027 24.9261H4.37039C4.66768 24.9261 4.87891 25.04 4.76968 25.4095C4.69325 25.6678 4.51557 25.8538 4.26824 25.8955L4.26673 25.901C4.51076 25.9207 4.59471 26.1011 4.51332 26.3761C4.3916 26.7869 4.09131 26.9149 3.75129 26.9149H2.81384L2.90938 26.5925H3.07442L3.47206 25.2484ZM3.92912 25.7483C4.1065 25.7483 4.2231 25.6847 4.28584 25.4734C4.34587 25.2706 4.24221 25.2318 4.08243 25.2318H3.92732L3.77416 25.7485H3.92912V25.7483ZM3.70676 26.6095C3.86413 26.6095 4.00375 26.5261 4.05911 26.34C4.1217 26.129 4.05595 26.054 3.8712 26.054H3.68374L3.5193 26.6095H3.70676ZM5.77303 26.3459H5.18522L5.03733 26.5928H5.22991L5.13437 26.9152H4.41417L4.50941 26.5928H4.61698L5.6635 24.9263H6.21851L6.27252 26.5928H6.37498L6.27929 26.9152H5.49169L5.58752 26.5928H5.77228L5.77303 26.3459ZM5.78175 25.3373H5.77649L5.38081 26.0402H5.75859L5.78175 25.3373ZM8.00299 24.9263H8.37279L8.18398 25.5652H7.79868C7.84547 25.4068 7.85209 25.2153 7.63469 25.2153C7.49733 25.2153 7.37922 25.2762 7.34312 25.3985C7.30099 25.5401 7.35982 25.5709 7.706 25.743C7.96989 25.8733 8.10033 25.982 7.99486 26.3376C7.86818 26.7652 7.57406 26.9488 7.19643 26.9488C7.02401 26.9488 6.89718 26.9208 6.85265 26.7514H6.84754L6.79909 26.9154H6.41379L6.6178 26.2264H7.02777C6.99407 26.3403 6.97692 26.4404 7.00551 26.5126C7.03409 26.585 7.09698 26.6262 7.21433 26.6262C7.33424 26.6262 7.45249 26.5486 7.49341 26.4098C7.5378 26.2598 7.48273 26.2096 7.13896 26.0623C6.9369 25.9762 6.74327 25.8539 6.83941 25.5291C6.96714 25.0985 7.22516 24.893 7.61046 24.893C7.74271 24.893 7.92881 24.9318 7.95244 25.0791H7.95755L8.00299 24.9263ZM9.50206 25.2484H9.382L9.47769 24.9263H10.2299L10.1347 25.2484H10.002L9.33777 25.8458L9.66139 26.5928H9.7667L9.67102 26.9151H8.88853L8.98392 26.5928H9.11902L8.85393 25.9094H8.84881L8.64661 26.5928H8.8115L8.71627 26.9151H7.93619L8.03157 26.5928H8.19631L8.59485 25.2484H8.42966L8.5252 24.9263H9.30497L9.20944 25.2484H9.0444L8.87364 25.8264L9.50206 25.2484ZM10.9592 25.5374H11.2491L11.0333 26.2653H10.7434L10.8063 26.054H10.6361L10.4764 26.5928H11.0338L11.1319 26.2626H11.5017L11.3084 26.9151H9.7661L9.86164 26.5928H10.0267L10.4245 25.2484H10.2594L10.3551 24.9263H11.8971L11.7141 25.5457H11.3437L11.4317 25.2484H10.8745L10.7264 25.7483H10.8964L10.9592 25.5374ZM13.1843 25.2484H12.9847L12.5863 26.5928H12.7862L12.691 26.9151H11.8109L11.9067 26.5928H12.1066L12.5046 25.2484H12.3046L12.1913 25.632H11.806L12.015 24.9263H13.665L13.456 25.632H13.0709L13.1843 25.2484ZM13.8066 25.2484H13.6414L13.7369 24.9261H14.7046C15.002 24.9261 15.213 25.04 15.1039 25.4095C15.0272 25.6678 14.8495 25.8538 14.6023 25.8955L14.6002 25.901C14.845 25.9207 14.9285 26.1011 14.8474 26.3761C14.7257 26.7869 14.4251 26.9149 14.0856 26.9149H13.1477L13.2434 26.5925H13.4085L13.8066 25.2484ZM14.2633 25.7483C14.4407 25.7483 14.5575 25.6847 14.62 25.4734C14.6796 25.2706 14.5763 25.2318 14.4163 25.2318H14.2615L14.1084 25.7485H14.2633V25.7483ZM14.041 26.6095C14.1983 26.6095 14.3381 26.5261 14.393 26.34C14.4555 26.129 14.3902 26.054 14.2053 26.054H14.0178L13.8532 26.6095H14.041ZM16.1069 26.3459H15.5193L15.3712 26.5928H15.564L15.4684 26.9152H14.7479L14.8435 26.5928H14.951L15.9971 24.9263H16.5524L16.6064 26.5928H16.7087L16.6132 26.9152H15.8257L15.9213 26.5928H16.1063L16.1069 26.3459ZM16.1157 25.3373H16.1104L15.7149 26.0402H16.0925L16.1157 25.3373ZM17.9775 26.1652H18.3774L18.1553 26.9151H16.7181L16.8133 26.5928H16.9788L17.3769 25.2484H17.2117L17.3069 24.9263H18.1967L18.1011 25.2484H17.8562L17.4583 26.5928H17.8508L17.9775 26.1652ZM19.5297 26.1652H19.9295L19.7073 26.9151H18.2702L18.3656 26.5928H18.5305L18.9283 25.2484H18.7636L18.8594 24.9263H19.7492L19.6536 25.2484H19.4085L19.0106 26.5928H19.403L19.5297 26.1652Z",
				fill: "white",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M21.5152 26.7784H21.1723V27.6109H21.0178V26.7784H20.6755V26.6712H21.5153V26.7784H21.5152ZM22.2809 27.4761C22.345 27.3309 22.4114 27.1967 22.477 27.0661L22.6747 26.6712H22.9223V27.6109H22.7716V27.1965C22.7716 27.0568 22.7734 26.9173 22.7765 26.766H22.7695C22.7013 26.9191 22.631 27.0584 22.5614 27.1979L22.3566 27.6109H22.1947L21.9906 27.1956C21.9212 27.0553 21.8528 26.9172 21.784 26.766H21.779C21.7812 26.9095 21.7824 27.053 21.7825 27.1965V27.6109H21.6358V26.6712H21.8844L22.0816 27.0661C22.1483 27.1995 22.2138 27.333 22.2746 27.4761H22.2809ZM26.1 5.94588C26.1 5.73254 26.2609 5.57126 26.4669 5.57126C26.6711 5.57126 26.8316 5.73239 26.8316 5.94588C26.8316 6.16253 26.6712 6.3223 26.4669 6.3223C26.2611 6.32215 26.1 6.16253 26.1 5.94588ZM26.467 6.39738C26.7127 6.39738 26.9225 6.20646 26.9225 5.94573C26.9225 5.68696 26.7126 5.49619 26.467 5.49619C26.2191 5.49619 26.0092 5.68711 26.0092 5.94573C26.0092 6.20661 26.219 6.39738 26.467 6.39738ZM26.3715 5.98123H26.4621L26.5993 6.20661H26.6872L26.5397 5.97777C26.6161 5.96845 26.6745 5.92767 26.6745 5.835C26.6745 5.73254 26.6137 5.68726 26.4911 5.68726H26.2928V6.20676H26.3715V5.98123ZM26.3715 5.91428V5.7536H26.4788C26.5337 5.7536 26.5922 5.76564 26.5922 5.82958C26.5922 5.90977 26.5328 5.91413 26.4658 5.91413H26.3715V5.91428ZM18.7501 4.48562L19.8079 2.88002L19.8643 4.48562H18.7501ZM22.9855 4.4644L24.0418 2.86408L24.0952 4.4644H22.9855ZM25.7124 6.39813L25.3707 1.39629H22.6306L22.3074 2.53941H22.7323L21.3801 4.68466L21.1899 1.39629H18.41L18.0947 2.53429L18.5187 2.53941L16.7033 5.29293L15.2115 5.30105C15.0543 5.30105 14.4486 5.14248 14.4486 4.3943C14.4486 3.64581 15.1609 2.55957 15.8846 2.55957L16.1879 2.56664C16.1371 2.75109 16.0301 3.13413 16.0301 3.13413H17.3613L17.8394 1.39644L15.6914 1.38922C14.7382 1.38922 13.4833 2.30636 13.1571 3.24787L13.6915 1.39765L11.8652 1.39629L11.5432 2.53941L12.0155 2.53715L11.5402 4.2106L10.3478 1.40261H8.63866L8.31821 2.54001H8.78671L7.72784 6.39647H9.09407L9.75515 3.99305L10.7492 6.39647L12.2699 6.39572L12.9656 3.94686C12.9027 4.31862 12.9025 4.69827 12.9648 5.07011C13.0989 5.87306 13.8793 6.39617 14.7322 6.39617L17.4914 6.39632L17.965 5.67883H19.9117L19.9514 6.38835H21.6769L22.1161 5.67898H24.1077L24.1853 6.39647L25.7124 6.39813Z",
				fill: "#1879BF",
				fillRule: "evenodd"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/LeagueNCAAF.tsx
function de(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "100%",
		viewBox: "0 0 35 24",
		width: "48",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [/* @__PURE__ */ t("g", {
			clipPath: "url(#clip0_1340_77708)",
			children: [
				/* @__PURE__ */ e("g", {
					opacity: "0.949997",
					children: /* @__PURE__ */ e("path", {
						d: "M35.003 5.0292C34.9744 4.88412 34.8993 4.7524 34.7893 4.65404C34.6793 4.55567 34.5404 4.49602 34.3936 4.48415C30.8088 4.2055 26.9466 3.83713 23.2424 3.43602C19.3264 1.01315 15.2604 0.477087 11.1488 1.85884C7.27684 1.27405 3.7981 0.656775 0.814585 0.0160029C0.688944 -0.0125383 0.557779 -0.00417544 0.43674 0.0400935C0.315702 0.0843625 0.209902 0.162668 0.131965 0.265667C0.056874 0.368351 0.0119017 0.490092 0.00213809 0.617114C-0.00762555 0.744136 0.0182092 0.871366 0.0767187 0.984407C0.96488 2.6573 1.89063 5.24563 2.44533 7.29563C0.847681 9.19545 -0.228377 12.0932 3.49424 15.8036C3.50495 18.6173 3.18815 21.2009 2.57896 23.1237C2.53262 23.2606 2.53244 23.409 2.57845 23.546C2.62446 23.683 2.71411 23.8009 2.83354 23.8817C2.9531 23.9635 3.09555 24.0048 3.24013 23.9996C3.38471 23.9945 3.52387 23.9431 3.63733 23.8529C6.02286 21.9201 9.37917 19.6467 13.5686 17.0954C17.5834 16.1824 21.3668 14.022 23.7356 11.286C27.6631 9.15847 31.7306 7.1012 34.6253 5.76544C34.7599 5.70126 34.8698 5.59445 34.938 5.46142C35.0063 5.3284 35.0291 5.17653 35.003 5.0292Z",
						fill: "white",
						opacity: "0.949997"
					})
				}),
				/* @__PURE__ */ e("path", {
					d: "M23.2999 10.7541C27.667 8.39448 31.6711 6.3887 34.3473 5.15139C30.8855 4.88023 27.0088 4.52062 23.0077 4.07753C19.1743 1.66014 15.233 1.15658 11.2164 2.55283C7.99177 2.067 4.87013 1.53119 2.00781 0.946899C3.00149 2.35714 3.84312 4.59659 4.44758 7.16516C3.86551 7.83667 3.39268 8.52218 3.11123 9.16694C2.78947 9.87044 2.618 10.5842 2.70037 11.2534C2.81286 11.8635 3.13239 12.4058 3.59451 12.8839C3.66394 12.9461 3.74133 13.0221 3.82793 13.1093C4.31183 13.532 4.84817 13.8901 5.42359 14.1746H5.42384C5.49924 14.2134 5.57464 14.2509 5.65178 14.2884C7.72724 15.4139 9.63372 15.4904 12.4639 15.7138C8.20106 16.005 4.2674 15.5069 2.2462 13.6541C3.05822 14.7849 4.16737 15.5931 5.4644 16.1162C5.44848 18.4091 5.19241 20.5461 4.64119 22.217C7.08818 20.3807 10.1075 18.4051 13.3175 16.4551C17.1195 15.6201 20.9166 13.5629 23.2999 10.7541Z",
					fill: "#005CB9"
				}),
				/* @__PURE__ */ e("path", {
					d: "M23.8298 7.26877C23.258 8.38313 22.0493 9.34728 22.0493 9.34728C22.0493 9.34728 21.9781 9.34103 22.0615 9.24082C22.4106 8.82872 23.4541 7.65864 23.5745 7.24054C23.7029 6.82869 23.3478 6.57303 23.2199 6.50106C23.1646 6.46607 23.2687 6.44508 23.3152 6.46007C23.4804 6.4914 23.6302 6.57809 23.74 6.70598C23.8507 6.81344 23.9465 6.69174 23.899 6.49306C23.6842 6.09821 23.2948 5.6981 22.7097 5.20728C17.9892 0.962293 9.51792 2.91135 5.93516 6.69548C9.49105 4.33284 14.9716 3.66457 14.9716 3.66457C15.4755 3.93747 16.0583 4.27136 16.5521 4.60548C18.6405 4.77418 20.6881 5.28026 22.6159 6.1042C22.6831 6.16092 22.698 6.31662 22.6592 6.31662C19.0486 5.10705 16.3296 5.60987 16.3296 5.60987C15.8359 5.9605 15.3531 6.31662 14.8658 6.68524C10.5718 6.46007 7.36011 7.26877 5.45785 8.39937C3.62105 9.48648 2.59527 11.7981 6.17755 14.5996C7.06646 15.2012 8.68053 15.687 12.3148 15.742C16.3642 15.2751 20.7015 13.3131 23.674 8.61054C23.8662 8.26747 24.0019 7.89547 24.0759 7.50894C24.0949 7.23828 23.8833 7.13607 23.8298 7.26877",
					fill: "#CE0E2D"
				}),
				/* @__PURE__ */ e("path", {
					d: "M2.00782 0.946818C1.81246 0.907334 1.61802 0.867349 1.4245 0.826862C1.17291 0.77563 0.921559 0.723898 0.670471 0.667419C1.95556 3.09005 2.84944 5.82132 3.41161 8.58157C3.71319 8.07866 4.05996 7.60453 4.44759 7.16508C3.84313 4.59651 3.00124 2.35731 2.00782 0.946818Z",
					fill: "#CE0E2D"
				}),
				/* @__PURE__ */ e("path", {
					d: "M3.21674 23.3226C3.66542 22.9615 4.14196 22.5914 4.64143 22.217C5.19239 20.5461 5.44846 18.4091 5.46439 16.1162C5.00949 15.9339 4.57224 15.7099 4.15814 15.4472C4.20617 18.5046 3.86375 21.2804 3.21674 23.3226",
					fill: "#CE0E2D"
				}),
				/* @__PURE__ */ e("path", {
					d: "M14.6721 5.70877C11.8705 5.55907 8.7635 6.40452 7.47693 6.82862C9.76813 5.51984 13.1182 4.73387 14.7781 4.62891L15.5587 5.05151L14.6721 5.70877Z",
					fill: "white"
				}),
				/* @__PURE__ */ e("path", {
					d: "M19.7725 11.9428L19.5147 8.1574L19.5142 8.1509H17.4377L17.436 8.1559L17.1918 9.02084L17.1894 9.02959H17.5062L16.5055 10.623L16.3634 8.1574L16.3632 8.1509H14.2563L14.2549 8.1559L14.0172 9.01659L14.0145 9.02609H14.0242L14.33 9.02959L12.9713 11.0993L11.8494 11.0956C11.7295 11.0956 11.2833 10.9819 11.2833 10.4266C11.2833 9.84929 11.8255 9.04558 12.3588 9.04558C12.3586 9.04558 12.5348 9.04933 12.5776 9.05033L12.4614 9.47068L12.4586 9.48018H13.4767L13.4787 9.47492L13.8388 8.16015L13.8415 8.1509H13.8316L12.2807 8.14465C11.8312 8.1504 11.3958 8.30305 11.0404 8.5795C10.745 8.79776 10.5082 9.08619 10.3511 9.41895L10.7134 8.16065L10.7161 8.15115H10.7064L9.32952 8.1509H9.3238L9.32231 8.1559L9.07967 9.02084L9.07719 9.03008L9.0869 9.02959L9.43306 9.02834L9.0834 10.2656L8.19201 8.15965L8.19002 8.15541H6.89224L6.89099 8.16066L6.64911 9.02135L6.64637 9.03059H6.999L6.20415 11.9398L6.20142 11.9493H7.24685L7.24786 11.9438L7.74084 10.1457L8.48142 11.9445L8.48341 11.9493H8.48864L9.63363 11.949H9.63986L9.64084 11.9433L10.1393 10.1832C10.1059 10.4345 10.1097 10.6894 10.1507 10.9396C10.2036 11.2365 10.3711 11.5004 10.6168 11.6739C10.8719 11.8551 11.1772 11.9514 11.4896 11.9493H13.5732L13.5757 11.946L13.9306 11.4065H15.3867L15.416 11.9368L15.4165 11.9438H16.7285L16.7302 11.9398L17.0592 11.4065H18.5494L18.6076 11.9423L18.6081 11.9493H18.6143L19.765 11.9505H19.773L19.7725 11.9428ZM18.5389 10.4723H17.7239L18.4996 9.29175L18.5389 10.4723ZM15.3503 10.4891H14.5318L15.309 9.30424L15.3503 10.4891Z",
					fill: "white"
				}),
				/* @__PURE__ */ e("path", {
					d: "M20.9044 11.1655C20.8316 11.0953 20.7345 11.0564 20.6336 11.0568C20.5582 11.0575 20.4847 11.0806 20.4223 11.1232C20.3599 11.1658 20.3115 11.226 20.2831 11.2962C20.2547 11.3663 20.2477 11.4434 20.2629 11.5176C20.278 11.5918 20.3147 11.6598 20.3684 11.7131C20.422 11.7664 20.4901 11.8025 20.5641 11.817C20.6382 11.8315 20.7148 11.8236 20.7844 11.7944C20.854 11.7652 20.9134 11.7159 20.9552 11.6528C20.9969 11.5898 21.0192 11.5157 21.0191 11.4399C21.0196 11.3888 21.0096 11.338 20.9899 11.2909C20.9702 11.2437 20.9411 11.201 20.9044 11.1655V11.1655ZM20.6336 11.7493C20.5934 11.7497 20.5534 11.742 20.5163 11.7265C20.4791 11.711 20.4454 11.6881 20.4173 11.6592C20.3891 11.6303 20.3671 11.596 20.3526 11.5583C20.338 11.5206 20.3312 11.4803 20.3325 11.4399C20.3313 11.3578 20.3625 11.2784 20.4193 11.2193C20.4474 11.191 20.4808 11.1687 20.5176 11.1536C20.5544 11.1385 20.5939 11.1309 20.6336 11.1313C20.6729 11.1309 20.7119 11.1385 20.7482 11.1536C20.7845 11.1687 20.8174 11.1911 20.8449 11.2193C20.8732 11.2485 20.8955 11.283 20.9105 11.3209C20.9254 11.3587 20.9328 11.3992 20.9322 11.4399C20.9337 11.4802 20.9271 11.5203 20.9127 11.5579C20.8984 11.5955 20.8766 11.6297 20.8487 11.6586C20.8208 11.6875 20.7873 11.7105 20.7504 11.7261C20.7134 11.7417 20.6737 11.7496 20.6336 11.7493H20.6336ZM20.7028 11.4699C20.718 11.4691 20.733 11.4653 20.7468 11.4586C20.7605 11.452 20.7729 11.4427 20.7831 11.4312C20.7932 11.4198 20.8011 11.4064 20.8061 11.3919C20.8111 11.3774 20.8132 11.362 20.8123 11.3467C20.8123 11.258 20.7613 11.2165 20.653 11.2165H20.4821V11.6644H20.5597V11.4757H20.6261L20.7391 11.6616L20.7404 11.6644H20.8277L20.8222 11.6554L20.7028 11.4699ZM20.5597 11.4077V11.2847H20.6433C20.7035 11.2847 20.7319 11.303 20.7319 11.3422C20.7319 11.403 20.6906 11.4077 20.6321 11.4077H20.5597Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", {
			id: "clip0_1340_77708",
			children: /* @__PURE__ */ e("rect", {
				fill: "white",
				height: "24",
				width: "35"
			})
		}) })]
	});
}
//#endregion
//#region primitives/icon/icons/LeagueNFL.tsx
function fe(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "100%",
		viewBox: "0 0 25 35",
		width: "30",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				d: "M24.1403 3.9818C23.0983 4.77816 21.0142 5.83997 18.4092 5.17634C13.8069 4.02604 12.5043 0 12.5043 0C12.5043 0 11.1931 4.02162 6.59951 5.17634C3.95537 5.83997 1.91039 4.76931 0.824939 3.98622H0V25.6649C0 26.24 0.130253 27.3019 1.00295 28.4079C2.08406 29.7352 3.90761 30.5891 6.43018 30.9607C8.47082 31.2571 9.94703 31.903 10.9891 32.9339C11.7706 33.6904 12.5087 35 12.5087 35C12.5087 35 13.2685 33.6639 14.0109 32.9339C15.0617 31.903 16.5509 31.2615 18.5698 30.9607C21.0967 30.5886 22.9116 29.7219 23.997 28.3902C24.8697 27.3107 25 26.2268 25 25.6826V4.00392H24.1707",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M24.2283 4.82264C24.2283 4.82264 21.7231 6.80911 18.1932 5.911C14.0816 4.86246 12.4621 1.72569 12.4621 1.72569C12.4621 1.72569 10.8643 4.86688 6.73092 5.911C3.25749 6.79584 0.739258 4.80494 0.739258 4.80494V25.643C0.739683 26.3509 1.03016 29.3594 6.55725 30.1557C8.73248 30.4765 10.3563 31.1866 11.5069 32.3324C11.9272 32.743 12.245 33.1598 12.4881 33.5447C12.7326 33.1611 13.0526 32.7439 13.4694 32.3324C14.6373 31.1866 16.2611 30.4743 18.419 30.1557C23.9331 29.3461 24.1936 26.3376 24.237 25.643V4.80494",
				fill: "#013369"
			}),
			/* @__PURE__ */ e("path", {
				d: "M12.5062 31.4695C12.5062 31.4695 14.104 29.4609 18.2374 28.8105C23.0133 28.0628 22.8397 25.7888 22.8397 25.6738V14.7459H2.12935V25.6738C2.12935 25.7888 1.98867 28.0628 6.73164 28.8105C10.8824 29.4653 12.4628 31.4695 12.4628 31.4695",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M7.64209 22.7404L7.64134 17.5641L7.0031 17.1991V15.8541H9.91644V17.1991L9.30859 17.5641V28.1379L7.75423 27.6645L5.50518 20.8955L5.50475 25.364L6.22114 25.9214V27.2973L3.0994 26.4877V25.3153L3.81579 25.0304V17.5534L3.08203 17.184V15.8391H5.44396L7.64959 22.7408",
				fill: "#D50A0A"
			}),
			/* @__PURE__ */ e("path", {
				d: "M13.0252 27.4744L13.6504 28.2354V29.5803L10.5547 28.4035V27.262L11.2363 26.9771V17.5535L10.559 17.2036V15.8409H15.9428V18.5795H14.7619L14.4041 17.4557H13.0365V20.6235H14.0611L14.4649 20.0218H15.2898V22.84H14.4649L14.0763 22.2693H13.0343V27.4899",
				fill: "#D50A0A"
			}),
			/* @__PURE__ */ e("path", {
				d: "M16.4558 27.961V26.616L17.2243 25.9745V17.5685L16.5687 17.2185V15.8559H19.6644V17.2185L19.0566 17.5685V25.4879L20.3895 25.1211L20.6448 23.0505H21.9169V26.5103L16.4463 27.9968",
				fill: "#D50A0A"
			}),
			/* @__PURE__ */ e("path", {
				d: "M2.67051 12.5207L1.73242 11.804H2.87898L3.25725 10.698L3.63553 11.804H4.78208L3.84399 12.5252L4.18883 13.6489L3.25508 12.9809L2.32133 13.6489L2.66617 12.5252",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M6.73008 12.5207L5.79199 11.804H6.93855L7.31682 10.698L7.6951 11.804H8.84165L7.90356 12.5252L8.2484 13.6489L7.31465 12.9809L6.3809 13.6489L6.72574 12.5252",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M2.67051 8.80395L1.73242 8.08723H2.87898L3.25725 6.98117L3.63553 8.08723H4.78208L3.84399 8.80838L4.18883 9.93213L3.25508 9.26407L2.32133 9.93213L2.66617 8.80838",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M6.73008 8.80395L5.79199 8.08723H6.93855L7.31682 6.98117L7.6951 8.08723H8.84165L7.90356 8.80838L8.2484 9.93213L7.31465 9.26407L6.3809 9.93213L6.72574 8.80838",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M22.6658 13.6267L21.7321 12.9587L20.7983 13.6267L21.1432 12.503L20.2051 11.7818H21.3516L21.7299 10.6758L22.1082 11.7818H23.2547L22.3167 12.503L22.6619 13.6267",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M18.5828 13.6267L17.6491 12.9587L16.7153 13.6267L17.0602 12.503L16.1221 11.7818H17.2686L17.6469 10.6758L18.0256 11.7818H19.1722L18.2341 12.503L18.5793 13.6267",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M22.6658 9.9104L21.7321 9.24234L20.7983 9.9104L21.1432 8.78665L20.2051 8.0655H21.3516L21.7299 6.95944L22.1082 8.0655H23.2547L22.3167 8.78665L22.6619 9.9104",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M18.5828 9.9104L17.6491 9.24234L16.7153 9.9104L17.0602 8.78665L16.1221 8.0655H17.2686L17.6469 6.95944L18.0256 8.0655H19.1722L18.2341 8.78665L18.5793 9.9104",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M13.3721 7.96341C12.9549 7.61302 12.4864 7.38827 11.9914 7.27766C12.1117 7.16175 12.235 7.0622 12.3431 6.97018C12.964 7.12237 13.3808 7.40596 13.6674 7.64708C13.5658 7.75326 13.4672 7.85679 13.3738 7.96253L13.3721 7.96341ZM12.7686 8.70226C12.3709 8.36204 11.8872 8.10941 11.3402 7.99438C11.424 7.88422 11.5221 7.76698 11.6163 7.65814C12.0348 7.7338 12.5715 7.95855 13.0404 8.35275C12.9449 8.46954 12.8554 8.58811 12.7712 8.70093L12.7686 8.70226ZM12.2259 9.4765C11.7969 9.11238 11.2967 8.88808 10.8061 8.79517C10.8061 8.79517 10.9568 8.54476 11.0423 8.41513C11.6415 8.53635 12.1278 8.82216 12.4708 9.11415C12.3831 9.24157 12.3001 9.36368 12.2259 9.47606V9.4765ZM15.0611 5.77785C15.0611 5.77785 14.5748 6.03578 13.8975 6.71578C14.0503 6.80383 14.2222 6.92682 14.3208 7.01044C14.2183 7.1029 14.1137 7.20289 14.0164 7.29668C13.5736 6.92638 13.1177 6.73923 12.7617 6.65075C12.8798 6.56448 13.0052 6.47953 13.129 6.39724C13.32 6.44679 13.505 6.52333 13.505 6.52333C14.2691 5.93049 14.9334 5.67388 14.9334 5.67388C14.9334 5.67388 14.8566 5.63557 14.6521 5.63831C11.6432 5.67791 8.8775 7.96545 9.39851 11.8765C9.45452 12.2919 9.61299 13.0489 9.81445 13.3807C9.88132 12.7303 10.1219 11.288 10.8348 9.73956C10.5869 9.64887 10.3832 9.6117 10.3832 9.6117C10.4562 9.45597 10.5573 9.25732 10.5573 9.25732C11.087 9.35864 11.5516 9.58383 11.9554 9.91211C11.8586 10.0718 11.793 10.1758 11.7465 10.2581C11.605 10.1444 11.4617 10.0466 11.3037 9.95723C10.5005 11.3863 10.1314 12.7356 9.97944 13.4391C9.98778 13.4826 10.075 13.505 10.1453 13.4957C13.4407 13.0608 14.9647 11.3456 15.4423 9.49181C15.751 8.27515 15.6498 7.00097 15.2365 5.96128C15.2074 5.88828 15.1509 5.76706 15.055 5.7759",
				fill: "white"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/LeagueNHL.tsx
function pe(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "100%",
		viewBox: "0 0 26 29",
		width: "31",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [/* @__PURE__ */ t("g", {
			clipPath: "url(#clip0_1340_77668)",
			children: [
				/* @__PURE__ */ e("path", {
					d: "M1.38835 17.5241C1.38835 14.9145 2.65048 13.932 2.90291 11.4452C2.55582 13.625 1.07281 15.375 1.07281 17.5241C1.07281 18.353 1.19903 19.0898 1.38835 19.7653C2.3034 22.774 5.0801 24.4319 7.73058 25.1073C3.66019 24.0941 1.38835 20.717 1.38835 17.5241ZM24.8956 17.5241C24.8956 16.1732 24.517 15.0987 24.1068 14.1162C23.6019 12.9496 23.0655 11.875 23.0655 10.5549C23.0655 13.7171 24.6116 14.6381 24.6116 17.5241C24.6116 20.717 22.3714 24.0941 18.2694 25.1073C21.9612 24.1862 24.8956 21.5459 24.8956 17.5241Z",
					fill: "white"
				}),
				/* @__PURE__ */ e("path", {
					d: "M23.5388 4.87514C22.6869 4.62953 22.0874 4.01551 21.7087 3.03307L20.8883 0.761169L20.4781 2.20413C21.2985 5.73478 24.2645 5.98039 24.2645 5.98039L25.4636 5.42777L23.5388 4.87514ZM9.466 17.739L7.91988 15.4057L6.18445 16.6644C6.18445 16.6644 6.78396 16.6951 6.78396 17.3092V21.6995L8.01454 20.8091V17.7083L9.40289 19.796L10.6966 18.8442V13.3794L9.466 14.2697V17.739ZM14.4514 12.6426L13.0631 13.6557V11.6294L11.2014 12.9803C11.2014 12.9803 11.801 13.011 11.801 13.625V18.0153L13.0631 17.0943V15.0987L14.4514 14.0855V16.1118L15.6505 15.2522V9.75665L14.4514 10.647V12.6426ZM17.9223 12.1514V8.06808L16.0607 9.41894C16.0607 9.41894 16.6602 9.44964 16.6602 10.0637V14.454L20.131 11.9057C20.0679 11.0461 20.131 10.5242 20.131 10.5242L17.9223 12.1514Z",
					fill: "#E4E5E6"
				}),
				/* @__PURE__ */ e("path", {
					d: "M2.08255 10.5549C2.08255 13.6557 0.504883 14.2698 0.504883 17.5241C0.504883 18.5065 0.66265 19.4583 0.978184 20.2872C1.07284 20.103 1.23061 19.8881 1.38838 19.7653C1.1675 19.0899 1.07284 18.353 1.07284 17.5241C1.07284 15.4057 2.55585 13.625 2.90294 11.4452C2.93449 11.1689 2.9345 10.8619 2.9345 10.5549C2.96605 8.06811 1.73547 5.98042 1.73547 5.98042L0.536436 5.4278L1.35682 7.23917C1.76702 8.16021 2.08255 9.29616 2.08255 10.5549Z",
					fill: "url(#paint0_linear_1340_77668)"
				}),
				/* @__PURE__ */ e("path", {
					d: "M23.0656 10.5549C23.0656 11.8751 23.602 12.9189 24.1068 14.1163L24.7694 14.0856C24.3592 13.1031 23.949 12.1514 23.949 10.5549C23.949 9.29616 24.2646 8.16021 24.6748 7.23917L25.4952 5.4278L24.2646 5.98042C24.2646 5.98042 23.0656 8.06811 23.0656 10.5549Z",
					fill: "url(#paint1_linear_1340_77668)"
				}),
				/* @__PURE__ */ e("path", {
					d: "M12.0534 26.059C11.0752 25.7213 9.71844 25.5985 7.76213 25.1073C5.08009 24.4626 2.33495 22.774 1.4199 19.7653C1.26213 19.9188 1.10436 20.103 1.0097 20.2872C2.05097 23.1731 4.70145 25.1994 7.54126 25.9362C9.37136 26.3968 10.2233 26.4275 11.5801 26.7959C11.7694 26.9801 13 28.3002 13 28.3002V27.0415C13 27.0415 12.1796 26.1511 12.0534 26.059Z",
					fill: "url(#paint2_linear_1340_77668)"
				}),
				/* @__PURE__ */ e("path", {
					d: "M7.98301 24.2477C10.1602 24.7696 11.5801 24.831 12.5267 25.2915C12.5267 25.2915 12.8738 25.5985 13 25.752C13.1262 25.5985 13.4733 25.2915 13.4733 25.2915C14.4199 24.831 15.8398 24.7696 18.017 24.2477C20.7621 23.5722 23.7282 21.2082 23.7282 17.5241C23.7282 14.8838 22.182 13.9013 22.182 10.5549C22.182 8.283 23.0655 6.53302 23.0655 6.53302C23.0655 6.53302 21.0461 6.13391 20.0995 3.6471C20.0995 3.6471 18.7427 4.87515 16.8811 4.87515C14.5461 4.87515 13 3.27869 13 3.27869C13 3.27869 11.4539 4.87515 9.11894 4.87515C7.25729 4.87515 5.90049 3.6471 5.90049 3.6471C4.95389 6.13391 2.93447 6.53302 2.93447 6.53302C2.93447 6.53302 3.81797 8.283 3.81797 10.5549C3.81797 13.9013 2.27185 14.8838 2.27185 17.5241C2.27185 21.2389 5.23787 23.5722 7.98301 24.2477ZM22.75 17.5241C22.75 20.6556 20.1942 22.7126 17.7961 23.3266C16.0607 23.7565 13.9782 23.9714 13.3155 24.3398C13.1578 24.4319 13 24.6161 13 24.6161C13 24.6161 12.8107 24.4319 12.6845 24.3398C12.0534 24.0021 9.93932 23.7565 8.20389 23.3266C8.14078 23.2959 8.07767 23.2959 8.01457 23.2652L21.5825 13.3487C22.0558 14.9452 22.75 15.9583 22.75 17.5241ZM21.7718 7.08565C21.4879 7.88388 21.1723 9.14263 21.1723 10.5549C21.1723 11.1382 21.2039 11.6908 21.2985 12.1514L6.75243 22.774C4.92233 21.853 3.34467 20.103 3.25001 17.7083L19.9733 5.48918C20.5728 6.28741 21.2354 6.77863 21.7718 7.08565ZM4.82767 10.5549C4.82767 9.11193 4.51214 7.88388 4.22816 7.08565C4.85923 6.74793 5.67962 6.13391 6.31068 5.09006C7.00486 5.45848 7.98301 5.8576 9.11894 5.8576C10.8544 5.8576 12.2112 5.12076 13 4.56814C13.7888 5.12076 15.1456 5.8576 16.8811 5.8576C17.165 5.8576 17.4175 5.82689 17.6699 5.79619L3.43933 16.1732C3.84952 14.6075 4.82767 13.318 4.82767 10.5549Z",
					fill: "url(#paint3_linear_1340_77668)"
				}),
				/* @__PURE__ */ e("path", {
					d: "M9.11892 4.01551C11.4539 4.01551 13 2.08133 13 2.08133V0.853273L11.7694 2.01992C11.1383 2.63395 10.1286 3.12517 9.11892 3.12517C8.36163 3.12517 7.63591 2.78746 7.03639 2.29624L5.14319 0.761169L5.55338 2.20413C5.52183 2.20413 7.32037 4.01551 9.11892 4.01551Z",
					fill: "url(#paint4_linear_1340_77668)"
				}),
				/* @__PURE__ */ e("path", {
					d: "M24.8956 17.5241C24.8956 21.5459 21.9612 24.1862 18.2379 25.1073C16.2815 25.5985 14.9248 25.7213 13.9466 26.059C13.8204 26.1818 13 27.0414 13 27.0414V28.3002C13 28.3002 14.2621 26.98 14.4199 26.7958C15.7767 26.4274 16.6286 26.3967 18.4587 25.9362C22.1505 25.0152 25.4951 21.8836 25.4951 17.5241C25.4951 15.9583 25.148 15.0065 24.7694 14.0855L24.1068 14.1162C24.517 15.0987 24.8956 16.1732 24.8956 17.5241Z",
					fill: "url(#paint5_linear_1340_77668)"
				}),
				/* @__PURE__ */ e("path", {
					d: "M16.8811 4.01551C18.6796 4.01551 20.4781 2.23483 20.4781 2.23483L20.8883 0.761169L18.9951 2.29624C18.3641 2.78746 17.6699 3.12517 16.9126 3.12517C15.9029 3.12517 14.8932 2.63395 14.2621 2.01992L13.0315 0.853273V2.05062C13 2.08133 14.5461 4.01551 16.8811 4.01551Z",
					fill: "url(#paint6_linear_1340_77668)"
				}),
				/* @__PURE__ */ e("path", {
					d: "M5.52188 2.20413L5.14324 0.761169L4.2913 3.03307C3.91265 4.01551 3.31314 4.62953 2.4612 4.87514L0.536438 5.42777L1.73547 5.98039C1.73547 5.98039 4.73304 5.73478 5.52188 2.20413Z",
					fill: "url(#paint7_linear_1340_77668)"
				}),
				/* @__PURE__ */ e("path", {
					d: "M3.43932 16.1732L17.6699 5.76549C17.4175 5.7962 17.1335 5.8269 16.8811 5.8269C15.1456 5.8269 13.7888 5.09007 13 4.53744C12.2112 5.09007 10.8544 5.8269 9.11893 5.8269C7.98301 5.8269 7.00485 5.45848 6.31068 5.05936C5.67961 6.10321 4.85922 6.71723 4.22816 7.05495C4.51214 7.85318 4.82767 9.11194 4.82767 10.5242C4.82767 13.318 3.84951 14.6075 3.43932 16.1732ZM8.01456 23.2652C8.07767 23.2959 8.14078 23.2959 8.20388 23.3266C9.93932 23.7565 12.0218 23.9714 12.6845 24.3398C12.8422 24.4319 13 24.6161 13 24.6161C13 24.6161 13.1893 24.4319 13.3155 24.3398C13.9466 24.0021 16.0607 23.7565 17.7961 23.3266C20.1942 22.7433 22.75 20.6863 22.75 17.5241C22.75 15.9583 22.0558 14.9452 21.5825 13.3487L8.01456 23.2652ZM1.70388 10.5549C1.70388 13.5329 0.126214 14.2084 0.126214 17.5241C0.126214 22.2828 3.91262 25.4143 7.4466 26.3047C9.21359 26.7345 9.75 26.7652 11.3592 27.1336C11.4854 27.2564 13 28.8529 13 28.8529C13 28.8529 14.5146 27.2871 14.6408 27.1336C16.25 26.7345 16.7864 26.7345 18.5534 26.3047C22.0874 25.4143 25.8738 22.2828 25.8738 17.5241C25.8738 14.2084 24.2961 13.5329 24.2961 10.5549C24.2961 9.48035 24.517 8.40581 24.9903 7.39266L26 5.18217L23.6651 4.53744C22.9393 4.32253 22.4345 3.80061 22.0874 2.94097L21.0461 0.177857L18.7112 2.05064C18.1117 2.54186 17.4806 2.78747 16.8495 2.78747C16.0291 2.78747 15.0825 2.38835 14.483 1.80503L13 0.362065L11.517 1.80503C10.8859 2.41905 9.97087 2.78747 9.15049 2.78747C8.55097 2.78747 7.9199 2.54186 7.28884 2.05064L4.95388 0.147156L3.91262 2.91027C3.59709 3.76991 3.06068 4.32253 2.33495 4.50674L0 5.21287L1.00971 7.42336C1.45146 8.40581 1.70388 9.48035 1.70388 10.5549ZM2.46117 4.87516C3.31311 4.62955 3.91262 4.01552 4.29126 3.03308L5.1432 0.761182L7.03641 2.29625C7.66748 2.78747 8.36165 3.12518 9.11893 3.12518C10.1286 3.12518 11.1383 2.63396 11.7694 2.01994L13 0.853286L14.2306 2.01994C14.8617 2.63396 15.8714 3.12518 16.8811 3.12518C17.6383 3.12518 18.3641 2.78747 18.9636 2.29625L20.8568 0.761182L21.7087 3.03308C22.0874 4.01552 22.6869 4.62955 23.5388 4.87516L25.4636 5.42778L24.6432 7.23916C24.233 8.1602 23.9175 9.26544 23.9175 10.5549C23.9175 12.1514 24.3277 13.1031 24.7379 14.0855C25.1165 15.0066 25.4636 15.9583 25.4636 17.5241C25.4951 21.8837 22.1505 25.0152 18.4587 25.9362C16.6286 26.3968 15.7767 26.4275 14.4199 26.7959C14.2306 26.9801 13 28.3002 13 28.3002C13 28.3002 11.7379 26.9801 11.5801 26.7959C10.2233 26.4275 9.37136 26.3968 7.54126 25.9362C4.70146 25.2301 2.05097 23.2038 1.00971 20.2872C0.694175 19.4276 0.536408 18.5065 0.536408 17.5241C0.504854 14.2698 2.08252 13.6557 2.08252 10.5549C2.08252 9.29614 1.76699 8.1602 1.3568 7.23916L0.536408 5.42778L2.46117 4.87516ZM6.75243 22.774L21.2985 12.1514C21.2354 11.6601 21.1723 11.1382 21.1723 10.5549C21.1723 9.11194 21.4879 7.88388 21.7718 7.08565C21.2354 6.77864 20.5413 6.31812 19.9733 5.51988L3.25 17.739C3.34466 20.1337 4.95388 21.8837 6.75243 22.774ZM17.9223 8.06809V12.1207L20.1311 10.4935C20.1311 10.4935 20.068 11.0154 20.1311 11.8751L16.6602 14.4233V10.0944C16.6602 9.48035 16.0607 9.44965 16.0607 9.44965L17.9223 8.06809ZM13.0631 11.6294V13.6557L14.4515 12.6426V10.6163L15.6505 9.72596V15.1908L14.4515 16.1118V14.1162L13.0631 15.1294V17.125L11.801 18.046V13.6557C11.801 13.0417 11.2015 13.011 11.2015 13.011L13.0631 11.6294ZM7.9199 15.4057L9.46602 17.739V14.2698L10.6966 13.3794V18.8442L9.40291 19.796L8.01456 17.7083V20.8091L6.78398 21.6995V17.3092C6.78398 16.6952 6.18447 16.6645 6.18447 16.6645L7.9199 15.4057ZM2.90291 11.4452C2.65049 13.932 1.38835 14.9145 1.38835 17.5241C1.38835 20.717 3.66019 24.0942 7.76214 25.1073C9.71845 25.5985 11.0752 25.7213 12.0534 26.0591C12.1796 26.1819 13 27.0415 13 27.0415C13 27.0415 13.8204 26.1819 13.9466 26.0591C14.9248 25.7213 16.2816 25.5985 18.2379 25.1073C22.3714 24.0942 24.6117 20.717 24.6117 17.5241C24.6117 14.6075 23.0655 13.7171 23.0655 10.5549C23.0655 8.06809 24.2646 5.9804 24.2646 5.9804C24.2646 5.9804 21.267 5.73479 20.4782 2.20414C20.4782 2.20414 18.6796 3.98482 16.8811 3.98482C14.5461 3.98482 13 2.05064 13 2.05064C13 2.05064 11.4539 3.98482 9.11893 3.98482C7.32039 3.98482 5.52184 2.20414 5.52184 2.20414C4.73301 5.73479 1.73544 5.9804 1.73544 5.9804C1.73544 5.9804 2.93447 8.06809 2.93447 10.5549C2.96602 10.8926 2.93447 11.1689 2.90291 11.4452ZM2.96602 6.53303C2.96602 6.53303 4.98544 6.13391 5.93204 3.6471C5.93204 3.6471 7.28884 4.87516 9.15049 4.87516C11.4854 4.87516 13.0316 3.27869 13.0316 3.27869C13.0316 3.27869 14.5777 4.87516 16.9126 4.87516C18.7743 4.87516 20.1311 3.6471 20.1311 3.6471C21.0777 6.13391 23.0971 6.53303 23.0971 6.53303C23.0971 6.53303 22.2136 8.283 22.2136 10.5549C22.2136 13.9013 23.7597 14.8838 23.7597 17.5241C23.7597 21.2082 20.7937 23.5722 18.0485 24.2477C15.8714 24.7696 14.4515 24.831 13.5049 25.2915C13.5049 25.2915 13.1578 25.5985 13.0316 25.752C12.9053 25.5985 12.5583 25.2915 12.5583 25.2915C11.6117 24.831 10.1917 24.7696 8.01456 24.2477C5.26942 23.5722 2.3034 21.2082 2.3034 17.5241C2.3034 14.8838 3.84951 13.9013 3.84951 10.5549C3.81796 8.283 2.96602 6.53303 2.96602 6.53303Z",
					fill: "#111111"
				})
			]
		}), /* @__PURE__ */ t("defs", { children: [
			/* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint0_linear_1340_77668",
				x1: "0.278534",
				x2: "3.40633",
				y1: "12.8698",
				y2: "12.8698",
				children: [
					/* @__PURE__ */ e("stop", {
						offset: "0.11",
						stopColor: "white"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.24",
						stopColor: "#DCDFE1"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.44",
						stopColor: "#A8AFB3"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.54",
						stopColor: "#949CA1"
					})
				]
			}),
			/* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint1_linear_1340_77668",
				x1: "24.2709",
				x2: "24.2709",
				y1: "14.1101",
				y2: "5.43701",
				children: [
					/* @__PURE__ */ e("stop", { stopColor: "white" }),
					/* @__PURE__ */ e("stop", {
						offset: "0.35",
						stopColor: "white"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.56",
						stopColor: "#949CA1"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "1",
						stopColor: "#949CA1"
					})
				]
			}),
			/* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint2_linear_1340_77668",
				x1: "1.00024",
				x2: "13.0063",
				y1: "24.0389",
				y2: "24.0389",
				children: [
					/* @__PURE__ */ e("stop", {
						offset: "0.15",
						stopColor: "white"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.21",
						stopColor: "#FAFAFA"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.29",
						stopColor: "#EBECED"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.37",
						stopColor: "#D2D5D7"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.45",
						stopColor: "#AFB5B9"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.51",
						stopColor: "#949CA1"
					})
				]
			}),
			/* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint3_linear_1340_77668",
				x1: "20.1311",
				x2: "6.41216",
				y1: "23.4464",
				y2: "3.3156",
				children: [
					/* @__PURE__ */ e("stop", { stopColor: "#949CA1" }),
					/* @__PURE__ */ e("stop", {
						offset: "0.01",
						stopColor: "#99A1A6"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.12",
						stopColor: "#C2C6C8"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.2",
						stopColor: "#DBDDDE"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.25",
						stopColor: "#E4E5E6"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.75",
						stopColor: "#E4E5E6"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.8",
						stopColor: "#DCDEDF"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.87",
						stopColor: "#C7CACD"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.97",
						stopColor: "#A3AAAE"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "1",
						stopColor: "#949CA1"
					})
				]
			}),
			/* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint4_linear_1340_77668",
				x1: "5.13372",
				x2: "13.0063",
				y1: "2.38834",
				y2: "2.38834",
				children: [
					/* @__PURE__ */ e("stop", {
						offset: "0.25",
						stopColor: "white"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.34",
						stopColor: "#FAFAFA"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.45",
						stopColor: "#EBECED"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.57",
						stopColor: "#D2D5D7"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.7",
						stopColor: "#AFB5B9"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.79",
						stopColor: "#949CA1"
					})
				]
			}),
			/* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint5_linear_1340_77668",
				x1: "13.0063",
				x2: "25.4951",
				y1: "21.1959",
				y2: "21.1959",
				children: [
					/* @__PURE__ */ e("stop", {
						offset: "0.2",
						stopColor: "white"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.33",
						stopColor: "#FAFBFB"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.47",
						stopColor: "#EDEEEF"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.63",
						stopColor: "#D7DADC"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.79",
						stopColor: "#B8BDC1"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.93",
						stopColor: "#949CA1"
					})
				]
			}),
			/* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint6_linear_1340_77668",
				x1: "13.0063",
				x2: "20.8789",
				y1: "2.38834",
				y2: "2.38834",
				children: [
					/* @__PURE__ */ e("stop", {
						offset: "0.25",
						stopColor: "white"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.34",
						stopColor: "#FAFAFA"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.45",
						stopColor: "#EBECED"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.57",
						stopColor: "#D2D5D7"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.7",
						stopColor: "#AFB5B9"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.79",
						stopColor: "#949CA1"
					})
				]
			}),
			/* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint7_linear_1340_77668",
				x1: "0.526972",
				x2: "5.53134",
				y1: "3.38306",
				y2: "3.38306",
				children: [
					/* @__PURE__ */ e("stop", {
						offset: "0.39",
						stopColor: "white"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.47",
						stopColor: "#FAFAFA"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.57",
						stopColor: "#EBECED"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.67",
						stopColor: "#D2D5D7"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.79",
						stopColor: "#AFB5B9"
					}),
					/* @__PURE__ */ e("stop", {
						offset: "0.87",
						stopColor: "#949CA1"
					})
				]
			}),
			/* @__PURE__ */ e("clipPath", {
				id: "clip0_1340_77668",
				children: /* @__PURE__ */ e("rect", {
					fill: "white",
					height: "29",
					width: "26"
				})
			})
		] })]
	});
}
//#endregion
//#region primitives/icon/icons/LeaguePremierLeague.tsx
function me(t) {
	return /* @__PURE__ */ e("svg", {
		height: "167px",
		version: "1.1",
		viewBox: "0 0 131.1 166.7",
		width: "132px",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M28.8,18.8c6.8,3.2,11.3,7.1,12.1,7.7c-0.3-1.8-1.7-10.3-2.6-15.5c3.9,2.7,13.3,9.2,16.3,11.3\n                C55.8,18.5,60.2,6,60.2,6s7.8,12.5,9,14.6C70.9,19,80.1,8.6,82.5,6c0.5,5.9,0.9,14.5,1.1,15.7c0.5-0.6,4.1-5.6,10-10.3\n                c-2.6,5.1-3.8,12.1-4.4,17.8c-5.9-1.7-12.1-2.6-18.4-2.6c-12.2,0-23.8,3.2-33.8,8.9C35.3,30,32.6,23.2,28.8,18.8z M122.6,126.2\n                l-5.4-6c-1.5,16.1-9.5,29.9-24,39.5l-2.3-8.7c-12.4,8.9-33.5,14.6-51.7,4.4c2.3-11.5,4.2-23.2,0-37.2c-10.1,15.5-19,21.7-19,21.7\n                c-6.8-11.5-6.2-34.4-4.2-41.2l-11.3,3.5c0-7.7,5.6-24,13.6-33.2l-6.9-1.1c4.8-9.8,11.9-18.2,20.8-24.7c-2.7,4.4-2.7,14.6,5,18.5\n                c-3.3-5.7-3.6-12.8-0.3-16.6c3.5-3.8,9.2-2.4,12.8,0.5c-1.1-3.2-4.4-7.2-9-7.5c9-4.7,19.5-7.2,30.3-7.2c2.1,0,4.1,0.2,6,0.3\n                c3.2,1.2,7.8,5.7,10,8.6c0,0,0.2-3.3-1.7-7.2c11.8,2.9,17.5,7.7,19.8,10c0.5,5.1,2,8.1,4.1,13c-3.8-4.2-13.4-11.2-18.1-12.8\n                c0,0-0.5,4.4-2,6.5c-9.2-6.6-13.6-8.3-13.6-8.3C65.3,42,59,46,55.4,49l3,2.6c-6,1.8-10,7.1-10,7.1c0,0.2,5.4,0.9,5.4,0.9\n                s-0.6,6.3,7.4,10.3c6.8,3.3,16.4-0.8,25.6,2.9c-6-6.9-10.1-10.1-10.1-10.1s-2.4-0.5-4.1-0.5c-2.1,0-5.3,0.5-8.6-0.9\n                c-1.7-0.6-3.6-1.8-5-2.7c0,0,4.2-4.4,10.4-5.3c0,0,5.6,1.5,10,4.8c2.9-2.9,6-2.7,6-2.7s-3,2.9-2.1,6.2c4.4,3.9,9.2,9.5,9.2,9.5\n                c4.8-2.7,15.4-2.1,17.6,0.5c-2.7-3.6-6.8-6.5-9.8-9c-0.3-1.4-3.8-6-4.2-6.5c0,0,3.2,1.1,6,3.5c0.8-1.2,2.4-2.4,4.4-2.9\n                c2.1,1.8,2.6,4.5,2.4,5c-0.9,1.2-2,1.7-2,1.7l5.1,5.6l0.5-4.1C124.4,81.8,130.9,101.5,122.6,126.2z M100.2,89.7v-8.7\n                c0,0-3.9-1.2-8.1-4.5c-8.4,1.2-18.5,9.7-18.5,9.7s3.5,6.5,7.2,13.6C87.4,100.5,97.2,92.3,100.2,89.7z M108.6,105.5\n                c0,0-0.6-3.6-3.6-6.9l-6.5,0.2c0,0-8.9,7.5-14.2,7.7c0,0,3,5.6,4.5,8.4c3-0.6,8.1-3,10.3-5.4c0,0,1.4,4.5,1.1,9.8\n                C103.2,117.4,107.3,112.8,108.6,105.5z M111.3,76.7c-3.3,2.7-6,4.4-6,4.4v8.7c2.4,2.6,4.7,4.8,6.5,8.7\n                C115.1,92.7,114.3,84,111.3,76.7z",
			fill: "#360D3A"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Left.tsx
function he(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M20 20H4V4h16z" }), /* @__PURE__ */ e("path", {
				d: "M7.78 11.306l6.442-6.69a.822.822 0 011.163-.023l.022.022a.887.887 0 010 1.231L9.481 12l5.926 6.154a.886.886 0 010 1.23.822.822 0 01-1.163.023l-.022-.022-6.443-6.691a1 1 0 010-1.388z",
				fill: "#00182E"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Legal.tsx
function ge(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 20 20",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", {
				d: "M20 10c0 5.522-4.477 10-10 10S0 15.522 0 10C0 4.477 4.477 0 10 0s10 4.477 10 10",
				fill: "#1ED560"
			}), /* @__PURE__ */ e("path", {
				d: "M7.104 12.204v-.673H4.917l1.017-1.238c.625-.764.625-.764.818-1.093.224-.374.328-.734.328-1.124 0-.901-.561-1.406-1.562-1.406-1.01 0-1.611.497-1.683 1.399l.785.061c.104-.52.401-.787.866-.787.488 0 .745.244.745.703 0 .466-.265 1.001-.85 1.704l-1.586 1.919v.535h3.309zm3.43 0V6.746h-.577l-1.499.612.265.627.953-.39v4.609h.858zm4.215-.978v-1.46h1.498v-.627h-1.498V7.671h-.714v1.468h-1.498v.627h1.498v1.46h.714z",
				fill: "#00182E"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Legislations.tsx
function _e(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "currentColor",
		height: "20",
		viewBox: "0 0 20 20",
		width: "20",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M2.41951 14.5966H6.44802C7.23081 14.5966 7.86777 13.9515 7.86777 13.1587V12.1527C7.86777 11.9095 7.67314 11.7124 7.43302 11.7124H6.71087L4.82149 4.48225C4.98823 4.39627 5.15892 4.302 5.33597 4.19453C7.15169 3.09064 8.80878 2.97642 9.52459 2.98837V15.8023H7.9833C7.29905 15.8023 6.74214 16.3663 6.74214 17.0597V18.5597C6.74214 18.8029 6.93677 19 7.17689 19H12.7422C12.9823 19 13.1769 18.8032 13.1769 18.5597V17.0597C13.1769 16.3663 12.62 15.8023 11.9358 15.8023H10.3939V2.98758C11.1103 2.9756 12.7674 3.09045 14.5825 4.19405C14.7092 4.27113 14.8311 4.33776 14.9527 4.40378L13.043 11.7119H12.5667C12.3266 11.7119 12.132 11.9087 12.132 12.1522V13.1582C12.132 13.951 12.7689 14.5961 13.5517 14.5961H17.5802C18.363 14.5961 19 13.951 19 13.1582V12.1522C19 11.909 18.8054 11.7119 18.5653 11.7119H17.8431L16.0617 4.89296C16.6732 5.09869 17.185 5.16471 17.5748 5.16471C18.1317 5.16471 18.447 5.03911 18.4746 5.02745C18.6944 4.93594 18.7975 4.68385 18.7102 4.46C18.6229 4.23645 18.3709 4.12591 18.1496 4.21096C18.1387 4.21496 16.9912 4.63041 15.03 3.43901C13.0376 2.22829 11.2343 2.09041 10.3943 2.10543V1.44033C10.3943 1.19713 10.1996 1 9.95953 1C9.71941 1 9.52478 1.19683 9.52478 1.44033V2.10543C8.6844 2.09038 6.8814 2.22825 4.88903 3.43901C2.92779 4.63071 1.78092 4.21527 1.77549 4.21312C1.55417 4.12192 1.29951 4.22786 1.20826 4.45263C1.1167 4.6774 1.2225 4.93441 1.44443 5.02745C1.47202 5.03912 1.78701 5.16471 2.34426 5.16471C2.69563 5.16471 3.14521 5.11189 3.67763 4.9513L1.91103 11.7119H1.43475C1.19463 11.7119 1 11.9087 1 12.1522V13.1582C1 13.9507 1.63672 14.5966 2.41951 14.5966ZM12.3072 17.0599V18.1195H7.61142V17.0599C7.61142 16.8517 7.77816 16.6828 7.98341 16.6828H11.9352C12.1405 16.6828 12.3072 16.8517 12.3072 17.0599ZM18.1311 13.1587C18.1311 13.466 17.8841 13.7163 17.5806 13.7163H13.5521C13.2486 13.7163 13.0015 13.466 13.0015 13.1587V12.593H18.1312L18.1311 13.1587ZM13.9425 11.7124L15.4435 5.96822L16.9445 11.7124H13.9425ZM6.99868 13.1587C6.99868 13.466 6.75159 13.7163 6.44812 13.7163H2.4196C2.11613 13.7163 1.86904 13.466 1.86904 13.1587V12.593H6.99871L6.99868 13.1587ZM4.31075 5.96814L5.81176 11.7123H2.80974L4.31075 5.96814Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: "0.1"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Less.tsx
function ve(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 20 2",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M20 1a1 1 0 01-1 1H1a1 1 0 010-2h18a1 1 0 011 1z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/LockIcon.tsx
function ye(n) {
	return /* @__PURE__ */ t("svg", {
		...n,
		fill: "none",
		height: "20",
		viewBox: "0 0 17 20",
		width: "17",
		xmlns: "http://www.w3.org/2000/svg",
		children: [/* @__PURE__ */ e("path", {
			d: "M8.6201 11.5V14.5M1 7.92736V18.3184H16.2402V7.92736H1ZM3.77094 7.92736C3.77094 3.77094 3.77094 1 8.6201 1C13.4692 1 13.4692 3.77094 13.4692 7.92736H3.77094Z",
			stroke: "#00E889",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5"
		}), /* @__PURE__ */ e("path", {
			d: "M8.62047 12.8547C9.00306 12.8547 9.31321 12.5446 9.31321 12.162C9.31321 11.7794 9.00306 11.4692 8.62047 11.4692C8.23788 11.4692 7.92773 11.7794 7.92773 12.162C7.92773 12.5446 8.23788 12.8547 8.62047 12.8547Z",
			stroke: "#00E889",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5"
		})]
	});
}
//#endregion
//#region primitives/icon/icons/MmaUfc.tsx
function be(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M15.92 4a4.13 4.13 0 013.015 1.303 3.96 3.96 0 011.048 3.063l-.665 7.179a.505.505 0 01-.508.455v3.5c0 .276-.229.5-.51.5H9.106a.505.505 0 01-.51-.5V16l-.071-.006-.034-.004-.044-.012-.039-.012-.025-.012a.518.518 0 01-.137-.088l-4.071-3.49A.494.494 0 014 12v-1.5C4 9.122 5.146 8 6.553 8h.854c0-.992.378-1.958 1.065-2.697A4.125 4.125 0 0111.486 4h4.433zm-4.25 12H9.618v3h8.17v-3h-6.116zm2.543 1c.282 0 .51.224.51.5s-.228.5-.51.5h-1.021c-.281 0-.51-.224-.51-.5s.229-.5.51-.5h1.022zM15.92 5h-4.433a3.05 3.05 0 00-2.26.977 2.972 2.972 0 00-.786 2.297l.015.141a.538.538 0 01.007.069L9.107 15h9.236l.622-6.725a2.962 2.962 0 00-.787-2.299A3.05 3.05 0 0015.92 5zM7.483 9h-.93c-.844 0-1.532.673-1.532 1.5v1.273l2.95 2.528L7.484 9z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/More.tsx
function xe(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 20 20",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M11 9h8a1 1 0 010 2h-8v8a1 1 0 01-2 0v-8H1a1 1 0 010-2h8V1a1 1 0 012 0v8z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/MotorSport.tsx
function Se(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 16",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" }), /* @__PURE__ */ e("path", {
				d: "M7.428 0c3.39 0 6.563 2.34 7.317 5.306h.143c.166.01.318.1.408.239 1.232 1.846.578 5.273.058 6.828a.527.527 0 01-.498.36.443.443 0 01-.154 0l-.716 1.752a1.24 1.24 0 01-1.172.774c-.101 0-.2-.011-.298-.037L1.698 12.516a1.23 1.23 0 01-.828-.68A15.157 15.157 0 010 6.899C0 3.22 3.47 0 7.428 0zm7.11 6.367h-.133a.53.53 0 01-.27-.037L8.25 5.958a2.077 2.077 0 01-.419 2.468l.287.096a.521.521 0 01.207.126l1.496 1.496 4.68 1.402c.435-1.534.71-3.884.037-5.179zm-8.182-.531a1.24 1.24 0 00-1.222 1.251 1.24 1.24 0 002.482 0 1.241 1.241 0 00-1.222-1.251h-.038zm-4.5 5.555a.168.168 0 00.118.096l10.84 2.705a.174.174 0 00.206-.1l.653-1.688-4.276-1.262a.603.603 0 01-.223-.133L7.672 9.502 6.24 9.03a2.124 2.124 0 11.127-4.245H6.4l7.216.451c-.801-2.33-3.454-4.176-6.187-4.176-3.396 0-6.367 2.728-6.367 5.837.022 1.531.291 3.048.796 4.493v.001z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Nascar.tsx
function Ce(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M11.428 4c3.39 0 6.563 2.34 7.317 5.306h.143c.166.01.318.1.408.239 1.232 1.846.578 5.273.058 6.828a.527.527 0 01-.498.36.443.443 0 01-.154 0l-.716 1.752a1.24 1.24 0 01-1.172.774c-.101 0-.2-.011-.298-.037L5.698 16.516a1.23 1.23 0 01-.828-.68A15.157 15.157 0 014 10.899C4 7.22 7.47 4 11.428 4zm7.11 6.367h-.133a.53.53 0 01-.27-.037l-5.885-.372a2.077 2.077 0 01-.419 2.468l.287.096a.521.521 0 01.207.126l1.496 1.496 4.68 1.402c.435-1.534.71-3.884.037-5.179zm-8.182-.531a1.24 1.24 0 00-1.222 1.251 1.24 1.24 0 002.482 0 1.241 1.241 0 00-1.222-1.251h-.038zm-4.5 5.555a.168.168 0 00.118.096l10.84 2.705a.174.174 0 00.206-.1l.653-1.688-4.276-1.262a.603.603 0 01-.223-.133l-1.502-1.507-1.432-.472a2.124 2.124 0 11.127-4.245h.033l7.216.451c-.801-2.33-3.454-4.176-6.187-4.176-3.396 0-6.367 2.728-6.367 5.837.022 1.531.291 3.048.796 4.493v.001z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/OCPlus.tsx
function we({ className: n = "", height: r = 20, width: i = 20 }) {
	return /* @__PURE__ */ e("svg", {
		className: n,
		height: r,
		viewBox: "0 0 245.7 247.1",
		width: i,
		children: /* @__PURE__ */ t("g", {
			fill: "#FFFFFF",
			children: [
				/* @__PURE__ */ e("path", { d: "M38.8,123.6c0-46.3,37.7-84,84-84c19.8,0,38,6.9,52.4,18.4l23.3-28.8c-20.7-16.6-47-26.6-75.7-26.6 c-66.8,0-121,54.2-121,121c0,28.7,10,55,26.6,75.7l29.4-22.5C46,162.2,38.8,143.7,38.8,123.6z" }),
				/* @__PURE__ */ e("path", { d: "M220.5,52.1l-0.6,0.5l-28.8,22.1c9.9,13.8,15.7,30.6,15.7,48.8c0,46.3-37.7,84-84,84 c-19.1,0-36.8-6.4-50.9-17.2l-22.8,29.2c20.4,15.7,46,25,73.7,25c66.8,0,121-54.2,121-121C243.8,96.8,235.2,72.1,220.5,52.1z" }),
				/* @__PURE__ */ e("polygon", { points: "135.8,175.5 135.8,136.5 174.8,136.5 174.8,110.5 135.8,110.5 135.8,71.6 109.8,71.6 109.8,110.5 70.8,110.5 70.8,136.5 109.8,136.5 109.8,175.5" })
			]
		})
	});
}
//#endregion
//#region primitives/icon/icons/OcLogo.tsx
function Te(n) {
	return /* @__PURE__ */ t("svg", {
		height: "1em",
		viewBox: "0 0 214 40",
		width: "1em",
		...n,
		children: [/* @__PURE__ */ t("defs", { children: [/* @__PURE__ */ t("radialGradient", {
			cx: "36.196%",
			cy: "34.35%",
			fx: "36.196%",
			fy: "34.35%",
			id: "oc-logo_svg__b",
			r: "78.25%",
			children: [
				/* @__PURE__ */ e("stop", {
					offset: "0%",
					stopColor: "#1ED460"
				}),
				/* @__PURE__ */ e("stop", {
					offset: "27%",
					stopColor: "#1ED260"
				}),
				/* @__PURE__ */ e("stop", {
					offset: "42%",
					stopColor: "#1ECA5E",
					stopOpacity: .99
				}),
				/* @__PURE__ */ e("stop", {
					offset: "54%",
					stopColor: "#1DBC5B",
					stopOpacity: .99
				}),
				/* @__PURE__ */ e("stop", {
					offset: "65%",
					stopColor: "#1CA957",
					stopOpacity: .98
				}),
				/* @__PURE__ */ e("stop", {
					offset: "75%",
					stopColor: "#1B9052",
					stopOpacity: .96
				}),
				/* @__PURE__ */ e("stop", {
					offset: "83%",
					stopColor: "#1A714C",
					stopOpacity: .95
				}),
				/* @__PURE__ */ e("stop", {
					offset: "92%",
					stopColor: "#194D44",
					stopOpacity: .93
				}),
				/* @__PURE__ */ e("stop", {
					offset: "99%",
					stopColor: "#17243C",
					stopOpacity: .9
				}),
				/* @__PURE__ */ e("stop", {
					offset: "100%",
					stopColor: "#171E3B",
					stopOpacity: .9
				})
			]
		}), /* @__PURE__ */ t("linearGradient", {
			id: "oc-logo_svg__a",
			x1: "56.161%",
			x2: "42.773%",
			y1: "13.762%",
			y2: "87.539%",
			children: [
				/* @__PURE__ */ e("stop", {
					offset: "0%",
					stopColor: "#1ED460",
					stopOpacity: .5
				}),
				/* @__PURE__ */ e("stop", {
					offset: "27%",
					stopColor: "#1ECE5F",
					stopOpacity: .5
				}),
				/* @__PURE__ */ e("stop", {
					offset: "45%",
					stopColor: "#1DBB5B",
					stopOpacity: .51
				}),
				/* @__PURE__ */ e("stop", {
					offset: "61%",
					stopColor: "#1C9C55",
					stopOpacity: .53
				}),
				/* @__PURE__ */ e("stop", {
					offset: "76%",
					stopColor: "#1A6F4B",
					stopOpacity: .56
				}),
				/* @__PURE__ */ e("stop", {
					offset: "89%",
					stopColor: "#183540",
					stopOpacity: .59
				}),
				/* @__PURE__ */ e("stop", {
					offset: "94%",
					stopColor: "#171E3B",
					stopOpacity: .6
				})
			]
		})] }), /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M0 28.571h213.714V40H0z" }), /* @__PURE__ */ t("g", {
				fillRule: "nonzero",
				children: [
					/* @__PURE__ */ e("path", {
						d: "M55.298 12.092v.011a5.004 5.004 0 014.994 5.017v6.628a5.013 5.013 0 01-4.994 5.017h-13.82V12.092h13.82zm23.301 0v3.744H67.736a2.127 2.127 0 00-1.18.324 1.226 1.226 0 000 2.08c.356.212.766.315 1.18.298h5.33a7.903 7.903 0 013.379.696 4.96 4.96 0 012.456 2.352c.325.651.497 1.368.502 2.095a4.693 4.693 0 01-.487 2.107c-1.013 1.984-2.959 2.977-5.85 2.977h-10.31V25.04h11.001a1.99 1.99 0 001.18-.346c.334-.217.527-.596.506-.994a1.177 1.177 0 00-.506-1.02 1.942 1.942 0 00-1.18-.372h-5.43c-2.75 0-4.626-1.012-5.642-2.977a4.704 4.704 0 01-.51-2.174 4.626 4.626 0 01.51-2.15c.994-1.944 2.888-2.915 5.642-2.915H78.6zm-43.987 0a4.812 4.812 0 013.506 1.466 4.867 4.867 0 011.489 3.562v6.628a5.013 5.013 0 01-4.995 5.017h-13.83V12.092zm-20.73-.004a5.022 5.022 0 015.017 5.032v6.628a5.014 5.014 0 01-5.017 5.017h-8.78a5.002 5.002 0 01-5.016-5.016V17.12a5.01 5.01 0 015.017-5.032zm41.412 3.752H45.223v9.181h10.07c.333.006.652-.129.88-.372.242-.236.377-.562.371-.9v-6.633a1.229 1.229 0 00-.372-.904 1.172 1.172 0 00-.878-.372zm-20.682 0H24.526v9.181h10.086a1.17 1.17 0 00.879-.372h-.012c.249-.233.388-.56.384-.9v-6.633a1.233 1.233 0 00-.372-.904 1.183 1.183 0 00-.879-.372zm-20.73.007h-8.78a1.153 1.153 0 00-.874.372 1.21 1.21 0 00-.372.901v6.628c-.007.34.128.666.372.901.225.243.543.378.875.372h8.775c.333.01.654-.125.879-.372.243-.235.378-.562.372-.9V17.12a1.301 1.301 0 00-.346-.9 1.21 1.21 0 00-.9-.373z",
						fill: "#FFF"
					}),
					/* @__PURE__ */ e("path", {
						d: "M193.947 12.047v3.748h-11.675v2.661h11.258v3.767h-11.258v2.776h11.675v3.77h-15.445V12.047h15.445zm5.628.004v.022h9.144a5.013 5.013 0 014.994 5.017v1.645a4.809 4.809 0 01-1.458 3.514 4.821 4.821 0 01-3.54 1.477h-.554l5.065 5.017h-5.318l-5.017-5.02h-3.294l-.022-.164v5.21h-3.745V12.051h3.745zm-94.071-.004l.004 6.41h8.362v-6.41h3.748V28.77h-3.748v-6.546h-8.351l-.011-.164v.164h-.004v6.546h-3.744V12.047h3.744zm29.439 0v3.748h-11.675v2.661h11.262v3.767h-11.262v2.776h11.675v3.77H119.5V12.047h15.442zm16.16.026c.81 0 1.61.19 2.333.555a3.772 3.772 0 011.76 1.619l-3.148 2.285a.872.872 0 00-.945-.715h-9.268a1.173 1.173 0 00-.878.373c-.245.234-.38.561-.372.9v6.636c-.007.34.127.668.372.904.226.245.546.38.878.373h9.268c.45 0 .96-.35 1.548-1.042l2.776 2.52a7.803 7.803 0 01-1.965 1.547 4.83 4.83 0 01-2.36.715h-9.255a4.8 4.8 0 01-3.517-1.455 4.843 4.843 0 01-1.49-3.562V17.09a5.007 5.007 0 014.995-5.017zm-55.559 0c.812 0 1.612.19 2.338.555a3.803 3.803 0 011.76 1.615l-3.145 2.289a.872.872 0 00-.945-.715h-9.27c-.332-.006-.65.13-.876.373a1.21 1.21 0 00-.372.9v6.636c-.007.34.128.668.372.904.225.244.544.38.875.373h9.27c.47 0 .969-.35 1.545-1.042l2.777 2.52a7.894 7.894 0 01-1.969 1.547 4.833 4.833 0 01-2.36.715h-9.267a5.013 5.013 0 01-4.994-5.017V17.09a5.013 5.013 0 014.994-5.017zm113.175 3.744h-9.144v4.161h9.148a1.257 1.257 0 001.246-1.246V17.09a1.214 1.214 0 00-.372-.9 1.164 1.164 0 00-.878-.373z",
						fill: "#1ED460"
					}),
					/* @__PURE__ */ t("g", {
						transform: "translate(157.3 .134)",
						children: [
							/* @__PURE__ */ e("path", {
								d: "M25.36 5.33L3.77 28.602 0 28.605V11.917h3.752v11.362L25.338 5.307z",
								fill: "#1ED460"
							}),
							/* @__PURE__ */ e("path", {
								d: "M3.752 11.917v11.355A2.316 2.316 0 01.03 21.728v-9.811h3.722z",
								fill: "url(#oc-logo_svg__a)"
							}),
							/* @__PURE__ */ e("path", {
								d: "M19.32 28.605h-5.323l-2.46-2.367-1.287-1.235 2.616-2.821 1.265 1.261z",
								fill: "#1ED460"
							}),
							/* @__PURE__ */ e("circle", {
								cx: 28.255,
								cy: 2.319,
								fill: "url(#oc-logo_svg__b)",
								r: 2.319
							})
						]
					})
				]
			})]
		})]
	});
}
//#endregion
//#region primitives/icon/icons/Offers.tsx
function Ee(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 16 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M15.455 3.28h-5.189c.562-.38.896-.812 1.009-1.295a1.672 1.672 0 00-.482-1.531l-.041-.031c-.013-.011-.022-.026-.035-.037A1.638 1.638 0 009.144.084C8.637.27 8.222.714 7.9 1.429 7.574.714 7.161.27 6.654.084A1.64 1.64 0 005.08.386c-.013.01-.024.024-.035.037-.01.013-.028.02-.041.03-.41.394-.593.972-.482 1.532.113.483.447.912 1.01 1.295H.542c-.3 0-.543.245-.543.547v3.401c0 .302.243.547.542.547h.584v7.678c0 .302.243.547.542.547h12.664c.3 0 .542-.245.542-.547V7.775h.584c.3 0 .542-.245.542-.547V3.827a.547.547 0 00-.545-.548zM9.008 4.373v2.308H6.717V4.373h2.29zm.5-3.265a.562.562 0 01.51.107l.02.013.018.02a.587.587 0 01.162.485c-.037.156-.269.656-1.677 1.188.36-1.459.82-1.757.968-1.813zm-3.219 0c.15.056.608.354.968 1.815C5.86 2.392 5.62 1.897 5.582 1.742a.577.577 0 01.165-.499l.015-.017.018-.011a.568.568 0 01.51-.107zM1.083 4.373h4.549v2.308H1.093l-.01-2.308zm1.134 3.402h3.415v7.131H2.217V7.775zm4.5 7.131V7.775h2.29v7.131h-2.29zm7.072 0h-3.688V7.775h3.688v7.131zm1.124-8.225h-4.82V4.373h4.82v2.308z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Olympics.tsx
function De(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M15.8537 3.55508C15.7396 3.4754 15.6005 3.43208 15.4574 3.43162C15.3144 3.43116 15.175 3.47359 15.0602 3.55252C14.9455 3.63146 14.8615 3.74266 14.821 3.86942C14.7805 3.99618 14.7855 4.13167 14.8354 4.25555C14.8762 4.37171 14.8821 4.4959 14.8526 4.61493C14.8231 4.73396 14.7593 4.84339 14.6679 4.93159C14.5679 5.01327 14.4452 5.06759 14.3136 5.08845C14.182 5.10932 14.0467 5.09589 13.9229 5.04969C13.4821 4.87457 13.2925 4.27591 13.2661 3.82794C13.222 3.01343 13.363 1.85276 14.28 1.06677C14.3726 0.986169 14.4381 0.882587 14.4686 0.768452C14.4991 0.654316 14.4933 0.534476 14.4519 0.423311C14.4108 0.311398 14.3349 0.213125 14.2338 0.140716C14.1327 0.0683072 14.0108 0.0249573 13.8832 0.0160587C13.228 -0.0359795 12.5683 0.0385297 11.9459 0.234847C11.3236 0.431163 10.7523 0.744991 10.2684 1.15636C9.78591 1.5797 9.421 2.10426 9.20459 2.68559C8.98819 3.26692 8.92668 3.88787 9.02528 4.49583C9.07528 4.74634 9.14152 4.99385 9.22365 5.23703C9.29233 5.4347 9.34827 5.63597 9.39116 5.83976C9.4303 5.96997 9.43875 6.10642 9.41593 6.23991C9.39312 6.37339 9.33958 6.5008 9.25892 6.61354C9.11545 6.70809 8.94362 6.7589 8.76739 6.7589C8.59116 6.7589 8.41933 6.70809 8.27586 6.61354C7.83221 6.32342 7.47572 5.93382 7.23991 5.48138C7.16983 5.36487 7.06042 5.27274 6.92838 5.21903C6.79634 5.16532 6.6489 5.15298 6.50856 5.18389C6.36821 5.21481 6.24267 5.28728 6.15106 5.39025C6.05946 5.49323 6.00682 5.62105 6.00118 5.75424C5.98208 6.70583 6.19114 7.64954 6.61337 8.5177C7.0356 9.38585 7.66054 10.1569 8.44338 10.7757H6.71092C6.60335 10.7763 6.49756 10.8011 6.4026 10.8478C6.30764 10.8945 6.22635 10.9617 6.16568 11.0438C6.10502 11.1258 6.06678 11.2203 6.05426 11.319C6.04173 11.4177 6.05528 11.5177 6.09375 11.6105L10.9429 23.0624C11.0331 23.2464 11.1508 23.5862 11.3345 23.6956C11.5182 23.805 11.7426 24 11.9612 24C12.1798 24 12.4841 23.805 12.6678 23.6956C12.8546 23.5119 12.9246 23.2464 13.0148 23.0624L17.8639 11.6105C17.9039 11.5184 17.9187 11.4186 17.9072 11.3199C17.8957 11.2212 17.8581 11.1266 17.7978 11.0444C17.7415 10.9662 17.6665 10.9009 17.5786 10.8536C17.4907 10.8063 17.3923 10.7783 17.2908 10.7716H16.3695C17.2909 9.95433 17.8648 8.85918 17.9874 7.68461C18.0489 6.88457 17.8847 6.08345 17.5107 5.35962C17.1367 4.63578 16.5658 4.014 15.8537 3.55508ZM11.9459 23.3321L6.92838 11.6105H16.9319L11.9459 23.3321ZM16.6693 7.57873C16.6061 8.19506 16.3769 8.78698 16.0027 9.30055C15.6285 9.81413 15.1211 10.233 14.5268 10.5191C14.3131 10.6205 14.0904 10.705 13.8612 10.7716H11.084C10.9339 10.7294 10.7867 10.6791 10.6431 10.6209C9.28066 10.0471 8.21899 8.99894 7.68956 7.70497C8.0834 7.93041 8.95502 9.00389 9.41593 8.96043C9.93023 9.4925 10.2376 7.4647 10.2376 7.4647C10.2376 7.4647 10.6146 6.9187 10.6911 6.60268C10.7677 6.28665 10.7633 5.95848 10.6784 5.64428C10.635 5.39361 10.5732 5.14596 10.4932 4.90308C10.4251 4.70527 10.3692 4.50403 10.3257 4.30035C10.2602 3.8841 10.3037 3.45941 10.4525 3.06189C10.6013 2.66436 10.8511 2.30559 11.1809 2.01567C11.5409 1.70848 11.9722 1.48142 12.4417 1.35185C12.0589 2.14121 11.8938 3.00593 11.9612 3.86866C12.0141 4.97639 12.5607 5.83976 13.4159 6.17371C13.8741 6.36072 14.3919 6.38068 14.8653 6.2296C15.3388 6.07852 15.7328 5.76758 15.9683 5.3592C16.4912 5.99343 16.741 6.78425 16.6693 7.57873Z",
			fill: "currentColor"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Options.tsx
function Oe(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M13.2 5.6a1.6 1.6 0 11-3.2 0 1.6 1.6 0 013.2 0zm0 6.4a1.6 1.6 0 11-3.2 0 1.6 1.6 0 013.2 0zm-1.6 8a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/OtherSports.tsx
function ke(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.744 6.23h-1.231v-.82a.41.41 0 00-.41-.41H7.897a.41.41 0 00-.41.41v.82h-1.23a2.258 2.258 0 00-.001 4.515.41.41 0 100-.82 1.436 1.436 0 010-2.873h1.231v3.487c0 2.018 1.34 3.79 3.282 4.341v1.403h-.947a.41.41 0 00-.347.193l-.9 1.436a.406.406 0 000 .41c.068.13.201.213.348.217h6.154a.409.409 0 00.359-.615l-.9-1.436a.411.411 0 00-.358-.205h-.947V14.88a4.514 4.514 0 003.282-4.34V7.05h1.23a1.435 1.435 0 11.001 2.872.41.41 0 100 .82 2.256 2.256 0 100-4.51zm-3.408 11.488H9.664l.385-.615h3.898l.39.615zm-1.926-1.436h-.82v-1.25c.135 0 .273.02.41.02.137 0 .275 0 .41-.02v1.25zm3.282-5.744a3.692 3.692 0 11-7.384 0V5.821h7.384v4.717z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Picks.tsx
function Ae(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "22",
		viewBox: "0 0 15 22",
		width: "15",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M6.2 12.3333H1L11.4 1L8.8 9.66667H14L3.6 21L6.2 12.3333Z",
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: "1.5"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Pie.tsx
function je(n) {
	return /* @__PURE__ */ t("svg", {
		height: "1em",
		viewBox: "0 0 28 29",
		width: "1em",
		...n,
		children: [
			/* @__PURE__ */ t("defs", { children: [
				/* @__PURE__ */ e("clipPath", {
					id: "clip-path",
					children: /* @__PURE__ */ e("path", {
						d: "M14,22.64a7.72,7.72,0,1,0-7.72-7.72h0A7.72,7.72,0,0,0,14,22.64Zm0,1.28a9,9,0,1,1,9-9,9,9,0,0,1-9,9Z",
						fill: "none"
					})
				}),
				/* @__PURE__ */ e("clipPath", {
					id: "clip-path-2",
					children: /* @__PURE__ */ e("path", {
						d: "M17,19.67a.25.25,0,0,0,.18-.1.31.31,0,0,0,.06-.19l-.36-3.07L19,14a.26.26,0,0,0,.06-.25.28.28,0,0,0-.2-.18l-3-.61L14.31,10.3a.25.25,0,0,0-.34-.1.24.24,0,0,0-.1.1L12.25,13l-3,.61a.28.28,0,0,0-.2.18.26.26,0,0,0,.06.25l2.1,2.28-.36,3.07a.26.26,0,0,0,.23.28.22.22,0,0,0,.14,0L14,18.36l2.82,1.29A.32.32,0,0,0,17,19.67Z",
						fill: "none"
					})
				}),
				/* @__PURE__ */ e("clipPath", {
					id: "clip-path-3",
					children: /* @__PURE__ */ e("rect", {
						fill: "none",
						height: "20",
						width: "20",
						x: "4",
						y: "5.17"
					})
				}),
				/* @__PURE__ */ e("clipPath", {
					id: "clip-path-4",
					children: /* @__PURE__ */ e("rect", {
						fill: "none",
						height: "10",
						width: "12",
						x: "8",
						y: "10.17"
					})
				})
			] }),
			/* @__PURE__ */ e("image", {
				height: "29",
				style: {
					opacity: .5,
					isolation: "isolate"
				},
				width: "28",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAeCAYAAADQBxWhAAAACXBIWXMAAAsSAAALEgHS3X78AAAEVklEQVRIS72WTU8bVxSGn/eOZxjjkKJYA0kDSqpSqcK7VJEqVaqSdsc+/B3bfyfZZ5susotCF5WtSkWFKOQDpkQIw3jwxz1deDAfpUkMUt6V5Tn3PPfec8+HzIwvLfcpg4skSYCKn/qU/XlpkpNK0qNHj9zNmzdL5XI5Auh2u733798Pnjx54u0znX0SKkmNRkOtVku1Wi1M07QSBMGNUqlUBRgMBrvD4fBDkiSHrVarX6vVrNFo2Mc28FFos9l0u7u74fT0dJzneTw1NTXrvV80syUz+wZA0oakdefc66Ojo704jvMsy/Jqtdqv1+v+Ir//C11dXQ2SJClPT08nZnYbmDOzBeB7YAm4VZi+A9aBPyVtATuS3mRZlqZp2n38+PHwvO8Loaurq0GtVit3Op0F7/09ST8AdyQl3vtbwA1J0wBmlgEfnHPvzCwFXpnZSzP7PYqirY2Njex8vP8DPQbu7e0tOufuAw/N7J6kOaAMxECJk5fvgQGQA10z25G0Juk37/1aHMdvDw4ODk5fd+k0sNlsuiRJyp1OZ6EA/grcl7RQAB1FqpxaFhT/h0BFUgUIzSwCZvI8/6NcLv8F/COpb2Y2zlNJKh5N4r2/BzwE7pvZIlDh5HQX5aWKb6XCdhH4EViR9LP3fnF3dzc+vtWg0WiMVklOUmUwGHwn6Rcz+0nSnWLnkxQRMYKXgbKkQ0l/l8vld8+fP88fPHhwctLl5WXleR4XsbtzKoaTAI/lgClJ1yR95b2/1u12o+XlZR1/RJKePn0aArOSvgYSLg8EwMwERN77WWDezK632+1QklxhwN27d6MoiubMbEnSvKQpLo7fZ0kSkiLn3BzwbRRFc0BkZqOTNJtNpWkamtl1il1570OuAAXkvT/jM03TsNlsanx9cRzLzEIgAkJp8u5xXoWPkNEJwziOT2L6pTWG5nlukvpAD+ifLluXVeGjD/Qk9fM8Nyig9XrdkiTpS9oHtiXtO+f6wFXA5pw74zNJkn69XrfjlGFzc7PX6/V2JK2b2baZHXFFqJkdmdm2pPVer7ezubnZk8RxytjKykof2DOzt0AKdBkV88vKM/KRFj73VlZWztbedrttcRznZrbDqD3tcHmwp+g4FL7iOM7b7fZJTAEajYZlWZYHQbBlZi8lrQFbNuqXk4B9sWZL0pqZvQyCYCvLsrzRaJyFmplVq9V+lmWpc24NeAa8kPQaOGTUMz0Xx9k46auHxZoXwDPn3FqWZWm1Wh1nxMRNXNKU935cPMzMnHP94uGNmzjwzHv/YnZ29nWr1Toztkw0rgCJpHkblbawMO9L2jezbUYP8JWZvXTOrc3MzGydB8KEgxlw28yWgHlgqjA9YpSH68AbLjuYHev8CArMOufmgiC4PhwOSwBBEAyGw+G+934HuNoIOjbQybBdqVTCmZmZyHs/Lt55nptzrt/pdHqHh4dXH7bPS5LMjGazeaYD1et1k8THQKf1L+QwtRuQGGuFAAAAAElFTkSuQmCC"
			}),
			/* @__PURE__ */ e("path", {
				d: "M24.7,13.83c-.81-1.46-1-1.59-1-2V10.5c0-1.73-1.74-2.14-2.35-2.62-.32-.19-.29-.35-1-1.57-.89-1.48-2.57-1-3.25-1.07-.38,0-.5-.2-2-1-1.87-1.07-3.16,1-4.14,1H9.58C7.86,5.24,7.44,7,7,7.58c-.17.3-.38.32-1.58,1.06-1.51.9-1,2.61-1.07,3.24,0,.91-2.06,2.36-1,4.14,1.44,2.57.88,1,1,3.33,0,2,2.28,2.22,2.64,2.91s.88,2.35,2.62,2.35c1.28,0,1.45-.08,1.8.11,1.4.78,1.64,1.09,2.31,1.17,1.08.14,1.44-.33,3-1.17.33-.19.49-.08,1.81-.11,2,0,2.18-2.24,2.9-2.64s2.35-.89,2.35-2.62c0-1.3-.07-1.46.11-1.79l.9-1.54A2.15,2.15,0,0,0,24.7,13.83Z",
				fill: "#d4af37"
			}),
			/* @__PURE__ */ e("g", {
				className: "cls-4",
				clipPath: "url(#clip-path)",
				children: /* @__PURE__ */ e("rect", {
					className: "cls-5",
					fill: "#fff",
					height: "28",
					width: "28",
					y: "0.92"
				})
			}),
			/* @__PURE__ */ e("g", {
				className: "cls-6",
				clipPath: "url(#clip-path-2)",
				children: /* @__PURE__ */ e("g", {
					className: "cls-7",
					clipPath: "url(#clip-path-3)",
					children: /* @__PURE__ */ e("g", {
						className: "cls-8",
						clipPath: "url(#clip-path-4)",
						children: /* @__PURE__ */ e("rect", {
							className: "cls-5",
							fill: "#fff",
							height: "19.5",
							width: "20",
							x: "4",
							y: "5.17"
						})
					})
				})
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/Politics.tsx
function Me(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 31 23",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M15 4V5.13266L29.3332 10.0542C30.4012 10.4209 30.1377 12 29.0084 12H1.5C0.387232 12 0.106449 10.4557 1.148 10.064L14 5.23077V4V3V1V0H15H16C16.5523 0 17 0.447715 17 1H18H19V2V4V5H18H17C16.4477 5 16 4.55228 16 4H15ZM17 3V2H18V4H17V3ZM15 1H16V2V3H15V1ZM29.0084 11L14.629 6.06259L1.5 11L29.0084 11ZM5 14.5V20H4V14.5C4 14.2239 4.22386 14 4.5 14C4.77614 14 5 14.2239 5 14.5ZM3 20V14.5C3 13.6716 3.67157 13 4.5 13C5.32843 13 6 13.6716 6 14.5V20H10V14.5C10 13.6716 10.6716 13 11.5 13C12.3284 13 13 13.6716 13 14.5V20H17V14.5C17 13.6716 17.6716 13 18.5 13C19.3284 13 20 13.6716 20 14.5V20H24V14.5C24 13.6716 24.6716 13 25.5 13C26.3284 13 27 13.6716 27 14.5V20H28.5C29.3284 20 30 20.6716 30 21.5C30 22.3284 29.3284 23 28.5 23H1.5C0.671573 23 0 22.3284 0 21.5C0 20.6716 0.671573 20 1.5 20H3ZM26 20V14.5C26 14.2239 25.7761 14 25.5 14C25.2239 14 25 14.2239 25 14.5V20H26ZM24 21H20H19H18H17H13H12H11H10H6H5H4H3H1.5C1.22386 21 1 21.2239 1 21.5C1 21.7761 1.22386 22 1.5 22H28.5C28.7761 22 29 21.7761 29 21.5C29 21.2239 28.7761 21 28.5 21H27H26H25H24ZM19 20V14.5C19 14.2239 18.7761 14 18.5 14C18.2239 14 18 14.2239 18 14.5V20H19ZM12 20V14.5C12 14.2239 11.7761 14 11.5 14C11.2239 14 11 14.2239 11 14.5V20H12Z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/PremiumAlert.tsx
function Ne(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "47",
		viewBox: "0 0 47 47",
		width: "47",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M39.7142 39.7142C43.8621 35.5663 46.4173 29.8279 46.4173 23.5007C46.4173 17.1757 43.8621 11.435 39.7142 7.28711C35.5663 3.13919 29.8279 0.583984 23.5007 0.583984C17.1757 0.583984 11.435 3.13919 7.28711 7.28711C3.13919 11.435 0.583984 17.1734 0.583984 23.5007C0.583984 29.8257 3.13919 35.5663 7.28711 39.7142C11.435 43.8621 17.1734 46.4173 23.5007 46.4173C29.8257 46.4173 35.5663 43.8621 39.7142 39.7142ZM26.6013 32.3396C26.6013 30.6209 25.2194 29.2413 23.5007 29.2413C21.7819 29.2413 20.3588 30.6232 20.3588 32.3396C20.3588 34.0584 21.7819 35.4838 23.5007 35.4838C25.2194 35.4838 26.6013 34.0584 26.6013 32.3396ZM23.5007 26.0971C22.3686 26.0971 21.5298 25.1759 21.4061 24.0025L20.3588 14.6617C20.1915 13.0277 21.9079 11.5152 23.5007 11.5152C25.0934 11.5152 26.8098 13.0254 26.6013 14.6594L25.5952 24.0002C25.4692 25.1736 24.6327 26.0948 23.5007 26.0948V26.0971Z",
			fill: "#D82F20",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/PremiumBadgeTrophy.tsx
function Pe(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "30",
		viewBox: "0 0 30 30",
		width: "30",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M14.6836 29.751C15.1337 30.083 15.8864 30.083 16.3364 29.751C18.9308 27.838 26.7955 21.5947 27.6793 16.3084C28.0873 12.1624 28.0116 7.01881 27.9542 4.87416C27.9395 4.3175 27.4691 3.8735 26.9109 3.8575C21.3576 3.69384 17.8782 1.50885 16.3561 0.283524C15.9204 -0.0681406 15.2511 -0.0981404 14.7954 0.224191C13.195 1.34885 9.31049 3.65484 4.06914 3.85183C3.51097 3.8765 3.04222 4.3175 3.03054 4.87416C2.98483 7.01881 2.93279 12.1621 3.34149 16.3084C4.22528 21.5947 12.089 27.838 14.6836 29.751Z",
				fill: "white",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M14.7489 28.7676C15.163 29.0775 15.8555 29.0775 16.2695 28.7676C18.6563 26.9821 25.8918 21.1551 26.7049 16.2212C27.0803 12.3516 27.0106 7.55089 26.9578 5.54922C26.9443 5.02966 26.5116 4.61527 25.998 4.60033C20.889 4.44758 17.6879 2.40826 16.2876 1.26462C15.8868 0.936402 15.2711 0.908402 14.8518 1.20924C13.3794 2.25893 9.80565 4.41118 4.98361 4.59505C4.47009 4.61807 4.03884 5.02966 4.0281 5.54922C3.98605 7.55089 3.93816 12.3513 4.31417 16.2212C5.12725 21.1551 12.3619 26.9821 14.7489 28.7676Z",
				fill: "#00182E",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				d: "M11.5208 8.56416H12.8726V9.95447H11.5208V8.56416Z",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M11.6833 10.5107H13.3055V11.901L13.8462 15.2377C13.8462 15.2377 12.6615 14.1856 12.224 13.2913C11.74 12.302 11.6833 10.5107 11.6833 10.5107Z",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M12.7657 19.1306C12.7657 19.1306 13.7099 18.0995 14.5107 17.9834C14.7797 17.9444 15.199 18.0183 15.199 18.0183L14.1176 19.1306H12.7657Z",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M22 9.65021C22 9.39535 21.7971 9.18907 21.5473 9.18907H19.7341V8.89898C19.9174 8.83992 20.0508 8.66724 20.0508 8.46114C20.0508 8.20628 19.8481 8 19.5981 8H11.5186C11.2682 8 11.0659 8.20645 11.0659 8.46114C11.0659 8.66723 11.1991 8.83992 11.383 8.89898V9.18907H9.45304C9.20267 9.18907 9 9.39552 9 9.65021C9 13.0001 11.4563 15.7757 14.6305 16.2099V16.211C14.6305 16.8923 14.3672 17.5608 13.8422 17.8977C13.3241 18.2298 12.7992 18.5689 12.4057 19.0777H12.3536C12.1034 19.0777 11.9009 19.2842 11.9009 19.5389C11.9009 19.7932 12.1036 20 12.3536 20H18.7322C18.9821 20 19.1849 19.7932 19.1849 19.5389C19.1849 19.284 18.9821 19.0777 18.7322 19.0777H18.643C18.2496 18.5689 17.725 18.2308 17.2071 17.8977C16.6826 17.5613 16.4184 16.8921 16.4184 16.211C16.4184 16.2084 16.4189 16.2039 16.4189 16.2039C19.5698 15.7476 22 12.9834 22 9.65021ZM19.7451 10.1543C19.7451 10.1393 19.7397 10.1261 19.7367 10.1115H21.0767C20.9351 11.8979 19.9804 13.51 18.5911 14.4957C19.3165 13.4083 19.7451 11.8992 19.7451 10.1543ZM11.9034 8.85307H12.8017V9.76216H11.9034V8.85307ZM9.92354 10.1117H11.3798C11.3774 10.1261 11.3717 10.1393 11.3717 10.1545C11.3717 11.9569 11.8166 13.5085 12.5648 14.6031C11.0915 13.6299 10.07 11.9644 9.92354 10.1117ZM12.635 13.7291C12.1932 12.8057 11.9554 11.8119 11.9103 10.5468H12.8019C12.8019 12.2866 13.1697 13.8255 13.8378 15.1718C13.3601 14.8636 12.92 14.3246 12.635 13.7291ZM14.188 18.9885H13.1076C13.694 18.4016 14.4454 18.0593 15.2661 17.9993C14.8467 18.2551 14.4804 18.5914 14.188 18.9885Z",
				fill: "url(#paint0_linear_2657_20787)"
			}),
			/* @__PURE__ */ e("defs", { children: /* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint0_linear_2657_20787",
				x1: "9.24977",
				x2: "20.5958",
				y1: "8.286",
				y2: "17.7036",
				children: [/* @__PURE__ */ e("stop", { stopColor: "#F5E01F" }), /* @__PURE__ */ e("stop", {
					offset: "1",
					stopColor: "#FF8A00"
				})]
			}) })
		]
	});
}
//#endregion
//#region primitives/icon/icons/PremiumHelp.tsx
function Fe(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "currentColor",
		height: "100%",
		preserveAspectRatio: "xMidYMid",
		viewBox: "0 0 24 24",
		width: "100%",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", { d: "M12.0003 2.51315C14.5164 2.51315 16.9293 3.51256 18.7086 5.29179C20.4878 7.07102 21.4872 9.48392 21.4872 12.0001C21.4872 14.5163 20.4878 16.9292 18.7086 18.7084C16.9293 20.4876 14.5164 21.487 12.0003 21.487C9.48409 21.487 7.07118 20.4876 5.29195 18.7084C3.51272 16.9292 2.51332 14.5163 2.51332 12.0001C2.51332 9.48392 3.51272 7.07102 5.29195 5.29179C7.07118 3.51256 9.48409 2.51315 12.0003 2.51315M12.0003 0.706055C9.00481 0.706055 6.13215 1.89597 4.0141 4.0141C1.89597 6.13207 0.706055 9.00489 0.706055 12.0003C0.706055 14.9956 1.89597 17.8684 4.0141 19.9864C6.13207 22.1045 9.00489 23.2945 12.0003 23.2945C14.9956 23.2945 17.8684 22.1045 19.9864 19.9864C22.1045 17.8684 23.2945 14.9956 23.2945 12.0003C23.2945 9.00489 22.1045 6.13215 19.9864 4.0141C17.8684 1.89597 14.9956 0.706055 12.0003 0.706055V0.706055Z" }),
			/* @__PURE__ */ e("path", { d: "M12.1038 6.0143L12.3477 6.03683H12.3479C12.9518 6.07496 13.543 6.22827 14.0894 6.48855C14.5774 6.71324 14.9935 7.06903 15.2912 7.51632C15.5177 7.86863 15.658 8.26964 15.6999 8.68639C15.7472 9.04689 15.7179 9.41325 15.6142 9.76159C15.4851 10.1773 15.2609 10.5571 14.959 10.8707C14.6138 11.2162 14.2355 11.5272 13.8296 11.799C13.6037 11.9549 13.4026 12.1175 13.1904 12.2803C12.9983 12.4389 12.8537 12.6477 12.7725 12.8832C12.7273 13.0052 12.6755 13.1272 12.6279 13.2491V13.2493C12.5698 13.4114 12.4631 13.5519 12.3225 13.6517C12.182 13.7514 12.0142 13.8058 11.8418 13.8072C11.6467 13.8286 11.4495 13.7974 11.2703 13.7168C10.9952 13.5824 10.8036 13.3216 10.7576 13.0189C10.6856 12.5996 10.7831 12.169 11.0288 11.8216C11.2242 11.5359 11.4635 11.2829 11.738 11.0717C12.0339 10.83 12.3388 10.5997 12.6414 10.358C12.8927 10.1657 13.1031 9.92528 13.2603 9.65099C13.3826 9.41811 13.4329 9.15421 13.4047 8.89279C13.3765 8.63124 13.2712 8.3842 13.1023 8.18268C12.9232 7.98746 12.6852 7.85573 12.4246 7.80767C12.0777 7.72669 11.7161 7.73299 11.3721 7.82579C11.015 7.92333 10.7177 8.17039 10.5565 8.50348C10.4503 8.70233 10.3577 8.90559 10.2584 9.10663C10.1855 9.25852 10.087 9.39686 9.96708 9.51535C9.7569 9.70002 9.47958 9.7892 9.20134 9.76163C9.03196 9.75721 8.86621 9.71231 8.71795 9.63069C8.58135 9.55995 8.46695 9.45296 8.38723 9.32139C8.3075 9.18999 8.26559 9.03904 8.26622 8.88528C8.25456 8.38644 8.41402 7.89862 8.71795 7.50284C9.06931 7.02796 9.53568 6.65009 10.0732 6.40509C10.4787 6.21255 10.9128 6.08744 11.3586 6.03466L11.6116 6.00977L12.1038 6.0143Z" }),
			/* @__PURE__ */ e("path", { d: "M11.6543 17.9863C11.5865 17.9727 11.5188 17.9614 11.4532 17.9434C11.0521 17.8385 10.7289 17.5415 10.5904 17.1508C10.4519 16.7598 10.5162 16.3258 10.7617 15.9917C11.0073 15.6575 11.4025 15.4667 11.8168 15.4823C12.2312 15.4979 12.611 15.7177 12.8309 16.0693C13.0509 16.4208 13.0823 16.8585 12.9149 17.2379C12.7476 17.6174 12.4031 17.8892 11.9952 17.9638L11.8846 17.9863L11.6543 17.9863Z" })
		]
	});
}
//#endregion
//#region primitives/icon/icons/PremiumIcon.tsx
function Ie(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "21",
		viewBox: "0 0 21 21",
		width: "21",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				d: "M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z",
				fill: "#03325B"
			}),
			/* @__PURE__ */ e("path", {
				d: "M12.4626 8.67272L11.0425 8.66885C11.0173 8.66934 10.9923 8.66433 10.9692 8.65418C10.9461 8.64402 10.9254 8.62895 10.9087 8.61003C10.8901 8.59141 10.8755 8.5692 10.8658 8.54475C10.856 8.52031 10.8514 8.49413 10.8521 8.46783L10.8549 7.42481C10.8544 7.3986 10.8592 7.37256 10.8691 7.34827C10.8789 7.32397 10.8936 7.30193 10.9122 7.28347C10.9291 7.26474 10.9498 7.24985 10.973 7.23982C10.9962 7.22978 11.0212 7.22483 11.0464 7.22529L12.4667 7.22917C12.5006 7.22608 12.5344 7.23602 12.5612 7.25695C12.588 7.27788 12.6058 7.30824 12.6111 7.34186L13.0939 6.98334C13.0339 6.87176 12.9396 6.78251 12.8248 6.72889C12.7143 6.67135 12.5917 6.64113 12.4671 6.64076L11.0475 6.63689C10.6241 6.63689 10.2811 6.98894 10.2803 7.4233L10.2783 8.46632C10.2768 8.90046 10.6179 9.25402 11.0413 9.25682L12.4609 9.2607C12.5892 9.25607 12.714 9.21765 12.8226 9.14931C12.9355 9.08511 13.0373 9.00328 13.1243 8.90692L12.7 8.50962C12.6111 8.61821 12.5346 8.67272 12.4626 8.67272Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M8.59643 6.63022L10.0318 6.63409C10.248 6.63413 10.4558 6.71774 10.6118 6.86743C10.6871 6.93993 10.747 7.02696 10.7877 7.12324C10.8284 7.21953 10.8492 7.32307 10.8488 7.42761L10.846 8.46891C10.8455 8.57325 10.8238 8.67639 10.7823 8.77212C10.7408 8.86784 10.6803 8.95416 10.6045 9.02586C10.4479 9.17389 10.2402 9.25578 10.0247 9.25446L8.58932 9.25058C8.3732 9.25072 8.16541 9.16718 8.00953 9.01746C7.93409 8.94534 7.87407 8.85866 7.83311 8.76267C7.79215 8.66668 7.7711 8.56337 7.77124 8.459L7.77404 7.41749C7.77431 7.313 7.79578 7.20965 7.83715 7.1137C7.87851 7.01774 7.93892 6.93118 8.01471 6.85924C8.17171 6.71056 8.38021 6.62847 8.59643 6.63022ZM10.1693 8.60788C10.1889 8.59001 10.2045 8.56816 10.2151 8.54379C10.2256 8.51942 10.2309 8.49309 10.2304 8.46654L10.2335 7.42503C10.234 7.39832 10.229 7.37178 10.219 7.34704C10.2089 7.3223 10.1939 7.29987 10.1748 7.28112C10.1558 7.26237 10.1332 7.2477 10.1083 7.23799C10.0834 7.22828 10.0568 7.22374 10.0301 7.22466L8.59471 7.22078C8.56816 7.22005 8.54174 7.22483 8.51712 7.2348C8.4925 7.24477 8.47021 7.25973 8.45165 7.27874C8.43199 7.29659 8.41636 7.31843 8.40581 7.3428C8.39526 7.36718 8.39003 7.39352 8.39046 7.42007L8.38766 8.46137C8.38714 8.48792 8.39224 8.51428 8.40264 8.53871C8.41304 8.56315 8.42849 8.58511 8.44799 8.60314C8.46649 8.62221 8.48873 8.63727 8.5133 8.64739C8.53787 8.65751 8.56426 8.66247 8.59083 8.66196L10.0256 8.66584C10.0522 8.66684 10.0788 8.66222 10.1036 8.65227C10.1283 8.64232 10.1507 8.62727 10.1693 8.60809V8.60788Z",
				fill: "white",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				d: "M3.84177 10.0383C4.41445 10.0383 4.72514 10.3498 4.72514 10.9275V11.2086C4.72514 11.7863 4.41381 12.0978 3.84177 12.0978H3.60477V13.5545H3.07324V10.0383H3.84177ZM3.60477 11.6055H3.82023C4.0764 11.6055 4.19189 11.47 4.19189 11.1746V10.9636C4.19189 10.6672 4.0764 10.5327 3.82023 10.5327H3.60477V11.6055Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M5.89612 12.0676H5.65007V13.5543H5.11768V10.0383H5.8862C6.45867 10.0383 6.76957 10.3498 6.76957 10.9275V11.1785C6.76957 11.5503 6.63901 11.8115 6.39274 11.9522L6.8801 13.5545H6.31819L5.89612 12.0676ZM5.65007 11.5753H5.86552C6.1217 11.5753 6.2374 11.4398 6.2374 11.1433V10.9626C6.2374 10.6661 6.1217 10.5317 5.86552 10.5317H5.65007V11.5753Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M7.84977 10.5306V11.5251H8.62843V12.0174H7.84977V13.0622H8.81415V13.5545H7.31738V10.0383H8.81415V10.5306H7.84977Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M11.0396 13.5545V11.1132H11.0295L10.5876 13.0523H10.2711L9.829 11.1132H9.81909V13.5545H9.31665V10.0383H10.0149L10.4318 11.9261H10.442L10.8537 10.0374H11.572V13.5537L11.0396 13.5545Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M12.1956 13.5545V10.0383H12.7287V13.5545H12.1956Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M14.9674 12.7664C14.9674 13.3188 14.6509 13.6051 14.1386 13.6051C13.6361 13.6051 13.3198 13.3188 13.3198 12.7664V10.0383H13.833V12.7509C13.833 13.007 13.9485 13.1025 14.1347 13.1025C14.3208 13.1025 14.4363 13.007 14.4363 12.7509V10.0383H14.9689L14.9674 12.7664Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M17.2833 13.5545V11.1132H17.2732L16.8313 13.0523H16.5148L16.0727 11.1132H16.0627V13.5545H15.5603V10.0383H16.2586L16.6755 11.9261H16.6856L17.0974 10.0374H17.8157V13.5537L17.2833 13.5545Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M10.48 20.5323C8.00641 20.5292 5.62213 19.6074 3.78969 17.9459C1.95724 16.2843 0.807248 14.0013 0.562788 11.5398C0.318328 9.07835 0.996827 6.61381 2.46667 4.62427C3.93651 2.63474 6.09292 1.26205 8.51758 0.772477C10.9422 0.282904 13.4623 0.711351 15.589 1.97471C17.7156 3.23806 19.2972 5.24626 20.027 7.60976C20.7568 9.97325 20.5827 12.5236 19.5385 14.766C18.4943 17.0084 16.6545 18.783 14.3759 19.7456C13.1434 20.2672 11.8183 20.5347 10.48 20.5323ZM10.48 0.945443C8.11316 0.948386 5.83177 1.83032 4.07839 3.42017C2.32501 5.01002 1.22463 7.19445 0.990716 9.54971C0.756798 11.905 1.40601 14.2632 2.81243 16.1668C4.21884 18.0705 6.28219 19.3839 8.60222 19.8524C10.9222 20.3208 13.3336 19.9108 15.3684 18.702C17.4033 17.4931 18.9166 15.5716 19.6148 13.3101C20.3131 11.0485 20.1465 8.60831 19.1473 6.4627C18.1481 4.31709 16.3877 2.61907 14.2074 1.69803C13.0282 1.19899 11.7604 0.94302 10.48 0.945443Z",
				fill: "#1ED560"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/PremiumIconMobileNav.tsx
function Le(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "21",
		viewBox: "0 0 21 21",
		width: "21",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				d: "M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z",
				fill: "#03325B"
			}),
			/* @__PURE__ */ e("path", {
				d: "M12.4626 8.67272L11.0425 8.66885C11.0173 8.66934 10.9923 8.66433 10.9692 8.65418C10.9461 8.64402 10.9254 8.62895 10.9087 8.61003C10.8901 8.59141 10.8755 8.5692 10.8658 8.54475C10.856 8.52031 10.8514 8.49413 10.8521 8.46783L10.8549 7.42481C10.8544 7.3986 10.8592 7.37256 10.8691 7.34827C10.8789 7.32397 10.8936 7.30193 10.9122 7.28347C10.9291 7.26474 10.9498 7.24985 10.973 7.23982C10.9962 7.22978 11.0212 7.22483 11.0464 7.22529L12.4667 7.22917C12.5006 7.22608 12.5344 7.23602 12.5612 7.25695C12.588 7.27788 12.6058 7.30824 12.6111 7.34186L13.0939 6.98334C13.0339 6.87176 12.9396 6.78251 12.8248 6.72889C12.7143 6.67135 12.5917 6.64113 12.4671 6.64076L11.0475 6.63689C10.6241 6.63689 10.2811 6.98894 10.2803 7.4233L10.2783 8.46632C10.2768 8.90046 10.6179 9.25402 11.0413 9.25682L12.4609 9.2607C12.5892 9.25607 12.714 9.21765 12.8226 9.14931C12.9355 9.08511 13.0373 9.00328 13.1243 8.90692L12.7 8.50962C12.6111 8.61821 12.5346 8.67272 12.4626 8.67272Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M8.59643 6.63022L10.0318 6.63409C10.248 6.63413 10.4558 6.71774 10.6118 6.86743C10.6871 6.93993 10.747 7.02696 10.7877 7.12324C10.8284 7.21953 10.8492 7.32307 10.8488 7.42761L10.846 8.46891C10.8455 8.57325 10.8238 8.67639 10.7823 8.77212C10.7408 8.86784 10.6803 8.95416 10.6045 9.02586C10.4479 9.17389 10.2402 9.25578 10.0247 9.25446L8.58932 9.25058C8.3732 9.25072 8.16541 9.16718 8.00953 9.01746C7.93409 8.94534 7.87407 8.85866 7.83311 8.76267C7.79215 8.66668 7.7711 8.56337 7.77124 8.459L7.77404 7.41749C7.77431 7.313 7.79578 7.20965 7.83715 7.1137C7.87851 7.01774 7.93892 6.93118 8.01471 6.85924C8.17171 6.71056 8.38021 6.62847 8.59643 6.63022ZM10.1693 8.60788C10.1889 8.59001 10.2045 8.56816 10.2151 8.54379C10.2256 8.51942 10.2309 8.49309 10.2304 8.46654L10.2335 7.42503C10.234 7.39832 10.229 7.37178 10.219 7.34704C10.2089 7.3223 10.1939 7.29987 10.1748 7.28112C10.1558 7.26237 10.1332 7.2477 10.1083 7.23799C10.0834 7.22828 10.0568 7.22374 10.0301 7.22466L8.59471 7.22078C8.56816 7.22005 8.54174 7.22483 8.51712 7.2348C8.4925 7.24477 8.47021 7.25973 8.45165 7.27874C8.43199 7.29659 8.41636 7.31843 8.40581 7.3428C8.39526 7.36718 8.39003 7.39352 8.39046 7.42007L8.38766 8.46137C8.38714 8.48792 8.39224 8.51428 8.40264 8.53871C8.41304 8.56315 8.42849 8.58511 8.44799 8.60314C8.46649 8.62221 8.48873 8.63727 8.5133 8.64739C8.53787 8.65751 8.56426 8.66247 8.59083 8.66196L10.0256 8.66584C10.0522 8.66684 10.0788 8.66222 10.1036 8.65227C10.1283 8.64232 10.1507 8.62727 10.1693 8.60809V8.60788Z",
				fill: "white",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				d: "M3.84177 10.0383C4.41445 10.0383 4.72514 10.3498 4.72514 10.9275V11.2086C4.72514 11.7863 4.41381 12.0978 3.84177 12.0978H3.60477V13.5545H3.07324V10.0383H3.84177ZM3.60477 11.6055H3.82023C4.0764 11.6055 4.19189 11.47 4.19189 11.1746V10.9636C4.19189 10.6672 4.0764 10.5327 3.82023 10.5327H3.60477V11.6055Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M5.89612 12.0676H5.65007V13.5543H5.11768V10.0383H5.8862C6.45867 10.0383 6.76957 10.3498 6.76957 10.9275V11.1785C6.76957 11.5503 6.63901 11.8115 6.39274 11.9522L6.8801 13.5545H6.31819L5.89612 12.0676ZM5.65007 11.5753H5.86552C6.1217 11.5753 6.2374 11.4398 6.2374 11.1433V10.9626C6.2374 10.6661 6.1217 10.5317 5.86552 10.5317H5.65007V11.5753Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M7.84977 10.5306V11.5251H8.62843V12.0174H7.84977V13.0622H8.81415V13.5545H7.31738V10.0383H8.81415V10.5306H7.84977Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M11.0396 13.5545V11.1132H11.0295L10.5876 13.0523H10.2711L9.829 11.1132H9.81909V13.5545H9.31665V10.0383H10.0149L10.4318 11.9261H10.442L10.8537 10.0374H11.572V13.5537L11.0396 13.5545Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M12.1956 13.5545V10.0383H12.7287V13.5545H12.1956Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M14.9674 12.7664C14.9674 13.3188 14.6509 13.6051 14.1386 13.6051C13.6361 13.6051 13.3198 13.3188 13.3198 12.7664V10.0383H13.833V12.7509C13.833 13.007 13.9485 13.1025 14.1347 13.1025C14.3208 13.1025 14.4363 13.007 14.4363 12.7509V10.0383H14.9689L14.9674 12.7664Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M17.2833 13.5545V11.1132H17.2732L16.8313 13.0523H16.5148L16.0727 11.1132H16.0627V13.5545H15.5603V10.0383H16.2586L16.6755 11.9261H16.6856L17.0974 10.0374H17.8157V13.5537L17.2833 13.5545Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ e("path", {
				d: "M10.48 20.5323C8.00641 20.5292 5.62213 19.6074 3.78969 17.9459C1.95724 16.2843 0.807248 14.0013 0.562788 11.5398C0.318328 9.07835 0.996827 6.61381 2.46667 4.62427C3.93651 2.63474 6.09292 1.26205 8.51758 0.772477C10.9422 0.282904 13.4623 0.711351 15.589 1.97471C17.7156 3.23806 19.2972 5.24626 20.027 7.60976C20.7568 9.97325 20.5827 12.5236 19.5385 14.766C18.4943 17.0084 16.6545 18.783 14.3759 19.7456C13.1434 20.2672 11.8183 20.5347 10.48 20.5323ZM10.48 0.945443C8.11316 0.948386 5.83177 1.83032 4.07839 3.42017C2.32501 5.01002 1.22463 7.19445 0.990716 9.54971C0.756798 11.905 1.40601 14.2632 2.81243 16.1668C4.21884 18.0705 6.28219 19.3839 8.60222 19.8524C10.9222 20.3208 13.3336 19.9108 15.3684 18.702C17.4033 17.4931 18.9166 15.5716 19.6148 13.3101C20.3131 11.0485 20.1465 8.60831 19.1473 6.4627C18.1481 4.31709 16.3877 2.61907 14.2074 1.69803C13.0282 1.19899 11.7604 0.94302 10.48 0.945443Z",
				fill: "currentColor"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/PremiumListTick.tsx
function Re(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 16 16",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM11.5712 4.77517C11.8619 4.48187 12.3324 4.47061 12.6369 4.74966C12.9604 5.04622 12.9705 5.55296 12.659 5.86215L7.42447 11.0585C7.03766 11.4424 6.41459 11.446 6.02348 11.0664L4.03454 9.13591C3.73689 8.84701 3.72307 8.37374 4.00336 8.06796C4.29824 7.74628 4.8018 7.73534 5.11037 8.04391L6.72785 9.66139L11.5712 4.77517Z",
			fill: "#2968FF",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/PremiumLock.tsx
function ze(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "100%",
		preserveAspectRatio: "xMidYMid",
		viewBox: "0 0 18 21",
		width: "18",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M9 12V14.25M0.75 8.25V19.5H17.25V8.25H0.75ZM3.75 8.25C3.75 3.75 3.75 0.75 9 0.75C14.25 0.75 14.25 3.75 14.25 8.25H3.75Z",
			stroke: "#00182E",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2"
		})
	});
}
//#endregion
//#region primitives/icon/icons/PremiumNFL.tsx
function Be(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "100%",
		preserveAspectRatio: "xMidYMid",
		viewBox: "0 0 20 28",
		width: "27",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				d: "M19.3123 3.18544C18.4786 3.82253 16.8114 4.67198 14.7273 4.14107C11.0455 3.22083 10.0035 0 10.0035 0C10.0035 0 8.9545 3.21729 5.27961 4.14107C3.16429 4.67198 1.52831 3.81545 0.659951 3.18898H0V20.5319C0 20.992 0.104203 21.8415 0.802362 22.7263C1.66725 23.7881 3.12609 24.4712 5.14415 24.7686C6.77666 25.0057 7.95763 25.5224 8.79125 26.3471C9.41646 26.9523 10.0069 28 10.0069 28C10.0069 28 10.6148 26.9311 11.2088 26.3471C12.0493 25.5224 13.2407 25.0092 14.8559 24.7686C16.8774 24.4709 18.3293 23.7775 19.1976 22.7122C19.8958 21.8486 20 20.9814 20 20.5461V3.20314H19.3366",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M19.3821 3.85831C19.3821 3.85831 17.3779 5.44749 14.554 4.72899C11.2647 3.89016 9.96908 1.38074 9.96908 1.38074C9.96908 1.38074 8.69086 3.8937 5.38415 4.72899C2.60541 5.43687 0.59082 3.84415 0.59082 3.84415V20.5146C0.591161 21.0809 0.82354 23.4877 5.24521 24.1248C6.9854 24.3814 8.28446 24.9495 9.20492 25.8661C9.54115 26.1946 9.79541 26.528 9.98992 26.8359C10.1855 26.5291 10.4415 26.1953 10.7749 25.8661C11.7093 24.9495 13.0083 24.3796 14.7346 24.1248C19.1459 23.4771 19.3543 21.0703 19.389 20.5146V3.84415",
				fill: "#013369"
			}),
			/* @__PURE__ */ e("path", {
				d: "M10.005 25.1758C10.005 25.1758 11.2832 23.5689 14.5899 23.0486C18.4107 22.4505 18.2717 20.6312 18.2717 20.5392V11.7969H1.70348V20.5392C1.70348 20.6312 1.59094 22.4505 5.38531 23.0486C8.70591 23.5724 9.97024 25.1758 9.97024 25.1758",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M6.11387 18.1917L6.11327 14.0507L5.60267 13.7587V12.6827H7.93334V13.7587L7.44706 14.0507V22.5098L6.20358 22.1311L4.40434 16.7158L4.40399 20.2906L4.97711 20.7365V21.8373L2.47971 21.1896V20.2516L3.05283 20.0237V14.0422L2.46582 13.7466V12.6707H4.35537L6.11987 18.1921",
				fill: "#D50A0A"
			}),
			/* @__PURE__ */ e("path", {
				d: "M10.4197 21.9793L10.9199 22.5881V23.6641L8.44336 22.7226V21.8094L8.98869 21.5815V14.0426L8.44683 13.7627V12.6725H12.7539V14.8634H11.8091L11.5229 13.9644H10.4288V16.4986H11.2485L11.5715 16.0172H12.2315V18.2718H11.5715L11.2607 17.8152H10.427V21.9917",
				fill: "#D50A0A"
			}),
			/* @__PURE__ */ e("path", {
				d: "M13.1649 22.3688V21.2928L13.7797 20.7796V14.0548L13.2552 13.7748V12.6847H15.7317V13.7748L15.2455 14.0548V20.3903L16.3118 20.0969L16.516 18.4404H17.5337V21.2082L13.1572 22.3975",
				fill: "#D50A0A"
			}),
			/* @__PURE__ */ e("path", {
				d: "M2.13621 10.0164L1.38574 9.44302H2.30299L2.60561 8.55818L2.90823 9.44302H3.82547L3.075 10.0199L3.35087 10.9189L2.60387 10.3845L1.85687 10.9189L2.13274 10.0199",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M5.38426 10.0164L4.63379 9.44302H5.55103L5.85365 8.55818L6.15627 9.44302H7.07352L6.32305 10.0199L6.59891 10.9189L5.85192 10.3845L5.10492 10.9189L5.38079 10.0199",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M2.13621 7.04277L1.38574 6.46939H2.30299L2.60561 5.58455L2.90823 6.46939H3.82547L3.075 7.04631L3.35087 7.94531L2.60387 7.41087L1.85687 7.94531L2.13274 7.04631",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M5.38426 7.04277L4.63379 6.46939H5.55103L5.85365 5.58455L6.15627 6.46939H7.07352L6.32305 7.04631L6.59891 7.94531L5.85192 7.41087L5.10492 7.94531L5.38079 7.04631",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M18.1336 10.9014L17.3866 10.3669L16.6396 10.9014L16.9155 10.0024L16.165 9.42545H17.0823L17.3849 8.5406L17.6875 9.42545H18.6048L17.8543 10.0024L18.1305 10.9014",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M14.8661 10.9014L14.1191 10.3669L13.3721 10.9014L13.6479 10.0024L12.8975 9.42545H13.8147L14.1173 8.5406L14.4203 9.42545H15.3375L14.5871 10.0024L14.8633 10.9014",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M18.1336 7.92773L17.3866 7.39329L16.6396 7.92773L16.9155 7.02873L16.165 6.45181H17.0823L17.3849 5.56697L17.6875 6.45181H18.6048L17.8543 7.02873L18.1305 7.92773",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M14.8661 7.92773L14.1191 7.39329L13.3721 7.92773L13.6479 7.02873L12.8975 6.45181H13.8147L14.1173 5.56697L14.4203 6.45181H15.3375L14.5871 7.02873L14.8633 7.92773",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M10.6985 6.37034C10.3647 6.09002 9.98989 5.91022 9.59392 5.82174C9.69014 5.72901 9.78878 5.64937 9.87527 5.57575C10.372 5.69751 10.7054 5.92438 10.9347 6.11728C10.8534 6.20222 10.7745 6.28504 10.6999 6.36963L10.6985 6.37034ZM10.2157 6.96142C9.8975 6.68924 9.51056 6.48714 9.07291 6.39512C9.13994 6.30699 9.21844 6.21319 9.29382 6.12612C9.62865 6.18665 10.058 6.36645 10.4331 6.68181C10.3567 6.77525 10.2851 6.8701 10.2177 6.96035L10.2157 6.96142ZM9.78149 7.58081C9.43831 7.28952 9.03817 7.11007 8.64567 7.03574C8.64567 7.03574 8.7662 6.83542 8.83463 6.73171C9.31396 6.82869 9.70299 7.05733 9.97739 7.29093C9.90722 7.39287 9.84088 7.49055 9.78149 7.58045V7.58081ZM12.0496 4.62189C12.0496 4.62189 11.6606 4.82824 11.1188 5.37224C11.241 5.44267 11.3786 5.54107 11.4574 5.60796C11.3754 5.68193 11.2917 5.76192 11.2139 5.83696C10.8596 5.54071 10.4949 5.391 10.2101 5.32021C10.3046 5.25119 10.405 5.18323 10.504 5.1174C10.6568 5.15704 10.8048 5.21828 10.8048 5.21828C11.4161 4.744 11.9475 4.53871 11.9475 4.53871C11.9475 4.53871 11.886 4.50806 11.7224 4.51026C9.31535 4.54193 7.10278 6.37197 7.51959 9.50078C7.5644 9.83312 7.69118 10.4387 7.85234 10.7042C7.90583 10.1839 8.09826 9.03004 8.6686 7.79126C8.47027 7.7187 8.30736 7.68897 8.30736 7.68897C8.36572 7.56438 8.44665 7.40547 8.44665 7.40547C8.87041 7.48652 9.24206 7.66667 9.56509 7.9293C9.48763 8.05707 9.43519 8.14024 9.39802 8.20607C9.28479 8.11511 9.17016 8.03689 9.04373 7.9654C8.40115 9.10861 8.1059 10.1881 7.98433 10.7509C7.991 10.7857 8.06075 10.8036 8.11702 10.7962C10.7534 10.4483 11.9725 9.07605 12.3546 7.59305C12.6016 6.61973 12.5206 5.60038 12.19 4.76863C12.1667 4.71023 12.1215 4.61326 12.0448 4.62033",
				fill: "white"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/PremiumNFLAllAccess.tsx
function Ve(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "100%",
		preserveAspectRatio: "xMidYMid",
		viewBox: "0 0 42 31",
		width: "42",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				d: "M21.3908 3.52673C20.4674 4.23208 18.6207 5.17254 16.3124 4.58476C12.2343 3.56592 11.0801 -8.90009e-08 11.0801 -8.90009e-08C11.0801 -8.90009e-08 9.91824 3.562 5.84784 4.58476C3.50486 5.17254 1.6928 4.22424 0.73098 3.53065H0V22.7318C0 23.2412 0.115418 24.1816 0.888718 25.1613C1.84669 26.3369 3.46254 27.0932 5.6978 27.4223C7.50601 27.6849 8.81408 28.257 9.73742 29.17C10.4299 29.8401 11.084 31 11.084 31C11.084 31 11.7572 29.8166 12.4151 29.17C13.3462 28.257 14.6658 27.6888 16.4547 27.4223C18.6938 27.0928 20.302 26.3251 21.2638 25.1456C22.0371 24.1895 22.1525 23.2294 22.1525 22.7474V3.54633H21.4177",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M21.468 4.27163C21.468 4.27163 19.2481 6.03108 16.1203 5.2356C12.4769 4.3069 11.0419 1.52861 11.0419 1.52861C11.0419 1.52861 9.62611 4.31082 5.96352 5.2356C2.88571 6.01932 0.654297 4.25596 0.654297 4.25596V22.7125C0.654674 23.3395 0.912063 26.0042 5.80963 26.7095C7.73711 26.9936 9.17598 27.6225 10.1955 28.6375C10.5679 29.0011 10.8495 29.3702 11.065 29.7112C11.2816 29.3714 11.5651 29.0019 11.9345 28.6375C12.9694 27.6225 14.4083 26.9916 16.3204 26.7095C21.2064 25.9924 21.4372 23.3278 21.4757 22.7125V4.25596",
				fill: "#013369"
			}),
			/* @__PURE__ */ e("path", {
				d: "M11.0821 27.8729C11.0821 27.8729 12.4979 26.0938 16.1605 25.5178C20.3924 24.8556 20.2386 22.8414 20.2386 22.7395V13.0606H1.88711V22.7395C1.88711 22.8414 1.76246 24.8556 5.96521 25.5178C9.64319 26.0978 11.0436 27.8729 11.0436 27.8729",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M6.77114 20.1413L6.77048 15.5566L6.20493 15.2333V14.042H8.78645V15.2333L8.24783 15.5566V24.922L6.87051 24.5027L4.87763 18.5073L4.87724 22.4651L5.51204 22.9588V24.1775L2.74586 23.4604V22.4219L3.38066 22.1696V15.5472L2.73047 15.22V14.0287H4.82338L6.77779 20.1417",
				fill: "#D50A0A"
			}),
			/* @__PURE__ */ e("path", {
				d: "M11.5407 24.3343L12.0947 25.0083V26.1996L9.35156 25.1572V24.1462L9.95558 23.8939V15.5473L9.35541 15.2373V14.0304H14.126V16.456H13.0796L12.7625 15.4607H11.5507V18.2664H12.4586L12.8164 17.7335H13.5474V20.2296H12.8164L12.4721 19.7241H11.5487V24.348",
				fill: "#D50A0A"
			}),
			/* @__PURE__ */ e("path", {
				d: "M14.5807 24.7653V23.574L15.2617 23.0058V15.5605L14.6808 15.2505V14.0436H17.4239V15.2505L16.8852 15.5605V22.5748L18.0663 22.2499L18.2926 20.416H19.4198V23.4803L14.5723 24.797",
				fill: "#D50A0A"
			}),
			/* @__PURE__ */ e("path", {
				d: "M2.3664 11.0898L1.53516 10.4549H2.55112L2.88631 9.4753L3.2215 10.4549H4.23746L3.40622 11.0937L3.71178 12.089L2.88439 11.4973L2.05699 12.089L2.36255 11.0937",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M5.9621 11.0899L5.13086 10.4551H6.14682L6.48201 9.47544L6.81721 10.4551H7.83317L7.00193 11.0938L7.30748 12.0891L6.48009 11.4974L5.6527 12.0891L5.95825 11.0938",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M2.3664 7.79786L1.53516 7.16305H2.55112L2.88631 6.1834L3.2215 7.16305H4.23746L3.40622 7.80178L3.71178 8.7971L2.88439 8.2054L2.05699 8.7971L2.36255 7.80178",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M5.9621 7.79786L5.13086 7.16305H6.14682L6.48201 6.1834L6.81721 7.16305H7.83317L7.00193 7.80178L7.30748 8.7971L6.48009 8.2054L5.6527 8.7971L5.95825 7.80178",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M20.0848 12.0694L19.2574 11.4777L18.43 12.0694L18.7355 11.0741L17.9043 10.4354H18.9203L19.2555 9.45573L19.5906 10.4354H20.6066L19.7754 11.0741L20.0813 12.0694",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M16.4656 12.0694L15.6382 11.4777L14.8108 12.0694L15.1164 11.0741L14.2852 10.4354H15.3011L15.6363 9.45573L15.9719 10.4354H16.9879L16.1566 11.0741L16.4626 12.0694",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M20.0848 8.77785L19.2574 8.18614L18.43 8.77785L18.7355 7.78252L17.9043 7.14379H18.9203L19.2555 6.16414L19.5906 7.14379H20.6066L19.7754 7.78252L20.0813 8.77785",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M16.4656 8.77785L15.6382 8.18614L14.8108 8.77785L15.1164 7.78252L14.2852 7.14379H15.3011L15.6363 6.16414L15.9719 7.14379H16.9879L16.1566 7.78252L16.4626 8.77785",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M11.8508 7.05325C11.481 6.7429 11.0659 6.54383 10.6273 6.44587C10.7339 6.3432 10.8432 6.25503 10.939 6.17353C11.4891 6.30833 11.8585 6.55951 12.1124 6.77307C12.0224 6.86712 11.935 6.95881 11.8523 7.05247L11.8508 7.05325ZM11.316 7.70766C10.9636 7.40632 10.535 7.18257 10.0502 7.08068C10.1245 6.98311 10.2114 6.87927 10.2949 6.78287C10.6658 6.84988 11.1413 7.04894 11.5568 7.39809C11.4722 7.50154 11.3929 7.60656 11.3183 7.70648L11.316 7.70766ZM10.8351 8.39341C10.455 8.07091 10.0118 7.87224 9.57703 7.78995C9.57703 7.78995 9.71053 7.56816 9.78632 7.45334C10.3172 7.56071 10.7481 7.81385 11.0521 8.07248C10.9744 8.18533 10.9009 8.29349 10.8351 8.39302V8.39341ZM13.3473 5.11746C13.3473 5.11746 12.9165 5.34592 12.3163 5.94821C12.4517 6.02619 12.6041 6.13513 12.6914 6.20919C12.6006 6.29109 12.5079 6.37965 12.4217 6.46272C12.0293 6.13473 11.6253 5.96898 11.3098 5.89061C11.4145 5.81419 11.5257 5.73895 11.6353 5.66607C11.8046 5.70996 11.9685 5.77775 11.9685 5.77775C12.6456 5.25266 13.2342 5.02538 13.2342 5.02538C13.2342 5.02538 13.1661 4.99144 12.9849 4.99387C10.3188 5.02894 7.86808 7.05505 8.32975 10.5191C8.37938 10.887 8.5198 11.5575 8.69832 11.8514C8.75756 11.2754 8.9707 9.99792 9.60242 8.62641C9.38274 8.54608 9.20231 8.51316 9.20231 8.51316C9.26694 8.37523 9.35658 8.19928 9.35658 8.19928C9.82595 8.28902 10.2376 8.48848 10.5954 8.77924C10.5096 8.9207 10.4515 9.01279 10.4103 9.08567C10.2849 8.98496 10.158 8.89836 10.0179 8.81921C9.30618 10.0849 8.97917 11.2801 8.84451 11.9031C8.8519 11.9417 8.92915 11.9615 8.99148 11.9533C11.9115 11.5681 13.2619 10.0489 13.6851 8.40697C13.9587 7.32936 13.869 6.2008 13.5028 5.27993C13.477 5.21527 13.427 5.10791 13.342 5.11574",
				fill: "white"
			}),
			/* @__PURE__ */ t("g", {
				clipPath: "url(#clip0_625_404345)",
				children: [
					/* @__PURE__ */ t("mask", {
						fill: "black",
						height: "28",
						id: "path-16-outside-1_625_404345",
						maskUnits: "userSpaceOnUse",
						width: "30",
						x: "10.4805",
						y: "2.92062",
						children: [
							/* @__PURE__ */ e("rect", {
								fill: "white",
								height: "28",
								width: "30",
								x: "10.4805",
								y: "2.92062"
							}),
							/* @__PURE__ */ e("path", { d: "M16.8347 5.10396H19.7051V8.02063H16.8347V5.10396Z" }),
							/* @__PURE__ */ e("path", { d: "M17.1757 9.18734H20.6201V12.104L21.7683 19.104C21.7683 19.104 19.2529 16.8968 18.3238 15.0207C17.2962 12.9454 17.1757 9.18734 17.1757 9.18734Z" }),
							/* @__PURE__ */ e("path", { d: "M19.4733 27.2706C19.4733 27.2706 21.478 25.1077 23.1784 24.8641C23.7495 24.7823 24.6399 24.9373 24.6399 24.9373L22.3436 27.2706H19.4733Z" }),
							/* @__PURE__ */ e("path", { d: "M39.0837 7.38253C39.0837 6.84786 38.653 6.41511 38.1225 6.41511H34.2724V5.80656C34.6618 5.68266 34.9449 5.3204 34.9449 4.88803C34.9449 4.35337 34.5145 3.92062 33.9837 3.92062H16.8283C16.2967 3.92062 15.8671 4.35373 15.8671 4.88803C15.8671 5.32039 16.1499 5.68265 16.5403 5.80656V6.41511H12.4424C11.9108 6.41511 11.4805 6.84823 11.4805 7.38253C11.4805 14.4101 16.6961 20.2329 23.4359 21.1438V21.146C23.4359 22.5753 22.8768 23.9777 21.762 24.6845C20.6619 25.3814 19.5474 26.0926 18.712 27.1601H18.6013C18.07 27.1601 17.6401 27.5932 17.6401 28.1275C17.6401 28.661 18.0704 29.0949 18.6013 29.0949H32.1451C32.6756 29.0949 33.1063 28.661 33.1063 28.1275C33.1063 27.5928 32.6756 27.1601 32.1451 27.1601H31.9558C31.1203 26.0926 30.0066 25.3833 28.9068 24.6845C27.7931 23.9789 27.2322 22.575 27.2322 21.146C27.2322 21.1407 27.2333 21.135 27.2333 21.1312C33.9237 20.1741 39.0837 14.3752 39.0837 7.38253ZM34.2957 8.44008C34.2957 8.40863 34.2845 8.38097 34.2781 8.35028H37.1233C36.8225 12.0979 34.7954 15.4798 31.8455 17.5476C33.3857 15.2664 34.2957 12.1006 34.2957 8.44008ZM17.6454 5.71024H19.5528V7.61737H17.6454V5.71024ZM13.4415 8.35064H16.5336C16.5284 8.38096 16.5163 8.40862 16.5163 8.44045C16.5163 12.2217 17.461 15.4768 19.0498 17.7731C15.9214 15.7314 13.7525 12.2374 13.4415 8.35064ZM19.1989 15.9394C18.2606 14.0023 17.7557 11.9174 17.6601 9.26346H19.5532C19.5532 12.9133 20.334 16.1418 21.7526 18.966C20.7384 18.3195 19.8039 17.1887 19.1989 15.9394ZM22.4962 26.9728H20.2022C21.4473 25.7417 23.0429 25.0236 24.7854 24.8978C23.8949 25.4343 23.117 26.1399 22.4962 26.9728Z" })
						]
					}),
					/* @__PURE__ */ e("path", {
						d: "M16.8347 5.10396H19.7051V8.02063H16.8347V5.10396Z",
						fill: "white"
					}),
					/* @__PURE__ */ e("path", {
						d: "M17.1757 9.18734H20.6201V12.104L21.7683 19.104C21.7683 19.104 19.2529 16.8968 18.3238 15.0207C17.2962 12.9454 17.1757 9.18734 17.1757 9.18734Z",
						fill: "white"
					}),
					/* @__PURE__ */ e("path", {
						d: "M19.4733 27.2706C19.4733 27.2706 21.478 25.1077 23.1784 24.8641C23.7495 24.7823 24.6399 24.9373 24.6399 24.9373L22.3436 27.2706H19.4733Z",
						fill: "white"
					}),
					/* @__PURE__ */ e("path", {
						d: "M39.0837 7.38253C39.0837 6.84786 38.653 6.41511 38.1225 6.41511H34.2724V5.80656C34.6618 5.68266 34.9449 5.3204 34.9449 4.88803C34.9449 4.35337 34.5145 3.92062 33.9837 3.92062H16.8283C16.2967 3.92062 15.8671 4.35373 15.8671 4.88803C15.8671 5.32039 16.1499 5.68265 16.5403 5.80656V6.41511H12.4424C11.9108 6.41511 11.4805 6.84823 11.4805 7.38253C11.4805 14.4101 16.6961 20.2329 23.4359 21.1438V21.146C23.4359 22.5753 22.8768 23.9777 21.762 24.6845C20.6619 25.3814 19.5474 26.0926 18.712 27.1601H18.6013C18.07 27.1601 17.6401 27.5932 17.6401 28.1275C17.6401 28.661 18.0704 29.0949 18.6013 29.0949H32.1451C32.6756 29.0949 33.1063 28.661 33.1063 28.1275C33.1063 27.5928 32.6756 27.1601 32.1451 27.1601H31.9558C31.1203 26.0926 30.0066 25.3833 28.9068 24.6845C27.7931 23.9789 27.2322 22.575 27.2322 21.146C27.2322 21.1407 27.2333 21.135 27.2333 21.1312C33.9237 20.1741 39.0837 14.3752 39.0837 7.38253ZM34.2957 8.44008C34.2957 8.40863 34.2845 8.38097 34.2781 8.35028H37.1233C36.8225 12.0979 34.7954 15.4798 31.8455 17.5476C33.3857 15.2664 34.2957 12.1006 34.2957 8.44008ZM17.6454 5.71024H19.5528V7.61737H17.6454V5.71024ZM13.4415 8.35064H16.5336C16.5284 8.38096 16.5163 8.40862 16.5163 8.44045C16.5163 12.2217 17.461 15.4768 19.0498 17.7731C15.9214 15.7314 13.7525 12.2374 13.4415 8.35064ZM19.1989 15.9394C18.2606 14.0023 17.7557 11.9174 17.6601 9.26346H19.5532C19.5532 12.9133 20.334 16.1418 21.7526 18.966C20.7384 18.3195 19.8039 17.1887 19.1989 15.9394ZM22.4962 26.9728H20.2022C21.4473 25.7417 23.0429 25.0236 24.7854 24.8978C23.8949 25.4343 23.117 26.1399 22.4962 26.9728Z",
						fill: "url(#paint0_linear_625_404345)"
					}),
					/* @__PURE__ */ e("path", {
						d: "M16.8347 5.10396V4.10396H15.8347V5.10396H16.8347ZM19.7051 5.10396H20.7051V4.10396H19.7051V5.10396ZM19.7051 8.02063V9.02063H20.7051V8.02063H19.7051ZM16.8347 8.02063H15.8347V9.02063H16.8347V8.02063ZM17.1757 9.18734V8.18734H16.1431L16.1762 9.21939L17.1757 9.18734ZM20.6201 9.18734H21.6201V8.18734H20.6201V9.18734ZM20.6201 12.104H19.6201V12.1855L19.6333 12.2659L20.6201 12.104ZM21.7683 19.104L21.1087 19.8557L23.2069 21.6967L22.7551 18.9421L21.7683 19.104ZM18.3238 15.0207L19.22 14.5769L18.3238 15.0207ZM19.4733 27.2706L18.7398 26.5909L17.183 28.2706H19.4733V27.2706ZM23.1784 24.8641L23.3202 25.854L23.3202 25.854L23.1784 24.8641ZM24.6399 24.9373L25.3527 25.6387L26.6906 24.2792L24.8114 23.9521L24.6399 24.9373ZM22.3436 27.2706V28.2706H22.7626L23.0564 27.972L22.3436 27.2706ZM34.2724 6.41511H33.2724V7.41511H34.2724V6.41511ZM34.2724 5.80656L33.9692 4.85366L33.2724 5.07541V5.80656H34.2724ZM16.5403 5.80656H17.5403V5.07478L16.8428 4.85341L16.5403 5.80656ZM16.5403 6.41511V7.41511H17.5403V6.41511H16.5403ZM23.4359 21.1438H24.4359V20.2698L23.5699 20.1528L23.4359 21.1438ZM21.762 24.6845L22.2971 25.5293L22.2975 25.5291L21.762 24.6845ZM18.712 27.1601V28.1601H19.1992L19.4994 27.7764L18.712 27.1601ZM31.9558 27.1601L31.1683 27.7764L31.4686 28.1601H31.9558V27.1601ZM28.9068 24.6845L29.4432 23.8405L29.442 23.8398L28.9068 24.6845ZM27.2333 21.1312L27.0917 20.1413L26.2333 20.2641V21.1312H27.2333ZM34.2781 8.35028V7.35028H33.048L33.2991 8.5544L34.2781 8.35028ZM37.1233 8.35028L38.1201 8.43029L38.2068 7.35028H37.1233V8.35028ZM31.8455 17.5476L31.0167 16.988L32.4195 18.3664L31.8455 17.5476ZM17.6454 5.71024V4.71024H16.6454V5.71024H17.6454ZM19.5528 5.71024H20.5528V4.71024H19.5528V5.71024ZM19.5528 7.61737V8.61737H20.5528V7.61737H19.5528ZM17.6454 7.61737H16.6454V8.61737H17.6454V7.61737ZM13.4415 8.35064V7.35064H12.3582L12.4446 8.43041L13.4415 8.35064ZM16.5336 8.35064L17.5189 8.52195L17.7225 7.35064H16.5336V8.35064ZM19.0498 17.7731L18.5032 18.6105L19.8721 17.2041L19.0498 17.7731ZM19.1989 15.9394L20.0989 15.5036L20.0988 15.5035L19.1989 15.9394ZM17.6601 9.26346V8.26346H16.6234L16.6607 9.29947L17.6601 9.26346ZM19.5532 9.26346H20.5532V8.26346H19.5532V9.26346ZM21.7526 18.966L21.2152 19.8093L24.2749 21.7594L22.6462 18.5171L21.7526 18.966ZM22.4962 26.9728V27.9728H22.9981L23.298 27.5704L22.4962 26.9728ZM20.2022 26.9728L19.4991 26.2617L17.7686 27.9728H20.2022V26.9728ZM24.7854 24.8978L25.3015 25.7543L24.7133 23.9004L24.7854 24.8978ZM16.8347 6.10396H19.7051V4.10396H16.8347V6.10396ZM18.7051 5.10396V8.02063H20.7051V5.10396H18.7051ZM19.7051 7.02063H16.8347V9.02063H19.7051V7.02063ZM17.8347 8.02063V5.10396H15.8347V8.02063H17.8347ZM17.1757 10.1873H20.6201V8.18734H17.1757V10.1873ZM19.6201 9.18734V12.104H21.6201V9.18734H19.6201ZM19.6333 12.2659L20.7815 19.2659L22.7551 18.9421L21.607 11.9421L19.6333 12.2659ZM21.7683 19.104C22.4278 18.3523 22.4279 18.3524 22.428 18.3525C22.428 18.3525 22.4281 18.3525 22.4281 18.3526C22.4281 18.3526 22.4281 18.3526 22.4281 18.3526C22.428 18.3525 22.4278 18.3523 22.4274 18.352C22.4267 18.3513 22.4254 18.3502 22.4235 18.3485C22.4196 18.3451 22.4135 18.3397 22.4052 18.3323C22.3886 18.3174 22.3632 18.2947 22.3301 18.2647C22.2639 18.2047 22.1669 18.1157 22.0471 18.0025C21.8069 17.7759 21.4772 17.4547 21.1204 17.0781C20.387 16.304 19.6144 15.3734 19.22 14.5769L17.4277 15.4644C17.9623 16.5441 18.9119 17.6551 19.6685 18.4537C20.0567 18.8634 20.4139 19.2113 20.6744 19.4571C20.8049 19.5802 20.9117 19.6783 20.9866 19.7463C21.0241 19.7803 21.0537 19.8068 21.0744 19.8253C21.0848 19.8345 21.0929 19.8417 21.0986 19.8468C21.1015 19.8493 21.1038 19.8513 21.1055 19.8528C21.1063 19.8536 21.107 19.8542 21.1076 19.8546C21.1078 19.8549 21.1081 19.8551 21.1083 19.8553C21.1084 19.8553 21.1085 19.8554 21.1085 19.8555C21.1086 19.8556 21.1087 19.8557 21.7683 19.104ZM19.22 14.5769C18.7836 13.6957 18.5121 12.3767 18.3558 11.1946C18.2797 10.6197 18.2344 10.1058 18.2081 9.73604C18.1949 9.55149 18.1866 9.40374 18.1817 9.30329C18.1792 9.25308 18.1775 9.21476 18.1765 9.18964C18.176 9.17708 18.1756 9.16783 18.1754 9.16205C18.1753 9.15916 18.1752 9.15713 18.1752 9.156C18.1752 9.15543 18.1752 9.15509 18.1752 9.15497C18.1752 9.15491 18.1752 9.1549 18.1752 9.15496C18.1752 9.15498 18.1752 9.15506 18.1752 9.15508C18.1752 9.15517 18.1752 9.15528 17.1757 9.18734C16.1762 9.21939 16.1762 9.21953 16.1762 9.21968C16.1762 9.21975 16.1762 9.21992 16.1762 9.22006C16.1762 9.22034 16.1763 9.22068 16.1763 9.22107C16.1763 9.22187 16.1763 9.22289 16.1764 9.22414C16.1765 9.22663 16.1766 9.23003 16.1767 9.23431C16.177 9.24288 16.1775 9.25498 16.1781 9.27045C16.1794 9.30139 16.1813 9.34584 16.1841 9.40245C16.1897 9.51562 16.1989 9.67768 16.2131 9.87788C16.2415 10.2776 16.2905 10.8329 16.373 11.4569C16.5339 12.6727 16.8364 14.2703 17.4277 15.4644L19.22 14.5769ZM19.4733 27.2706C20.2067 27.9504 20.2066 27.9505 20.2065 27.9506C20.2065 27.9507 20.2064 27.9508 20.2063 27.9508C20.2062 27.9509 20.2061 27.951 20.2061 27.9511C20.206 27.9511 20.206 27.9511 20.2062 27.9509C20.2065 27.9506 20.2073 27.9498 20.2085 27.9485C20.211 27.9458 20.2153 27.9412 20.2214 27.9348C20.2336 27.922 20.2529 27.9018 20.2787 27.8754C20.3303 27.8224 20.4078 27.7444 20.5067 27.6492C20.7054 27.4578 20.9859 27.2013 21.313 26.9395C22.012 26.3801 22.7567 25.9347 23.3202 25.854L23.0366 23.8742C21.8997 24.0371 20.7918 24.795 20.0634 25.3779C19.6767 25.6873 19.3497 25.9867 19.1194 26.2086C19.0038 26.3199 18.9114 26.4128 18.8468 26.4791C18.8145 26.5122 18.789 26.5388 18.771 26.5577C18.762 26.5672 18.7549 26.5748 18.7497 26.5803C18.747 26.5831 18.7449 26.5854 18.7433 26.5872C18.7425 26.588 18.7418 26.5888 18.7412 26.5894C18.7409 26.5897 18.7407 26.59 18.7404 26.5902C18.7403 26.5903 18.7402 26.5905 18.7401 26.5906C18.74 26.5907 18.7398 26.5909 19.4733 27.2706ZM23.3202 25.854C23.4814 25.8309 23.7476 25.8383 24.0268 25.8654C24.1553 25.8778 24.2689 25.8926 24.3499 25.9042C24.3902 25.91 24.4218 25.9149 24.4424 25.9182C24.4527 25.9199 24.4602 25.9211 24.4647 25.9218C24.4669 25.9222 24.4684 25.9225 24.469 25.9226C24.4693 25.9226 24.4694 25.9226 24.4694 25.9226C24.4693 25.9226 24.4692 25.9226 24.4691 25.9226C24.469 25.9226 24.4689 25.9226 24.4688 25.9225C24.4688 25.9225 24.4687 25.9225 24.4687 25.9225C24.4686 25.9225 24.4685 25.9225 24.6399 24.9373C24.8114 23.9521 24.8113 23.9521 24.8112 23.9521C24.8112 23.9521 24.8111 23.952 24.811 23.952C24.8108 23.952 24.8107 23.952 24.8105 23.9519C24.8101 23.9519 24.8097 23.9518 24.8092 23.9517C24.8083 23.9516 24.8071 23.9514 24.8057 23.9511C24.803 23.9506 24.7993 23.95 24.7949 23.9493C24.786 23.9478 24.7739 23.9458 24.7587 23.9434C24.7284 23.9385 24.686 23.932 24.6338 23.9245C24.5301 23.9096 24.3854 23.8908 24.2199 23.8747C23.9111 23.8447 23.4465 23.8155 23.0366 23.8742L23.3202 25.854ZM23.9272 24.2359L21.6309 26.5692L23.0564 27.972L25.3527 25.6387L23.9272 24.2359ZM22.3436 26.2706H19.4733V28.2706H22.3436V26.2706ZM40.0837 7.38253C40.0837 6.30114 39.2108 5.41511 38.1225 5.41511V7.41511C38.118 7.41511 38.1114 7.41399 38.105 7.41125C38.0992 7.4088 38.0953 7.40585 38.0929 7.40334C38.0904 7.40083 38.0881 7.3976 38.0863 7.39338C38.0842 7.38851 38.0837 7.3842 38.0837 7.38253H40.0837ZM38.1225 5.41511H34.2724V7.41511H38.1225V5.41511ZM35.2724 6.41511V5.80656H33.2724V6.41511H35.2724ZM34.5757 6.75946C35.3647 6.50836 35.9449 5.77168 35.9449 4.88803H33.9449C33.9449 4.8863 33.9453 4.88208 33.947 4.87684C33.9487 4.87194 33.9509 4.86796 33.9531 4.86498C33.957 4.85979 33.9622 4.85588 33.9692 4.85366L34.5757 6.75946ZM35.9449 4.88803C35.9449 3.80691 35.0726 2.92062 33.9837 2.92062V4.92062C33.9794 4.92062 33.9728 4.91954 33.9663 4.91678C33.9605 4.91431 33.9566 4.91132 33.9541 4.90875C33.9515 4.90618 33.9492 4.9029 33.9474 4.89869C33.9454 4.89382 33.9449 4.88958 33.9449 4.88803H35.9449ZM33.9837 2.92062H16.8283V4.92062H33.9837V2.92062ZM16.8283 2.92062C15.7379 2.92062 14.8671 3.80803 14.8671 4.88803H16.8671C16.8671 4.88951 16.8666 4.89368 16.8646 4.8985C16.8628 4.90268 16.8605 4.90597 16.8579 4.90861C16.8553 4.91125 16.8513 4.91429 16.8454 4.91679C16.8389 4.91958 16.8324 4.92062 16.8283 4.92062V2.92062ZM14.8671 4.88803C14.8671 5.77162 15.447 6.50872 16.2378 6.75971L16.8428 4.85341C16.8492 4.85544 16.8545 4.85925 16.8587 4.86483C16.861 4.86794 16.8633 4.87204 16.865 4.87699C16.8667 4.88227 16.8671 4.88644 16.8671 4.88803H14.8671ZM15.5403 5.80656V6.41511H17.5403V5.80656H15.5403ZM16.5403 5.41511H12.4424V7.41511H16.5403V5.41511ZM12.4424 5.41511C11.353 5.41511 10.4805 6.3015 10.4805 7.38253H12.4805C12.4805 7.38425 12.4799 7.38859 12.4779 7.39347C12.4761 7.3977 12.4738 7.40095 12.4713 7.40348C12.4688 7.40602 12.4649 7.40895 12.4592 7.41137C12.4528 7.41408 12.4465 7.41511 12.4424 7.41511V5.41511ZM10.4805 7.38253C10.4805 14.9135 16.069 21.1572 23.302 22.1347L23.5699 20.1528C17.3232 19.3085 12.4805 13.9067 12.4805 7.38253H10.4805ZM22.4359 21.1438V21.146H24.4359V21.1438H22.4359ZM22.4359 21.146C22.4359 22.3605 21.9586 23.3758 21.2266 23.8399L22.2975 25.5291C23.795 24.5796 24.4359 22.7901 24.4359 21.146H22.4359ZM21.2269 23.8397C20.1469 24.5238 18.8827 25.3195 17.9245 26.5438L19.4994 27.7764C20.2121 26.8658 21.1769 26.2389 22.2971 25.5293L21.2269 23.8397ZM18.712 26.1601H18.6013V28.1601H18.712V26.1601ZM18.6013 26.1601C17.5114 26.1601 16.6401 27.0472 16.6401 28.1275H18.6401C18.6401 28.1291 18.6396 28.1333 18.6375 28.1382C18.6358 28.1423 18.6335 28.1456 18.6309 28.1482C18.6284 28.1507 18.6244 28.1538 18.6186 28.1562C18.6121 28.159 18.6055 28.1601 18.6013 28.1601V26.1601ZM16.6401 28.1275C16.6401 29.2067 17.5116 30.0949 18.6013 30.0949V28.0949C18.606 28.0949 18.6127 28.0961 18.6192 28.0988C18.625 28.1013 18.6288 28.1043 18.6312 28.1066C18.6335 28.109 18.6357 28.1121 18.6375 28.1162C18.6395 28.121 18.6401 28.1254 18.6401 28.1275H16.6401ZM18.6013 30.0949H32.1451V28.0949H18.6013V30.0949ZM32.1451 30.0949C33.2342 30.0949 34.1063 29.207 34.1063 28.1275H32.1063C32.1063 28.1253 32.107 28.1208 32.109 28.116C32.1107 28.1119 32.1129 28.1089 32.1152 28.1065C32.1175 28.1042 32.1212 28.1013 32.127 28.0989C32.1335 28.0961 32.1403 28.0949 32.1451 28.0949V30.0949ZM34.1063 28.1275C34.1063 27.0461 33.2335 26.1601 32.1451 26.1601V28.1601C32.1406 28.1601 32.134 28.159 32.1276 28.1562C32.1218 28.1538 32.118 28.1508 32.1155 28.1483C32.113 28.1458 32.1107 28.1426 32.1089 28.1384C32.1069 28.1335 32.1063 28.1292 32.1063 28.1275H34.1063ZM32.1451 26.1601H31.9558V28.1601H32.1451V26.1601ZM32.7432 26.5438C31.7851 25.3195 30.521 24.5254 29.4432 23.8405L28.3705 25.5285C29.4922 26.2413 30.4555 26.8658 31.1683 27.7764L32.7432 26.5438ZM29.442 23.8398C28.7111 23.3767 28.2322 22.3598 28.2322 21.146H26.2322C26.2322 22.7902 26.8752 24.5812 28.3717 25.5293L29.442 23.8398ZM28.2322 21.146C28.2322 21.1629 28.2317 21.1778 28.2312 21.19C28.2306 21.2022 28.2299 21.2127 28.2292 21.2209C28.2286 21.229 28.228 21.2356 28.2275 21.2399C28.2271 21.2442 28.2268 21.2473 28.2267 21.2477C28.2267 21.2479 28.2267 21.248 28.2267 21.2479C28.2267 21.2478 28.2267 21.2478 28.2267 21.2477C28.2267 21.2476 28.2267 21.2475 28.2268 21.2473C28.2268 21.2467 28.227 21.2454 28.2271 21.2438C28.2275 21.2407 28.2282 21.2342 28.2289 21.2262C28.2297 21.2181 28.2307 21.2059 28.2316 21.1911C28.2324 21.1764 28.2333 21.1558 28.2333 21.1312H26.2333C26.2333 21.1076 26.2342 21.088 26.235 21.0744C26.2358 21.0607 26.2367 21.0496 26.2373 21.0427C26.238 21.0357 26.2386 21.0304 26.2388 21.0286C26.2388 21.0281 26.2389 21.0276 26.2389 21.0274C26.2389 21.0272 26.2389 21.0271 26.2389 21.027C26.2389 21.027 26.2389 21.0269 26.2389 21.0269C26.239 21.0265 26.2388 21.0278 26.2388 21.0284C26.2386 21.0301 26.2381 21.0346 26.2375 21.0401C26.237 21.0458 26.2362 21.0537 26.2355 21.0632C26.2347 21.0726 26.2339 21.0845 26.2333 21.098C26.2327 21.1116 26.2322 21.1278 26.2322 21.146H28.2322ZM27.3749 22.1212C34.5548 21.094 40.0837 14.8759 40.0837 7.38253H38.0837C38.0837 13.8745 33.2926 19.2542 27.0917 20.1413L27.3749 22.1212ZM35.2957 8.44008C35.2957 8.30591 35.2713 8.20052 35.2602 8.15534C35.2573 8.1435 35.2546 8.13347 35.253 8.12749C35.2484 8.11008 35.2533 8.1287 35.2502 8.11699C35.2495 8.11412 35.2531 8.12721 35.257 8.14615L33.2991 8.5544C33.3063 8.58868 33.3136 8.61675 33.3168 8.62867C33.3177 8.63189 33.3184 8.63486 33.3189 8.63664C33.3195 8.63879 33.3197 8.63958 33.3199 8.64028C33.3203 8.64165 33.3195 8.63895 33.3184 8.63445C33.3145 8.61863 33.2957 8.54281 33.2957 8.44008H35.2957ZM34.2781 9.35028H37.1233V7.35028H34.2781V9.35028ZM36.1265 8.27026C35.8503 11.7117 33.9852 14.8265 31.2715 16.7287L32.4195 18.3664C35.6057 16.1331 37.7947 12.4841 38.1201 8.43029L36.1265 8.27026ZM32.6743 18.1072C34.3481 15.628 35.2957 12.2566 35.2957 8.44008H33.2957C33.2957 11.9446 32.4233 14.9047 31.0167 16.988L32.6743 18.1072ZM17.6454 6.71024H19.5528V4.71024H17.6454V6.71024ZM18.5528 5.71024V7.61737H20.5528V5.71024H18.5528ZM19.5528 6.61737H17.6454V8.61737H19.5528V6.61737ZM18.6454 7.61737V5.71024H16.6454V7.61737H18.6454ZM13.4415 9.35064H16.5336V7.35064H13.4415V9.35064ZM15.5484 8.17933C15.5535 8.15028 15.5588 8.12947 15.5596 8.1264C15.5599 8.12513 15.5602 8.12408 15.5588 8.12943C15.5578 8.13306 15.5555 8.14208 15.5529 8.15238C15.5432 8.19125 15.5163 8.30069 15.5163 8.44045H17.5163C17.5163 8.49592 17.511 8.54223 17.5056 8.57592C17.5004 8.60823 17.4946 8.63166 17.4931 8.63758C17.4924 8.64053 17.4919 8.64224 17.4929 8.63854C17.4934 8.63657 17.4956 8.6282 17.4978 8.61958C17.5024 8.6018 17.5112 8.56617 17.5189 8.52195L15.5484 8.17933ZM15.5163 8.44045C15.5163 12.3764 16.4981 15.8426 18.2274 18.3421L19.8721 17.2041C18.4239 15.1109 17.5163 12.067 17.5163 8.44045H15.5163ZM19.5963 16.9356C16.7201 15.0585 14.7239 11.8405 14.4383 8.27087L12.4446 8.43041C12.7811 12.6343 15.1228 16.4043 18.5032 18.6105L19.5963 16.9356ZM20.0988 15.5035C19.2294 13.7083 18.7508 11.7629 18.6594 9.22746L16.6607 9.29947C16.7606 12.072 17.2919 14.2962 18.2989 16.3753L20.0988 15.5035ZM17.6601 10.2635H19.5532V8.26346H17.6601V10.2635ZM18.5532 9.26346C18.5532 13.0605 19.3667 16.4438 20.859 19.4148L22.6462 18.5171C21.3014 15.8397 20.5532 12.7661 20.5532 9.26346H18.5532ZM22.2901 18.1227C21.4643 17.5964 20.6416 16.6242 20.0989 15.5036L18.2988 16.3752C18.9662 17.7533 20.0124 19.0427 21.2152 19.8093L22.2901 18.1227ZM22.4962 25.9728H20.2022V27.9728H22.4962V25.9728ZM20.9053 27.6839C21.9795 26.6218 23.3508 26.004 24.8574 25.8952L24.7133 23.9004C22.7351 24.0432 20.9151 24.8617 19.4991 26.2617L20.9053 27.6839ZM24.2692 24.0413C23.2675 24.6449 22.3927 25.4385 21.6945 26.3752L23.298 27.5704C23.8414 26.8414 24.5224 26.2238 25.3015 25.7543L24.2692 24.0413Z",
						fill: "white",
						mask: "url(#path-16-outside-1_625_404345)"
					})
				]
			}),
			/* @__PURE__ */ t("defs", { children: [/* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint0_linear_625_404345",
				x1: "12.0108",
				x2: "35.8645",
				y1: "4.52062",
				y2: "24.5603",
				children: [/* @__PURE__ */ e("stop", { stopColor: "#F5E01F" }), /* @__PURE__ */ e("stop", {
					offset: "1",
					stopColor: "#FF8A00"
				})]
			}), /* @__PURE__ */ e("clipPath", {
				id: "clip0_625_404345",
				children: /* @__PURE__ */ e("rect", {
					fill: "white",
					height: "28",
					transform: "translate(9 2)",
					width: "31"
				})
			})] })
		]
	});
}
//#endregion
//#region primitives/icon/icons/PremiumPlus.tsx
function He(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "6",
		viewBox: "0 0 7 6",
		width: "7",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M0.799766 3.46V2.08H2.74377V0.0639999H4.25577V2.08H6.18777V3.46H4.25577V5.452H2.74377V3.46H0.799766Z",
			fill: "#9DAFBD"
		})
	});
}
//#endregion
//#region primitives/icon/icons/PremiumRecommended.tsx
function Ue(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "30",
		viewBox: "0 0 93 30",
		width: "93",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("g", {
				filter: "url(#filter0_dd_2812_59964)",
				children: /* @__PURE__ */ e("path", {
					d: "M83 21.3496L83 5.86993L90 5.86993L87.9 13.6098L90 21.3496L83 21.3496Z",
					fill: "#2968FF"
				})
			}),
			/* @__PURE__ */ e("g", {
				filter: "url(#filter1_dd_2812_59964)",
				children: /* @__PURE__ */ e("path", {
					d: "M10 5.86914L10 21.3488L3 21.3488L5.1 13.609L3 5.86914L10 5.86914Z",
					fill: "#2968FF"
				})
			}),
			/* @__PURE__ */ e("g", {
				filter: "url(#filter2_dd_2812_59964)",
				children: /* @__PURE__ */ e("rect", {
					fill: "#2968FF",
					height: "23.2195",
					rx: "4",
					width: "75",
					x: "9",
					y: "2"
				})
			}),
			/* @__PURE__ */ e("path", {
				d: "M15.3576 10H11.7976V17H13.2376V14.2H13.9976L15.0076 17H16.4676L15.3876 14.1L16.4376 13.04V11.09L15.3576 10ZM14.7076 11.44L15.0076 11.74V12.67L14.7076 12.97H13.2376V11.44H14.7076ZM22.3619 10H17.9519V17H22.3719V15.57H19.3919V13.97H21.4519V12.86H19.3919V11.44H22.3619V10ZM27.2751 10H24.8951L23.6451 11.25V15.7C24.0751 16.14 24.5151 16.57 24.9451 17H27.2251L28.3551 15.87V14.22H26.9251V15.25C26.8151 15.36 26.7051 15.46 26.6051 15.57H25.4651L25.0851 15.18V11.81L25.4451 11.44H26.6251L26.9251 11.74V12.64H28.3551V11.09L27.2751 10ZM34.5213 11.17L33.3513 10H30.8913L29.7213 11.17V15.79L30.9413 17H33.2913L34.5213 15.79V11.17ZM33.0813 11.77V15.21L32.7313 15.57H31.5113L31.1613 15.21V11.77L31.4913 11.44H32.7413L33.0813 11.77ZM41.6653 10H40.0553L38.8853 12.36L37.7253 10H35.9753V17H37.3353V11.94L38.5253 14.25H39.1053L40.2953 11.94V17H41.6653V10ZM48.8939 10H47.2839L46.1139 12.36L44.9539 10H43.2039V17H44.5639V11.94L45.7539 14.25H46.3339L47.5239 11.94V17H48.8939V10ZM54.8424 10H50.4324V17H54.8524V15.57H51.8724V13.97H53.9324V12.86H51.8724V11.44H54.8424V10ZM61.1056 10H59.8756V14.27L57.8456 10H56.2156V17H57.4456V12.43L59.7056 17H61.1056V10ZM67.3831 11.42L65.9631 10H62.6531V17H65.9131L67.3831 15.53V11.42ZM65.4431 11.44L65.9431 11.94V15.05L65.4231 15.57H64.0931V11.44H65.4431ZM73.2467 10H68.8367V17H73.2567V15.57H70.2767V13.97H72.3367V12.86H70.2767V11.44H73.2467V10ZM79.3499 11.42L77.9299 10H74.6199V17H77.8799L79.3499 15.53V11.42ZM77.4099 11.44L77.9099 11.94V15.05L77.3899 15.57H76.0599V11.44H77.4099Z",
				fill: "#F6F7F7"
			}),
			/* @__PURE__ */ t("defs", { children: [
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "21.4805",
					id: "filter0_dd_2812_59964",
					width: "13",
					x: "80",
					y: "3.86914",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_2812_59964"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_2812_59964"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_2812_59964",
							mode: "normal",
							result: "effect2_dropShadow_2812_59964"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_2812_59964",
							mode: "normal",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "21.4805",
					id: "filter1_dd_2812_59964",
					width: "13",
					x: "0",
					y: "3.86914",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_2812_59964"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_2812_59964"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_2812_59964",
							mode: "normal",
							result: "effect2_dropShadow_2812_59964"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_2812_59964",
							mode: "normal",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "29.2188",
					id: "filter2_dd_2812_59964",
					width: "81",
					x: "6",
					y: "0",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_2812_59964"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_2812_59964"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_2812_59964",
							mode: "normal",
							result: "effect2_dropShadow_2812_59964"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_2812_59964",
							mode: "normal",
							result: "shape"
						})
					]
				})
			] })
		]
	});
}
//#endregion
//#region primitives/icon/icons/PremiumRecommendedLarge.tsx
function We(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "33",
		viewBox: "0 0 149 33",
		width: "149",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("g", {
				filter: "url(#filter0_dd_2812_101275)",
				children: /* @__PURE__ */ e("path", {
					d: "M134.083 24.4434L134.083 7.07084L144.875 7.07084L141.637 15.7571L144.875 24.4434L134.083 24.4434Z",
					fill: "#2968FF"
				})
			}),
			/* @__PURE__ */ e("g", {
				filter: "url(#filter1_dd_2812_101275)",
				children: /* @__PURE__ */ e("path", {
					d: "M14.292 7.07031L14.292 24.4428L3.50001 24.4428L6.7376 15.7566L3.50001 7.07031L14.292 7.07031Z",
					fill: "#2968FF"
				})
			}),
			/* @__PURE__ */ e("g", {
				filter: "url(#filter2_dd_2812_101275)",
				children: /* @__PURE__ */ e("rect", {
					fill: "#2968FF",
					height: "25.8762",
					rx: "4",
					width: "120.87",
					x: "13.752",
					y: "2.93359"
				})
			}),
			/* @__PURE__ */ e("path", {
				d: "M27.9507 10.4055H22.2547V21.6055H24.5587V17.1255H25.7747L27.3907 21.6055H29.7267L27.9987 16.9655L29.6787 15.2695V12.1495L27.9507 10.4055ZM26.9107 12.7095L27.3907 13.1895V14.6775L26.9107 15.1575H24.5587V12.7095H26.9107ZM38.8575 10.4055H31.8015V21.6055H38.8735V19.3175H34.1055V16.7575H37.4015V14.9815H34.1055V12.7095H38.8575V10.4055ZM46.4187 10.4055H42.6107L40.6107 12.4055V19.5255C41.2987 20.2295 42.0027 20.9175 42.6907 21.6055H46.3387L48.1467 19.7975V17.1575H45.8587V18.8055C45.6827 18.9815 45.5067 19.1415 45.3467 19.3175H43.5227L42.9147 18.6935V13.3015L43.4907 12.7095H45.3787L45.8587 13.1895V14.6295H48.1467V12.1495L46.4187 10.4055ZM57.7125 12.2775L55.8405 10.4055H51.9045L50.0325 12.2775V19.6695L51.9845 21.6055H55.7445L57.7125 19.6695V12.2775ZM55.4085 13.2375V18.7415L54.8485 19.3175H52.8965L52.3365 18.7415V13.2375L52.8645 12.7095H54.8645L55.4085 13.2375ZM68.843 10.4055H66.267L64.395 14.1815L62.539 10.4055H59.739V21.6055H61.915V13.5095L63.819 17.2055H64.747L66.651 13.5095V21.6055H68.843V10.4055ZM80.1087 10.4055H77.5327L75.6607 14.1815L73.8047 10.4055H71.0047V21.6055H73.1807V13.5095L75.0847 17.2055H76.0127L77.9167 13.5095V21.6055H80.1087V10.4055ZM89.3263 10.4055H82.2703V21.6055H89.3423V19.3175H84.5743V16.7575H87.8703V14.9815H84.5743V12.7095H89.3263V10.4055ZM99.0474 10.4055H97.0794V17.2375L93.8314 10.4055H91.2234V21.6055H93.1914V14.2935L96.8074 21.6055H99.0474V10.4055ZM108.791 12.6775L106.519 10.4055H101.223V21.6055H106.439L108.791 19.2535V12.6775ZM105.687 12.7095L106.487 13.5095V18.4855L105.655 19.3175H103.527V12.7095H105.687ZM117.873 10.4055H110.817V21.6055H117.889V19.3175H113.121V16.7575H116.417V14.9815H113.121V12.7095H117.873V10.4055ZM127.338 12.6775L125.066 10.4055H119.77V21.6055H124.986L127.338 19.2535V12.6775ZM124.234 12.7095L125.034 13.5095V18.4855L124.202 19.3175H122.074V12.7095H124.234Z",
				fill: "#F6F7F7"
			}),
			/* @__PURE__ */ t("defs", { children: [
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "23.373",
					id: "filter0_dd_2812_101275",
					width: "16.792",
					x: "131.083",
					y: "5.07031",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_2812_101275"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_2812_101275"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_2812_101275",
							mode: "normal",
							result: "effect2_dropShadow_2812_101275"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_2812_101275",
							mode: "normal",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "23.373",
					id: "filter1_dd_2812_101275",
					width: "16.792",
					x: "0.5",
					y: "5.07031",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_2812_101275"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_2812_101275"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_2812_101275",
							mode: "normal",
							result: "effect2_dropShadow_2812_101275"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_2812_101275",
							mode: "normal",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "31.877",
					id: "filter2_dd_2812_101275",
					width: "126.87",
					x: "10.752",
					y: "0.933594",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_2812_101275"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_2812_101275"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_2812_101275",
							mode: "normal",
							result: "effect2_dropShadow_2812_101275"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_2812_101275",
							mode: "normal",
							result: "shape"
						})
					]
				})
			] })
		]
	});
}
//#endregion
//#region primitives/icon/icons/PremiumRecommendedV2.tsx
function Ge(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "33",
		viewBox: "0 0 174 33",
		width: "174",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("g", {
				filter: "url(#filter0_dd_581_97741)",
				children: /* @__PURE__ */ e("path", {
					d: "M10 6.5L10 24.5L3 24.5L5.1 15.5L3 6.5L10 6.5Z",
					fill: "#FBDA2E"
				})
			}),
			/* @__PURE__ */ e("g", {
				filter: "url(#filter1_dd_581_97741)",
				children: /* @__PURE__ */ e("path", {
					d: "M164 25L164 9L171 9L168.9 17L171 25L164 25Z",
					fill: "#FBDA2E"
				})
			}),
			/* @__PURE__ */ e("g", {
				filter: "url(#filter2_dd_581_97741)",
				children: /* @__PURE__ */ e("rect", {
					fill: "#FBDA2E",
					height: "27",
					rx: "4",
					width: "156",
					x: "9",
					y: "2"
				})
			}),
			/* @__PURE__ */ t("defs", { children: [
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "24",
					id: "filter0_dd_581_97741",
					width: "13",
					x: "0",
					y: "4.5",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_581_97741"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_581_97741"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_581_97741",
							mode: "normal",
							result: "effect2_dropShadow_581_97741"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_581_97741",
							mode: "normal",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "22",
					id: "filter1_dd_581_97741",
					width: "13",
					x: "161",
					y: "7",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_581_97741"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_581_97741"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_581_97741",
							mode: "normal",
							result: "effect2_dropShadow_581_97741"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_581_97741",
							mode: "normal",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "33",
					id: "filter2_dd_581_97741",
					width: "162",
					x: "6",
					y: "0",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_581_97741"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_581_97741"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_581_97741",
							mode: "normal",
							result: "effect2_dropShadow_581_97741"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_581_97741",
							mode: "normal",
							result: "shape"
						})
					]
				})
			] })
		]
	});
}
//#endregion
//#region primitives/icon/icons/PremiumRecommendedV2Large.tsx
function Ke(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "33",
		viewBox: "0 0 296 33",
		width: "296",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("g", {
				filter: "url(#filter0_dd_581_98102)",
				children: /* @__PURE__ */ e("path", {
					d: "M10 6.5L10 24.5L3 24.5L5.1 15.5L3 6.5L10 6.5Z",
					fill: "#FBDA2E"
				})
			}),
			/* @__PURE__ */ e("g", {
				filter: "url(#filter1_dd_581_98102)",
				children: /* @__PURE__ */ e("path", {
					d: "M286 25L286 9L293 9L290.9 17L293 25L286 25Z",
					fill: "#FBDA2E"
				})
			}),
			/* @__PURE__ */ e("g", {
				filter: "url(#filter2_dd_581_98102)",
				children: /* @__PURE__ */ e("rect", {
					fill: "#FBDA2E",
					height: "27",
					rx: "4",
					width: "276",
					x: "10",
					y: "2"
				})
			}),
			/* @__PURE__ */ t("defs", { children: [
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "24",
					id: "filter0_dd_581_98102",
					width: "13",
					x: "0",
					y: "4.5",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_581_98102"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_581_98102"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_581_98102",
							mode: "normal",
							result: "effect2_dropShadow_581_98102"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_581_98102",
							mode: "normal",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "22",
					id: "filter1_dd_581_98102",
					width: "13",
					x: "283",
					y: "7",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_581_98102"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_581_98102"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_581_98102",
							mode: "normal",
							result: "effect2_dropShadow_581_98102"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_581_98102",
							mode: "normal",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ t("filter", {
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					height: "33",
					id: "filter2_dd_581_98102",
					width: "282",
					x: "7",
					y: "0",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "1" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "BackgroundImageFix",
							mode: "normal",
							result: "effect1_dropShadow_581_98102"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ e("feMorphology", {
							in: "SourceAlpha",
							operator: "dilate",
							radius: "1",
							result: "effect2_dropShadow_581_98102"
						}),
						/* @__PURE__ */ e("feOffset", {}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							in2: "effect1_dropShadow_581_98102",
							mode: "normal",
							result: "effect2_dropShadow_581_98102"
						}),
						/* @__PURE__ */ e("feBlend", {
							in: "SourceGraphic",
							in2: "effect2_dropShadow_581_98102",
							mode: "normal",
							result: "shape"
						})
					]
				})
			] })
		]
	});
}
//#endregion
//#region primitives/icon/icons/PremiumTrophy.tsx
function qe(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "100%",
		preserveAspectRatio: "xMinYMid",
		viewBox: "0 0 27 24",
		width: "33",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("rect", {
				fill: "white",
				height: "2.5",
				width: "2.5",
				x: "6.2002",
				y: "2.5"
			}),
			/* @__PURE__ */ e("path", {
				d: "M6.5 6H9.5V8.5L10.5 14.5C10.5 14.5 8.30916 12.6081 7.5 11C6.60496 9.2212 6.5 6 6.5 6Z",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M8.5 21.5C8.5 21.5 10.246 19.6461 11.7271 19.4373C12.2245 19.3672 13 19.5 13 19.5L11 21.5L8.5 21.5Z",
				fill: "white"
			}),
			/* @__PURE__ */ e("path", {
				d: "M25.5796 4.4527C25.5796 3.99441 25.2045 3.62349 24.7424 3.62349H21.3892V3.10187C21.7282 2.99566 21.9748 2.68516 21.9748 2.31456C21.9748 1.85627 21.6 1.48535 21.1377 1.48535H6.19588C5.73286 1.48535 5.3587 1.85659 5.3587 2.31456C5.3587 2.68515 5.60497 2.99566 5.94502 3.10187V3.62349H2.37592C1.9129 3.62349 1.53809 3.99473 1.53809 4.4527C1.53809 10.4763 6.08072 15.4673 11.9509 16.248V16.25C11.9509 17.4751 11.4639 18.6772 10.493 19.283C9.53482 19.8803 8.56413 20.4899 7.83648 21.4049H7.74008C7.27738 21.4049 6.90289 21.7761 6.90289 22.2341C6.90289 22.6914 7.2777 23.0633 7.74008 23.0633H19.5363C19.9984 23.0633 20.3735 22.6914 20.3735 22.2341C20.3735 21.7758 19.9984 21.4049 19.5363 21.4049H19.3714C18.6437 20.4899 17.6737 19.882 16.7159 19.283C15.7459 18.6782 15.2573 17.4748 15.2573 16.25C15.2573 16.2454 15.2583 16.2406 15.2583 16.2373C21.0854 15.4169 25.5796 10.4464 25.5796 4.4527ZM21.4095 5.35917C21.4095 5.33222 21.3996 5.3085 21.394 5.2822H23.8722C23.6102 8.49444 21.8447 11.3932 19.2754 13.1656C20.6169 11.2103 21.4095 8.49675 21.4095 5.35917ZM6.90757 3.01931H8.5688V4.654H6.90757V3.01931ZM3.24604 5.28251H5.93924C5.93465 5.30849 5.92415 5.3322 5.92415 5.35949C5.92415 8.60058 6.7469 11.3906 8.13071 13.3589C5.40603 11.6089 3.51694 8.61399 3.24604 5.28251ZM8.26055 11.7872C7.44337 10.1268 7.00361 8.33977 6.92033 6.06493H8.56914C8.56914 9.19336 9.24924 11.9606 10.4848 14.3814C9.60144 13.8273 8.78748 12.858 8.26055 11.7872ZM11.1325 21.2444H9.13444C10.2189 20.1892 11.6086 19.5736 13.1262 19.4658C12.3507 19.9257 11.6732 20.5305 11.1325 21.2444Z",
				fill: "url(#paint0_linear_2099_33929)"
			}),
			/* @__PURE__ */ e("defs", { children: /* @__PURE__ */ t("linearGradient", {
				gradientUnits: "userSpaceOnUse",
				id: "paint0_linear_2099_33929",
				x1: "2",
				x2: "22.5",
				y1: "1.99963",
				y2: "19.4996",
				children: [/* @__PURE__ */ e("stop", { stopColor: "#F5E01F" }), /* @__PURE__ */ e("stop", {
					offset: "1",
					stopColor: "#FF8A00"
				})]
			}) })
		]
	});
}
//#endregion
//#region primitives/icon/icons/Projections.tsx
function Je({ accent: n, primary: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		fill: "currentColor",
		height: "17",
		viewBox: "0 0 17 17",
		width: "17",
		xmlns: "http://www.w3.org/2000/svg",
		...i,
		children: [/* @__PURE__ */ e("path", {
			d: "M15.5932 14.5507H1.38447V0.808434C1.38447 0.36999 1.0351 -0.0870854 0.6 0.014259C0.248685 0.0960875 0 0.36999 0 0.808434V15.2201C0 15.6588 0.182082 16.0143 0.40678 16.0143H15.5932C15.8179 16.0143 16 15.6588 16 15.2201C16 14.7817 15.8179 14.5507 15.5932 14.5507Z",
			fill: r ?? "white"
		}), /* @__PURE__ */ e("path", {
			d: "M4.4141 11.5928L4.41626 11.5928C4.57981 11.5926 4.73436 11.5207 4.84195 11.3969L4.84207 11.3968L9.25914 6.3036L10.3321 7.53822L10.3321 7.53823L10.3332 7.53946C10.4636 7.68617 10.658 7.75751 10.8515 7.72658L10.8515 7.72674L10.8584 7.72529C10.982 7.6995 11.0941 7.63457 11.1791 7.54054L11.1791 7.54056L11.181 7.5383L15.0126 3.12569V4.04886C15.0126 4.36591 15.2625 4.63175 15.5813 4.63175C15.9001 4.63175 16.15 4.36591 16.15 4.04886V1.59C16.15 1.27278 15.9001 1.0071 15.5813 1.0071H13.203C12.8844 1.0071 12.6343 1.27276 12.6343 1.59C12.6343 1.90708 12.8844 2.17289 13.203 2.17289H14.3148L10.7578 6.27587L9.68476 5.03857L9.68482 5.03851L9.68148 5.03491C9.57203 4.91674 9.41938 4.84886 9.25878 4.84886C9.09818 4.84886 8.94553 4.91674 8.83608 5.03491L8.83602 5.03486L8.8328 5.03856L3.98991 10.6228L3.98989 10.6228L3.98831 10.6247C3.8439 10.7968 3.80979 11.0382 3.89916 11.2446L3.8992 11.2447C3.98893 11.4516 4.18863 11.5898 4.4141 11.5928Z",
			fill: n ?? "currentColor",
			stroke: n ?? "white",
			strokeWidth: "0.3"
		})]
	});
}
//#endregion
//#region primitives/icon/icons/Right.tsx
function Ye(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M16.22 12.694l-6.442 6.69a.822.822 0 01-1.163.023l-.022-.022a.887.887 0 010-1.231L14.519 12 8.593 5.846a.886.886 0 010-1.23.822.822 0 011.163-.023l.022.022 6.443 6.691a1 1 0 010 1.388z",
				fill: "#00182E"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/RugbyLeague.tsx
function Xe(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M18.574 4.241a1.5 1.5 0 011.128 1.03l.03.113a12.046 12.046 0 01-3.277 11.07A12.025 12.025 0 017.925 20c-.842 0-1.693-.089-2.54-.269a1.503 1.503 0 01-1.144-1.157A12.14 12.14 0 017.567 7.567 12.145 12.145 0 0118.574 4.24zM5.085 14.789a11.173 11.173 0 00.137 3.587c.037.183.19.338.373.376 1.211.26 2.434.313 3.624.172L5.085 14.79zm8.505-9.488a11.14 11.14 0 00-5.315 2.974A11.152 11.152 0 005.3 13.59l5.122 5.125a11.069 11.069 0 005.325-2.967 11.057 11.057 0 002.965-5.325L13.59 5.301zm-.737 3.847l.645.645.647-.646a.5.5 0 01.707.707l-.647.646.646.646a.499.499 0 11-.706.707l-.647-.646-.793.793.647.647a.5.5 0 01-.257.844L13 13.5a.5.5 0 01-.353-.147L12 12.706l-.793.793.646.647a.499.499 0 11-.705.707l-.648-.647-.645.647a.5.5 0 01-.258.136l-.095.01a.5.5 0 01-.354-.853l.645-.647-.645-.646a.5.5 0 01.707-.707l.645.646.791-.792-.645-.645a.5.5 0 01.707-.707l.645.645.793-.792-.645-.645a.5.5 0 01.707-.707zM16.16 5c-.46 0-.918.028-1.371.085l4.134 4.135c.14-1.191.088-2.415-.17-3.628a.496.496 0 00-.377-.371A11.245 11.245 0 0016.16 5z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/RugbyUnion.tsx
function Ze(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M18.574 4.241a1.5 1.5 0 011.128 1.03l.03.113a12.046 12.046 0 01-3.277 11.07A12.025 12.025 0 017.925 20c-.842 0-1.693-.089-2.54-.269a1.503 1.503 0 01-1.144-1.157A12.14 12.14 0 017.567 7.567 12.145 12.145 0 0118.574 4.24zM5.085 14.789a11.173 11.173 0 00.137 3.587c.037.183.19.338.373.376 1.211.26 2.434.313 3.624.172L5.085 14.79zm8.505-9.488a11.14 11.14 0 00-5.315 2.974A11.152 11.152 0 005.3 13.59l5.122 5.125a11.069 11.069 0 005.325-2.967 11.057 11.057 0 002.965-5.325L13.59 5.301zm-.737 3.847l.645.645.647-.646a.5.5 0 01.707.707l-.647.646.646.646a.499.499 0 11-.706.707l-.647-.646-.793.793.647.647a.5.5 0 01-.257.844L13 13.5a.5.5 0 01-.353-.147L12 12.706l-.793.793.646.647a.499.499 0 11-.705.707l-.648-.647-.645.647a.5.5 0 01-.258.136l-.095.01a.5.5 0 01-.354-.853l.645-.647-.645-.646a.5.5 0 01.707-.707l.645.646.791-.792-.645-.645a.5.5 0 01.707-.707l.645.645.793-.792-.645-.645a.5.5 0 01.707-.707zM16.16 5c-.46 0-.918.028-1.371.085l4.134 4.135c.14-1.191.088-2.415-.17-3.628a.496.496 0 00-.377-.371A11.245 11.245 0 0016.16 5z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Share.tsx
function Qe(t) {
	return /* @__PURE__ */ e("svg", {
		height: "16",
		viewBox: "0 0 14 16",
		width: "14",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M6.64645 0.646444L3.46447 3.82843C3.2692 4.02369 3.2692 4.34027 3.46447 4.53553C3.65973 4.73079 3.97631 4.73079 4.17157 4.53553L6.5 2.2071L6.5 10H7.5L7.5 2.2071L9.82843 4.53553C10.0237 4.73079 10.3403 4.73079 10.5355 4.53553C10.7308 4.34027 10.7308 4.02369 10.5355 3.82843L7.35355 0.646444C7.15829 0.451182 6.84171 0.451182 6.64645 0.646444ZM0 4.92315V15.0001V16.0001V16.0001H1V16.0001H13L13 16.0001H14L14 4.92315H13L13 15.0001H1L1 4.92315H0Z",
			fill: "#052643",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Shield.tsx
function $e(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 20 20",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("circle", {
				cx: 10,
				cy: 10,
				fill: "#00182E",
				r: 10
			}), /* @__PURE__ */ e("path", {
				d: "M10 0c5.522 0 10 4.477 10 10s-4.478 10-10 10C4.477 20 0 15.522 0 10S4.477 0 10 0zm0 4.474L4.488 6.82s.366 8.706 5.512 8.706c5.145 0 5.512-8.706 5.512-8.706L10 4.474zm2.603 3.44l.698.917-3.913 3.977-.002-.005-.005.005-2.182-2.432.91-.8 1.314.954 3.18-2.617z",
				fill: "#1ED560"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/SilksAu.tsx
function et(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		width: "1em",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M21.1 17.88v-2.42c0-.64-.96-3.34-1.98-4.5-1.02-1.17 0-5.35 1.02-6.82.68-.98 1.94-1.9 3.79-2.75 2.18-.52 3.98-.52 5.4 0 2.12.77 2.92 3.73 2.92 4.48 0 .75 2.1 1.63 2.1 2.58 0 .64-.39 1.2-1.18 1.7 0 .56-.07 1.47-.2 2.74-.2 1.9-2.71 3.9-2.71 5v2.08c.62.44 1.77.85 3.45 1.25 2.53.6 4.61 1.48 5.53 1.95.91.48 7.06 11.94 7.06 14.4 0 2.45.83 6.64 0 8.66-.55 1.35-2.03 3.23-4.43 5.64 0 .96-.39 1.64-1.16 2.05-1.16.6-1.63 2.47-2.39 3.06-.76.59-1.64.98-2.34.98-.71 0-1.1-.98-2.27-1.57a2.68 2.68 0 01-1.46-1.9H20.14c-.68 0-1.22.37-1.62 1.1-.6 1.08-1.16 1-1.9 1.39-.75.39-1.3.7-2.1.98-.8.27-.94.86-1.54.97-.6.12-1.93-2.42-1.93-3.35 0-.61-1.04-1.37-3.13-2.28h-.96a22.34 22.34 0 01-4.24-5.24c-1.65-2.87-1.94-3.8-1.59-5.9.35-2.09 1.44-4.75 3.25-9.9 1.82-5.14 5.36-8.75 8.6-10.4 2.16-1.1 4.2-1.74 6.14-1.89l1.98-2.09zM9.15 41.76l2.62 7.94 3.54 1.8.64-4.97-4.18-7.62-2.62 2.85zm28-3.36l-1.53 4.18v7.9l1.52-.77c1.44-3.1 2.01-5.48 1.72-7.13a9.76 9.76 0 00-1.72-4.18z",
			fill: "#DDD",
			fillRule: "evenodd",
			stroke: "#eeeff4"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Snooker.tsx
function tt(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M12 4c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0 1c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 3.446A3.558 3.558 0 0115.554 12 3.558 3.558 0 0112 15.554 3.558 3.558 0 018.446 12 3.558 3.558 0 0112 8.446zm-.054 1a2.502 2.502 0 00-2.5 2.5c0 1.378 1.121 2.5 2.5 2.5 1.378 0 2.5-1.122 2.5-2.5 0-1.379-1.122-2.5-2.5-2.5zm.127 1.05c.581 0 .885.39.885.775 0 .142-.04.38-.265.576.232.161.357.39.357.663 0 .513-.424.886-1.008.886-.654 0-.996-.42-.996-.836 0-.279.124-.514.354-.682a.726.726 0 01-.258-.557c0-.478.391-.824.931-.824zm-.071 1.671c-.125.045-.291.142-.291.347a.285.285 0 00.076.217.352.352 0 00.263.099c.206 0 .339-.112.339-.285 0-.154-.067-.278-.387-.377zM12 6.054a5.954 5.954 0 015.947 5.947.32.32 0 01-.64 0A5.313 5.313 0 0012 6.694a.32.32 0 110-.64zm.054 5.005c-.202 0-.274.124-.274.24 0 .098.038.209.309.292.1-.042.227-.127.227-.285 0-.092-.034-.247-.262-.247z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Soccer.tsx
function nt(t) {
	let n = t.fill || "#00182E";
	return /* @__PURE__ */ e("svg", {
		height: t.height || "1em",
		viewBox: "0 0 16 16",
		width: t.width || "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M8 0c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm1.768 11.5H6.235l-1.002 1.203.63 1.964a6.99 6.99 0 003.916.104l.974-2.105-.985-1.167zm3.374 1.245l-1.456.287-.572 1.237a7.036 7.036 0 002.028-1.524zm-8.5 1.396l-.343-1.07-1.19-.067c.456.445.971.828 1.533 1.137zm-1.914-7.3L1.033 8.683a6.962 6.962 0 001.193 3.27l2.228.121.98-1.177L4.27 7.594 2.728 6.84zm10.556 0l-1.54.754-1.177 3.301.967 1.146 2.498-.493a6.944 6.944 0 00.935-2.866L13.284 6.84zM8.008 5.424L5.268 7.42l1.086 3.08h3.293l1.1-3.08-2.74-1.996zM1.046 7.191l1.021-1.11-.282-1.3a6.937 6.937 0 00-.739 2.41zM14.224 4.8l-.278 1.284 1.007 1.098a6.944 6.944 0 00-.729-2.382zM10.57 1.49L8.508 2.6v1.95l2.885 2.104 1.572-.77.492-2.264a7.036 7.036 0 00-2.887-2.131zM2.555 3.606l.492 2.277 1.576.77L7.508 4.55V2.596L5.445 1.483a7.027 7.027 0 00-2.89 2.123zM8 1a6.99 6.99 0 00-1.165.097l1.175.635L9.184 1.1C8.799 1.034 8.404 1 8 1z",
			fill: n,
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Sort.tsx
function rt(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 13 12",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M4.76 9.084a.683.683 0 010 .942l-1.714 1.779a.63.63 0 01-.908 0L.424 10.027a.683.683 0 01-.168-.645c.059-.23.233-.41.455-.472s.46.005.622.174l.616.64V.667c0-.369.288-.667.643-.667.355 0 .642.298.642.667v9.057l.616-.64a.63.63 0 01.909 0zm2.091-6.168a.683.683 0 010-.942L8.564.194a.63.63 0 01.909.001l1.714 1.778a.685.685 0 01.168.645.658.658 0 01-.455.472.627.627 0 01-.622-.174l-.616-.64v9.057a.655.655 0 01-.643.667.655.655 0 01-.643-.667V2.276l-.616.64a.63.63 0 01-.909 0z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Sorted.tsx
function it(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 15 12",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M4.526 9.084c.12.125.188.295.188.472 0 .176-.067.346-.188.47l-1.714 1.779c-.12.125-.284.195-.454.195-.17 0-.334-.07-.454-.195L.19 10.027c-.163-.168-.228-.414-.168-.645.059-.23.233-.41.455-.472s.46.005.622.174l.616.64V.667c0-.369.288-.667.643-.667C2.713 0 3 .298 3 .667v9.057l.616-.64c.12-.125.284-.195.455-.195.17 0 .334.07.454.195zM13.152 1.286H6.455c-.37 0-.67.3-.67.67 0 .37.3.669.67.669h6.697c.37 0 .67-.3.67-.67 0-.37-.3-.67-.67-.67zM12.259 3.91H6.455c-.37 0-.67.3-.67.67 0 .37.3.67.67.67h5.804c.37 0 .67-.3.67-.67 0-.37-.3-.67-.67-.67zM11.366 6.536h-4.91c-.37 0-.67.3-.67.67 0 .37.3.669.67.669h4.91c.37 0 .67-.3.67-.67 0-.37-.3-.67-.67-.67zM10.473 9.16H6.455c-.37 0-.67.3-.67.67 0 .37.3.67.67.67h4.018c.37 0 .67-.3.67-.67 0-.37-.3-.67-.67-.67z",
			fill: "currentColor",
			fillRule: "evenodd",
			transform: "translate(.546)"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Specials.tsx
function at(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.744 6.23h-1.231v-.82a.41.41 0 00-.41-.41H7.897a.41.41 0 00-.41.41v.82h-1.23a2.258 2.258 0 00-.001 4.515.41.41 0 100-.82 1.436 1.436 0 010-2.873h1.231v3.487c0 2.018 1.34 3.79 3.282 4.341v1.403h-.947a.41.41 0 00-.347.193l-.9 1.436a.406.406 0 000 .41c.068.13.201.213.348.217h6.154a.409.409 0 00.359-.615l-.9-1.436a.411.411 0 00-.358-.205h-.947V14.88a4.514 4.514 0 003.282-4.34V7.05h1.23a1.435 1.435 0 11.001 2.872.41.41 0 100 .82 2.256 2.256 0 100-4.51zm-3.408 11.488H9.664l.385-.615h3.898l.39.615zm-1.926-1.436h-.82v-1.25c.135 0 .273.02.41.02.137 0 .275 0 .41-.02v1.25zm3.282-5.744a3.692 3.692 0 11-7.384 0V5.821h7.384v4.717z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/SquareCheckIcon.tsx
function ot(n) {
	return /* @__PURE__ */ t("svg", {
		...n,
		fill: "none",
		height: "22",
		viewBox: "0 0 22 22",
		width: "22",
		xmlns: "http://www.w3.org/2000/svg",
		children: [/* @__PURE__ */ e("rect", {
			fill: "currentColor",
			height: "20",
			rx: "3",
			width: "20",
			x: "1",
			y: "1"
		}), /* @__PURE__ */ e("path", {
			d: "M15.538 6L17.1748 7.67813L9.18828 15.473L5 11.4736L6.61906 9.77859L9.17047 12.2152L15.538 6Z",
			fill: "white"
		})]
	});
}
//#endregion
//#region primitives/icon/icons/StarFull.tsx
function st(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 20 20",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M16.256 19.805a.556.556 0 00.115-.406l-.716-6.476 4.207-4.79a.563.563 0 00.113-.535.525.525 0 00-.39-.363L13.49 5.953 10.447.273C10.355.103 10.185 0 10 0s-.355.104-.447.272L6.51 5.953.415 7.235a.525.525 0 00-.39.363.558.558 0 00.113.534l4.207 4.791L3.63 19.4a.552.552 0 00.208.498c.15.114.347.135.515.054L10 17.231l5.648 2.72a.488.488 0 00.249.048c.14-.01.27-.08.36-.194z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Stats.tsx
function ct(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 20 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M3.846 6.4c.425 0 .77.358.77.8v8c0 .442-.345.8-.77.8H.77c-.426 0-.77-.358-.77-.8v-8c0-.442.344-.8.77-.8h3.076zM14.103 0c.424 0 .769.358.769.8v14.4c0 .442-.345.8-.77.8h-3.076c-.425 0-.77-.358-.77-.8V.8c0-.442.345-.8.77-.8h3.077zm5.128 1.6c.425 0 .769.358.769.8v12.8c0 .442-.344.8-.77.8h-3.076c-.425 0-.77-.358-.77-.8V2.4c0-.442.345-.8.77-.8h3.077zM8.974 4.8c.425 0 .77.358.77.8v9.6c0 .442-.345.8-.77.8H5.897c-.424 0-.769-.358-.769-.8V5.6c0-.442.345-.8.77-.8h3.076zm-5.59 2.88H1.232v7.04h2.154V7.68zm10.257-6.4h-2.154v13.44h2.154V1.28zm5.128 1.6h-2.154v11.84h2.154V2.88zM8.513 6.08H6.359v8.64h2.154V6.08z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Stripe.tsx
function lt(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "17",
		viewBox: "0 0 103 17",
		width: "103",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M102.469 8.271C102.469 5.53538 101.144 3.3768 98.6114 3.3768C96.0681 3.3768 94.5293 5.53538 94.5293 8.24963C94.5293 11.4661 96.3459 13.0904 98.9533 13.0904C100.225 13.0904 101.187 12.8019 101.913 12.3958V10.2586C101.187 10.6219 100.353 10.8463 99.2953 10.8463C98.2587 10.8463 97.3397 10.483 97.2222 9.22206H102.448C102.448 9.08314 102.469 8.52747 102.469 8.271ZM97.1901 7.25583C97.1901 6.04831 97.9275 5.54606 98.6007 5.54606C99.2525 5.54606 99.9471 6.04831 99.9471 7.25583H97.1901Z",
				fill: "#635BFF",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M90.4027 3.3768C89.3554 3.3768 88.6822 3.86836 88.3082 4.21031L88.1693 3.54778H85.8184V16.0077L88.4899 15.4413L88.5006 12.4172C88.8852 12.695 89.4516 13.0904 90.392 13.0904C92.3048 13.0904 94.0466 11.5516 94.0466 8.16414C94.0359 5.06519 92.2727 3.3768 90.4027 3.3768ZM89.7615 10.7395C89.131 10.7395 88.757 10.5151 88.5006 10.2372L88.4899 6.27271C88.7677 5.96282 89.1524 5.7491 89.7615 5.7491C90.7339 5.7491 91.4072 6.83907 91.4072 8.23894C91.4072 9.67087 90.7446 10.7395 89.7615 10.7395Z",
				fill: "#635BFF",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M82.1465 2.74631L84.8287 2.16926V0L82.1465 0.56636V2.74631Z",
				fill: "#635BFF",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				d: "M84.8287 3.55844H82.1465V12.9087H84.8287V3.55844Z",
				fill: "#635BFF"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M79.2702 4.34919L79.0992 3.55842H76.791V12.9087H79.4625V6.57188C80.093 5.74906 81.1616 5.89867 81.4929 6.01621V3.55842C81.1509 3.43019 79.9007 3.1951 79.2702 4.34919Z",
				fill: "#635BFF",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M73.9247 1.23956L71.3173 1.79524L71.3066 10.3547C71.3066 11.9363 72.4928 13.1011 74.0743 13.1011C74.9506 13.1011 75.5917 12.9408 75.9444 12.7484V10.5792C75.6024 10.7181 73.914 11.2096 73.914 9.6281V5.83456H75.9444V3.55843H73.914L73.9247 1.23956Z",
				fill: "#635BFF",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M66.7036 6.27271C66.7036 5.85596 67.0455 5.69567 67.6119 5.69567C68.424 5.69567 69.4499 5.94145 70.262 6.37957V3.86836C69.3751 3.51572 68.4988 3.3768 67.6119 3.3768C65.4426 3.3768 64 4.50952 64 6.40095C64 9.35029 68.0607 8.88011 68.0607 10.1517C68.0607 10.6433 67.6333 10.8036 67.0348 10.8036C66.1479 10.8036 65.0152 10.4403 64.1175 9.94871V12.492C65.1113 12.9194 66.1158 13.1011 67.0348 13.1011C69.2575 13.1011 70.7856 12.0004 70.7856 10.0876C70.7749 6.90319 66.7036 7.46955 66.7036 6.27271Z",
				fill: "#635BFF",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				d: "M2.233 9.052H3.641C4.587 9.052 5.148 8.898 5.566 8.524C6.039 8.095 6.248 7.49 6.248 6.588C6.248 5.752 6.072 5.202 5.665 4.773C5.236 4.322 4.675 4.146 3.641 4.146H1.056V12H2.233V9.052ZM2.211 8.095V5.092H3.641C4.642 5.092 5.082 5.543 5.082 6.599C5.082 7.633 4.642 8.095 3.641 8.095H2.211ZM7.58184 9.635C7.58184 11.351 8.30784 12.11 9.94684 12.11C11.5748 12.11 12.3008 11.351 12.3008 9.635V8.777C12.3008 7.061 11.5748 6.302 9.94684 6.302C8.30784 6.302 7.58184 7.061 7.58184 8.777V9.635ZM11.1788 9.558C11.1788 10.702 10.8048 11.208 9.93584 11.208C9.07784 11.208 8.70384 10.702 8.70384 9.558V8.854C8.70384 7.71 9.07784 7.204 9.93584 7.204C10.8048 7.204 11.1788 7.71 11.1788 8.854V9.558ZM15.0922 12H16.0272L17.3032 8.117L18.5792 12H19.5142L21.2082 6.412H20.0752L18.9862 10.57L17.6992 6.412H16.9072L15.6202 10.57L14.5312 6.412H13.3982L15.0922 12ZM23.4258 9.47H26.9678V9.03C26.9678 7.116 26.2748 6.302 24.6358 6.302C22.9968 6.302 22.3038 7.116 22.3038 9.03V9.459C22.3038 11.296 23.0408 12.11 24.7018 12.11C25.7688 12.11 26.3958 11.835 26.8578 11.153L26.0218 10.658C25.7248 11.054 25.3728 11.219 24.8118 11.219C23.9098 11.219 23.4258 10.68 23.4258 9.668V9.47ZM23.4258 8.667V8.568C23.4258 8.238 23.5138 7.886 23.6458 7.666C23.8438 7.325 24.1628 7.171 24.6688 7.171C25.4718 7.171 25.9008 7.655 25.9008 8.557V8.667H23.4258ZM28.5947 12H29.7167V9.283C29.7167 7.864 30.0137 7.27 30.7287 7.27C30.9927 7.27 31.2017 7.347 31.4877 7.556L31.9717 6.621C31.5537 6.39 31.2457 6.302 30.8387 6.302C30.2667 6.302 29.9367 6.456 29.5847 6.885L29.4637 6.412H28.5947V12ZM33.9261 9.47H37.4681V9.03C37.4681 7.116 36.7751 6.302 35.1361 6.302C33.4971 6.302 32.8041 7.116 32.8041 9.03V9.459C32.8041 11.296 33.5411 12.11 35.2021 12.11C36.2691 12.11 36.8961 11.835 37.3581 11.153L36.5221 10.658C36.2251 11.054 35.8731 11.219 35.3121 11.219C34.4101 11.219 33.9261 10.68 33.9261 9.668V9.47ZM33.9261 8.667V8.568C33.9261 8.238 34.0141 7.886 34.1461 7.666C34.3441 7.325 34.6631 7.171 35.1691 7.171C35.9721 7.171 36.4011 7.655 36.4011 8.557V8.667H33.9261ZM42.6699 12H43.5389V4.146H42.4169V6.764C42.2299 6.621 42.1199 6.544 42.1089 6.533C41.7789 6.368 41.4489 6.302 41.0089 6.302C39.5569 6.302 38.9189 7.061 38.9189 8.788V9.624C38.9189 11.362 39.5569 12.11 41.0419 12.11C41.6029 12.11 42.1639 11.967 42.3839 11.758C42.4389 11.714 42.4829 11.67 42.5269 11.626C42.5379 11.615 42.5599 11.593 42.5929 11.571L42.6699 12ZM40.0299 8.865C40.0299 7.732 40.4039 7.204 41.2179 7.204C42.0209 7.204 42.4169 7.699 42.4169 8.7V9.712C42.4169 10.713 42.0209 11.208 41.2179 11.208C40.4039 11.208 40.0299 10.68 40.0299 9.547V8.865ZM47.7586 12H48.6276L48.7046 11.571C48.8806 11.714 48.9906 11.802 49.0236 11.824C49.3206 12.011 49.7496 12.11 50.2556 12.11C51.7406 12.11 52.3786 11.362 52.3786 9.624V8.788C52.3786 7.061 51.7406 6.302 50.2776 6.302C49.6726 6.302 49.3096 6.423 48.8806 6.764V4.146H47.7586V12ZM51.2676 9.547C51.2676 10.68 50.8936 11.208 50.0796 11.208C49.2766 11.208 48.8806 10.713 48.8806 9.712V8.7C48.8806 7.699 49.2766 7.204 50.0796 7.204C50.8936 7.204 51.2676 7.732 51.2676 8.865V9.547ZM55.3535 11.945L55.1335 12.605C54.8145 13.485 54.6385 13.617 53.7805 13.606V14.53C55.4085 14.519 55.7165 14.288 56.2775 12.704L58.3895 6.412H57.2565L55.9475 10.724L54.5065 6.412H53.3735L55.3535 11.945Z",
				fill: "#00182E"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/TagAwards.tsx
function ut(n) {
	return /* @__PURE__ */ e("svg", {
		height: "16px",
		viewBox: "4 4 16 16",
		width: "16px",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.744 6.23h-1.231v-.82a.41.41 0 00-.41-.41H7.897a.41.41 0 00-.41.41v.82h-1.23a2.258 2.258 0 00-.001 4.515.41.41 0 100-.82 1.436 1.436 0 010-2.873h1.231v3.487c0 2.018 1.34 3.79 3.282 4.341v1.403h-.947a.41.41 0 00-.347.193l-.9 1.436a.406.406 0 000 .41c.068.13.201.213.348.217h6.154a.409.409 0 00.359-.615l-.9-1.436a.411.411 0 00-.358-.205h-.947V14.88a4.514 4.514 0 003.282-4.34V7.05h1.23a1.435 1.435 0 11.001 2.872.41.41 0 100 .82 2.256 2.256 0 100-4.51zm-3.408 11.488H9.664l.385-.615h3.898l.39.615zm-1.926-1.436h-.82v-1.25c.135 0 .273.02.41.02.137 0 .275 0 .41-.02v1.25zm3.282-5.744a3.692 3.692 0 11-7.384 0V5.821h7.384v4.717z",
				fill: "#0b4721"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagBaseball.tsx
function dt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16px",
		viewBox: "4 4 16 16",
		width: "16px",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M17.5 4a2.503 2.503 0 011.538 4.472L7.58 17.892c.084.189.128.395.128.609 0 .401-.157.777-.44 1.061-.283.282-.66.438-1.06.438-.35 0-.682-.12-.95-.339l-.111-.1-.707-.707c-.284-.284-.44-.661-.44-1.062s.157-.777.44-1.061c.432-.43 1.111-.533 1.66-.305L15.528 4.96a.268.268 0 01.035-.048A2.502 2.502 0 0117.5 4zM5.147 17.44a.494.494 0 000 .706l.707.708a.51.51 0 00.707 0 .496.496 0 000-.707l-.707-.707a.512.512 0 00-.707 0zm3.296-2.289L6.88 17.052l.067.067 1.901-1.563-.405-.405zM17.5 5c-.436 0-.844.184-1.129.507l-.031.042-7.259 8.826.543.543 8.827-7.258.042-.031A1.502 1.502 0 0017.5 5zM6 4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z",
			fill: "#2c8feb",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagBasketball.tsx
function ft(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 17 16",
		width: "17",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M14.156 2.34055C15.668 3.85256 16.5 5.86213 16.5 8.00042C16.5 10.1387 15.668 12.1483 14.156 13.6596C12.5967 15.2203 10.548 16 8.5 16C6.45133 16 4.40267 15.221 2.84267 13.6596C1.332 12.1489 0.5 10.138 0.5 8.00042C0.5 5.94149 1.27133 4.00129 2.678 2.51129L2.84333 2.34055C5.96067 -0.779516 11.0367 -0.78085 14.156 2.34055ZM6.014 11.1932L3.91533 13.2941C5.094 14.3172 6.53533 14.8802 8.004 14.9835C7.66533 13.5729 6.98667 12.2803 6.014 11.1932ZM8.49867 8.7074L6.72333 10.4842C7.87933 11.7621 8.66933 13.3008 9.03133 14.9795C10.486 14.8702 11.9133 14.3086 13.0827 13.2948L8.49867 8.7074ZM10.9833 6.22295L9.20667 8.00042L13.7907 12.5871C14.7807 11.4473 15.3687 10.0367 15.4807 8.53199C13.8013 8.17049 12.2627 7.38014 10.984 6.22295H10.9833ZM1.518 8.49464L1.53133 8.66805C1.668 10.122 2.24933 11.4813 3.20867 12.5865L5.308 10.4855C4.22133 9.51309 2.928 8.83412 1.518 8.49464V8.49464ZM1.53133 7.33212L1.52067 7.46751C3.20067 7.82901 4.73867 8.62003 6.01733 9.77721L7.792 7.99975L3.20933 3.41436C2.24933 4.52019 1.668 5.8788 1.53133 7.33212ZM13.7893 3.4137L11.6913 5.5133C12.7787 6.48574 14.072 7.16604 15.482 7.50553C15.3773 5.98551 14.7873 4.56288 13.7893 3.4137ZM7.96933 1.02129L7.82933 1.03196C6.422 1.16669 5.048 1.72561 3.916 2.70805L8.5 7.29277L10.2773 5.5153C9.122 4.23806 8.33133 2.69938 7.97067 1.02129H7.96933ZM8.996 1.01796L9.038 1.18737C9.39 2.53063 10.0527 3.76385 10.9847 4.80632L13.0833 2.70738C11.9053 1.68492 10.464 1.12134 8.99667 1.01796H8.996Z",
			fill: "#df8e14",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagBoxingMMA.tsx
function pt(n) {
	return /* @__PURE__ */ e("svg", {
		height: "16",
		viewBox: "4 4 16 16",
		width: "16",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M15.92 4a4.13 4.13 0 013.015 1.303 3.96 3.96 0 011.048 3.063l-.665 7.179a.505.505 0 01-.508.455v3.5c0 .276-.229.5-.51.5H9.106a.505.505 0 01-.51-.5V16l-.071-.006-.034-.004-.044-.012-.039-.012-.025-.012a.518.518 0 01-.137-.088l-4.071-3.49A.494.494 0 014 12v-1.5C4 9.122 5.146 8 6.553 8h.854c0-.992.378-1.958 1.065-2.697A4.125 4.125 0 0111.486 4h4.433zm-4.25 12H9.618v3h8.17v-3h-6.116zm2.543 1c.282 0 .51.224.51.5s-.228.5-.51.5h-1.021c-.281 0-.51-.224-.51-.5s.229-.5.51-.5h1.022zM15.92 5h-4.433a3.05 3.05 0 00-2.26.977 2.972 2.972 0 00-.786 2.297l.015.141a.538.538 0 01.007.069L9.107 15h9.236l.622-6.725a2.962 2.962 0 00-.787-2.299A3.05 3.05 0 0015.92 5zM7.483 9h-.93c-.844 0-1.532.673-1.532 1.5v1.273l2.95 2.528L7.484 9z",
				fill: "#4e2424"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagCasino.tsx
function mt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "24",
		viewBox: "0 0 24 24",
		width: "24",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M5.61159 15.9521C6.55867 16.9002 7.79794 17.4092 9.13796 17.4092C9.19112 17.4092 9.24429 17.4064 9.29449 17.4038L9.29452 17.4038H9.29455C9.33946 17.4014 9.38201 17.3992 9.42007 17.3992C10.0445 17.3645 10.6592 17.1893 11.2437 16.8806V20.503H7.67703C7.26394 20.503 6.92138 20.8423 6.92138 21.2515C6.92138 21.6607 7.26394 22 7.67703 22H16.3317C16.7448 22 17.0874 21.6607 17.0874 21.2515C17.0874 20.8423 16.7448 20.503 16.3317 20.503H12.755V16.8868C13.3335 17.1886 13.9412 17.3649 14.5585 17.3992C16.0093 17.479 17.3695 16.9701 18.3871 15.9521C19.3342 15.004 19.9085 13.7066 19.9891 12.2994C20.1402 9.76447 18.6894 7.71856 17.5912 6.39122C16.2914 4.82435 14.4074 3.25749 13.1076 2.38922C13.0573 2.3493 13.017 2.31936 12.9666 2.28942L12.9364 2.26946C12.6643 2.08982 12.3419 2 12.0094 2H11.9994C11.6669 2 11.3445 2.08982 11.0623 2.26946L11.0321 2.28942C10.9817 2.31936 10.9414 2.3493 10.8911 2.38922C9.59135 3.25749 7.70726 4.82435 6.40754 6.39122C5.30933 7.71856 3.86856 9.76447 4.00961 12.2994V12.3094C4.09021 13.7066 4.66451 15.004 5.61159 15.9521ZM9.35961 15.9022C10.0711 15.8636 10.7638 15.5354 11.4193 14.9268C11.5587 14.7612 11.7679 14.6547 11.9994 14.6547L12.0044 14.6547C12.195 14.6534 12.3859 14.7233 12.5333 14.8643C13.2084 15.513 13.9237 15.8623 14.6592 15.9022C15.6768 15.9621 16.6239 15.6028 17.3292 14.8942C18.0244 14.2056 18.4375 13.2475 18.4979 12.2096C18.6088 10.2036 17.3796 8.46707 16.4426 7.33932C15.2335 5.89222 13.42 4.39521 12.2512 3.61677C12.2311 3.60679 12.2109 3.58683 12.1908 3.56687C12.1807 3.55689 12.1706 3.54691 12.1606 3.54691L12.1303 3.52695C12.1001 3.50699 12.0598 3.49701 12.0195 3.49701H11.9994C11.9591 3.49701 11.9187 3.50699 11.8784 3.53693L11.8583 3.55689C11.8533 3.56188 11.8482 3.56437 11.8432 3.56687C11.8381 3.56936 11.8331 3.57186 11.8281 3.57685C11.818 3.58683 11.8079 3.59431 11.7978 3.6018C11.7878 3.60928 11.7777 3.61677 11.7676 3.62675C10.5989 4.40519 8.78532 5.9022 7.57628 7.3493C6.63927 8.46707 5.41008 10.2036 5.52091 12.2096C5.58136 13.2575 5.99445 14.2056 6.68965 14.8942C7.39492 15.6028 8.34201 15.9621 9.35961 15.9022Z",
			fill: "#000000",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagChampionsLeague.tsx
function ht(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 23 23",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M11.6886 22.8224C5.54225 22.8224 0.541016 17.8212 0.541016 11.6749C0.541016 5.52858 5.54225 0.527344 11.6886 0.527344C17.8349 0.527344 22.8361 5.52858 22.8361 11.6749C22.8361 17.8212 17.8349 22.8224 11.6886 22.8224ZM1.98024 12.6278L4.34221 10.0601L6.49155 11.1114L8.11251 15.7144L6.74705 17.3556L3.64313 17.1842C2.735 15.8623 2.14384 14.3066 1.98024 12.6278ZM3.02973 7.18628C2.49472 8.21397 2.13738 9.34823 1.99872 10.5481L3.42155 9.00184L3.02973 7.18628ZM8.1267 2.59392C6.54146 3.21805 5.15765 4.24577 4.1026 5.54976L4.78681 8.72665L6.98192 9.8L11.0037 6.86822V4.14597L8.1267 2.59392ZM10.063 2.05585L11.7019 2.94056L13.3392 2.0599C12.8025 1.96802 12.251 1.92015 11.6886 1.92015C11.1349 1.92024 10.5918 1.9667 10.063 2.05585ZM15.2716 2.60194L12.3967 4.14803V6.86948L16.417 9.80025L18.6071 8.72762L19.2914 5.57029C18.2389 4.26212 16.8563 3.23012 15.2716 2.60194ZM20.3616 7.21344L19.9743 9.00374L21.377 10.5353C21.2385 9.3507 20.8869 8.23027 20.3616 7.21344ZM21.3971 12.6254L19.0518 10.0616L16.9064 11.1123L15.2651 15.7109L16.6126 17.3076L20.0933 16.6207C20.7983 15.4276 21.2565 14.0722 21.3971 12.6254ZM18.854 18.286L16.8245 18.6869L16.0259 20.4105C17.0942 19.8777 18.0519 19.1546 18.854 18.286ZM14.1659 21.1104L15.5247 18.1775L14.1523 16.5521H9.22921L7.83365 18.2294L8.71174 20.9647C9.65056 21.2663 10.6509 21.4292 11.6886 21.4292C12.5442 21.4292 13.3745 21.3184 14.1659 21.1104ZM7.01036 20.2322L6.53127 18.7399L4.8743 18.6476C5.50864 19.2676 6.22695 19.8021 7.01036 20.2322ZM9.39486 15.1581H13.9832L15.5153 10.8667L11.6993 8.08518L7.88236 10.8667L9.39486 15.1581Z",
			fill: "#5dd319",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagClose.tsx
function gt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "10px",
		viewBox: "0 0 10 9",
		width: "12px",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M0.556215 1.24261L1.64201 0.15681L4.89941 3.4142L8.15681 0.156809L9.24261 1.24261L5.98521 4.5L9.24261 7.7574L8.15681 8.84319L4.89941 5.5858L1.64201 8.84319L0.556214 7.7574L3.81361 4.5L0.556215 1.24261Z",
			fill: "#00182E"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagEntertainment.tsx
function _t(n) {
	return /* @__PURE__ */ e("svg", {
		height: "16px",
		viewBox: "4 4 16 16",
		width: "16px",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.744 6.23h-1.231v-.82a.41.41 0 00-.41-.41H7.897a.41.41 0 00-.41.41v.82h-1.23a2.258 2.258 0 00-.001 4.515.41.41 0 100-.82 1.436 1.436 0 010-2.873h1.231v3.487c0 2.018 1.34 3.79 3.282 4.341v1.403h-.947a.41.41 0 00-.347.193l-.9 1.436a.406.406 0 000 .41c.068.13.201.213.348.217h6.154a.409.409 0 00.359-.615l-.9-1.436a.411.411 0 00-.358-.205h-.947V14.88a4.514 4.514 0 003.282-4.34V7.05h1.23a1.435 1.435 0 11.001 2.872.41.41 0 100 .82 2.256 2.256 0 100-4.51zm-3.408 11.488H9.664l.385-.615h3.898l.39.615zm-1.926-1.436h-.82v-1.25c.135 0 .273.02.41.02.137 0 .275 0 .41-.02v1.25zm3.282-5.744a3.692 3.692 0 11-7.384 0V5.821h7.384v4.717z",
				fill: "#0b4721"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagF1.tsx
function vt(n) {
	return /* @__PURE__ */ e("svg", {
		height: "16px",
		viewBox: "0 0 16 16",
		width: "16px",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" }), /* @__PURE__ */ e("path", {
				d: "M7.428 0c3.39 0 6.563 2.34 7.317 5.306h.143c.166.01.318.1.408.239 1.232 1.846.578 5.273.058 6.828a.527.527 0 01-.498.36.443.443 0 01-.154 0l-.716 1.752a1.24 1.24 0 01-1.172.774c-.101 0-.2-.011-.298-.037L1.698 12.516a1.23 1.23 0 01-.828-.68A15.157 15.157 0 010 6.899C0 3.22 3.47 0 7.428 0zm7.11 6.367h-.133a.53.53 0 01-.27-.037L8.25 5.958a2.077 2.077 0 01-.419 2.468l.287.096a.521.521 0 01.207.126l1.496 1.496 4.68 1.402c.435-1.534.71-3.884.037-5.179zm-8.182-.531a1.24 1.24 0 00-1.222 1.251 1.24 1.24 0 002.482 0 1.241 1.241 0 00-1.222-1.251h-.038zm-4.5 5.555a.168.168 0 00.118.096l10.84 2.705a.174.174 0 00.206-.1l.653-1.688-4.276-1.262a.603.603 0 01-.223-.133L7.672 9.502 6.24 9.03a2.124 2.124 0 11.127-4.245H6.4l7.216.451c-.801-2.33-3.454-4.176-6.187-4.176-3.396 0-6.367 2.728-6.367 5.837.022 1.531.291 3.048.796 4.493v.001z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagFootball.tsx
function yt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 16 16",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M14.5733 0.241028C15.1056 0.347075 15.5468 0.754947 15.7024 1.27159L15.7317 1.38375C16.5889 5.40605 15.3646 9.54596 12.4551 12.4541C10.1588 14.7531 7.09497 15.9999 3.9258 15.9999C3.08287 15.9999 2.23177 15.9115 1.38476 15.7313C0.815096 15.609 0.356239 15.1433 0.241355 14.5737C-0.565552 10.5704 0.677779 6.45564 3.56687 3.56655C6.45529 0.678131 10.5707 -0.5652 14.574 0.241028H14.5733ZM1.22229 14.3758C1.259 14.5594 1.41195 14.7137 1.59481 14.7524C2.80619 15.0121 4.02913 15.0652 5.21944 14.9244L1.08497 10.7893C0.938817 11.9674 0.980284 13.1774 1.22161 14.3758H1.22229ZM1.30114 9.59082C1.77088 7.60856 2.78444 5.76362 4.27453 4.27421V4.27489C5.76327 2.78479 7.60821 1.77191 9.59047 1.3015L14.7133 6.42437C14.2518 8.40867 13.2423 10.2557 11.7481 11.7491C10.2546 13.2433 8.40764 14.2542 6.42266 14.7157L1.30114 9.59082ZM12.1614 0.999671C11.7012 0.999671 11.243 1.02822 10.7896 1.08464L14.9241 5.21979C15.0648 4.0288 15.0125 2.80519 14.7541 1.59245C14.7147 1.40958 14.5597 1.25799 14.3769 1.2206C13.64 1.07309 12.897 0.999671 12.1614 0.999671ZM5.50053 10.9987C5.37216 10.9986 5.2445 10.9496 5.1467 10.8525C4.9516 10.6574 4.9516 10.3406 5.1467 10.1455L5.79295 9.49928L5.1467 8.85325C4.9516 8.65816 4.9516 8.34137 5.1467 8.14628C5.3418 7.95118 5.65858 7.95118 5.85368 8.14628L6.49971 8.79252L7.29245 7.99978L6.64631 7.35364C6.45121 7.15854 6.45121 6.84176 6.64631 6.64666C6.84141 6.45225 7.15819 6.45225 7.35329 6.64666L7.99932 7.29291L8.79183 6.5004L8.14592 5.85471C7.95082 5.65893 7.95082 5.34215 8.14592 5.14773C8.34034 4.95263 8.6578 4.95263 8.8529 5.14773L9.4987 5.79353L10.1452 5.14705C10.3403 4.95263 10.6571 4.95263 10.8522 5.14705C11.0466 5.34215 11.0466 5.65893 10.8522 5.85403L10.2057 6.50051L10.8515 7.14631C11.0466 7.34141 11.0466 7.65887 10.8515 7.85329C10.7549 7.9505 10.6271 7.99944 10.4987 7.99944C10.3709 7.99944 10.2431 7.9505 10.1452 7.85329L9.49893 7.20726L8.70618 8.00001L9.35187 8.64592C9.54696 8.84102 9.54696 9.1578 9.35187 9.3529C9.25534 9.45011 9.12754 9.49905 8.99974 9.49905H8.99906C8.87126 9.49905 8.74346 9.45011 8.64557 9.3529L7.99943 8.70676L7.20657 9.49962L7.85225 10.1455C8.04803 10.3406 8.04803 10.6574 7.85225 10.8525C7.75572 10.9497 7.62792 10.9987 7.50012 10.9987C7.37164 10.9987 7.24384 10.9497 7.14664 10.8525L6.50005 10.2061L5.85368 10.8525C5.75656 10.9496 5.6289 10.9986 5.50053 10.9987ZM5.50053 10.9987C5.50042 10.9987 5.5003 10.9987 5.50019 10.9987H5.50087C5.50076 10.9987 5.50064 10.9987 5.50053 10.9987Z",
			fill: "#071457",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagGolf.tsx
function bt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 11 16",
		width: "11",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M0 5.5C0 7.47509 1.04685 9.21086 2.61508 10.181C2.54322 10.2676 2.5 10.3788 2.5 10.5V12.5C2.5 12.776 2.724 13 3 13H4V15.5C4 15.776 4.224 16 4.5 16H6.5C6.776 16 7 15.776 7 15.5V13H8C8.276 13 8.5 12.776 8.5 12.5V10.5C8.5 10.3787 8.45672 10.2674 8.38477 10.1808C9.95285 9.21064 11 7.47497 11 5.5C11 2.467 8.532 0 5.5 0C2.467 0 0 2.467 0 5.5ZM5 15V13H6V15H5ZM3.5 12H4.5H6.5H7.5V11H5.5H3.5V12ZM10 5.5C10 7.981 7.981 10 5.5 10C3.019 10 1 7.981 1 5.5C1 3.019 3.019 1 5.5 1C7.981 1 10 3.019 10 5.5ZM5.02 3C4.744 3 4.515 2.776 4.515 2.5C4.515 2.224 4.734 2 5.01 2H5.02C5.296 2 5.52 2.224 5.52 2.5C5.52 2.776 5.296 3 5.02 3ZM3.015 3C3.015 3.276 3.244 3.5 3.52 3.5C3.796 3.5 4.02 3.276 4.02 3C4.02 2.724 3.796 2.5 3.52 2.5H3.51C3.234 2.5 3.015 2.724 3.015 3ZM2.515 4.5C2.515 4.776 2.744 5 3.02 5C3.296 5 3.52 4.776 3.52 4.5C3.52 4.224 3.296 4 3.02 4H3.01C2.734 4 2.515 4.224 2.515 4.5ZM4.015 4C4.015 4.276 4.244 4.5 4.52 4.5C4.796 4.5 5.02 4.276 5.02 4C5.02 3.724 4.796 3.5 4.52 3.5H4.51C4.234 3.5 4.015 3.724 4.015 4Z",
			fill: "#327EA5",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagHockey.tsx
function xt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 16 16",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M2 16H5.978H5.97867C6.66667 16 7.29733 15.6533 7.66667 15.0713L15.7667 2.30267C15.9187 2.06333 16 1.78533 16 1.5C16 0.673333 15.3267 0 14.5 0C14.0233 0 13.5713 0.228667 13.29 0.614L4.944 12H2C0.896667 12 0 12.8973 0 14C0 15.1027 0.896667 16 2 16ZM1 14C1 13.448 1.44933 13 2 13H3V15H2C1.44933 15 1 14.552 1 14ZM5.978 15H4V13H4.944C5.26 13 5.562 12.848 5.75 12.592L7.14318 10.6914L8.60865 11.7206L6.82333 14.5347C6.638 14.826 6.322 15 5.978 15ZM9.14495 10.8753L7.7345 9.88471L8.59502 8.71078L9.88394 9.71049L9.14495 10.8753ZM10.4228 8.86119L14.9233 1.76733C14.974 1.68733 15 1.59733 15 1.5C15 1.224 14.7753 1 14.5 1C14.3393 1 14.192 1.07533 14.0967 1.20533L9.18723 7.90288L10.4228 8.86119ZM0.5 10H4.5C4.776 10 5 9.776 5 9.5V7.5C5 7.224 4.776 7 4.5 7H0.5C0.224 7 0 7.224 0 7.5V9.5C0 9.776 0.224 10 0.5 10ZM4 9H1V8H4V9Z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagHorseRacing.tsx
function St(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "16px",
		viewBox: "16 16 70 70",
		width: "16px",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				d: "M19.4306 25.7063L22.358 26.8519C19.7224 33.6476 18.627 42.4662 18.204 47.2234C17.9467 50.1156 18.017 52.7216 18.4194 55.1909C20.9534 70.7252 34.2351 82.0009 50.0008 82.0009C65.7665 82.0009 79.0479 70.7252 81.5822 55.1895C81.9846 52.7208 82.0554 50.1148 81.7976 47.2224C81.3746 42.4651 80.2792 33.6471 77.6436 26.8509L80.5716 25.7053C81.4399 25.3654 82.0008 24.5435 82.0008 23.611V20.2494C82.0008 19.0089 80.9919 18 79.7514 18H68.5019C67.1783 18 66.1006 19.0776 66.1006 20.4013V26.1C66.1006 26.1859 66.114 26.2713 66.1414 26.3533C66.2195 26.5872 73.8439 49.8833 65.3958 61.6062C62.1955 66.0465 57.0158 68.2982 50.0001 68.2982C42.9984 68.2982 37.8265 66.0499 34.6273 61.6163C26.1775 49.9049 33.7813 26.5863 33.8588 26.3535C33.8862 26.272 33.9001 26.1866 33.9001 26.1007V20.402C33.9001 19.0783 32.8226 18.0007 31.4989 18.0007H20.2494C19.0089 18.0007 18 19.0096 18 20.2501V23.6117C18 24.5442 18.5608 25.3661 19.4297 25.706L19.4306 25.7063ZM19.6008 20.2504C19.6008 19.8922 19.8921 19.6009 20.2503 19.6009H31.4997C31.9417 19.6009 32.3011 19.9602 32.3011 20.4022V25.9731C31.6225 28.0618 24.6375 50.5016 33.3295 62.5516C36.8463 67.4272 42.4551 69.8993 50.001 69.8993C57.5595 69.8993 63.1763 67.4245 66.6938 62.5428C75.3803 50.4904 68.3813 28.0628 67.7005 25.9742V20.4034C67.7005 19.9614 68.0599 19.602 68.5019 19.602H79.7513C80.1095 19.602 80.4009 19.8933 80.4009 20.2516V23.6131C80.4009 23.8821 80.239 24.1198 79.9885 24.2181L76.3093 25.6572C76.109 25.7353 75.9488 25.891 75.8646 26.0891C75.7803 26.2872 75.7792 26.5104 75.8618 26.7091C78.6363 33.3961 79.7731 42.5219 80.2039 47.3662C80.4495 50.1241 80.3836 52.6001 80.003 54.9344C77.5962 69.6915 64.9773 80.4029 50.0002 80.4029C35.023 80.4029 22.4045 69.6919 19.9973 54.9358C19.6167 52.6004 19.5514 50.1249 19.7964 47.3672C20.2272 42.5229 21.364 33.3974 24.1386 26.7101C24.2212 26.5114 24.2201 26.2882 24.1358 26.0901C24.0515 25.8926 23.8914 25.7369 23.691 25.6582L20.0125 24.2191C19.7619 24.1208 19.5995 23.8831 19.5995 23.6141L19.6008 20.2504Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M72.1664 31.2348C72.2752 31.5741 72.5894 31.7901 72.9276 31.7901C73.0085 31.7901 73.0911 31.7778 73.1731 31.751C73.5933 31.616 73.8249 31.1651 73.6893 30.7443C73.4281 29.9318 73.148 29.155 72.8573 28.4358C72.6921 28.0262 72.2272 27.8297 71.816 27.9938C71.4064 28.1595 71.2083 28.6255 71.374 29.0351C71.6497 29.7187 71.9164 30.4586 72.1664 31.2348V31.2348Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M27.7502 62.582C27.3758 62.8169 27.2625 63.3102 27.4975 63.6847C28.363 65.0653 29.3579 66.3761 30.4539 67.5798C30.6118 67.7534 30.8283 67.841 31.046 67.841C31.2379 67.841 31.4304 67.7723 31.5845 67.6323C31.9109 67.3349 31.9349 66.8287 31.6375 66.5023C30.6057 65.3689 29.6688 64.1351 28.8535 62.8348C28.618 62.4604 28.1241 62.3471 27.7502 62.5821L27.7502 62.582Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M25.4232 54.322C25.3328 53.8901 24.912 53.6144 24.4762 53.7026C24.0437 53.793 23.7669 54.2176 23.8568 54.6496C24.191 56.2456 24.6687 57.8193 25.2759 59.3276C25.4014 59.6395 25.7016 59.8292 26.0186 59.8292C26.1179 59.8292 26.2189 59.8103 26.3171 59.7712C26.7267 59.606 26.9254 59.1401 26.7602 58.7305C26.1882 57.3097 25.7379 55.8265 25.4232 54.322V54.322Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M24.1251 50.5691C24.5671 50.5613 24.9187 50.1975 24.9114 49.7555L24.9075 49.2862C24.9075 48.4347 24.9471 47.5406 25.0264 46.6293C25.066 46.1746 25.1134 45.6634 25.1709 45.1054C25.2161 44.6662 24.8969 44.2728 24.4566 44.2281C24.0158 44.1757 23.624 44.5027 23.5794 44.9424C23.5213 45.5094 23.4728 46.0289 23.4326 46.4916C23.35 47.4486 23.3076 48.3894 23.3076 49.2861C23.3076 49.4519 23.3087 49.617 23.3115 49.7828C23.3188 50.2197 23.6754 50.569 24.1112 50.569H24.1251L24.1251 50.5691Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M74.8265 45.0577C74.8862 45.6342 74.9353 46.1626 74.9761 46.6303C75.0548 47.5415 75.0949 48.4356 75.0949 49.2871L75.0916 49.7096C75.086 50.1515 75.4387 50.5143 75.8807 50.5204H75.8918C76.3288 50.5204 76.6853 50.1694 76.6915 49.7313L76.6948 49.2871C76.6948 48.3898 76.6524 47.449 76.5698 46.4926C76.5285 46.0166 76.4783 45.4803 76.418 44.8933C76.3728 44.4541 75.9822 44.1288 75.5397 44.1801C75.1005 44.2248 74.7813 44.6182 74.8265 45.0579V45.0577Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M73.3695 35.7534C73.6875 37.1999 73.976 38.7563 74.226 40.3784C74.2869 40.7735 74.6278 41.0564 75.0156 41.0564C75.0564 41.0564 75.0971 41.0531 75.139 41.047C75.5759 40.98 75.875 40.571 75.8075 40.1346C75.5525 38.4789 75.2578 36.889 74.9319 35.4091C74.8371 34.9772 74.4074 34.7021 73.9788 34.8003C73.5469 34.8952 73.2746 35.3215 73.3694 35.7535L73.3695 35.7534Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M38.2074 73.4849C38.3229 73.5435 38.4462 73.5708 38.5673 73.5708C38.8597 73.5708 39.1415 73.4101 39.2822 73.1316C39.4814 72.7371 39.3229 72.2561 38.9289 72.0569C37.5656 71.3688 36.2542 70.5469 35.0305 69.6137C34.6784 69.3464 34.1772 69.4134 33.9088 69.7649C33.641 70.1165 33.7091 70.6182 34.0601 70.8866C35.3614 71.8782 36.7571 72.7526 38.2073 73.4849L38.2074 73.4849Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M24.8552 41.0963C24.8959 41.1024 24.9372 41.1058 24.978 41.1058C25.3658 41.1058 25.7068 40.8229 25.7676 40.4272C26.0176 38.8016 26.3044 37.2448 26.6214 35.8005C26.7163 35.3686 26.4434 34.9422 26.0115 34.8479C25.5773 34.7525 25.1526 35.0265 25.0589 35.4578C24.7347 36.935 24.4411 38.5249 24.1861 40.1844C24.1191 40.6208 24.4188 41.0293 24.8552 41.0963L24.8552 41.0963Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M68.9875 67.8063C69.2057 67.8063 69.4222 67.7181 69.5807 67.544C70.6739 66.3392 71.6661 65.0267 72.5304 63.6433C72.7642 63.2689 72.6504 62.775 72.2759 62.5412C71.9026 62.3074 71.4071 62.4212 71.1738 62.7956C70.3597 64.0987 69.4255 65.3346 68.396 66.4692C68.0991 66.7962 68.1237 67.3024 68.4512 67.5992C68.6036 67.7376 68.7955 67.8063 68.9875 67.8063L68.9875 67.8063Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M75.5334 53.6548C75.1015 53.565 74.6774 53.8429 74.5875 54.2754C74.2756 55.7798 73.8286 57.2642 73.2589 58.6867C73.0942 59.0968 73.294 59.5622 73.7042 59.7263C73.8013 59.7654 73.9023 59.7843 74.001 59.7843C74.3186 59.7843 74.6188 59.594 74.7438 59.281C75.3487 57.7716 75.823 56.1961 76.1539 54.6001C76.2438 54.1677 75.9659 53.7441 75.5334 53.6548L75.5334 53.6548Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M42.7667 75.2734C44.3337 75.7238 45.9526 76.0279 47.5797 76.178C47.6048 76.1802 47.6294 76.1813 47.654 76.1813C48.063 76.1813 48.4112 75.8694 48.4497 75.4548C48.4904 75.0151 48.1668 74.625 47.7265 74.5848C46.1992 74.4436 44.6791 74.1585 43.2086 73.7355C42.7823 73.6111 42.3409 73.8588 42.2187 74.2829C42.097 74.7081 42.342 75.1518 42.7667 75.2734L42.7667 75.2734Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M61.4776 73.5491C61.5992 73.5491 61.7231 73.5212 61.8392 73.4626C63.2889 72.7272 64.6829 71.8499 65.9814 70.8561C66.3324 70.5877 66.3989 70.0854 66.1304 69.7344C65.8626 69.3834 65.3609 69.317 65.0088 69.5854C63.7884 70.5196 62.4781 71.3443 61.1148 72.0357C60.7208 72.2355 60.5634 72.7171 60.7638 73.111C60.9044 73.3884 61.1857 73.5491 61.4775 73.5491L61.4776 73.5491Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M52.3979 76.1791C52.423 76.1791 52.4481 76.178 52.4738 76.1758C54.1005 76.0229 55.7193 75.7148 57.2846 75.2612C57.7087 75.1378 57.9531 74.6948 57.8304 74.2701C57.7076 73.846 57.2634 73.6016 56.8393 73.7244C55.37 74.1501 53.8504 74.4386 52.3237 74.5826C51.884 74.6239 51.5609 75.0145 51.6022 75.4543C51.6413 75.8683 51.9895 76.1791 52.3979 76.1791L52.3979 76.1791Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			}),
			/* @__PURE__ */ e("path", {
				d: "M26.8291 31.7506C26.9105 31.7774 26.9931 31.7896 27.0746 31.7896C27.4128 31.7896 27.727 31.5737 27.8358 31.2344C28.0858 30.4582 28.3525 29.7182 28.6287 29.0347C28.7945 28.6251 28.5964 28.1591 28.1868 27.9934C27.7766 27.8282 27.3107 28.0263 27.1455 28.4353C26.8547 29.1547 26.5746 29.9315 26.3134 30.7439C26.1773 31.1647 26.4089 31.6156 26.8291 31.7506V31.7506Z",
				fill: "#858649",
				stroke: "#858649",
				strokeWidth: "0.7"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/TagInsight.tsx
function Ct(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "17",
		viewBox: "0 0 16 17",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M6.45312 11.9531H9.54688V12.6406H6.45312V11.9531ZM6.46257 13.6719C6.54806 14.4453 7.20378 15.0469 8 15.0469C8.79622 15.0469 9.45194 14.4453 9.53743 13.6719H6.46257ZM5.59375 10.9219V11.4375H5.42188V13.5C5.42188 14.9239 6.57614 16.0781 8 16.0781C9.42386 16.0781 10.5781 14.9239 10.5781 13.5V11.4375H10.4062V10.9219H5.59375Z",
				fill: "#052643",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				d: "M10.1994 11.4375C11.3565 10.7119 12.125 9.43077 12.125 7.97135C12.125 5.709 10.2782 3.875 8 3.875C5.72183 3.875 3.875 5.709 3.875 7.97135C3.875 9.43077 4.64353 10.7119 5.80062 11.4375",
				stroke: "#052643",
				strokeWidth: "1.03125"
			}),
			/* @__PURE__ */ e("path", {
				d: "M7.3125 1.125C7.3125 0.745304 7.6203 0.4375 8 0.4375V0.4375C8.3797 0.4375 8.6875 0.745304 8.6875 1.125V2.54255C8.46228 2.51447 8.23283 2.5 8 2.5C7.76717 2.5 7.53772 2.51447 7.3125 2.54255V1.125Z",
				fill: "#052643"
			}),
			/* @__PURE__ */ e("path", {
				d: "M4.62741 3.65507L3.62483 2.65249C3.35634 2.384 2.92104 2.384 2.65255 2.65249V2.65249C2.38407 2.92098 2.38407 3.35628 2.65255 3.62476L3.65513 4.62733C3.93743 4.26418 4.26425 3.93736 4.62741 3.65507Z",
				fill: "#052643"
			}),
			/* @__PURE__ */ e("path", {
				d: "M2.54255 7.3125H1.125C0.745304 7.3125 0.4375 7.6203 0.4375 8V8C0.4375 8.3797 0.745304 8.6875 1.125 8.6875H2.54255C2.51447 8.46228 2.5 8.23283 2.5 8C2.5 7.76717 2.51447 7.53772 2.54255 7.3125Z",
				fill: "#052643"
			}),
			/* @__PURE__ */ e("path", {
				d: "M13.4574 8.6875H14.875C15.2547 8.6875 15.5625 8.3797 15.5625 8V8C15.5625 7.6203 15.2547 7.3125 14.875 7.3125H13.4574C13.4855 7.53772 13.5 7.76717 13.5 8C13.5 8.23283 13.4855 8.46228 13.4574 8.6875Z",
				fill: "#052643"
			}),
			/* @__PURE__ */ e("path", {
				d: "M12.345 4.6275L13.3477 3.62482C13.6162 3.35634 13.6162 2.92104 13.3477 2.65255V2.65255C13.0792 2.38407 12.6439 2.38407 12.3754 2.65255L11.3728 3.6552C11.7359 3.93751 12.0627 4.26434 12.345 4.6275Z",
				fill: "#052643"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/TagLaLiga.tsx
function wt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 23 23",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M11.6886 22.8224C5.54225 22.8224 0.541016 17.8212 0.541016 11.6749C0.541016 5.52858 5.54225 0.527344 11.6886 0.527344C17.8349 0.527344 22.8361 5.52858 22.8361 11.6749C22.8361 17.8212 17.8349 22.8224 11.6886 22.8224ZM1.98024 12.6278L4.34221 10.0601L6.49155 11.1114L8.11251 15.7144L6.74705 17.3556L3.64313 17.1842C2.735 15.8623 2.14384 14.3066 1.98024 12.6278ZM3.02973 7.18628C2.49472 8.21397 2.13738 9.34823 1.99872 10.5481L3.42155 9.00184L3.02973 7.18628ZM8.1267 2.59392C6.54146 3.21805 5.15765 4.24577 4.1026 5.54976L4.78681 8.72665L6.98192 9.8L11.0037 6.86822V4.14597L8.1267 2.59392ZM10.063 2.05585L11.7019 2.94056L13.3392 2.0599C12.8025 1.96802 12.251 1.92015 11.6886 1.92015C11.1349 1.92024 10.5918 1.9667 10.063 2.05585ZM15.2716 2.60194L12.3967 4.14803V6.86948L16.417 9.80025L18.6071 8.72762L19.2914 5.57029C18.2389 4.26212 16.8563 3.23012 15.2716 2.60194ZM20.3616 7.21344L19.9743 9.00374L21.377 10.5353C21.2385 9.3507 20.8869 8.23027 20.3616 7.21344ZM21.3971 12.6254L19.0518 10.0616L16.9064 11.1123L15.2651 15.7109L16.6126 17.3076L20.0933 16.6207C20.7983 15.4276 21.2565 14.0722 21.3971 12.6254ZM18.854 18.286L16.8245 18.6869L16.0259 20.4105C17.0942 19.8777 18.0519 19.1546 18.854 18.286ZM14.1659 21.1104L15.5247 18.1775L14.1523 16.5521H9.22921L7.83365 18.2294L8.71174 20.9647C9.65056 21.2663 10.6509 21.4292 11.6886 21.4292C12.5442 21.4292 13.3745 21.3184 14.1659 21.1104ZM7.01036 20.2322L6.53127 18.7399L4.8743 18.6476C5.50864 19.2676 6.22695 19.8021 7.01036 20.2322ZM9.39486 15.1581H13.9832L15.5153 10.8667L11.6993 8.08518L7.88236 10.8667L9.39486 15.1581Z",
			fill: "#14A039",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagMLB.tsx
function Tt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "4 4 16 16",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M17.5 4a2.503 2.503 0 011.538 4.472L7.58 17.892c.084.189.128.395.128.609 0 .401-.157.777-.44 1.061-.283.282-.66.438-1.06.438-.35 0-.682-.12-.95-.339l-.111-.1-.707-.707c-.284-.284-.44-.661-.44-1.062s.157-.777.44-1.061c.432-.43 1.111-.533 1.66-.305L15.528 4.96a.268.268 0 01.035-.048A2.502 2.502 0 0117.5 4zM5.147 17.44a.494.494 0 000 .706l.707.708a.51.51 0 00.707 0 .496.496 0 000-.707l-.707-.707a.512.512 0 00-.707 0zm3.296-2.289L6.88 17.052l.067.067 1.901-1.563-.405-.405zM17.5 5c-.436 0-.844.184-1.129.507l-.031.042-7.259 8.826.543.543 8.827-7.258.042-.031A1.502 1.502 0 0017.5 5zM6 4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z",
			fill: "#2c3feb",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagMLS.tsx
function Et(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 23 23",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M11.6886 22.8224C5.54225 22.8224 0.541016 17.8212 0.541016 11.6749C0.541016 5.52858 5.54225 0.527344 11.6886 0.527344C17.8349 0.527344 22.8361 5.52858 22.8361 11.6749C22.8361 17.8212 17.8349 22.8224 11.6886 22.8224ZM1.98024 12.6278L4.34221 10.0601L6.49155 11.1114L8.11251 15.7144L6.74705 17.3556L3.64313 17.1842C2.735 15.8623 2.14384 14.3066 1.98024 12.6278ZM3.02973 7.18628C2.49472 8.21397 2.13738 9.34823 1.99872 10.5481L3.42155 9.00184L3.02973 7.18628ZM8.1267 2.59392C6.54146 3.21805 5.15765 4.24577 4.1026 5.54976L4.78681 8.72665L6.98192 9.8L11.0037 6.86822V4.14597L8.1267 2.59392ZM10.063 2.05585L11.7019 2.94056L13.3392 2.0599C12.8025 1.96802 12.251 1.92015 11.6886 1.92015C11.1349 1.92024 10.5918 1.9667 10.063 2.05585ZM15.2716 2.60194L12.3967 4.14803V6.86948L16.417 9.80025L18.6071 8.72762L19.2914 5.57029C18.2389 4.26212 16.8563 3.23012 15.2716 2.60194ZM20.3616 7.21344L19.9743 9.00374L21.377 10.5353C21.2385 9.3507 20.8869 8.23027 20.3616 7.21344ZM21.3971 12.6254L19.0518 10.0616L16.9064 11.1123L15.2651 15.7109L16.6126 17.3076L20.0933 16.6207C20.7983 15.4276 21.2565 14.0722 21.3971 12.6254ZM18.854 18.286L16.8245 18.6869L16.0259 20.4105C17.0942 19.8777 18.0519 19.1546 18.854 18.286ZM14.1659 21.1104L15.5247 18.1775L14.1523 16.5521H9.22921L7.83365 18.2294L8.71174 20.9647C9.65056 21.2663 10.6509 21.4292 11.6886 21.4292C12.5442 21.4292 13.3745 21.3184 14.1659 21.1104ZM7.01036 20.2322L6.53127 18.7399L4.8743 18.6476C5.50864 19.2676 6.22695 19.8021 7.01036 20.2322ZM9.39486 15.1581H13.9832L15.5153 10.8667L11.6993 8.08518L7.88236 10.8667L9.39486 15.1581Z",
			fill: "#14A039",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagMotorsport.tsx
function Dt(n) {
	return /* @__PURE__ */ e("svg", {
		height: "16px",
		viewBox: "0 0 16 16",
		width: "16px",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" }), /* @__PURE__ */ e("path", {
				d: "M7.428 0c3.39 0 6.563 2.34 7.317 5.306h.143c.166.01.318.1.408.239 1.232 1.846.578 5.273.058 6.828a.527.527 0 01-.498.36.443.443 0 01-.154 0l-.716 1.752a1.24 1.24 0 01-1.172.774c-.101 0-.2-.011-.298-.037L1.698 12.516a1.23 1.23 0 01-.828-.68A15.157 15.157 0 010 6.899C0 3.22 3.47 0 7.428 0zm7.11 6.367h-.133a.53.53 0 01-.27-.037L8.25 5.958a2.077 2.077 0 01-.419 2.468l.287.096a.521.521 0 01.207.126l1.496 1.496 4.68 1.402c.435-1.534.71-3.884.037-5.179zm-8.182-.531a1.24 1.24 0 00-1.222 1.251 1.24 1.24 0 002.482 0 1.241 1.241 0 00-1.222-1.251h-.038zm-4.5 5.555a.168.168 0 00.118.096l10.84 2.705a.174.174 0 00.206-.1l.653-1.688-4.276-1.262a.603.603 0 01-.223-.133L7.672 9.502 6.24 9.03a2.124 2.124 0 11.127-4.245H6.4l7.216.451c-.801-2.33-3.454-4.176-6.187-4.176-3.396 0-6.367 2.728-6.367 5.837.022 1.531.291 3.048.796 4.493v.001z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagMyocpremium.tsx
function Ot(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "32",
		viewBox: "0 0 32 32",
		width: "32",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [
			/* @__PURE__ */ e("path", {
				d: "M16.048 30.733C24.1271 30.733 30.6765 24.1753 30.6765 16.0859C30.6765 7.99647 24.1271 1.43872 16.048 1.43872C7.96884 1.43872 1.41943 7.99647 1.41943 16.0859C1.41943 24.1753 7.96884 30.733 16.048 30.733Z",
				fill: "#03325B"
			}),
			/* @__PURE__ */ e("path", {
				d: "M18.7824 13.5367L16.804 13.5313C16.7688 13.532 16.7339 13.525 16.7017 13.5108C16.6695 13.4967 16.6408 13.4756 16.6176 13.4492C16.5917 13.4233 16.5713 13.3923 16.5577 13.3582C16.5441 13.3241 16.5376 13.2876 16.5386 13.2509L16.5425 11.7959C16.5418 11.7593 16.5485 11.723 16.5623 11.6891C16.576 11.6552 16.5964 11.6245 16.6224 11.5987C16.6459 11.5726 16.6748 11.5518 16.7071 11.5378C16.7393 11.5238 16.7742 11.5169 16.8094 11.5176L18.7881 11.523C18.8353 11.5187 18.8824 11.5325 18.9197 11.5617C18.9571 11.5909 18.9819 11.6333 18.9892 11.6802L19.6619 11.1801C19.5784 11.0244 19.4469 10.8999 19.287 10.8251C19.1331 10.7448 18.9622 10.7027 18.7887 10.7022L16.8109 10.6968C16.221 10.6968 15.7432 11.1879 15.742 11.7938L15.7393 13.2488C15.7372 13.8544 16.2123 14.3476 16.8022 14.3515L18.78 14.3569C18.9587 14.3505 19.1326 14.2969 19.284 14.2015C19.4412 14.112 19.583 13.9978 19.7042 13.8634L19.1132 13.3092C18.9892 13.4607 18.8827 13.5367 18.7824 13.5367Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				clipRule: "evenodd",
				d: "M13.3957 10.6875L15.3955 10.6929C15.6967 10.693 15.9862 10.8096 16.2035 11.0184C16.3085 11.1196 16.3918 11.241 16.4486 11.3753C16.5054 11.5096 16.5343 11.654 16.5337 11.7999L16.5298 13.2525C16.5291 13.398 16.4989 13.5419 16.441 13.6754C16.3832 13.809 16.2989 13.9294 16.1933 14.0294C15.9752 14.2359 15.6858 14.3501 15.3856 14.3483L13.3858 14.3429C13.0847 14.3431 12.7952 14.2265 12.5781 14.0177C12.473 13.9171 12.3894 13.7962 12.3323 13.6622C12.2752 13.5283 12.2459 13.3842 12.2461 13.2386L12.25 11.7858C12.2504 11.64 12.2803 11.4958 12.3379 11.362C12.3955 11.2281 12.4797 11.1074 12.5853 11.007C12.804 10.7996 13.0945 10.6851 13.3957 10.6875ZM15.587 13.4463C15.6144 13.4214 15.6361 13.3909 15.6508 13.3569C15.6655 13.3229 15.6728 13.2862 15.6722 13.2492L15.6764 11.7963C15.6772 11.759 15.6703 11.722 15.6562 11.6875C15.6422 11.653 15.6213 11.6217 15.5948 11.5955C15.5683 11.5694 15.5367 11.5489 15.502 11.5354C15.4673 11.5218 15.4303 11.5155 15.3931 11.5168L13.3933 11.5114C13.3564 11.5103 13.3195 11.517 13.2852 11.5309C13.2509 11.5448 13.2199 11.5657 13.194 11.5922C13.1666 11.6171 13.1449 11.6476 13.1302 11.6816C13.1155 11.7156 13.1082 11.7523 13.1088 11.7894L13.1049 13.2419C13.1042 13.279 13.1113 13.3157 13.1258 13.3498C13.1402 13.3839 13.1618 13.4145 13.1889 13.4397C13.2147 13.4663 13.2457 13.4873 13.2799 13.5014C13.3142 13.5155 13.3509 13.5225 13.3879 13.5218L15.3868 13.5272C15.4239 13.5286 15.461 13.5221 15.4955 13.5082C15.5299 13.4944 15.5611 13.4734 15.587 13.4466V13.4463Z",
				fill: "white",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ e("path", {
				d: "M6.77139 15.4417C7.56925 15.4417 8.00209 15.8763 8.00209 16.682V17.0743C8.00209 17.88 7.56835 18.3146 6.77139 18.3146H6.44121V20.3467H5.70068V15.4417H6.77139ZM6.44121 17.6279H6.74138C7.09828 17.6279 7.25917 17.4388 7.25917 17.0268V16.7325C7.25917 16.319 7.09828 16.1314 6.74138 16.1314H6.44121V17.6279Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M9.63383 18.2726H9.29104V20.3464H8.54932V15.4417H9.62002C10.4176 15.4417 10.8507 15.8763 10.8507 16.682V17.0322C10.8507 17.5509 10.6688 17.9152 10.3257 18.1115L11.0047 20.3467H10.2219L9.63383 18.2726ZM9.29104 17.5858H9.59121C9.94811 17.5858 10.1093 17.3967 10.1093 16.9832V16.731C10.1093 16.3175 9.94811 16.1299 9.59121 16.1299H9.29104V17.5858Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M12.356 16.1284V17.5158H13.4408V18.2025H12.356V19.6599H13.6995V20.3467H11.6143V15.4417H13.6995V16.1284H12.356Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M16.7999 20.3467V16.9411H16.7858L16.1701 19.6461H15.7292L15.1132 16.9411H15.0994V20.3467H14.3994V15.4416H15.3723L15.9531 18.0751H15.9672L16.5408 15.4404H17.5416V20.3455L16.7999 20.3467Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M18.4102 20.3467V15.4417H19.1519V20.3467H18.4102Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M22.272 19.2473C22.272 20.0179 21.831 20.4173 21.1172 20.4173C20.4172 20.4173 19.9766 20.0179 19.9766 19.2473V15.4417H20.6916V19.2256C20.6916 19.583 20.8525 19.7161 21.1118 19.7161C21.3712 19.7161 21.532 19.583 21.532 19.2256V15.4417H22.2741L22.272 19.2473Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M25.4981 20.3467V16.9411H25.484L24.8684 19.6461H24.4274L23.8115 16.9411H23.7977V20.3467H23.0977V15.4416H24.0705L24.6513 18.0751H24.6654L25.2391 15.4404H26.2398V20.3455L25.4981 20.3467Z",
				fill: "#1ED560"
			}),
			/* @__PURE__ */ e("path", {
				d: "M16.0204 30.0804C12.5742 30.076 9.25247 28.7902 6.69952 26.4724C4.14657 24.1546 2.54441 20.9699 2.20383 17.5362C1.86325 14.1025 2.80853 10.6646 4.8563 7.88924C6.90407 5.11391 9.90836 3.19905 13.2864 2.51612C16.6644 1.83318 20.1754 2.43085 23.1382 4.19318C26.101 5.95552 28.3045 8.7569 29.3212 12.0539C30.3379 15.3509 30.0954 18.9085 28.6406 22.0366C27.1859 25.1646 24.6226 27.6402 21.4481 28.983C19.731 29.7106 17.8849 30.0838 16.0204 30.0804ZM16.0204 2.7574C12.7229 2.7615 9.54453 3.99178 7.10174 6.20956C4.65895 8.42735 3.12591 11.4746 2.80002 14.7601C2.47412 18.0456 3.37861 21.3352 5.33801 23.9907C7.29741 26.6463 10.1721 28.4785 13.4043 29.1319C16.6365 29.7854 19.996 29.2135 22.8309 27.5272C25.6659 25.8409 27.7742 23.1604 28.747 20.0056C29.7198 16.8509 29.4877 13.4468 28.0956 10.4538C26.7036 7.46074 24.2509 5.09205 21.2134 3.80723C19.5705 3.11109 17.8043 2.75402 16.0204 2.7574Z",
				fill: "#1ED560"
			})
		]
	});
}
//#endregion
//#region primitives/icon/icons/TagNASCAR.tsx
function kt(n) {
	return /* @__PURE__ */ e("svg", {
		height: "16px",
		viewBox: "0 0 16 16",
		width: "16px",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" }), /* @__PURE__ */ e("path", {
				d: "M7.428 0c3.39 0 6.563 2.34 7.317 5.306h.143c.166.01.318.1.408.239 1.232 1.846.578 5.273.058 6.828a.527.527 0 01-.498.36.443.443 0 01-.154 0l-.716 1.752a1.24 1.24 0 01-1.172.774c-.101 0-.2-.011-.298-.037L1.698 12.516a1.23 1.23 0 01-.828-.68A15.157 15.157 0 010 6.899C0 3.22 3.47 0 7.428 0zm7.11 6.367h-.133a.53.53 0 01-.27-.037L8.25 5.958a2.077 2.077 0 01-.419 2.468l.287.096a.521.521 0 01.207.126l1.496 1.496 4.68 1.402c.435-1.534.71-3.884.037-5.179zm-8.182-.531a1.24 1.24 0 00-1.222 1.251 1.24 1.24 0 002.482 0 1.241 1.241 0 00-1.222-1.251h-.038zm-4.5 5.555a.168.168 0 00.118.096l10.84 2.705a.174.174 0 00.206-.1l.653-1.688-4.276-1.262a.603.603 0 01-.223-.133L7.672 9.502 6.24 9.03a2.124 2.124 0 11.127-4.245H6.4l7.216.451c-.801-2.33-3.454-4.176-6.187-4.176-3.396 0-6.367 2.728-6.367 5.837.022 1.531.291 3.048.796 4.493v.001z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagNBA.tsx
function At(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 17 16",
		width: "17",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M14.156 2.34055C15.668 3.85256 16.5 5.86213 16.5 8.00042C16.5 10.1387 15.668 12.1483 14.156 13.6596C12.5967 15.2203 10.548 16 8.5 16C6.45133 16 4.40267 15.221 2.84267 13.6596C1.332 12.1489 0.5 10.138 0.5 8.00042C0.5 5.94149 1.27133 4.00129 2.678 2.51129L2.84333 2.34055C5.96067 -0.779516 11.0367 -0.78085 14.156 2.34055ZM6.014 11.1932L3.91533 13.2941C5.094 14.3172 6.53533 14.8802 8.004 14.9835C7.66533 13.5729 6.98667 12.2803 6.014 11.1932ZM8.49867 8.7074L6.72333 10.4842C7.87933 11.7621 8.66933 13.3008 9.03133 14.9795C10.486 14.8702 11.9133 14.3086 13.0827 13.2948L8.49867 8.7074ZM10.9833 6.22295L9.20667 8.00042L13.7907 12.5871C14.7807 11.4473 15.3687 10.0367 15.4807 8.53199C13.8013 8.17049 12.2627 7.38014 10.984 6.22295H10.9833ZM1.518 8.49464L1.53133 8.66805C1.668 10.122 2.24933 11.4813 3.20867 12.5865L5.308 10.4855C4.22133 9.51309 2.928 8.83412 1.518 8.49464V8.49464ZM1.53133 7.33212L1.52067 7.46751C3.20067 7.82901 4.73867 8.62003 6.01733 9.77721L7.792 7.99975L3.20933 3.41436C2.24933 4.52019 1.668 5.8788 1.53133 7.33212ZM13.7893 3.4137L11.6913 5.5133C12.7787 6.48574 14.072 7.16604 15.482 7.50553C15.3773 5.98551 14.7873 4.56288 13.7893 3.4137ZM7.96933 1.02129L7.82933 1.03196C6.422 1.16669 5.048 1.72561 3.916 2.70805L8.5 7.29277L10.2773 5.5153C9.122 4.23806 8.33133 2.69938 7.97067 1.02129H7.96933ZM8.996 1.01796L9.038 1.18737C9.39 2.53063 10.0527 3.76385 10.9847 4.80632L13.0833 2.70738C11.9053 1.68492 10.464 1.12134 8.99667 1.01796H8.996Z",
			fill: "#E36C16",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagNCAAB.tsx
function jt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 16 16",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M13.656 2.34055C15.168 3.85256 16 5.86213 16 8.00042C16 10.1387 15.168 12.1483 13.656 13.6596C12.0967 15.2203 10.048 16 8 16C5.95133 16 3.90267 15.221 2.34267 13.6596C0.832 12.1489 0 10.138 0 8.00042C0 5.94149 0.771333 4.00129 2.178 2.51129L2.34333 2.34055C5.46067 -0.779516 10.5367 -0.78085 13.656 2.34055ZM5.514 11.1932L3.41533 13.2941C4.594 14.3172 6.03533 14.8802 7.504 14.9835C7.16533 13.5729 6.48667 12.2803 5.514 11.1932ZM7.99867 8.7074L6.22333 10.4842C7.37933 11.7621 8.16933 13.3008 8.53133 14.9795C9.986 14.8702 11.4133 14.3086 12.5827 13.2948L7.99867 8.7074ZM10.4833 6.22295L8.70667 8.00042L13.2907 12.5871C14.2807 11.4473 14.8687 10.0367 14.9807 8.53199C13.3013 8.17049 11.7627 7.38014 10.484 6.22295H10.4833ZM1.018 8.49464L1.03133 8.66805C1.168 10.122 1.74933 11.4813 2.70867 12.5865L4.808 10.4855C3.72133 9.51309 2.428 8.83412 1.018 8.49464ZM1.03133 7.33212L1.02067 7.46751C2.70067 7.82901 4.23867 8.62003 5.51733 9.77721L7.292 7.99975L2.70933 3.41436C1.74933 4.52019 1.168 5.8788 1.03133 7.33212ZM13.2893 3.4137L11.1913 5.5133C12.2787 6.48574 13.572 7.16604 14.982 7.50553C14.8773 5.98551 14.2873 4.56288 13.2893 3.4137ZM7.46933 1.02129L7.32933 1.03196C5.922 1.16669 4.548 1.72561 3.416 2.70805L8 7.29277L9.77733 5.5153C8.622 4.23807 7.83133 2.69938 7.47067 1.02129H7.46933ZM8.496 1.01796L8.538 1.18737C8.89 2.53063 9.55267 3.76385 10.4847 4.80632L12.5833 2.70738C11.4053 1.68492 9.964 1.12134 8.49667 1.01796H8.496Z",
			fill: "#0E4724",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagNCAAF.tsx
function Mt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 16 16",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M14.5733 0.241028C15.1056 0.347075 15.5468 0.754947 15.7024 1.27159L15.7317 1.38375C16.5889 5.40605 15.3646 9.54596 12.4551 12.4541C10.1588 14.7531 7.09497 15.9999 3.9258 15.9999C3.08287 15.9999 2.23177 15.9115 1.38476 15.7313C0.815096 15.609 0.356239 15.1433 0.241355 14.5737C-0.565552 10.5704 0.677779 6.45564 3.56687 3.56655C6.45529 0.678131 10.5707 -0.5652 14.574 0.241028H14.5733ZM1.22229 14.3758C1.259 14.5594 1.41195 14.7137 1.59481 14.7524C2.80619 15.0121 4.02913 15.0652 5.21944 14.9244L1.08497 10.7893C0.938817 11.9674 0.980284 13.1774 1.22161 14.3758H1.22229ZM1.30114 9.59082C1.77088 7.60856 2.78444 5.76362 4.27453 4.27421V4.27489C5.76327 2.78479 7.60821 1.77191 9.59047 1.3015L14.7133 6.42437C14.2518 8.40867 13.2423 10.2557 11.7481 11.7491C10.2546 13.2433 8.40764 14.2542 6.42266 14.7157L1.30114 9.59082ZM12.1614 0.999671C11.7012 0.999671 11.243 1.02822 10.7896 1.08464L14.9241 5.21979C15.0648 4.0288 15.0125 2.80519 14.7541 1.59245C14.7147 1.40958 14.5597 1.25799 14.3769 1.2206C13.64 1.07309 12.897 0.999671 12.1614 0.999671ZM5.50053 10.9987C5.37216 10.9986 5.2445 10.9496 5.1467 10.8525C4.9516 10.6574 4.9516 10.3406 5.1467 10.1455L5.79295 9.49928L5.1467 8.85325C4.9516 8.65816 4.9516 8.34137 5.1467 8.14628C5.3418 7.95118 5.65858 7.95118 5.85368 8.14628L6.49971 8.79252L7.29245 7.99978L6.64631 7.35364C6.45121 7.15854 6.45121 6.84176 6.64631 6.64666C6.84141 6.45225 7.15819 6.45225 7.35329 6.64666L7.99932 7.29291L8.79183 6.5004L8.14592 5.85471C7.95082 5.65893 7.95082 5.34215 8.14592 5.14773C8.34034 4.95263 8.6578 4.95263 8.8529 5.14773L9.4987 5.79353L10.1452 5.14705C10.3403 4.95263 10.6571 4.95263 10.8522 5.14705C11.0466 5.34215 11.0466 5.65893 10.8522 5.85403L10.2057 6.50051L10.8515 7.14631C11.0466 7.34141 11.0466 7.65887 10.8515 7.85329C10.7549 7.9505 10.6271 7.99944 10.4987 7.99944C10.3709 7.99944 10.2431 7.9505 10.1452 7.85329L9.49893 7.20726L8.70618 8.00001L9.35187 8.64592C9.54696 8.84102 9.54696 9.1578 9.35187 9.3529C9.25534 9.45011 9.12754 9.49905 8.99974 9.49905H8.99906C8.87126 9.49905 8.74346 9.45011 8.64557 9.3529L7.99943 8.70676L7.20657 9.49962L7.85225 10.1455C8.04803 10.3406 8.04803 10.6574 7.85225 10.8525C7.75572 10.9497 7.62792 10.9987 7.50012 10.9987C7.37164 10.9987 7.24384 10.9497 7.14664 10.8525L6.50005 10.2061L5.85368 10.8525C5.75656 10.9496 5.6289 10.9986 5.50053 10.9987ZM5.50053 10.9987C5.50042 10.9987 5.5003 10.9987 5.50019 10.9987H5.50087C5.50076 10.9987 5.50064 10.9987 5.50053 10.9987Z",
			fill: "#00239B",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagNFL.tsx
function Nt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 16 16",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M14.5733 0.241028C15.1056 0.347075 15.5468 0.754947 15.7024 1.27159L15.7317 1.38375C16.5889 5.40605 15.3646 9.54596 12.4551 12.4541C10.1588 14.7531 7.09497 15.9999 3.9258 15.9999C3.08287 15.9999 2.23177 15.9115 1.38476 15.7313C0.815096 15.609 0.356239 15.1433 0.241355 14.5737C-0.565552 10.5704 0.677779 6.45564 3.56687 3.56655C6.45529 0.678131 10.5707 -0.5652 14.574 0.241028H14.5733ZM1.22229 14.3758C1.259 14.5594 1.41195 14.7137 1.59481 14.7524C2.80619 15.0121 4.02913 15.0652 5.21944 14.9244L1.08497 10.7893C0.938817 11.9674 0.980284 13.1774 1.22161 14.3758H1.22229ZM1.30114 9.59082C1.77088 7.60856 2.78444 5.76362 4.27453 4.27421V4.27489C5.76327 2.78479 7.60821 1.77191 9.59047 1.3015L14.7133 6.42437C14.2518 8.40867 13.2423 10.2557 11.7481 11.7491C10.2546 13.2433 8.40764 14.2542 6.42266 14.7157L1.30114 9.59082ZM12.1614 0.999671C11.7012 0.999671 11.243 1.02822 10.7896 1.08464L14.9241 5.21979C15.0648 4.0288 15.0125 2.80519 14.7541 1.59245C14.7147 1.40958 14.5597 1.25799 14.3769 1.2206C13.64 1.07309 12.897 0.999671 12.1614 0.999671ZM5.50053 10.9987C5.37216 10.9986 5.2445 10.9496 5.1467 10.8525C4.9516 10.6574 4.9516 10.3406 5.1467 10.1455L5.79295 9.49928L5.1467 8.85325C4.9516 8.65816 4.9516 8.34137 5.1467 8.14628C5.3418 7.95118 5.65858 7.95118 5.85368 8.14628L6.49971 8.79252L7.29245 7.99978L6.64631 7.35364C6.45121 7.15854 6.45121 6.84176 6.64631 6.64666C6.84141 6.45225 7.15819 6.45225 7.35329 6.64666L7.99932 7.29291L8.79183 6.5004L8.14592 5.85471C7.95082 5.65893 7.95082 5.34215 8.14592 5.14773C8.34034 4.95263 8.6578 4.95263 8.8529 5.14773L9.4987 5.79353L10.1452 5.14705C10.3403 4.95263 10.6571 4.95263 10.8522 5.14705C11.0466 5.34215 11.0466 5.65893 10.8522 5.85403L10.2057 6.50051L10.8515 7.14631C11.0466 7.34141 11.0466 7.65887 10.8515 7.85329C10.7549 7.9505 10.6271 7.99944 10.4987 7.99944C10.3709 7.99944 10.2431 7.9505 10.1452 7.85329L9.49893 7.20726L8.70618 8.00001L9.35187 8.64592C9.54696 8.84102 9.54696 9.1578 9.35187 9.3529C9.25534 9.45011 9.12754 9.49905 8.99974 9.49905H8.99906C8.87126 9.49905 8.74346 9.45011 8.64557 9.3529L7.99943 8.70676L7.20657 9.49962L7.85225 10.1455C8.04803 10.3406 8.04803 10.6574 7.85225 10.8525C7.75572 10.9497 7.62792 10.9987 7.50012 10.9987C7.37164 10.9987 7.24384 10.9497 7.14664 10.8525L6.50005 10.2061L5.85368 10.8525C5.75656 10.9496 5.6289 10.9986 5.50053 10.9987ZM5.50053 10.9987C5.50042 10.9987 5.5003 10.9987 5.50019 10.9987H5.50087C5.50076 10.9987 5.50064 10.9987 5.50053 10.9987Z",
			fill: "#9F1300",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagNHL.tsx
function Pt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 16 16",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M2 16H5.978H5.97867C6.66667 16 7.29733 15.6533 7.66667 15.0713L15.7667 2.30267C15.9187 2.06333 16 1.78533 16 1.5C16 0.673333 15.3267 0 14.5 0C14.0233 0 13.5713 0.228667 13.29 0.614L4.944 12H2C0.896667 12 0 12.8973 0 14C0 15.1027 0.896667 16 2 16ZM1 14C1 13.448 1.44933 13 2 13H3V15H2C1.44933 15 1 14.552 1 14ZM5.978 15H4V13H4.944C5.26 13 5.562 12.848 5.75 12.592L7.14318 10.6914L8.60865 11.7206L6.82333 14.5347C6.638 14.826 6.322 15 5.978 15ZM9.14495 10.8753L7.7345 9.88471L8.59502 8.71078L9.88394 9.71049L9.14495 10.8753ZM10.4228 8.86119L14.9233 1.76733C14.974 1.68733 15 1.59733 15 1.5C15 1.224 14.7753 1 14.5 1C14.3393 1 14.192 1.07533 14.0967 1.20533L9.18723 7.90288L10.4228 8.86119ZM0.5 10H4.5C4.776 10 5 9.776 5 9.5V7.5C5 7.224 4.776 7 4.5 7H0.5C0.224 7 0 7.224 0 7.5V9.5C0 9.776 0.224 10 0.5 10ZM4 9H1V8H4V9Z",
			fill: "#656565",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagOtherSports.tsx
function Ft(n) {
	return /* @__PURE__ */ e("svg", {
		height: "16px",
		viewBox: "4 4 16 16",
		width: "16px",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.744 6.23h-1.231v-.82a.41.41 0 00-.41-.41H7.897a.41.41 0 00-.41.41v.82h-1.23a2.258 2.258 0 00-.001 4.515.41.41 0 100-.82 1.436 1.436 0 010-2.873h1.231v3.487c0 2.018 1.34 3.79 3.282 4.341v1.403h-.947a.41.41 0 00-.347.193l-.9 1.436a.406.406 0 000 .41c.068.13.201.213.348.217h6.154a.409.409 0 00.359-.615l-.9-1.436a.411.411 0 00-.358-.205h-.947V14.88a4.514 4.514 0 003.282-4.34V7.05h1.23a1.435 1.435 0 11.001 2.872.41.41 0 100 .82 2.256 2.256 0 100-4.51zm-3.408 11.488H9.664l.385-.615h3.898l.39.615zm-1.926-1.436h-.82v-1.25c.135 0 .273.02.41.02.137 0 .275 0 .41-.02v1.25zm3.282-5.744a3.692 3.692 0 11-7.384 0V5.821h7.384v4.717z",
				fill: "#0b4721"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagPicks.tsx
function It(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 11 16",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M4.7625 8.91667H1.1875L8.3375 1.125L6.55 7.08333H10.125L2.975 14.875L4.7625 8.91667Z",
			stroke: "#052643",
			strokeLinejoin: "round",
			strokeWidth: "1.03125"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagPolitics.tsx
function Lt(t) {
	return /* @__PURE__ */ e("svg", {
		height: "16px",
		viewBox: "0 4 30 16",
		width: "16px",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M15 4V5.13266L29.3332 10.0542C30.4012 10.4209 30.1377 12 29.0084 12H1.5C0.387232 12 0.106449 10.4557 1.148 10.064L14 5.23077V4V3V1V0H15H16C16.5523 0 17 0.447715 17 1H18H19V2V4V5H18H17C16.4477 5 16 4.55228 16 4H15ZM17 3V2H18V4H17V3ZM15 1H16V2V3H15V1ZM29.0084 11L14.629 6.06259L1.5 11L29.0084 11ZM5 14.5V20H4V14.5C4 14.2239 4.22386 14 4.5 14C4.77614 14 5 14.2239 5 14.5ZM3 20V14.5C3 13.6716 3.67157 13 4.5 13C5.32843 13 6 13.6716 6 14.5V20H10V14.5C10 13.6716 10.6716 13 11.5 13C12.3284 13 13 13.6716 13 14.5V20H17V14.5C17 13.6716 17.6716 13 18.5 13C19.3284 13 20 13.6716 20 14.5V20H24V14.5C24 13.6716 24.6716 13 25.5 13C26.3284 13 27 13.6716 27 14.5V20H28.5C29.3284 20 30 20.6716 30 21.5C30 22.3284 29.3284 23 28.5 23H1.5C0.671573 23 0 22.3284 0 21.5C0 20.6716 0.671573 20 1.5 20H3ZM26 20V14.5C26 14.2239 25.7761 14 25.5 14C25.2239 14 25 14.2239 25 14.5V20H26ZM24 21H20H19H18H17H13H12H11H10H6H5H4H3H1.5C1.22386 21 1 21.2239 1 21.5C1 21.7761 1.22386 22 1.5 22H28.5C28.7761 22 29 21.7761 29 21.5C29 21.2239 28.7761 21 28.5 21H27H26H25H24ZM19 20V14.5C19 14.2239 18.7761 14 18.5 14C18.2239 14 18 14.2239 18 14.5V20H19ZM12 20V14.5C12 14.2239 11.7761 14 11.5 14C11.2239 14 11 14.2239 11 14.5V20H12Z",
			fill: "#7a86c5",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagPremierLeague.tsx
function Rt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 23 23",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M11.6886 22.8224C5.54225 22.8224 0.541016 17.8212 0.541016 11.6749C0.541016 5.52858 5.54225 0.527344 11.6886 0.527344C17.8349 0.527344 22.8361 5.52858 22.8361 11.6749C22.8361 17.8212 17.8349 22.8224 11.6886 22.8224ZM1.98024 12.6278L4.34221 10.0601L6.49155 11.1114L8.11251 15.7144L6.74705 17.3556L3.64313 17.1842C2.735 15.8623 2.14384 14.3066 1.98024 12.6278ZM3.02973 7.18628C2.49472 8.21397 2.13738 9.34823 1.99872 10.5481L3.42155 9.00184L3.02973 7.18628ZM8.1267 2.59392C6.54146 3.21805 5.15765 4.24577 4.1026 5.54976L4.78681 8.72665L6.98192 9.8L11.0037 6.86822V4.14597L8.1267 2.59392ZM10.063 2.05585L11.7019 2.94056L13.3392 2.0599C12.8025 1.96802 12.251 1.92015 11.6886 1.92015C11.1349 1.92024 10.5918 1.9667 10.063 2.05585ZM15.2716 2.60194L12.3967 4.14803V6.86948L16.417 9.80025L18.6071 8.72762L19.2914 5.57029C18.2389 4.26212 16.8563 3.23012 15.2716 2.60194ZM20.3616 7.21344L19.9743 9.00374L21.377 10.5353C21.2385 9.3507 20.8869 8.23027 20.3616 7.21344ZM21.3971 12.6254L19.0518 10.0616L16.9064 11.1123L15.2651 15.7109L16.6126 17.3076L20.0933 16.6207C20.7983 15.4276 21.2565 14.0722 21.3971 12.6254ZM18.854 18.286L16.8245 18.6869L16.0259 20.4105C17.0942 19.8777 18.0519 19.1546 18.854 18.286ZM14.1659 21.1104L15.5247 18.1775L14.1523 16.5521H9.22921L7.83365 18.2294L8.71174 20.9647C9.65056 21.2663 10.6509 21.4292 11.6886 21.4292C12.5442 21.4292 13.3745 21.3184 14.1659 21.1104ZM7.01036 20.2322L6.53127 18.7399L4.8743 18.6476C5.50864 19.2676 6.22695 19.8021 7.01036 20.2322ZM9.39486 15.1581H13.9832L15.5153 10.8667L11.6993 8.08518L7.88236 10.8667L9.39486 15.1581Z",
			fill: "#0E4724",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagSoccer.tsx
function zt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 23 23",
		width: "16",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M11.6886 22.8224C5.54225 22.8224 0.541016 17.8212 0.541016 11.6749C0.541016 5.52858 5.54225 0.527344 11.6886 0.527344C17.8349 0.527344 22.8361 5.52858 22.8361 11.6749C22.8361 17.8212 17.8349 22.8224 11.6886 22.8224ZM1.98024 12.6278L4.34221 10.0601L6.49155 11.1114L8.11251 15.7144L6.74705 17.3556L3.64313 17.1842C2.735 15.8623 2.14384 14.3066 1.98024 12.6278ZM3.02973 7.18628C2.49472 8.21397 2.13738 9.34823 1.99872 10.5481L3.42155 9.00184L3.02973 7.18628ZM8.1267 2.59392C6.54146 3.21805 5.15765 4.24577 4.1026 5.54976L4.78681 8.72665L6.98192 9.8L11.0037 6.86822V4.14597L8.1267 2.59392ZM10.063 2.05585L11.7019 2.94056L13.3392 2.0599C12.8025 1.96802 12.251 1.92015 11.6886 1.92015C11.1349 1.92024 10.5918 1.9667 10.063 2.05585ZM15.2716 2.60194L12.3967 4.14803V6.86948L16.417 9.80025L18.6071 8.72762L19.2914 5.57029C18.2389 4.26212 16.8563 3.23012 15.2716 2.60194ZM20.3616 7.21344L19.9743 9.00374L21.377 10.5353C21.2385 9.3507 20.8869 8.23027 20.3616 7.21344ZM21.3971 12.6254L19.0518 10.0616L16.9064 11.1123L15.2651 15.7109L16.6126 17.3076L20.0933 16.6207C20.7983 15.4276 21.2565 14.0722 21.3971 12.6254ZM18.854 18.286L16.8245 18.6869L16.0259 20.4105C17.0942 19.8777 18.0519 19.1546 18.854 18.286ZM14.1659 21.1104L15.5247 18.1775L14.1523 16.5521H9.22921L7.83365 18.2294L8.71174 20.9647C9.65056 21.2663 10.6509 21.4292 11.6886 21.4292C12.5442 21.4292 13.3745 21.3184 14.1659 21.1104ZM7.01036 20.2322L6.53127 18.7399L4.8743 18.6476C5.50864 19.2676 6.22695 19.8021 7.01036 20.2322ZM9.39486 15.1581H13.9832L15.5153 10.8667L11.6993 8.08518L7.88236 10.8667L9.39486 15.1581Z",
			fill: "#14A039",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagSpecials.tsx
function Bt(n) {
	return /* @__PURE__ */ e("svg", {
		height: "16px",
		viewBox: "4 4 16 16",
		width: "16px",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M17.744 6.23h-1.231v-.82a.41.41 0 00-.41-.41H7.897a.41.41 0 00-.41.41v.82h-1.23a2.258 2.258 0 00-.001 4.515.41.41 0 100-.82 1.436 1.436 0 010-2.873h1.231v3.487c0 2.018 1.34 3.79 3.282 4.341v1.403h-.947a.41.41 0 00-.347.193l-.9 1.436a.406.406 0 000 .41c.068.13.201.213.348.217h6.154a.409.409 0 00.359-.615l-.9-1.436a.411.411 0 00-.358-.205h-.947V14.88a4.514 4.514 0 003.282-4.34V7.05h1.23a1.435 1.435 0 11.001 2.872.41.41 0 100 .82 2.256 2.256 0 100-4.51zm-3.408 11.488H9.664l.385-.615h3.898l.39.615zm-1.926-1.436h-.82v-1.25c.135 0 .273.02.41.02.137 0 .275 0 .41-.02v1.25zm3.282-5.744a3.692 3.692 0 11-7.384 0V5.821h7.384v4.717z",
				fill: "#0b4721"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/TagTennis.tsx
function Vt(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "16",
		viewBox: "0 0 17 16",
		width: "17",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M15.1325 1.36699C16.0848 2.318 16.5673 3.61972 16.4924 5.03279C16.422 6.35627 15.8691 7.62791 14.929 8.63651L14.7773 8.79395C13.7296 9.84095 12.3754 10.4496 10.9656 10.5091L10.9157 10.5104L6.50876 10.6972L4.7693 12.438C4.86466 12.6377 4.91457 12.8585 4.91457 13.0863C4.91457 13.4876 4.75778 13.8639 4.47491 14.1474L3.05992 15.5604C2.77704 15.8433 2.40074 15.9995 1.99947 15.9995C1.63852 15.9995 1.29805 15.8734 1.0267 15.6411L0.938385 15.5604C0.654875 15.2763 0.5 14.8987 0.5 14.4981C0.5 14.0975 0.656795 13.7218 0.940305 13.4376L2.35402 12.0246C2.79816 11.5817 3.49958 11.4851 4.05636 11.7366L5.80158 9.98943L5.99102 5.53518L5.99294 5.51086L6.00382 5.33294C6.11005 3.99475 6.70971 2.71927 7.70744 1.7209C9.85265 -0.423026 13.1837 -0.581741 15.1325 1.36699ZM3.41446 12.5858C3.28071 12.5858 3.15591 12.637 3.0612 12.7317L1.64684 14.1461C1.55213 14.2408 1.49965 14.3656 1.49965 14.4981C1.49965 14.6056 1.53293 14.708 1.59564 14.7925L1.64684 14.8526C1.835 15.0414 2.16522 15.0414 2.35274 14.8526L3.76773 13.4383C3.86309 13.3436 3.91493 13.2188 3.91493 13.0856C3.91493 12.9577 3.86757 12.838 3.78181 12.7458C3.77541 12.7426 3.77029 12.7381 3.76581 12.733L3.75237 12.7183L3.70757 12.6799C3.62246 12.6191 3.52134 12.5858 3.4151 12.5858H3.41446ZM6.86395 8.56804L6.81659 9.6816L7.93015 9.63552C7.726 9.48961 7.53337 9.32577 7.35289 9.14594C7.17306 8.96546 7.00986 8.77219 6.86395 8.56804ZM11.0596 8.26725L9.90129 9.42753C10.2309 9.49729 10.5733 9.5248 10.9227 9.50753C11.3195 9.49089 11.7124 9.42049 12.0919 9.30017L11.0596 8.26853V8.26725ZM8.93748 6.14636L7.45401 7.63111C7.61656 7.9255 7.8188 8.19621 8.06071 8.43748C8.30198 8.67875 8.57461 8.88227 8.87028 9.04546L10.3525 7.56071L8.93812 6.14636H8.93748ZM13.3092 6.01772L11.7668 7.56007L13.0685 8.86307C13.4269 8.65187 13.7642 8.39076 14.0708 8.08485C14.2928 7.86278 14.4912 7.62407 14.6646 7.37192L13.3092 6.01772ZM11.1876 3.89619L9.6453 5.43854L11.0597 6.85417L12.6026 5.31118L11.1883 3.89619H11.1876ZM7.19802 4.40689C7.0777 4.7864 7.0073 5.17871 6.99066 5.57613C6.97531 5.92812 7.00346 6.26987 7.07194 6.59754L8.2303 5.43918L7.19802 4.40689ZM15.4141 3.91347L14.0164 5.31054L15.1613 6.45419C15.3533 5.98252 15.4665 5.48462 15.4941 4.97903C15.5133 4.61169 15.4857 4.25394 15.4141 3.91347ZM9.12691 1.83354C8.87668 2.00569 8.63733 2.20345 8.41398 2.4268C8.10743 2.73335 7.84696 3.07062 7.63512 3.42965L8.93748 4.732L10.4805 3.18901L9.12691 1.83418V1.83354ZM13.6164 1.46619L11.8948 3.18901L13.3092 4.60337L15.0333 2.88054C14.8707 2.58615 14.6672 2.3148 14.4253 2.07289C14.1808 1.82842 13.9082 1.62683 13.6164 1.46619ZM11.7444 1.00029C11.178 1.00029 10.5989 1.11356 10.0446 1.33884L11.1876 2.48184L12.5834 1.08668C12.3102 1.02909 12.0292 1.00029 11.7451 1.00029H11.7444ZM2.49993 3.99987C1.39725 3.99987 0.5 3.10262 0.5 1.99993C0.5 0.89725 1.39725 0 2.49993 0C3.60262 0 4.49987 0.89725 4.49987 1.99993C4.49987 3.10262 3.60262 3.99987 2.49993 3.99987ZM2.49993 0.999647C1.94955 0.999647 1.49965 1.44891 1.49965 1.99993C1.49965 2.55032 1.94891 3.00022 2.49993 3.00022C3.05032 3.00022 3.50022 2.55096 3.50022 1.99993C3.50022 1.44955 3.05096 0.999647 2.49993 0.999647Z",
			fill: "#0B4721",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/Tennis.tsx
function Ht(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M18.632 5.367c.953.951 1.435 2.253 1.36 3.666-.07 1.323-.623 2.595-1.563 3.604l-.152.157c-1.047 1.047-2.402 1.656-3.811 1.715l-.05.001-4.407.187-1.74 1.741c.096.2.146.42.146.648 0 .402-.157.778-.44 1.061L6.56 19.56c-.283.283-.66.44-1.06.44-.361 0-.702-.127-.973-.359l-.089-.08a1.502 1.502 0 01.002-2.124l1.414-1.413c.444-.443 1.146-.54 1.702-.288l1.746-1.748.189-4.454.002-.024.01-.178c.107-1.338.707-2.614 1.704-3.612 2.146-2.144 5.477-2.303 7.425-.354zM6.914 16.586a.495.495 0 00-.353.146l-1.414 1.414a.495.495 0 00-.051.646l.05.06c.189.19.52.19.707 0l1.415-1.414a.494.494 0 00.014-.692.042.042 0 01-.016-.013l-.014-.015-.044-.038a.51.51 0 00-.293-.094zm3.45-4.018l-.047 1.114 1.113-.046a4.616 4.616 0 01-1.067-1.068zm4.196-.3l-1.16 1.159c.33.07.672.097 1.022.08.396-.017.79-.088 1.169-.208L14.56 12.27v-.002zm-2.123-2.123l-1.483 1.486a3.59 3.59 0 001.417 1.414l1.481-1.484-1.414-1.415zm4.372-.128l-1.542 1.543 1.302 1.303a5.065 5.065 0 001.596-1.491l-1.356-1.354zm-2.121-2.122L13.145 9.44l1.415 1.415 1.543-1.543-1.415-1.415zm-3.99.51c-.12.38-.19.773-.207 1.17-.016.352.012.694.08 1.022l1.16-1.159-1.033-1.032zm8.216-.493L17.516 9.31l1.145 1.143c.192-.471.306-.97.333-1.475a4.083 4.083 0 00-.08-1.066zm-6.287-2.08a5.094 5.094 0 00-1.492 1.597l1.302 1.302 1.543-1.542-1.353-1.355zm4.49-.367L15.394 7.19l1.414 1.414 1.724-1.722a3.576 3.576 0 00-1.417-1.415zM15.243 5c-.566 0-1.145.114-1.7.339l1.144 1.143 1.395-1.395A4.01 4.01 0 0015.245 5zM6 8c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3c-.55 0-1 .449-1 1 0 .55.449 1 1 1 .55 0 1-.449 1-1 0-.55-.449-1-1-1z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Tick.tsx
function Ut(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "currentColor",
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: [/* @__PURE__ */ e("path", {
			d: "M0 0h24v24H0z",
			fill: "none"
		}), /* @__PURE__ */ e("path", { d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" })]
	});
}
//#endregion
//#region primitives/icon/icons/TickBullet.tsx
var Wt = () => /* @__PURE__ */ e("svg", {
	fill: "none",
	height: "16",
	viewBox: "0 0 16 16",
	width: "16",
	xmlns: "http://www.w3.org/2000/svg",
	children: /* @__PURE__ */ e("path", {
		clipRule: "evenodd",
		d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM11.5712 4.77517C11.8619 4.48187 12.3324 4.47061 12.6369 4.74966C12.9604 5.04622 12.9705 5.55296 12.659 5.86215L7.42447 11.0585C7.03766 11.4424 6.41459 11.446 6.02348 11.0664L4.03454 9.13591C3.73689 8.84701 3.72307 8.37374 4.00336 8.06796C4.29824 7.74628 4.8018 7.73534 5.11037 8.04391L6.72785 9.66139L11.5712 4.77517Z",
		fill: "#2968FF",
		fillRule: "evenodd"
	})
});
//#endregion
//#region primitives/icon/icons/Tiktok.tsx
function Gt(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 1080 1080",
		width: "1em",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("g", { children: /* @__PURE__ */ e("g", {
			fill: "currentColor",
			id: "Layer_1",
			children: /* @__PURE__ */ e("path", { d: "M540,0C241.8,0,0,241.8,0,540s241.8,540,540,540,540-241.8,540-540S838.2,0,540,0ZM829.9,392.1v88.8c-59.3,0-114.2-19-159-51.1v232.3c0,116-94.4,210.4-210.4,210.4s-86.4-14.1-120.6-38.1c-54.2-38.1-89.8-101.1-89.8-172.2,0-116,94.4-210.4,210.4-210.4s19.1.8,28.3,2.1v116.7c-9-2.8-18.5-4.4-28.3-4.4-53,0-96.1,43.1-96.1,96.1s20.9,68.9,51.5,85c13.3,7,28.5,11,44.6,11,51.8,0,94-41.2,95.9-92.5l.2-458.1h114.3c0,9.9,1,19.6,2.7,29,8.1,43.5,33.9,80.9,69.7,104.3,24.9,16.3,54.7,25.7,86.6,25.7v25.5Z" })
		}) })
	});
}
//#endregion
//#region primitives/icon/icons/Trophy.tsx
function Kt(n) {
	return /* @__PURE__ */ t("svg", {
		fill: "none",
		height: "1em",
		viewBox: "0 0 14 14",
		width: "1em",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: [/* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M8.616 3.669l-.945-.125c-.056-.013-.113-.041-.14-.096l-.41-.844a.31.31 0 00-.55 0l-.423.83c-.028.055-.084.097-.14.097l-.945.124a.296.296 0 00-.17.512l.692.65c.042.041.07.096.056.166l-.17.926a.301.301 0 00.438.318l.846-.442c.056-.028.127-.028.169 0l.846.442c.225.125.479-.069.437-.318l-.17-.926c-.014-.056.015-.125.057-.166l.69-.65a.287.287 0 00-.168-.498z",
			fill: "#00182E",
			fillRule: "evenodd"
		}), /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M12.07 1.65h-1.255V1a.435.435 0 00-.437-.428H3.3A.435.435 0 002.864 1v.664H1.609c-.804 0-1.466.65-1.466 1.438v.927c0 .968.592 1.811 1.494 2.17l1.861.72a4.057 4.057 0 001.833 1.507v1.867c-.804.041-1.438.677-1.438 1.48v1.023c0 .235.197.428.437.428h5.019c.24 0 .437-.193.437-.428v-1.024c0-.788-.635-1.438-1.438-1.48v-1.88a3.89 3.89 0 001.832-1.507l1.861-.72a2.31 2.31 0 001.509-2.17v-.927a1.482 1.482 0 00-1.48-1.438zM1.96 5.398a1.469 1.469 0 01-.958-1.37v-.926c0-.332.268-.595.606-.595h1.255v2.31c0 .345.056.677.14.995l-1.043-.414zm6.95 6.36v.609H4.768v-.609a.64.64 0 01.648-.636h2.862c.353 0 .635.29.635.636zm-1.423-1.48H6.205v-1.63c.211.027.423.054.648.054.226 0 .437-.027.649-.055v1.632h-.014zm-.649-2.42c-1.706 0-3.101-1.368-3.101-3.041V1.415H9.94v3.402c0 1.673-1.396 3.042-3.102 3.042zm5.837-3.83c0 .609-.38 1.148-.959 1.37l-1.043.4c.084-.317.14-.65.14-.995V2.507h1.255c.339 0 .607.263.607.595v.927z",
			fill: "#00182E",
			fillRule: "evenodd"
		})]
	});
}
//#endregion
//#region primitives/icon/icons/Twitter.tsx
function qt(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M19.5 40C8.73 40 0 31.05 0 20S8.73 0 19.5 0 39 8.95 39 20s-8.73 20-19.5 20zM30 14.02c-.77.34-1.6.58-2.47.68a4.33 4.33 0 001.9-2.38c-.84.49-1.76.85-2.74 1.04a4.3 4.3 0 00-7.34 3.93 12.24 12.24 0 01-8.89-4.5 4.29 4.29 0 001.34 5.75A4.3 4.3 0 019.84 18v.06a4.31 4.31 0 003.46 4.22 4.32 4.32 0 01-1.95.08 4.31 4.31 0 004.03 3A8.65 8.65 0 019 27.13a12.2 12.2 0 006.6 1.93c7.93 0 12.27-6.57 12.27-12.26l-.01-.56A8.75 8.75 0 0030 14.02z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/TwitterFlat.tsx
function Jt(t) {
	return /* @__PURE__ */ e("svg", {
		height: "50",
		viewBox: "0 0 50 50",
		width: "50",
		...t,
		children: /* @__PURE__ */ e("g", { children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M38.4712 17.526C37.4805 17.9545 36.4155 18.2443 35.2981 18.3746C36.4385 17.7074 37.3146 16.6522 37.7276 15.3942C36.6591 16.0114 35.4772 16.4601 34.2187 16.701C33.2107 15.6542 31.7747 15 30.185 15C27.1334 15 24.6596 17.412 24.6596 20.3873C24.6596 20.8096 24.7085 21.2207 24.803 21.6149C20.2106 21.3903 16.1396 19.2456 13.414 15.9861C12.9382 16.7819 12.6658 17.7074 12.6658 18.6947C12.6658 20.5636 13.6409 22.2125 15.1235 23.179C14.2181 23.1509 13.3662 22.9083 12.6214 22.5051C12.6209 22.5275 12.6209 22.55 12.6209 22.5724C12.6209 25.1827 14.5251 27.36 17.0531 27.8553C16.5894 27.9783 16.101 28.044 15.5976 28.044C15.241 28.044 14.8949 28.0103 14.5573 27.9474C15.2606 30.0876 17.3013 31.6455 19.7193 31.6887C17.8284 33.1337 15.4455 33.9951 12.857 33.9951C12.4106 33.9951 11.9711 33.9699 11.5386 33.9199C13.9836 35.4485 16.8883 36.3403 20.009 36.3403C30.1723 36.3403 35.73 28.131 35.73 21.0118C35.73 20.7782 35.7249 20.5457 35.7139 20.3149C36.7939 19.555 37.7304 18.6065 38.4712 17.526",
			fill: "currentColor",
			fillRule: "evenodd"
		}) })
	});
}
//#endregion
//#region primitives/icon/icons/UfcMma.tsx
function Yt(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M15.92 4a4.13 4.13 0 013.015 1.303 3.96 3.96 0 011.048 3.063l-.665 7.179a.505.505 0 01-.508.455v3.5c0 .276-.229.5-.51.5H9.106a.505.505 0 01-.51-.5V16l-.071-.006-.034-.004-.044-.012-.039-.012-.025-.012a.518.518 0 01-.137-.088l-4.071-3.49A.494.494 0 014 12v-1.5C4 9.122 5.146 8 6.553 8h.854c0-.992.378-1.958 1.065-2.697A4.125 4.125 0 0111.486 4h4.433zm-4.25 12H9.618v3h8.17v-3h-6.116zm2.543 1c.282 0 .51.224.51.5s-.228.5-.51.5h-1.021c-.281 0-.51-.224-.51-.5s.229-.5.51-.5h1.022zM15.92 5h-4.433a3.05 3.05 0 00-2.26.977 2.972 2.972 0 00-.786 2.297l.015.141a.538.538 0 01.007.069L9.107 15h9.236l.622-6.725a2.962 2.962 0 00-.787-2.299A3.05 3.05 0 0015.92 5zM7.483 9h-.93c-.844 0-1.532.673-1.532 1.5v1.273l2.95 2.528L7.484 9z",
				fill: "currentColor"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Up.tsx
function Xt(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 24 24",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ e("path", {
				d: "M12.694 7.224l6.69 6.443a.822.822 0 01.023 1.163l-.022.022a.89.89 0 01-1.231 0L12 8.926l-6.154 5.926a.888.888 0 01-1.23 0 .822.822 0 01-.023-1.163l.022-.022 6.691-6.443a1 1 0 011.388 0z",
				fill: "#00182E"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/UsaFlag.tsx
function Zt(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 32 32",
		width: "1em",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ e("circle", {
					cx: 16,
					cy: 16,
					fill: "#F0F0F0",
					r: 16
				}),
				/* @__PURE__ */ e("g", {
					fill: "#D80027",
					children: /* @__PURE__ */ e("path", { d: "M15.304 16H32c0-1.444-.192-2.843-.551-4.174H15.304V16zM15.304 7.652h14.348a16.084 16.084 0 00-3.692-4.174H15.304v4.174zM16 32c3.766 0 7.227-1.302 9.96-3.478H6.04A15.931 15.931 0 0016 32zM2.348 24.348h27.304a15.905 15.905 0 001.797-4.174H.55a15.905 15.905 0 001.797 4.174z" })
				}),
				/* @__PURE__ */ e("path", {
					d: "M7.412 2.499H8.87l-1.357.985.518 1.594-1.356-.985-1.356.985.447-1.377A16.088 16.088 0 002.663 7.16h.467l-.863.627c-.134.224-.263.452-.387.683l.412 1.27-.769-.56c-.191.405-.366.82-.523 1.242l.454 1.398H3.13l-1.356.986.518 1.594-1.356-.985-.812.59C.042 14.659 0 15.325 0 16h16V0c-3.16 0-6.107.917-8.588 2.499zm.62 11.901l-1.357-.985-1.356.985.518-1.594-1.356-.986h1.676l.518-1.594.518 1.594H8.87l-1.357.986.518 1.594zm-.519-6.255l.518 1.594-1.356-.985-1.356.985.518-1.594-1.356-.985h1.676l.518-1.595.518 1.595H8.87l-1.357.985zm6.258 6.255l-1.357-.985-1.356.985.518-1.594-1.356-.986h1.676l.518-1.594.518 1.594h1.677l-1.357.986.518 1.594zm-.519-6.255l.518 1.594-1.356-.985-1.356.985.518-1.594-1.356-.985h1.676l.518-1.595.518 1.595h1.677l-1.357.985zm0-4.661l.518 1.594-1.356-.985-1.356.985.518-1.594-1.356-.985h1.676l.518-1.595.518 1.595h1.677l-1.357.985z",
					fill: "#0052B4"
				})
			]
		})
	});
}
//#endregion
//#region primitives/icon/icons/User.tsx
function Qt(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 17 16",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M1.685 16h14.437c.431 0 .782-.35.782-.781v-3.094c0-2.243-1.246-4.27-3.252-5.29l-.196-.1.073-.207c.186-.53.28-1.076.28-1.622C13.81 2.2 11.61 0 8.904 0S3.998 2.2 3.998 4.906c0 .545.094 1.091.28 1.622l.074.208-.197.1C2.15 7.856.904 9.882.904 12.125v3.094c0 .43.35.781.78.781zM8.904 1.56c1.845 0 3.346 1.5 3.346 3.346 0 1.845-1.501 3.346-3.346 3.346-1.845 0-3.346-1.501-3.346-3.346 0-1.846 1.5-3.347 3.346-3.347zm-6.44 10.565c0-1.692.995-3.249 2.536-3.966l.167-.078.125.136C6.222 9.23 7.538 9.81 8.904 9.81s2.682-.58 3.612-1.594l.124-.136.167.078c1.542.717 2.537 2.274 2.537 3.966v2.316H2.464v-2.316z",
			fill: "#1ED560",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/ValueBet.tsx
function $t({ className: n = "", height: r = 20, width: i = 20 }) {
	return /* @__PURE__ */ t("svg", {
		className: n,
		fill: "none",
		height: r,
		viewBox: "0 0 24 24",
		width: i,
		xmlns: "http://www.w3.org/2000/svg",
		children: [/* @__PURE__ */ e("circle", {
			cx: "12",
			cy: "12",
			r: "11.5385",
			stroke: "white",
			strokeWidth: "0.923077"
		}), /* @__PURE__ */ e("path", {
			d: "M4.00941 14.319L4.00415 9.65807H4.86162L4.86688 14.319H4.00941ZM2.09981 12.4251V11.5677L6.7607 11.5624V12.4199L2.09981 12.4251ZM7.73342 15.8182V8.2114H12.6468L12.6416 9.18988H8.86445V11.4993H12.2365V12.462H8.85919V14.824L12.7363 14.8292V15.8182H7.73342ZM15.6657 15.8182L12.9775 8.2114H14.077L16.3285 14.5294L18.5748 8.2114H19.6795L16.9913 15.8182H15.6657Z",
			fill: "white"
		})]
	});
}
//#endregion
//#region primitives/icon/icons/WeatherFine.tsx
function en(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 50 50",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			transform: "translate(1 1)",
			children: [/* @__PURE__ */ e("path", {
				d: "M23,37 C15.8202983,37 10,31.1797017 10,24 C10,16.8202983 15.8202983,11 23,11 C30.1797017,11 36,16.8202983 36,24 C36,31.1797017 30.1797017,37 23,37 Z M24,5.38263845 C24,5.9349232 23.5522847,6.38263845 23,6.38263845 C22.4477153,6.38263845 22,5.9349232 22,5.38263845 L22,1 C22,0.44771525 22.4477153,0 23,0 C23.5522847,0 24,0.44771525 24,1 L24,5.38263845 Z M37.7105572,11.8633074 C37.3219479,12.2557373 36.6887905,12.2588345 36.2963606,11.8702252 C35.9039307,11.4816159 35.9008335,10.8484585 36.2894428,10.4560285 L39.418349,7.29636058 C39.8069583,6.90393066 40.4401158,6.90083346 40.8325457,7.28944278 C41.2249756,7.6780521 41.2280728,8.3112095 40.8394635,8.70363942 L37.7105572,11.8633074 Z M9.41834903,11.8633074 L6.28944278,8.70363942 C5.90083346,8.3112095 5.90393066,7.6780521 6.29636058,7.28944278 C6.6887905,6.90083346 7.3219479,6.90393066 7.71055722,7.29636058 L10.8394635,10.4560285 C11.2280728,10.8484585 11.2249756,11.4816159 10.8325457,11.8702252 C10.4401158,12.2588345 9.80695835,12.2557373 9.41834903,11.8633074 Z M24,43 L24,47.3826384 C24,47.9349232 23.5522847,48.3826384 23,48.3826384 C22.4477153,48.3826384 22,47.9349232 22,47.3826384 L22,43 C22,42.4477153 22.4477153,42 23,42 C23.5522847,42 24,42.4477153 24,43 Z M37.7105572,36.2963606 L40.8394635,39.4560285 C41.2280728,39.8484585 41.2249756,40.4816159 40.8325457,40.8702252 C40.4401158,41.2588345 39.8069583,41.2557373 39.418349,40.8633074 L36.2894428,37.7036394 C35.9008335,37.3112095 35.9039307,36.6780521 36.2963606,36.2894428 C36.6887905,35.9008335 37.3219479,35.9039307 37.7105572,36.2963606 Z M9.41834903,36.2963606 C9.80695835,35.9039307 10.4401158,35.9008335 10.8325457,36.2894428 C11.2249756,36.6780521 11.2280728,37.3112095 10.8394635,37.7036394 L7.71055722,40.8633074 C7.3219479,41.2557373 6.6887905,41.2588345 6.29636058,40.8702252 C5.90393066,40.4816159 5.90083346,39.8484585 6.28944278,39.4560285 L9.41834903,36.2963606 Z M42,25 C41.4477153,25 41,24.5522847 41,24 C41,23.4477153 41.4477153,23 42,23 L46.6484375,23 C47.2007222,23 47.6484375,23.4477153 47.6484375,24 C47.6484375,24.5522847 47.2007222,25 46.6484375,25 L42,25 Z M1,25 C0.44771525,25 0,24.5522847 0,24 C0,23.4477153 0.44771525,23 1,23 L5.6484375,23 C6.20072225,23 6.6484375,23.4477153 6.6484375,24 C6.6484375,24.5522847 6.20072225,25 5.6484375,25 L1,25 Z",
				fill: "#FDDB00"
			}), /* @__PURE__ */ e("path", {
				d: "M26.9069803,39 C24.7492131,39 23,37.2588851 23,35.1111111 C23,32.9633371 24.7492131,31.2222222 26.9069767,31.2222222 C27.1945475,27.079548 30.4684631,24 34.7209302,24 C37.7430512,24 40.4568337,26.0347056 41.5110561,29.0212012 C41.6643945,29.0071707 41.8197281,29 41.9767442,29 C44.7510118,29 47,31.2385763 47,34 C47,36.5736409 45.046484,38.6931261 42.5348837,38.969484 L26.9069803,39 Z",
				fill: "#FFF"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/WeatherHot.tsx
function tn(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 50 50",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M24,38 C16.8202983,38 11,32.1797017 11,25 C11,17.8202983 16.8202983,12 24,12 C31.1797017,12 37,17.8202983 37,25 C37,32.1797017 31.1797017,38 24,38 Z M25,6.38263845 C25,6.9349232 24.5522847,7.38263845 24,7.38263845 C23.4477153,7.38263845 23,6.9349232 23,6.38263845 L23,2 C23,1.44771525 23.4477153,1 24,1 C24.5522847,1 25,1.44771525 25,2 L25,6.38263845 Z M38.7105572,12.8633074 C38.3219479,13.2557373 37.6887905,13.2588345 37.2963606,12.8702252 C36.9039307,12.4816159 36.9008335,11.8484585 37.2894428,11.4560285 L40.418349,8.29636058 C40.8069583,7.90393066 41.4401158,7.90083346 41.8325457,8.28944278 C42.2249756,8.6780521 42.2280728,9.3112095 41.8394635,9.70363942 L38.7105572,12.8633074 Z M10.418349,12.8633074 L7.28944278,9.70363942 C6.90083346,9.3112095 6.90393066,8.6780521 7.29636058,8.28944278 C7.6887905,7.90083346 8.3219479,7.90393066 8.71055722,8.29636058 L11.8394635,11.4560285 C12.2280728,11.8484585 12.2249756,12.4816159 11.8325457,12.8702252 C11.4401158,13.2588345 10.8069583,13.2557373 10.418349,12.8633074 Z M25,44 L25,48.3826384 C25,48.9349232 24.5522847,49.3826384 24,49.3826384 C23.4477153,49.3826384 23,48.9349232 23,48.3826384 L23,44 C23,43.4477153 23.4477153,43 24,43 C24.5522847,43 25,43.4477153 25,44 Z M38.7105572,37.2963606 L41.8394635,40.4560285 C42.2280728,40.8484585 42.2249756,41.4816159 41.8325457,41.8702252 C41.4401158,42.2588345 40.8069583,42.2557373 40.418349,41.8633074 L37.2894428,38.7036394 C36.9008335,38.3112095 36.9039307,37.6780521 37.2963606,37.2894428 C37.6887905,36.9008335 38.3219479,36.9039307 38.7105572,37.2963606 Z M10.418349,37.2963606 C10.8069583,36.9039307 11.4401158,36.9008335 11.8325457,37.2894428 C12.2249756,37.6780521 12.2280728,38.3112095 11.8394635,38.7036394 L8.71055722,41.8633074 C8.3219479,42.2557373 7.6887905,42.2588345 7.29636058,41.8702252 C6.90393066,41.4816159 6.90083346,40.8484585 7.28944278,40.4560285 L10.418349,37.2963606 Z M43,26 C42.4477153,26 42,25.5522847 42,25 C42,24.4477153 42.4477153,24 43,24 L47.6484375,24 C48.2007222,24 48.6484375,24.4477153 48.6484375,25 C48.6484375,25.5522847 48.2007222,26 47.6484375,26 L43,26 Z M2,26 C1.44771525,26 1,25.5522847 1,25 C1,24.4477153 1.44771525,24 2,24 L6.6484375,24 C7.20072225,24 7.6484375,24.4477153 7.6484375,25 C7.6484375,25.5522847 7.20072225,26 6.6484375,26 L2,26 Z",
			fill: "#FDDB00",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/WeatherOvercast.tsx
function nn(t) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 50 50",
		width: "1em",
		...t,
		children: /* @__PURE__ */ e("path", {
			d: "M9.03704427,41 C4.59830405,41 1,37.401696 1,32.962963 C1,28.52423 4.59830405,24.9259259 9.03703704,24.9259259 C9.6285985,16.3643991 16.3633663,10 25.1111111,10 C31.3279123,10 36.9104311,14.2050582 39.0790707,20.377149 C39.394503,20.3481529 39.7140394,20.3333333 40.037037,20.3333333 C45.7439795,20.3333333 50.3703704,24.9597243 50.3703704,30.6666667 C50.3703704,35.9855246 46.351795,40.3657939 41.1851852,40.9369336 L9.03704427,41 Z",
			fill: "#eeeff4",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/WeatherShowers.tsx
function rn(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 50 50",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			fill: "none",
			fillRule: "evenodd",
			transform: "translate(4 4)",
			children: [
				/* @__PURE__ */ e("path", {
					d: "M15.9291687,26 C10.9567043,26 6.92572553,21.9100607 6.92572553,16.8648649 C6.92572553,11.819669 10.9567043,7.72972973 15.9291687,7.72972973 C20.9016331,7.72972973 24.9326119,11.819669 24.9326119,16.8648649 C24.9326119,21.9100607 20.9016331,26 15.9291687,26 Z M16.6217413,3.78239459 C16.6217413,4.17048657 16.311666,4.48509729 15.9291687,4.48509729 C15.5466715,4.48509729 15.2365962,4.17048657 15.2365962,3.78239459 L15.2365962,0.702702703 C15.2365962,0.314610716 15.5466715,0 15.9291687,0 C16.311666,0 16.6217413,0.314610716 16.6217413,0.702702703 L16.6217413,3.78239459 Z M26.1172969,8.33637816 C25.8481567,8.61213973 25.4096493,8.61431614 25.1378631,8.34123932 C24.8660769,8.0681625 24.8639319,7.62324109 25.133072,7.34747952 L27.3000666,5.1271723 C27.5692068,4.85141074 28.0077142,4.84923432 28.2795004,5.12231114 C28.5512866,5.39538796 28.5534316,5.84030938 28.2842915,6.11607094 L26.1172969,8.33637816 Z M6.52289003,8.33637816 L4.35589544,6.11607094 C4.08675529,5.84030938 4.08890033,5.39538796 4.36068652,5.12231114 C4.63247271,4.84923432 5.07098015,4.85141074 5.3401203,5.1271723 L7.50711489,7.34747952 C7.77625504,7.62324109 7.77411,8.0681625 7.50232381,8.34123932 C7.23053762,8.61431614 6.79203018,8.61213973 6.52289003,8.33637816 Z M29.0880472,17.5675676 C28.70555,17.5675676 28.3954747,17.2529569 28.3954747,16.8648649 C28.3954747,16.4767729 28.70555,16.1621622 29.0880472,16.1621622 L32.3074274,16.1621622 C32.6899247,16.1621622 33,16.4767729 33,16.8648649 C33,17.2529569 32.6899247,17.5675676 32.3074274,17.5675676 L29.0880472,17.5675676 Z M0.692572553,17.5675676 C0.310075294,17.5675676 0,17.2529569 0,16.8648649 C0,16.4767729 0.310075294,16.1621622 0.692572553,16.1621622 L3.91195278,16.1621622 C4.29445004,16.1621622 4.60452533,16.4767729 4.60452533,16.8648649 C4.60452533,17.2529569 4.29445004,17.5675676 3.91195278,17.5675676 L0.692572553,17.5675676 Z",
					fill: "#FDDB00"
				}),
				/* @__PURE__ */ e("path", {
					d: "M28.9391499,42.0722673 C28.749436,42.5909455 28.1751707,42.8576237 27.6564925,42.6679097 C27.1378143,42.4781957 26.8711361,41.9039304 27.0608501,41.3852523 L29.8877544,33.6564925 C30.0774683,33.1378143 30.6517336,32.8711361 31.1704118,33.0608501 C31.68909,33.250564 31.9557682,33.8248293 31.7660542,34.3435075 L28.9391499,42.0722673 Z M37.9391499,36.0722673 C37.749436,36.5909455 37.1751707,36.8576237 36.6564925,36.6679097 C36.1378143,36.4781957 35.8711361,35.9039304 36.0608501,35.3852523 L38.8877544,27.6564925 C39.0774683,27.1378143 39.6517336,26.8711361 40.1704118,27.0608501 C40.68909,27.250564 40.9557682,27.8248293 40.7660542,28.3435075 L37.9391499,36.0722673 Z M7.93914993,39.0722673 C7.74943598,39.5909455 7.17517068,39.8576237 6.6564925,39.6679097 C6.13781431,39.4781957 5.87113611,38.9039304 6.06085007,38.3852523 L8.88775436,30.6564925 C9.07746832,30.1378143 9.65173362,29.8711361 10.1704118,30.0608501 C10.68909,30.250564 10.9557682,30.8248293 10.7660542,31.3435075 L7.93914993,39.0722673 Z M22.9391499,38.0722673 C22.749436,38.5909455 22.1751707,38.8576237 21.6564925,38.6679097 C21.1378143,38.4781957 20.8711361,37.9039304 21.0608501,37.3852523 L23.8877544,29.6564925 C24.0774683,29.1378143 24.6517336,28.8711361 25.1704118,29.0608501 C25.68909,29.250564 25.9557682,29.8248293 25.7660542,30.3435075 L22.9391499,38.0722673 Z M14.930483,41.6309835 C14.7281617,42.1448751 14.1475565,42.3974527 13.6336649,42.1951314 C13.1197734,41.9928102 12.8671957,41.412205 13.069517,40.8983134 L13.9611186,38.6336649 C14.1634398,38.1197734 14.744045,37.8671957 15.2579366,38.069517 C15.7718282,38.2718383 16.0244058,38.8524435 15.8220846,39.3663351 L14.930483,41.6309835 Z",
					fill: "#9ACAEE",
					fillRule: "nonzero"
				}),
				/* @__PURE__ */ e("path", {
					d: "M11.1860521,34 C7.76958736,34 5,31.2142162 5,27.7777778 C5,24.3413393 7.76958736,21.5555556 11.1860465,21.5555556 C11.6413669,14.9272767 16.8250666,10 23.5581395,10 C28.3431643,10 32.6399867,13.2555289 34.3091722,18.0339218 C34.551958,18.0114732 34.7979028,18 35.0465116,18 C39.439102,18 43,21.581722 43,26 C43,30.1178255 39.906933,33.5090017 35.9302326,33.9511744 L11.1860521,34 Z",
					fill: "#eeeff4"
				})
			]
		})
	});
}
//#endregion
//#region primitives/icon/icons/X.tsx
function an(n) {
	return /* @__PURE__ */ e("svg", {
		height: "1em",
		viewBox: "0 0 40 40",
		width: "1em",
		...n,
		children: /* @__PURE__ */ t("g", {
			id: "surface1",
			children: [/* @__PURE__ */ e("path", {
				d: "M 17.867188 0.148438 C 10.839844 0.878906 4.558594 5.507812 1.707031 12.054688 C -0.132812 16.28125 -0.441406 21.148438 0.867188 25.625 C 2.480469 31.214844 6.652344 35.933594 12.054688 38.292969 C 16.28125 40.132812 21.148438 40.4375 25.628906 39.132812 C 32.332031 37.199219 37.613281 31.695312 39.347656 24.851562 C 42.054688 14.132812 35.414062 3.171875 24.667969 0.613281 C 22.304688 0.0546875 20.226562 -0.09375 17.867188 0.148438 Z M 18.132812 12.535156 C 19.839844 14.800781 21.28125 16.667969 21.332031 16.667969 C 21.386719 16.667969 23.160156 14.800781 25.253906 12.535156 L 29.078125 8.398438 L 31.253906 8.398438 L 30.785156 8.894531 C 30.519531 9.171875 28.785156 11.054688 26.933594 13.066406 C 25.078125 15.078125 23.265625 17.039062 22.90625 17.398438 L 22.265625 18.078125 L 27.265625 24.734375 C 30.011719 28.398438 32.265625 31.441406 32.265625 31.492188 C 32.265625 31.558594 30.628906 31.601562 28.640625 31.601562 L 25 31.585938 L 21.613281 27.054688 C 19.28125 23.921875 18.1875 22.574219 18.078125 22.652344 C 18 22.71875 16.105469 24.761719 13.867188 27.1875 L 9.800781 31.601562 L 8.773438 31.601562 C 8.199219 31.601562 7.734375 31.574219 7.734375 31.535156 C 7.734375 31.492188 9.851562 29.171875 12.441406 26.386719 C 15.011719 23.601562 17.148438 21.265625 17.171875 21.226562 C 17.1875 21.171875 15.066406 18.28125 12.464844 14.800781 C 9.867188 11.332031 7.734375 8.464844 7.734375 8.441406 C 7.734375 8.414062 9.371094 8.398438 11.386719 8.398438 L 15.039062 8.398438 Z M 18.132812 12.535156 ",
				fill: "currentColor",
				fillRule: "nonzero"
			}), /* @__PURE__ */ e("path", {
				d: "M 11.027344 10.1875 C 11.082031 10.28125 14.441406 14.785156 18.464844 20.171875 L 25.800781 29.988281 L 27.441406 30 C 28.453125 30 29.066406 29.945312 29.039062 29.867188 C 29.027344 29.800781 25.679688 25.292969 21.628906 19.867188 L 14.238281 10 L 12.585938 10 C 11.214844 10 10.933594 10.027344 11.027344 10.1875 Z M 11.027344 10.1875 ",
				fill: "rgb(0%,0%,0%)",
				fillRule: "nonzero"
			})]
		})
	});
}
//#endregion
//#region primitives/icon/icons/Youtube.tsx
function on(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "1em",
		viewBox: "0 0 39 39",
		width: "1em",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M19.5 39C30.27 39 39 30.27 39 19.5S30.27 0 19.5 0 0 8.73 0 19.5 8.73 39 19.5 39zm12.173-25.625a3.053 3.053 0 00-2.148-2.148c-1.908-.502-9.538-.502-9.538-.502s-7.63 0-9.537.502a3.053 3.053 0 00-2.148 2.148C7.8 15.283 7.8 19.238 7.8 19.238s0 3.976.502 5.863a3.053 3.053 0 002.148 2.148c1.908.502 9.537.502 9.537.502s7.63 0 9.538-.502a3.051 3.051 0 002.148-2.148c.502-1.907.502-5.863.502-5.863s.02-3.975-.502-5.863zm-14.115 9.517v-7.308l6.325 3.654-6.325 3.654z",
			fill: "#fff",
			fillRule: "evenodd",
			opacity: .5
		})
	});
}
//#endregion
//#region primitives/icon/icons/YoutubeFlat.tsx
function sn(t) {
	return /* @__PURE__ */ e("svg", {
		height: "50",
		viewBox: "0 0 50 50",
		width: "50",
		...t,
		children: /* @__PURE__ */ e("g", { children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M37.852 14.3935C39.1906 14.7539 40.246 15.8093 40.6063 17.1478C41.2756 19.5675 41.2499 24.6643 41.2499 24.6643C41.2499 24.6643 41.2499 29.7353 40.6063 32.1807C40.246 33.5193 39.1906 34.5747 37.852 34.935C35.4066 35.5786 25.6249 35.5786 25.6249 35.5786C25.6249 35.5786 15.8433 35.5786 13.3978 34.935C12.0593 34.5747 11.0039 33.5193 10.6435 32.1807C10 29.7611 10 24.6643 10 24.6643C10 24.6643 10 19.5933 10.6435 17.1478C11.0039 15.8093 12.0593 14.7539 13.3978 14.3935C15.8433 13.75 25.6249 13.75 25.6249 13.75C25.6249 13.75 35.4066 13.75 37.852 14.3935ZM22.5102 19.9794V29.3492L30.6187 24.6643L22.5102 19.9794Z",
			fill: "currentColor",
			fillRule: "evenodd"
		}) })
	});
}
//#endregion
//#region primitives/icon/icons/YoutubeFooter.tsx
function cn(t) {
	return /* @__PURE__ */ e("svg", {
		fill: "none",
		height: "1em",
		viewBox: "0 0 39 39",
		width: "1em",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("path", {
			clipRule: "evenodd",
			d: "M19.5 39C30.27 39 39 30.27 39 19.5S30.27 0 19.5 0 0 8.73 0 19.5 8.73 39 19.5 39zm12.173-25.625a3.053 3.053 0 00-2.148-2.148c-1.908-.502-9.538-.502-9.538-.502s-7.63 0-9.537.502a3.053 3.053 0 00-2.148 2.148C7.8 15.283 7.8 19.238 7.8 19.238s0 3.976.502 5.863a3.053 3.053 0 002.148 2.148c1.908.502 9.537.502 9.537.502s7.63 0 9.538-.502a3.051 3.051 0 002.148-2.148c.502-1.907.502-5.863.502-5.863s.02-3.975-.502-5.863zm-14.115 9.517v-7.308l6.325 3.654-6.325 3.654z",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	});
}
//#endregion
//#region primitives/icon/icons/index.ts
var ln = /* @__PURE__ */ r({
	Age: () => i,
	AmericanFootball: () => a,
	Arrow: () => o,
	ArrowRight: () => s,
	ArrowTopRight: () => c,
	Athletics: () => l,
	AussieRules: () => u,
	Awards: () => d,
	AzMenu: () => f,
	Baseball: () => p,
	Baseball2: () => m,
	Baseball3: () => h,
	Basketball: () => g,
	Betslip: () => _,
	Boxing: () => v,
	CanadaFlag: () => y,
	Casino: () => b,
	Checkmark: () => x,
	ChevronsDown: () => S,
	ChevronsLeft: () => C,
	ChevronsRight: () => w,
	ChevronsUp: () => T,
	CircleCheckIcon: () => E,
	Clickout: () => D,
	ClockDate: () => O,
	Close: () => k,
	Closed: () => A,
	Cog: () => j,
	CopyLinkFlat: () => M,
	Cycling: () => N,
	Darts: () => P,
	Delete: () => F,
	Dollar: () => I,
	Down: () => L,
	ESports: () => R,
	ErrorCircle: () => z,
	Facebook: () => B,
	FacebookFlat: () => V,
	FacebookFooter: () => H,
	Filter: () => U,
	Football: () => W,
	FreeBets: () => G,
	Golf: () => K,
	Graph: () => q,
	Guides: () => J,
	HamburgerMenu: () => Y,
	Handicappers: () => X,
	Hockey: () => Z,
	Home: () => Q,
	HorseRacing: () => $,
	HotStreak: () => ee,
	IceHockey: () => te,
	Infinity: () => re,
	Info: () => ne,
	Insights: () => ie,
	Instagram: () => ae,
	InstagramFlat: () => oe,
	LeagueChampionsLeague: () => se,
	LeagueMLB: () => ce,
	LeagueNBA: () => le,
	LeagueNCAAB: () => ue,
	LeagueNCAAF: () => de,
	LeagueNFL: () => fe,
	LeagueNHL: () => pe,
	LeaguePremierLeague: () => me,
	Left: () => he,
	Legal: () => ge,
	Legislations: () => _e,
	Less: () => ve,
	LockIcon: () => ye,
	MmaUfc: () => be,
	More: () => xe,
	MotorSport: () => Se,
	Nascar: () => Ce,
	OCPlus: () => we,
	OcLogo: () => Te,
	Offers: () => Ee,
	Olympics: () => De,
	Options: () => Oe,
	OtherSports: () => ke,
	Picks: () => Ae,
	Pie: () => je,
	Politics: () => Me,
	PremiumAlert: () => Ne,
	PremiumBadgeTrophy: () => Pe,
	PremiumHelp: () => Fe,
	PremiumIcon: () => Ie,
	PremiumIconMobileNav: () => Le,
	PremiumListTick: () => Re,
	PremiumLock: () => ze,
	PremiumNFL: () => Be,
	PremiumNFLAllAccess: () => Ve,
	PremiumPlus: () => He,
	PremiumRecommended: () => Ue,
	PremiumRecommendedLarge: () => We,
	PremiumRecommendedV2: () => Ge,
	PremiumRecommendedV2Large: () => Ke,
	PremiumTrophy: () => qe,
	Projections: () => Je,
	Right: () => Ye,
	RugbyLeague: () => Xe,
	RugbyUnion: () => Ze,
	Share: () => Qe,
	Shield: () => $e,
	SilksAu: () => et,
	Snooker: () => tt,
	Soccer: () => nt,
	Sort: () => rt,
	Sorted: () => it,
	Specials: () => at,
	SquareCheckIcon: () => ot,
	StarFull: () => st,
	Stats: () => ct,
	Stripe: () => lt,
	TagAwards: () => ut,
	TagBaseball: () => dt,
	TagBasketball: () => ft,
	TagBoxingMMA: () => pt,
	TagCasino: () => mt,
	TagChampionsLeague: () => ht,
	TagClose: () => gt,
	TagEntertainment: () => _t,
	TagF1: () => vt,
	TagFootball: () => yt,
	TagGolf: () => bt,
	TagHockey: () => xt,
	TagHorseRacing: () => St,
	TagInsight: () => Ct,
	TagLaLiga: () => wt,
	TagMLB: () => Tt,
	TagMLS: () => Et,
	TagMotorsport: () => Dt,
	TagMyocpremium: () => Ot,
	TagNASCAR: () => kt,
	TagNBA: () => At,
	TagNCAAB: () => jt,
	TagNCAAF: () => Mt,
	TagNFL: () => Nt,
	TagNHL: () => Pt,
	TagOtherSports: () => Ft,
	TagPicks: () => It,
	TagPolitics: () => Lt,
	TagPremierLeague: () => Rt,
	TagSoccer: () => zt,
	TagSpecials: () => Bt,
	TagTennis: () => Vt,
	Tennis: () => Ht,
	Tick: () => Ut,
	TickBullet: () => Wt,
	Tiktok: () => Gt,
	Trophy: () => Kt,
	Twitter: () => qt,
	TwitterFlat: () => Jt,
	UfcMma: () => Yt,
	Up: () => Xt,
	UsaFlag: () => Zt,
	User: () => Qt,
	ValueBet: () => $t,
	WeatherFine: () => en,
	WeatherHot: () => tn,
	WeatherOvercast: () => nn,
	WeatherShowers: () => rn,
	X: () => an,
	Youtube: () => on,
	YoutubeFlat: () => sn,
	YoutubeFooter: () => cn
});
//#endregion
export { ut as $, u as $n, ue as $t, Nt as A, N as An, Ne as At, Ct as B, C as Bn, Ce as Bt, Bt as C, B as Cn, Be as Ct, It as D, I as Dn, Ie as Dt, Lt as E, L as En, Le as Et, Ot as F, O as Fn, Oe as Ft, vt as G, v as Gn, ve as Gt, xt as H, x as Hn, xe as Ht, Dt as I, D as In, De as It, ht as J, h as Jn, he as Jt, _t as K, _ as Kn, _e as Kt, Et as L, E as Ln, Ee as Lt, jt as M, j as Mn, je as Mt, At as N, A as Nn, Ae as Nt, Ft as O, F as On, Fe as Ot, kt as P, k as Pn, ke as Pt, dt as Q, d as Qn, de as Qt, Tt as R, T as Rn, Te as Rt, Vt as S, V as Sn, Ve as St, Rt as T, R as Tn, Re as Tt, bt as U, b as Un, be as Ut, St as V, S as Vn, Se as Vt, yt as W, y as Wn, ye as Wt, pt as X, p as Xn, pe as Xt, mt as Y, m as Yn, me as Yt, ft as Z, f as Zn, fe as Zt, Kt as _, K as _n, Ke as _t, an as a, ie as an, i as ar, it as at, Ut as b, U as bn, Ue as bt, tn as c, te as cn, tt as ct, Qt as d, Q as dn, Qe as dt, le as en, l as er, lt as et, Zt as f, Z as fn, Ze as ft, qt as g, q as gn, qe as gt, Jt as h, J as hn, Je as ht, on as i, ae as in, a as ir, at as it, Mt as j, M as jn, Me as jt, Pt as k, P as kn, Pe as kt, en as l, ee as ln, et as lt, Yt as m, Y as mn, Ye as mt, cn as n, se as nn, s as nr, st as nt, rn as o, re as on, rt as ot, Xt as p, X as pn, Xe as pt, gt as q, g as qn, ge as qt, sn as r, oe as rn, o as rr, ot as rt, nn as s, ne as sn, nt as st, ln as t, ce as tn, c as tr, ct as tt, $t as u, $ as un, $e as ut, Gt as v, G as vn, Ge as vt, zt as w, z as wn, ze as wt, Ht as x, H as xn, He as xt, Wt as y, W as yn, We as yt, wt as z, w as zn, we as zt };
